const gcJcamp1 = `

##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.1.0)
##DATA TYPE=GAS CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=Intensity
##SOFTWARE=LabSolutions
##SOFTWARE_VERSION=5.110
##METHOD=D:\\Methods\\GC-BID_inc-5min-30_GC-3min-40-7min-180-2min_Calibrated.gcm
##DATE=14.11.2023
##TIME=12:48:40
##OPERATOR=System Administrator
##INSTRUMENT=ComPlat_GC-BID
##NAME1=H2
##RTIME1=2.887
##CONC_PPM1=24148.876
##CONC_QUOTA1=13.975
##NAME2=Ar / O2
##RTIME2=3.472
##CONC_PPM2=0.000
##CONC_QUOTA2=0.000
##NAME3=N2
##RTIME3=4.355
##CONC_PPM3=0.000
##CONC_QUOTA3=0.000
##NAME4=CH4
##RTIME4=0.000
##CONC_PPM4=0.000
##CONC_QUOTA4=0.000
##NAME5=CO
##RTIME5=6.682
##CONC_PPM5=148645.945
##CONC_QUOTA5=86.025
##FIRSTX=0.0
##LASTX=12.0
##MINX=0.0
##MAXX=12.0
##MINY=-307.0
##MAXY=1796764.0
##NPOINTS=18001
##FIRSTY=0.0
##XUNITS=MINUTES
##YUNITS=Intensity
##XYDATA=(XY..XY)
0.0, 0.0
0.00067, 0.0
0.00133, 1.0
0.002, 1.0
0.00267, 1.0
0.00333, 2.0
0.004, 2.0
0.00467, 3.0
0.00533, 3.0
0.006, 3.0
0.00667, 4.0
0.00733, 4.0
0.008, 4.0
0.00867, 4.0
0.00933, 4.0
0.01, 4.0
0.01067, 4.0
0.01133, 4.0
0.012, 4.0
0.01267, 4.0
0.01333, 4.0
0.014, 4.0
0.01467, 4.0
0.01533, 4.0
0.016, 4.0
0.01667, 4.0
0.01733, 4.0
0.018, 4.0
0.01867, 4.0
0.01933, 4.0
0.02, 4.0
0.02067, 4.0
0.02133, 4.0
0.022, 4.0
0.02267, 3.0
0.02333, 3.0
0.024, 3.0
0.02467, 3.0
0.02533, 3.0
0.026, 3.0
0.02667, 3.0
0.02733, 4.0
0.028, 4.0
0.02867, 3.0
0.02933, 3.0
0.03, 3.0
0.03067, 3.0
0.03133, 4.0
0.032, 4.0
0.03267, 4.0
0.03333, 4.0
0.034, 4.0
0.03467, 4.0
0.03533, 5.0
0.036, 5.0
0.03667, 5.0
0.03733, 5.0
0.038, 5.0
0.03867, 4.0
0.03933, 4.0
0.04, 4.0
0.04067, 3.0
0.04133, 3.0
0.042, 3.0
0.04267, 2.0
0.04333, 2.0
0.044, 2.0
0.04467, 2.0
0.04533, 1.0
0.046, 1.0
0.04667, 1.0
0.04733, 1.0
0.048, 1.0
0.04867, 1.0
0.04933, 1.0
0.05, 1.0
0.05067, 1.0
0.05133, 1.0
0.052, 1.0
0.05267, 1.0
0.05333, 1.0
0.054, 1.0
0.05467, 1.0
0.05533, 2.0
0.056, 2.0
0.05667, 2.0
0.05733, 2.0
0.058, 2.0
0.05867, 2.0
0.05933, 3.0
0.06, 3.0
0.06067, 3.0
0.06133, 3.0
0.062, 3.0
0.06267, 3.0
0.06333, 3.0
0.064, 3.0
0.06467, 3.0
0.06533, 3.0
0.066, 3.0
0.06667, 3.0
0.06733, 2.0
0.068, 2.0
0.06867, 2.0
0.06933, 2.0
0.07, 2.0
0.07067, 1.0
0.07133, 1.0
0.072, 1.0
0.07267, 1.0
0.07333, 0.0
0.074, -0.0
0.07467, -0.0
0.07533, -0.0
0.076, -1.0
0.07667, -1.0
0.07733, -1.0
0.078, -1.0
0.07867, -1.0
0.07933, -1.0
0.08, -1.0
0.08067, -1.0
0.08133, -0.0
0.082, -0.0
0.08267, -0.0
0.08333, 0.0
0.084, 0.0
0.08467, 0.0
0.08533, 0.0
0.086, 1.0
0.08667, 1.0
0.08733, 1.0
0.088, 1.0
0.08867, 1.0
0.08933, 1.0
0.09, 1.0
0.09067, 2.0
0.09133, 2.0
0.092, 2.0
0.09267, 2.0
0.09333, 2.0
0.094, 2.0
0.09467, 2.0
0.09533, 1.0
0.096, 1.0
0.09667, 1.0
0.09733, 1.0
0.098, 1.0
0.09867, 1.0
0.09933, 1.0
0.1, 1.0
0.10067, 1.0
0.10133, 1.0
0.102, 1.0
0.10267, 1.0
0.10333, 0.0
0.104, 0.0
0.10467, 0.0
0.10533, -0.0
0.106, -0.0
0.10667, -0.0
0.10733, -0.0
0.108, -0.0
0.10867, -0.0
0.10933, -0.0
0.11, -0.0
0.11067, -0.0
0.11133, -0.0
0.112, -0.0
0.11267, -0.0
0.11333, -0.0
0.114, -0.0
0.11467, -0.0
0.11533, -0.0
0.116, -0.0
0.11667, 0.0
0.11733, 0.0
0.118, 0.0
0.11867, 1.0
0.11933, 1.0
0.12, 1.0
0.12067, 1.0
0.12133, 2.0
0.122, 2.0
0.12267, 2.0
0.12333, 2.0
0.124, 2.0
0.12467, 2.0
0.12533, 2.0
0.126, 2.0
0.12667, 2.0
0.12733, 2.0
0.128, 2.0
0.12867, 2.0
0.12933, 2.0
0.13, 2.0
0.13067, 2.0
0.13133, 2.0
0.132, 2.0
0.13267, 2.0
0.13333, 2.0
0.134, 2.0
0.13467, 2.0
0.13533, 2.0
0.136, 2.0
0.13667, 2.0
0.13733, 2.0
0.138, 3.0
0.13867, 3.0
0.13933, 3.0
0.14, 3.0
0.14067, 3.0
0.14133, 4.0
0.142, 4.0
0.14267, 4.0
0.14333, 4.0
0.144, 5.0
0.14467, 5.0
0.14533, 5.0
0.146, 5.0
0.14667, 6.0
0.14733, 6.0
0.148, 6.0
0.14867, 6.0
0.14933, 7.0
0.15, 7.0
0.15067, 7.0
0.15133, 7.0
0.152, 7.0
0.15267, 7.0
0.15333, 7.0
0.154, 7.0
0.15467, 7.0
0.15533, 7.0
0.156, 7.0
0.15667, 6.0
0.15733, 6.0
0.158, 6.0
0.15867, 6.0
0.15933, 5.0
0.16, 5.0
0.16067, 5.0
0.16133, 5.0
0.162, 5.0
0.16267, 4.0
0.16333, 4.0
0.164, 4.0
0.16467, 4.0
0.16533, 4.0
0.166, 4.0
0.16667, 4.0
0.16733, 4.0
0.168, 4.0
0.16867, 4.0
0.16933, 5.0
0.17, 5.0
0.17067, 5.0
0.17133, 4.0
0.172, 4.0
0.17267, 4.0
0.17333, 5.0
0.174, 5.0
0.17467, 5.0
0.17533, 5.0
0.176, 5.0
0.17667, 5.0
0.17733, 5.0
0.178, 5.0
0.17867, 5.0
0.17933, 5.0
0.18, 5.0
0.18067, 5.0
0.18133, 5.0
0.182, 5.0
0.18267, 5.0
0.18333, 5.0
0.184, 5.0
0.18467, 5.0
0.18533, 5.0
0.186, 5.0
0.18667, 5.0
0.18733, 5.0
0.188, 5.0
0.18867, 4.0
0.18933, 4.0
0.19, 4.0
0.19067, 4.0
0.19133, 4.0
0.192, 4.0
0.19267, 4.0
0.19333, 4.0
0.194, 4.0
0.19467, 4.0
0.19533, 5.0
0.196, 5.0
0.19667, 5.0
0.19733, 5.0
0.198, 5.0
0.19867, 6.0
0.19933, 6.0
0.2, 6.0
0.20067, 6.0
0.20133, 6.0
0.202, 7.0
0.20267, 7.0
0.20333, 7.0
0.204, 7.0
0.20467, 7.0
0.20533, 7.0
0.206, 7.0
0.20667, 7.0
0.20733, 7.0
0.208, 7.0
0.20867, 8.0
0.20933, 8.0
0.21, 8.0
0.21067, 8.0
0.21133, 8.0
0.212, 8.0
0.21267, 9.0
0.21333, 9.0
0.214, 9.0
0.21467, 9.0
0.21533, 10.0
0.216, 10.0
0.21667, 10.0
0.21733, 10.0
0.218, 11.0
0.21867, 11.0
0.21933, 11.0
0.22, 11.0
0.22067, 11.0
0.22133, 11.0
0.222, 11.0
0.22267, 11.0
0.22333, 11.0
0.224, 11.0
0.22467, 11.0
0.22533, 11.0
0.226, 11.0
0.22667, 11.0
0.22733, 11.0
0.228, 10.0
0.22867, 10.0
0.22933, 10.0
0.23, 10.0
0.23067, 10.0
0.23133, 10.0
0.232, 10.0
0.23267, 10.0
0.23333, 10.0
0.234, 10.0
0.23467, 9.0
0.23533, 9.0
0.236, 9.0
0.23667, 9.0
0.23733, 9.0
0.238, 9.0
0.23867, 9.0
0.23933, 9.0
0.24, 9.0
0.24067, 9.0
0.24133, 9.0
0.242, 9.0
0.24267, 10.0
0.24333, 10.0
0.244, 10.0
0.24467, 10.0
0.24533, 10.0
0.246, 10.0
0.24667, 10.0
0.24733, 10.0
0.248, 10.0
0.24867, 10.0
0.24933, 10.0
0.25, 11.0
0.25067, 11.0
0.25133, 11.0
0.252, 11.0
0.25267, 11.0
0.25333, 11.0
0.254, 12.0
0.25467, 12.0
0.25533, 11.0
0.256, 11.0
0.25667, 11.0
0.25733, 11.0
0.258, 11.0
0.25867, 11.0
0.25933, 11.0
0.26, 11.0
0.26067, 11.0
0.26133, 11.0
0.262, 11.0
0.26267, 11.0
0.26333, 11.0
0.264, 11.0
0.26467, 11.0
0.26533, 11.0
0.266, 11.0
0.26667, 11.0
0.26733, 11.0
0.268, 11.0
0.26867, 11.0
0.26933, 10.0
0.27, 10.0
0.27067, 10.0
0.27133, 10.0
0.272, 10.0
0.27267, 10.0
0.27333, 11.0
0.274, 11.0
0.27467, 11.0
0.27533, 11.0
0.276, 11.0
0.27667, 11.0
0.27733, 11.0
0.278, 11.0
0.27867, 11.0
0.27933, 11.0
0.28, 11.0
0.28067, 12.0
0.28133, 12.0
0.282, 12.0
0.28267, 12.0
0.28333, 13.0
0.284, 13.0
0.28467, 13.0
0.28533, 13.0
0.286, 13.0
0.28667, 14.0
0.28733, 14.0
0.288, 14.0
0.28867, 14.0
0.28933, 14.0
0.29, 14.0
0.29067, 14.0
0.29133, 13.0
0.292, 13.0
0.29267, 13.0
0.29333, 13.0
0.294, 12.0
0.29467, 12.0
0.29533, 12.0
0.296, 12.0
0.29667, 12.0
0.29733, 12.0
0.298, 12.0
0.29867, 12.0
0.29933, 12.0
0.3, 12.0
0.30067, 12.0
0.30133, 13.0
0.302, 13.0
0.30267, 13.0
0.30333, 13.0
0.304, 13.0
0.30467, 13.0
0.30533, 13.0
0.306, 13.0
0.30667, 13.0
0.30733, 13.0
0.308, 13.0
0.30867, 13.0
0.30933, 13.0
0.31, 13.0
0.31067, 12.0
0.31133, 13.0
0.312, 13.0
0.31267, 13.0
0.31333, 13.0
0.314, 13.0
0.31467, 13.0
0.31533, 13.0
0.316, 13.0
0.31667, 14.0
0.31733, 14.0
0.318, 14.0
0.31867, 14.0
0.31933, 14.0
0.32, 15.0
0.32067, 15.0
0.32133, 15.0
0.322, 15.0
0.32267, 15.0
0.32333, 15.0
0.324, 16.0
0.32467, 16.0
0.32533, 16.0
0.326, 16.0
0.32667, 16.0
0.32733, 16.0
0.328, 16.0
0.32867, 15.0
0.32933, 15.0
0.33, 15.0
0.33067, 15.0
0.33133, 15.0
0.332, 15.0
0.33267, 15.0
0.33333, 15.0
0.334, 15.0
0.33467, 14.0
0.33533, 14.0
0.336, 14.0
0.33667, 14.0
0.33733, 14.0
0.338, 13.0
0.33867, 13.0
0.33933, 13.0
0.34, 13.0
0.34067, 13.0
0.34133, 13.0
0.342, 12.0
0.34267, 12.0
0.34333, 12.0
0.344, 12.0
0.34467, 12.0
0.34533, 12.0
0.346, 12.0
0.34667, 11.0
0.34733, 12.0
0.348, 12.0
0.34867, 12.0
0.34933, 12.0
0.35, 12.0
0.35067, 12.0
0.35133, 12.0
0.352, 12.0
0.35267, 12.0
0.35333, 12.0
0.354, 13.0
0.35467, 13.0
0.35533, 13.0
0.356, 13.0
0.35667, 13.0
0.35733, 13.0
0.358, 13.0
0.35867, 14.0
0.35933, 14.0
0.36, 14.0
0.36067, 14.0
0.36133, 14.0
0.362, 14.0
0.36267, 14.0
0.36333, 14.0
0.364, 14.0
0.36467, 14.0
0.36533, 14.0
0.366, 14.0
0.36667, 14.0
0.36733, 13.0
0.368, 13.0
0.36867, 13.0
0.36933, 13.0
0.37, 13.0
0.37067, 13.0
0.37133, 13.0
0.372, 13.0
0.37267, 12.0
0.37333, 12.0
0.374, 12.0
0.37467, 12.0
0.37533, 11.0
0.376, 11.0
0.37667, 11.0
0.37733, 11.0
0.378, 11.0
0.37867, 11.0
0.37933, 11.0
0.38, 11.0
0.38067, 11.0
0.38133, 11.0
0.382, 10.0
0.38267, 10.0
0.38333, 10.0
0.384, 10.0
0.38467, 10.0
0.38533, 9.0
0.386, 9.0
0.38667, 9.0
0.38733, 9.0
0.388, 9.0
0.38867, 9.0
0.38933, 9.0
0.39, 9.0
0.39067, 9.0
0.39133, 10.0
0.392, 10.0
0.39267, 10.0
0.39333, 10.0
0.394, 10.0
0.39467, 10.0
0.39533, 10.0
0.396, 11.0
0.39667, 10.0
0.39733, 10.0
0.398, 10.0
0.39867, 10.0
0.39933, 10.0
0.4, 10.0
0.40067, 10.0
0.40133, 10.0
0.402, 10.0
0.40267, 10.0
0.40333, 10.0
0.404, 10.0
0.40467, 11.0
0.40533, 11.0
0.406, 11.0
0.40667, 11.0
0.40733, 11.0
0.408, 11.0
0.40867, 10.0
0.40933, 10.0
0.41, 10.0
0.41067, 10.0
0.41133, 10.0
0.412, 10.0
0.41267, 10.0
0.41333, 10.0
0.414, 10.0
0.41467, 10.0
0.41533, 11.0
0.416, 11.0
0.41667, 11.0
0.41733, 11.0
0.418, 11.0
0.41867, 11.0
0.41933, 11.0
0.42, 11.0
0.42067, 11.0
0.42133, 11.0
0.422, 11.0
0.42267, 12.0
0.42333, 12.0
0.424, 12.0
0.42467, 12.0
0.42533, 12.0
0.426, 13.0
0.42667, 13.0
0.42733, 13.0
0.428, 14.0
0.42867, 14.0
0.42933, 14.0
0.43, 14.0
0.43067, 14.0
0.43133, 14.0
0.432, 15.0
0.43267, 15.0
0.43333, 15.0
0.434, 15.0
0.43467, 15.0
0.43533, 15.0
0.436, 15.0
0.43667, 15.0
0.43733, 15.0
0.438, 15.0
0.43867, 15.0
0.43933, 15.0
0.44, 15.0
0.44067, 15.0
0.44133, 15.0
0.442, 15.0
0.44267, 15.0
0.44333, 15.0
0.444, 15.0
0.44467, 15.0
0.44533, 15.0
0.446, 15.0
0.44667, 15.0
0.44733, 15.0
0.448, 15.0
0.44867, 15.0
0.44933, 15.0
0.45, 15.0
0.45067, 15.0
0.45133, 15.0
0.452, 15.0
0.45267, 15.0
0.45333, 15.0
0.454, 15.0
0.45467, 15.0
0.45533, 15.0
0.456, 15.0
0.45667, 15.0
0.45733, 15.0
0.458, 15.0
0.45867, 15.0
0.45933, 15.0
0.46, 15.0
0.46067, 14.0
0.46133, 14.0
0.462, 14.0
0.46267, 14.0
0.46333, 14.0
0.464, 14.0
0.46467, 14.0
0.46533, 14.0
0.466, 14.0
0.46667, 14.0
0.46733, 13.0
0.468, 13.0
0.46867, 13.0
0.46933, 13.0
0.47, 13.0
0.47067, 13.0
0.47133, 13.0
0.472, 13.0
0.47267, 13.0
0.47333, 13.0
0.474, 13.0
0.47467, 13.0
0.47533, 13.0
0.476, 13.0
0.47667, 13.0
0.47733, 13.0
0.478, 13.0
0.47867, 14.0
0.47933, 14.0
0.48, 14.0
0.48067, 15.0
0.48133, 15.0
0.482, 15.0
0.48267, 15.0
0.48333, 16.0
0.484, 16.0
0.48467, 16.0
0.48533, 16.0
0.486, 16.0
0.48667, 16.0
0.48733, 16.0
0.488, 16.0
0.48867, 16.0
0.48933, 16.0
0.49, 16.0
0.49067, 16.0
0.49133, 16.0
0.492, 16.0
0.49267, 17.0
0.49333, 17.0
0.494, 17.0
0.49467, 17.0
0.49533, 18.0
0.496, 18.0
0.49667, 18.0
0.49733, 19.0
0.498, 19.0
0.49867, 19.0
0.49933, 20.0
0.5, 20.0
0.50067, 20.0
0.50133, 20.0
0.502, 20.0
0.50267, 20.0
0.50333, 20.0
0.504, 19.0
0.50467, 19.0
0.50533, 19.0
0.506, 18.0
0.50667, 18.0
0.50733, 18.0
0.508, 17.0
0.50867, 17.0
0.50933, 17.0
0.51, 17.0
0.51067, 16.0
0.51133, 16.0
0.512, 16.0
0.51267, 16.0
0.51333, 16.0
0.514, 16.0
0.51467, 16.0
0.51533, 16.0
0.516, 16.0
0.51667, 16.0
0.51733, 16.0
0.518, 16.0
0.51867, 16.0
0.51933, 16.0
0.52, 16.0
0.52067, 16.0
0.52133, 17.0
0.522, 17.0
0.52267, 17.0
0.52333, 17.0
0.524, 17.0
0.52467, 18.0
0.52533, 18.0
0.526, 18.0
0.52667, 19.0
0.52733, 19.0
0.528, 19.0
0.52867, 19.0
0.52933, 20.0
0.53, 20.0
0.53067, 20.0
0.53133, 20.0
0.532, 19.0
0.53267, 19.0
0.53333, 19.0
0.534, 19.0
0.53467, 19.0
0.53533, 18.0
0.536, 18.0
0.53667, 18.0
0.53733, 18.0
0.538, 18.0
0.53867, 18.0
0.53933, 18.0
0.54, 19.0
0.54067, 19.0
0.54133, 19.0
0.542, 20.0
0.54267, 20.0
0.54333, 20.0
0.544, 20.0
0.54467, 21.0
0.54533, 21.0
0.546, 21.0
0.54667, 21.0
0.54733, 21.0
0.548, 22.0
0.54867, 22.0
0.54933, 22.0
0.55, 22.0
0.55067, 22.0
0.55133, 23.0
0.552, 23.0
0.55267, 23.0
0.55333, 23.0
0.554, 23.0
0.55467, 23.0
0.55533, 23.0
0.556, 23.0
0.55667, 24.0
0.55733, 24.0
0.558, 24.0
0.55867, 24.0
0.55933, 24.0
0.56, 24.0
0.56067, 25.0
0.56133, 25.0
0.562, 25.0
0.56267, 25.0
0.56333, 26.0
0.564, 26.0
0.56467, 26.0
0.56533, 27.0
0.566, 27.0
0.56667, 27.0
0.56733, 27.0
0.568, 27.0
0.56867, 27.0
0.56933, 27.0
0.57, 28.0
0.57067, 28.0
0.57133, 28.0
0.572, 28.0
0.57267, 28.0
0.57333, 28.0
0.574, 28.0
0.57467, 28.0
0.57533, 28.0
0.576, 28.0
0.57667, 28.0
0.57733, 27.0
0.578, 27.0
0.57867, 27.0
0.57933, 27.0
0.58, 26.0
0.58067, 26.0
0.58133, 26.0
0.582, 26.0
0.58267, 25.0
0.58333, 25.0
0.584, 25.0
0.58467, 25.0
0.58533, 25.0
0.586, 25.0
0.58667, 24.0
0.58733, 24.0
0.588, 24.0
0.58867, 25.0
0.58933, 25.0
0.59, 25.0
0.59067, 25.0
0.59133, 25.0
0.592, 25.0
0.59267, 25.0
0.59333, 25.0
0.594, 25.0
0.59467, 25.0
0.59533, 25.0
0.596, 25.0
0.59667, 25.0
0.59733, 25.0
0.598, 25.0
0.59867, 25.0
0.59933, 25.0
0.6, 25.0
0.60067, 25.0
0.60133, 25.0
0.602, 25.0
0.60267, 25.0
0.60333, 25.0
0.604, 24.0
0.60467, 24.0
0.60533, 24.0
0.606, 24.0
0.60667, 24.0
0.60733, 24.0
0.608, 24.0
0.60867, 24.0
0.60933, 24.0
0.61, 24.0
0.61067, 24.0
0.61133, 24.0
0.612, 24.0
0.61267, 24.0
0.61333, 24.0
0.614, 24.0
0.61467, 24.0
0.61533, 24.0
0.616, 23.0
0.61667, 23.0
0.61733, 23.0
0.618, 23.0
0.61867, 23.0
0.61933, 23.0
0.62, 23.0
0.62067, 22.0
0.62133, 22.0
0.622, 22.0
0.62267, 22.0
0.62333, 22.0
0.624, 22.0
0.62467, 22.0
0.62533, 22.0
0.626, 21.0
0.62667, 21.0
0.62733, 21.0
0.628, 20.0
0.62867, 20.0
0.62933, 19.0
0.63, 19.0
0.63067, 18.0
0.63133, 18.0
0.632, 17.0
0.63267, 16.0
0.63333, 16.0
0.634, 15.0
0.63467, 14.0
0.63533, 13.0
0.636, 13.0
0.63667, 12.0
0.63733, 11.0
0.638, 10.0
0.63867, 9.0
0.63933, 9.0
0.64, 8.0
0.64067, 8.0
0.64133, 7.0
0.642, 7.0
0.64267, 7.0
0.64333, 6.0
0.644, 6.0
0.64467, 6.0
0.64533, 6.0
0.646, 5.0
0.64667, 5.0
0.64733, 5.0
0.648, 5.0
0.64867, 6.0
0.64933, 6.0
0.65, 6.0
0.65067, 6.0
0.65133, 5.0
0.652, 5.0
0.65267, 5.0
0.65333, 4.0
0.654, 4.0
0.65467, 3.0
0.65533, 3.0
0.656, 2.0
0.65667, 1.0
0.65733, 0.0
0.658, -0.0
0.65867, -1.0
0.65933, -2.0
0.66, -4.0
0.66067, -5.0
0.66133, -6.0
0.662, -7.0
0.66267, -9.0
0.66333, -10.0
0.664, -11.0
0.66467, -12.0
0.66533, -13.0
0.666, -14.0
0.66667, -14.0
0.66733, -15.0
0.668, -16.0
0.66867, -16.0
0.66933, -16.0
0.67, -16.0
0.67067, -16.0
0.67133, -16.0
0.672, -16.0
0.67267, -16.0
0.67333, -15.0
0.674, -15.0
0.67467, -15.0
0.67533, -14.0
0.676, -13.0
0.67667, -13.0
0.67733, -12.0
0.678, -11.0
0.67867, -11.0
0.67933, -10.0
0.68, -9.0
0.68067, -9.0
0.68133, -8.0
0.682, -8.0
0.68267, -7.0
0.68333, -7.0
0.684, -7.0
0.68467, -6.0
0.68533, -6.0
0.686, -6.0
0.68667, -6.0
0.68733, -5.0
0.688, -5.0
0.68867, -5.0
0.68933, -5.0
0.69, -5.0
0.69067, -5.0
0.69133, -5.0
0.692, -5.0
0.69267, -4.0
0.69333, -4.0
0.694, -4.0
0.69467, -4.0
0.69533, -4.0
0.696, -4.0
0.69667, -3.0
0.69733, -4.0
0.698, -4.0
0.69867, -4.0
0.69933, -4.0
0.7, -4.0
0.70067, -5.0
0.70133, -5.0
0.702, -6.0
0.70267, -6.0
0.70333, -6.0
0.704, -7.0
0.70467, -7.0
0.70533, -7.0
0.706, -7.0
0.70667, -7.0
0.70733, -7.0
0.708, -8.0
0.70867, -8.0
0.70933, -8.0
0.71, -7.0
0.71067, -7.0
0.71133, -7.0
0.712, -7.0
0.71267, -7.0
0.71333, -6.0
0.714, -6.0
0.71467, -6.0
0.71533, -6.0
0.716, -5.0
0.71667, -5.0
0.71733, -4.0
0.718, -4.0
0.71867, -4.0
0.71933, -3.0
0.72, -3.0
0.72067, -2.0
0.72133, -2.0
0.722, -2.0
0.72267, -1.0
0.72333, -1.0
0.724, -1.0
0.72467, -1.0
0.72533, -1.0
0.726, -1.0
0.72667, -1.0
0.72733, -1.0
0.728, -1.0
0.72867, -1.0
0.72933, -1.0
0.73, -1.0
0.73067, -1.0
0.73133, -1.0
0.732, -1.0
0.73267, -1.0
0.73333, -1.0
0.734, -1.0
0.73467, -1.0
0.73533, -1.0
0.736, -1.0
0.73667, -1.0
0.73733, -1.0
0.738, -1.0
0.73867, -1.0
0.73933, -1.0
0.74, -1.0
0.74067, -1.0
0.74133, -1.0
0.742, -1.0
0.74267, -1.0
0.74333, -0.0
0.744, -0.0
0.74467, 0.0
0.74533, 0.0
0.746, 1.0
0.74667, 1.0
0.74733, 1.0
0.748, 2.0
0.74867, 2.0
0.74933, 2.0
0.75, 3.0
0.75067, 3.0
0.75133, 4.0
0.752, 4.0
0.75267, 4.0
0.75333, 5.0
0.754, 5.0
0.75467, 5.0
0.75533, 5.0
0.756, 6.0
0.75667, 6.0
0.75733, 6.0
0.758, 6.0
0.75867, 6.0
0.75933, 6.0
0.76, 6.0
0.76067, 6.0
0.76133, 6.0
0.762, 6.0
0.76267, 6.0
0.76333, 6.0
0.764, 6.0
0.76467, 6.0
0.76533, 6.0
0.766, 6.0
0.76667, 6.0
0.76733, 6.0
0.768, 6.0
0.76867, 6.0
0.76933, 6.0
0.77, 7.0
0.77067, 7.0
0.77133, 7.0
0.772, 7.0
0.77267, 8.0
0.77333, 8.0
0.774, 9.0
0.77467, 10.0
0.77533, 10.0
0.776, 11.0
0.77667, 11.0
0.77733, 12.0
0.778, 12.0
0.77867, 13.0
0.77933, 13.0
0.78, 14.0
0.78067, 14.0
0.78133, 15.0
0.782, 15.0
0.78267, 16.0
0.78333, 16.0
0.784, 17.0
0.78467, 17.0
0.78533, 18.0
0.786, 18.0
0.78667, 18.0
0.78733, 19.0
0.788, 19.0
0.78867, 19.0
0.78933, 20.0
0.79, 20.0
0.79067, 20.0
0.79133, 21.0
0.792, 21.0
0.79267, 21.0
0.79333, 21.0
0.794, 21.0
0.79467, 21.0
0.79533, 21.0
0.796, 21.0
0.79667, 21.0
0.79733, 21.0
0.798, 20.0
0.79867, 20.0
0.79933, 20.0
0.8, 20.0
0.80067, 20.0
0.80133, 20.0
0.802, 20.0
0.80267, 20.0
0.80333, 20.0
0.804, 20.0
0.80467, 20.0
0.80533, 21.0
0.806, 21.0
0.80667, 21.0
0.80733, 21.0
0.808, 21.0
0.80867, 22.0
0.80933, 22.0
0.81, 22.0
0.81067, 22.0
0.81133, 22.0
0.812, 23.0
0.81267, 23.0
0.81333, 23.0
0.814, 24.0
0.81467, 24.0
0.81533, 24.0
0.816, 25.0
0.81667, 25.0
0.81733, 26.0
0.818, 26.0
0.81867, 26.0
0.81933, 26.0
0.82, 27.0
0.82067, 27.0
0.82133, 26.0
0.822, 26.0
0.82267, 26.0
0.82333, 26.0
0.824, 26.0
0.82467, 26.0
0.82533, 26.0
0.826, 26.0
0.82667, 26.0
0.82733, 26.0
0.828, 26.0
0.82867, 26.0
0.82933, 26.0
0.83, 26.0
0.83067, 26.0
0.83133, 26.0
0.832, 26.0
0.83267, 26.0
0.83333, 26.0
0.834, 26.0
0.83467, 26.0
0.83533, 26.0
0.836, 26.0
0.83667, 26.0
0.83733, 26.0
0.838, 26.0
0.83867, 26.0
0.83933, 26.0
0.84, 27.0
0.84067, 27.0
0.84133, 27.0
0.842, 27.0
0.84267, 28.0
0.84333, 28.0
0.844, 28.0
0.84467, 29.0
0.84533, 29.0
0.846, 29.0
0.84667, 29.0
0.84733, 29.0
0.848, 30.0
0.84867, 30.0
0.84933, 30.0
0.85, 30.0
0.85067, 30.0
0.85133, 30.0
0.852, 30.0
0.85267, 30.0
0.85333, 30.0
0.854, 30.0
0.85467, 30.0
0.85533, 30.0
0.856, 30.0
0.85667, 30.0
0.85733, 30.0
0.858, 31.0
0.85867, 31.0
0.85933, 31.0
0.86, 31.0
0.86067, 31.0
0.86133, 31.0
0.862, 31.0
0.86267, 31.0
0.86333, 31.0
0.864, 31.0
0.86467, 31.0
0.86533, 31.0
0.866, 31.0
0.86667, 31.0
0.86733, 31.0
0.868, 30.0
0.86867, 30.0
0.86933, 30.0
0.87, 29.0
0.87067, 29.0
0.87133, 29.0
0.872, 29.0
0.87267, 29.0
0.87333, 29.0
0.874, 29.0
0.87467, 29.0
0.87533, 29.0
0.876, 29.0
0.87667, 29.0
0.87733, 30.0
0.878, 30.0
0.87867, 30.0
0.87933, 30.0
0.88, 30.0
0.88067, 30.0
0.88133, 31.0
0.882, 31.0
0.88267, 31.0
0.88333, 31.0
0.884, 31.0
0.88467, 31.0
0.88533, 31.0
0.886, 31.0
0.88667, 31.0
0.88733, 31.0
0.888, 31.0
0.88867, 30.0
0.88933, 30.0
0.89, 30.0
0.89067, 30.0
0.89133, 30.0
0.892, 31.0
0.89267, 31.0
0.89333, 31.0
0.894, 31.0
0.89467, 31.0
0.89533, 31.0
0.896, 31.0
0.89667, 31.0
0.89733, 31.0
0.898, 31.0
0.89867, 32.0
0.89933, 32.0
0.9, 32.0
0.90067, 32.0
0.90133, 32.0
0.902, 32.0
0.90267, 32.0
0.90333, 32.0
0.904, 32.0
0.90467, 32.0
0.90533, 32.0
0.906, 32.0
0.90667, 32.0
0.90733, 32.0
0.908, 32.0
0.90867, 32.0
0.90933, 32.0
0.91, 32.0
0.91067, 32.0
0.91133, 31.0
0.912, 31.0
0.91267, 31.0
0.91333, 31.0
0.914, 31.0
0.91467, 31.0
0.91533, 31.0
0.916, 30.0
0.91667, 31.0
0.91733, 31.0
0.918, 31.0
0.91867, 31.0
0.91933, 31.0
0.92, 31.0
0.92067, 31.0
0.92133, 32.0
0.922, 32.0
0.92267, 32.0
0.92333, 32.0
0.924, 32.0
0.92467, 33.0
0.92533, 33.0
0.926, 33.0
0.92667, 33.0
0.92733, 33.0
0.928, 33.0
0.92867, 33.0
0.92933, 33.0
0.93, 33.0
0.93067, 33.0
0.93133, 33.0
0.932, 33.0
0.93267, 33.0
0.93333, 33.0
0.934, 33.0
0.93467, 32.0
0.93533, 32.0
0.936, 32.0
0.93667, 32.0
0.93733, 32.0
0.938, 32.0
0.93867, 31.0
0.93933, 31.0
0.94, 31.0
0.94067, 31.0
0.94133, 31.0
0.942, 31.0
0.94267, 31.0
0.94333, 31.0
0.944, 31.0
0.94467, 31.0
0.94533, 32.0
0.946, 32.0
0.94667, 32.0
0.94733, 32.0
0.948, 32.0
0.94867, 32.0
0.94933, 32.0
0.95, 33.0
0.95067, 33.0
0.95133, 33.0
0.952, 33.0
0.95267, 33.0
0.95333, 34.0
0.954, 34.0
0.95467, 34.0
0.95533, 34.0
0.956, 35.0
0.95667, 35.0
0.95733, 35.0
0.958, 35.0
0.95867, 35.0
0.95933, 35.0
0.96, 35.0
0.96067, 35.0
0.96133, 35.0
0.962, 34.0
0.96267, 34.0
0.96333, 34.0
0.964, 34.0
0.96467, 34.0
0.96533, 34.0
0.966, 34.0
0.96667, 35.0
0.96733, 35.0
0.968, 35.0
0.96867, 35.0
0.96933, 35.0
0.97, 35.0
0.97067, 35.0
0.97133, 35.0
0.972, 35.0
0.97267, 35.0
0.97333, 35.0
0.974, 35.0
0.97467, 35.0
0.97533, 35.0
0.976, 35.0
0.97667, 35.0
0.97733, 35.0
0.978, 35.0
0.97867, 35.0
0.97933, 35.0
0.98, 35.0
0.98067, 35.0
0.98133, 35.0
0.982, 35.0
0.98267, 35.0
0.98333, 35.0
0.984, 35.0
0.98467, 35.0
0.98533, 35.0
0.986, 35.0
0.98667, 35.0
0.98733, 35.0
0.988, 34.0
0.98867, 34.0
0.98933, 34.0
0.99, 33.0
0.99067, 33.0
0.99133, 33.0
0.992, 32.0
0.99267, 32.0
0.99333, 32.0
0.994, 32.0
0.99467, 31.0
0.99533, 31.0
0.996, 31.0
0.99667, 31.0
0.99733, 31.0
0.998, 31.0
0.99867, 31.0
0.99933, 31.0
1.0, 31.0
1.00067, 31.0
1.00133, 31.0
1.002, 31.0
1.00267, 31.0
1.00333, 31.0
1.004, 31.0
1.00467, 31.0
1.00533, 31.0
1.006, 31.0
1.00667, 31.0
1.00733, 30.0
1.008, 30.0
1.00867, 30.0
1.00933, 30.0
1.01, 29.0
1.01067, 29.0
1.01133, 29.0
1.012, 29.0
1.01267, 28.0
1.01333, 28.0
1.014, 28.0
1.01467, 28.0
1.01533, 28.0
1.016, 28.0
1.01667, 28.0
1.01733, 28.0
1.018, 29.0
1.01867, 29.0
1.01933, 30.0
1.02, 31.0
1.02067, 31.0
1.02133, 32.0
1.022, 33.0
1.02267, 34.0
1.02333, 35.0
1.024, 36.0
1.02467, 37.0
1.02533, 37.0
1.026, 38.0
1.02667, 39.0
1.02733, 40.0
1.028, 41.0
1.02867, 41.0
1.02933, 42.0
1.03, 42.0
1.03067, 43.0
1.03133, 43.0
1.032, 43.0
1.03267, 43.0
1.03333, 43.0
1.034, 43.0
1.03467, 43.0
1.03533, 43.0
1.036, 43.0
1.03667, 43.0
1.03733, 42.0
1.038, 42.0
1.03867, 42.0
1.03933, 41.0
1.04, 41.0
1.04067, 41.0
1.04133, 41.0
1.042, 42.0
1.04267, 42.0
1.04333, 42.0
1.044, 43.0
1.04467, 44.0
1.04533, 45.0
1.046, 46.0
1.04667, 47.0
1.04733, 48.0
1.048, 50.0
1.04867, 51.0
1.04933, 53.0
1.05, 55.0
1.05067, 56.0
1.05133, 58.0
1.052, 60.0
1.05267, 62.0
1.05333, 63.0
1.054, 65.0
1.05467, 67.0
1.05533, 68.0
1.056, 70.0
1.05667, 71.0
1.05733, 73.0
1.058, 74.0
1.05867, 75.0
1.05933, 76.0
1.06, 77.0
1.06067, 78.0
1.06133, 78.0
1.062, 78.0
1.06267, 78.0
1.06333, 78.0
1.064, 78.0
1.06467, 78.0
1.06533, 78.0
1.066, 77.0
1.06667, 77.0
1.06733, 76.0
1.068, 75.0
1.06867, 74.0
1.06933, 73.0
1.07, 72.0
1.07067, 72.0
1.07133, 71.0
1.072, 70.0
1.07267, 69.0
1.07333, 68.0
1.074, 68.0
1.07467, 67.0
1.07533, 66.0
1.076, 66.0
1.07667, 65.0
1.07733, 64.0
1.078, 64.0
1.07867, 63.0
1.07933, 63.0
1.08, 62.0
1.08067, 62.0
1.08133, 61.0
1.082, 60.0
1.08267, 59.0
1.08333, 58.0
1.084, 58.0
1.08467, 57.0
1.08533, 56.0
1.086, 55.0
1.08667, 55.0
1.08733, 54.0
1.088, 54.0
1.08867, 53.0
1.08933, 53.0
1.09, 52.0
1.09067, 52.0
1.09133, 51.0
1.092, 51.0
1.09267, 50.0
1.09333, 50.0
1.094, 49.0
1.09467, 49.0
1.09533, 48.0
1.096, 47.0
1.09667, 47.0
1.09733, 46.0
1.098, 45.0
1.09867, 45.0
1.09933, 44.0
1.1, 43.0
1.10067, 43.0
1.10133, 42.0
1.102, 42.0
1.10267, 41.0
1.10333, 41.0
1.104, 40.0
1.10467, 40.0
1.10533, 39.0
1.106, 39.0
1.10667, 39.0
1.10733, 38.0
1.108, 38.0
1.10867, 37.0
1.10933, 37.0
1.11, 36.0
1.11067, 36.0
1.11133, 35.0
1.112, 35.0
1.11267, 34.0
1.11333, 34.0
1.114, 33.0
1.11467, 33.0
1.11533, 33.0
1.116, 32.0
1.11667, 32.0
1.11733, 31.0
1.118, 31.0
1.11867, 31.0
1.11933, 30.0
1.12, 30.0
1.12067, 30.0
1.12133, 30.0
1.122, 30.0
1.12267, 30.0
1.12333, 29.0
1.124, 29.0
1.12467, 29.0
1.12533, 30.0
1.126, 30.0
1.12667, 30.0
1.12733, 30.0
1.128, 29.0
1.12867, 29.0
1.12933, 29.0
1.13, 29.0
1.13067, 29.0
1.13133, 29.0
1.132, 28.0
1.13267, 28.0
1.13333, 28.0
1.134, 28.0
1.13467, 28.0
1.13533, 28.0
1.136, 28.0
1.13667, 27.0
1.13733, 27.0
1.138, 27.0
1.13867, 27.0
1.13933, 27.0
1.14, 27.0
1.14067, 27.0
1.14133, 26.0
1.142, 26.0
1.14267, 26.0
1.14333, 26.0
1.144, 25.0
1.14467, 25.0
1.14533, 25.0
1.146, 24.0
1.14667, 24.0
1.14733, 24.0
1.148, 23.0
1.14867, 23.0
1.14933, 23.0
1.15, 22.0
1.15067, 22.0
1.15133, 22.0
1.152, 22.0
1.15267, 22.0
1.15333, 21.0
1.154, 21.0
1.15467, 21.0
1.15533, 21.0
1.156, 21.0
1.15667, 21.0
1.15733, 20.0
1.158, 20.0
1.15867, 20.0
1.15933, 20.0
1.16, 20.0
1.16067, 20.0
1.16133, 20.0
1.162, 20.0
1.16267, 21.0
1.16333, 21.0
1.164, 21.0
1.16467, 21.0
1.16533, 21.0
1.166, 21.0
1.16667, 21.0
1.16733, 21.0
1.168, 21.0
1.16867, 21.0
1.16933, 21.0
1.17, 20.0
1.17067, 20.0
1.17133, 20.0
1.172, 19.0
1.17267, 19.0
1.17333, 19.0
1.174, 18.0
1.17467, 18.0
1.17533, 17.0
1.176, 17.0
1.17667, 17.0
1.17733, 16.0
1.178, 16.0
1.17867, 16.0
1.17933, 16.0
1.18, 15.0
1.18067, 15.0
1.18133, 15.0
1.182, 15.0
1.18267, 15.0
1.18333, 16.0
1.184, 16.0
1.18467, 16.0
1.18533, 16.0
1.186, 16.0
1.18667, 16.0
1.18733, 16.0
1.188, 16.0
1.18867, 16.0
1.18933, 16.0
1.19, 16.0
1.19067, 16.0
1.19133, 16.0
1.192, 15.0
1.19267, 15.0
1.19333, 15.0
1.194, 15.0
1.19467, 15.0
1.19533, 15.0
1.196, 15.0
1.19667, 15.0
1.19733, 15.0
1.198, 15.0
1.19867, 15.0
1.19933, 15.0
1.2, 15.0
1.20067, 15.0
1.20133, 15.0
1.202, 15.0
1.20267, 15.0
1.20333, 15.0
1.204, 15.0
1.20467, 15.0
1.20533, 15.0
1.206, 15.0
1.20667, 14.0
1.20733, 14.0
1.208, 14.0
1.20867, 14.0
1.20933, 14.0
1.21, 14.0
1.21067, 14.0
1.21133, 14.0
1.212, 14.0
1.21267, 14.0
1.21333, 13.0
1.214, 13.0
1.21467, 13.0
1.21533, 12.0
1.216, 12.0
1.21667, 12.0
1.21733, 12.0
1.218, 12.0
1.21867, 11.0
1.21933, 11.0
1.22, 11.0
1.22067, 11.0
1.22133, 11.0
1.222, 11.0
1.22267, 11.0
1.22333, 11.0
1.224, 11.0
1.22467, 11.0
1.22533, 11.0
1.226, 11.0
1.22667, 11.0
1.22733, 11.0
1.228, 11.0
1.22867, 11.0
1.22933, 11.0
1.23, 11.0
1.23067, 10.0
1.23133, 10.0
1.232, 10.0
1.23267, 10.0
1.23333, 10.0
1.234, 10.0
1.23467, 10.0
1.23533, 10.0
1.236, 9.0
1.23667, 9.0
1.23733, 9.0
1.238, 9.0
1.23867, 9.0
1.23933, 8.0
1.24, 8.0
1.24067, 8.0
1.24133, 8.0
1.242, 8.0
1.24267, 8.0
1.24333, 8.0
1.244, 8.0
1.24467, 8.0
1.24533, 8.0
1.246, 8.0
1.24667, 8.0
1.24733, 8.0
1.248, 8.0
1.24867, 8.0
1.24933, 8.0
1.25, 8.0
1.25067, 7.0
1.25133, 7.0
1.252, 7.0
1.25267, 7.0
1.25333, 6.0
1.254, 6.0
1.25467, 6.0
1.25533, 5.0
1.256, 5.0
1.25667, 5.0
1.25733, 4.0
1.258, 4.0
1.25867, 4.0
1.25933, 4.0
1.26, 4.0
1.26067, 4.0
1.26133, 4.0
1.262, 3.0
1.26267, 3.0
1.26333, 3.0
1.264, 3.0
1.26467, 3.0
1.26533, 3.0
1.266, 3.0
1.26667, 3.0
1.26733, 3.0
1.268, 3.0
1.26867, 3.0
1.26933, 2.0
1.27, 2.0
1.27067, 2.0
1.27133, 2.0
1.272, 2.0
1.27267, 2.0
1.27333, 2.0
1.274, 2.0
1.27467, 2.0
1.27533, 2.0
1.276, 2.0
1.27667, 2.0
1.27733, 2.0
1.278, 2.0
1.27867, 2.0
1.27933, 2.0
1.28, 1.0
1.28067, 1.0
1.28133, 1.0
1.282, 1.0
1.28267, 0.0
1.28333, 0.0
1.284, -0.0
1.28467, -1.0
1.28533, -1.0
1.286, -1.0
1.28667, -1.0
1.28733, -1.0
1.288, -2.0
1.28867, -2.0
1.28933, -2.0
1.29, -2.0
1.29067, -2.0
1.29133, -3.0
1.292, -3.0
1.29267, -3.0
1.29333, -4.0
1.294, -4.0
1.29467, -4.0
1.29533, -4.0
1.296, -4.0
1.29667, -4.0
1.29733, -4.0
1.298, -4.0
1.29867, -4.0
1.29933, -4.0
1.3, -4.0
1.30067, -4.0
1.30133, -4.0
1.302, -4.0
1.30267, -4.0
1.30333, -4.0
1.304, -4.0
1.30467, -4.0
1.30533, -4.0
1.306, -4.0
1.30667, -4.0
1.30733, -5.0
1.308, -5.0
1.30867, -5.0
1.30933, -5.0
1.31, -5.0
1.31067, -5.0
1.31133, -5.0
1.312, -5.0
1.31267, -5.0
1.31333, -6.0
1.314, -6.0
1.31467, -6.0
1.31533, -6.0
1.316, -7.0
1.31667, -7.0
1.31733, -7.0
1.318, -7.0
1.31867, -8.0
1.31933, -8.0
1.32, -8.0
1.32067, -8.0
1.32133, -8.0
1.322, -8.0
1.32267, -8.0
1.32333, -8.0
1.324, -7.0
1.32467, -7.0
1.32533, -7.0
1.326, -7.0
1.32667, -7.0
1.32733, -7.0
1.328, -7.0
1.32867, -7.0
1.32933, -7.0
1.33, -7.0
1.33067, -7.0
1.33133, -6.0
1.332, -6.0
1.33267, -6.0
1.33333, -6.0
1.334, -6.0
1.33467, -6.0
1.33533, -6.0
1.336, -6.0
1.33667, -6.0
1.33733, -6.0
1.338, -7.0
1.33867, -7.0
1.33933, -7.0
1.34, -7.0
1.34067, -7.0
1.34133, -7.0
1.342, -7.0
1.34267, -7.0
1.34333, -7.0
1.344, -7.0
1.34467, -8.0
1.34533, -8.0
1.346, -8.0
1.34667, -8.0
1.34733, -8.0
1.348, -8.0
1.34867, -8.0
1.34933, -8.0
1.35, -8.0
1.35067, -8.0
1.35133, -8.0
1.352, -8.0
1.35267, -8.0
1.35333, -8.0
1.354, -8.0
1.35467, -8.0
1.35533, -8.0
1.356, -8.0
1.35667, -8.0
1.35733, -8.0
1.358, -8.0
1.35867, -8.0
1.35933, -8.0
1.36, -8.0
1.36067, -8.0
1.36133, -8.0
1.362, -8.0
1.36267, -8.0
1.36333, -8.0
1.364, -8.0
1.36467, -8.0
1.36533, -8.0
1.366, -8.0
1.36667, -8.0
1.36733, -8.0
1.368, -8.0
1.36867, -9.0
1.36933, -9.0
1.37, -9.0
1.37067, -9.0
1.37133, -10.0
1.372, -10.0
1.37267, -10.0
1.37333, -11.0
1.374, -11.0
1.37467, -12.0
1.37533, -12.0
1.376, -13.0
1.37667, -13.0
1.37733, -14.0
1.378, -14.0
1.37867, -14.0
1.37933, -15.0
1.38, -15.0
1.38067, -15.0
1.38133, -16.0
1.382, -16.0
1.38267, -16.0
1.38333, -16.0
1.384, -16.0
1.38467, -16.0
1.38533, -16.0
1.386, -16.0
1.38667, -16.0
1.38733, -16.0
1.388, -16.0
1.38867, -16.0
1.38933, -16.0
1.39, -16.0
1.39067, -16.0
1.39133, -16.0
1.392, -16.0
1.39267, -15.0
1.39333, -15.0
1.394, -15.0
1.39467, -15.0
1.39533, -16.0
1.396, -16.0
1.39667, -16.0
1.39733, -16.0
1.398, -17.0
1.39867, -17.0
1.39933, -17.0
1.4, -18.0
1.40067, -18.0
1.40133, -18.0
1.402, -19.0
1.40267, -19.0
1.40333, -19.0
1.404, -20.0
1.40467, -20.0
1.40533, -21.0
1.406, -21.0
1.40667, -22.0
1.40733, -22.0
1.408, -22.0
1.40867, -23.0
1.40933, -23.0
1.41, -23.0
1.41067, -24.0
1.41133, -24.0
1.412, -24.0
1.41267, -24.0
1.41333, -24.0
1.414, -24.0
1.41467, -25.0
1.41533, -25.0
1.416, -25.0
1.41667, -25.0
1.41733, -25.0
1.418, -25.0
1.41867, -25.0
1.41933, -24.0
1.42, -24.0
1.42067, -24.0
1.42133, -24.0
1.422, -24.0
1.42267, -24.0
1.42333, -23.0
1.424, -23.0
1.42467, -23.0
1.42533, -23.0
1.426, -22.0
1.42667, -22.0
1.42733, -22.0
1.428, -22.0
1.42867, -21.0
1.42933, -21.0
1.43, -21.0
1.43067, -21.0
1.43133, -21.0
1.432, -21.0
1.43267, -21.0
1.43333, -22.0
1.434, -22.0
1.43467, -22.0
1.43533, -23.0
1.436, -23.0
1.43667, -24.0
1.43733, -24.0
1.438, -24.0
1.43867, -25.0
1.43933, -25.0
1.44, -25.0
1.44067, -25.0
1.44133, -26.0
1.442, -26.0
1.44267, -26.0
1.44333, -26.0
1.444, -26.0
1.44467, -26.0
1.44533, -25.0
1.446, -25.0
1.44667, -25.0
1.44733, -25.0
1.448, -25.0
1.44867, -25.0
1.44933, -25.0
1.45, -25.0
1.45067, -25.0
1.45133, -25.0
1.452, -25.0
1.45267, -25.0
1.45333, -25.0
1.454, -25.0
1.45467, -25.0
1.45533, -25.0
1.456, -25.0
1.45667, -25.0
1.45733, -26.0
1.458, -26.0
1.45867, -26.0
1.45933, -26.0
1.46, -26.0
1.46067, -26.0
1.46133, -26.0
1.462, -26.0
1.46267, -27.0
1.46333, -27.0
1.464, -28.0
1.46467, -28.0
1.46533, -28.0
1.466, -29.0
1.46667, -29.0
1.46733, -29.0
1.468, -29.0
1.46867, -30.0
1.46933, -30.0
1.47, -30.0
1.47067, -30.0
1.47133, -30.0
1.472, -30.0
1.47267, -30.0
1.47333, -30.0
1.474, -30.0
1.47467, -30.0
1.47533, -30.0
1.476, -30.0
1.47667, -30.0
1.47733, -30.0
1.478, -30.0
1.47867, -30.0
1.47933, -30.0
1.48, -30.0
1.48067, -30.0
1.48133, -30.0
1.482, -30.0
1.48267, -29.0
1.48333, -29.0
1.484, -29.0
1.48467, -29.0
1.48533, -29.0
1.486, -29.0
1.48667, -29.0
1.48733, -29.0
1.488, -29.0
1.48867, -29.0
1.48933, -29.0
1.49, -29.0
1.49067, -29.0
1.49133, -29.0
1.492, -29.0
1.49267, -29.0
1.49333, -29.0
1.494, -30.0
1.49467, -30.0
1.49533, -30.0
1.496, -30.0
1.49667, -31.0
1.49733, -31.0
1.498, -31.0
1.49867, -31.0
1.49933, -31.0
1.5, -31.0
1.50067, -31.0
1.50133, -31.0
1.502, -31.0
1.50267, -31.0
1.50333, -31.0
1.504, -31.0
1.50467, -31.0
1.50533, -31.0
1.506, -31.0
1.50667, -30.0
1.50733, -31.0
1.508, -31.0
1.50867, -31.0
1.50933, -31.0
1.51, -31.0
1.51067, -31.0
1.51133, -31.0
1.512, -31.0
1.51267, -31.0
1.51333, -31.0
1.514, -32.0
1.51467, -32.0
1.51533, -32.0
1.516, -32.0
1.51667, -33.0
1.51733, -33.0
1.518, -33.0
1.51867, -33.0
1.51933, -33.0
1.52, -34.0
1.52067, -34.0
1.52133, -34.0
1.522, -34.0
1.52267, -34.0
1.52333, -35.0
1.524, -35.0
1.52467, -35.0
1.52533, -34.0
1.526, -34.0
1.52667, -35.0
1.52733, -35.0
1.528, -35.0
1.52867, -35.0
1.52933, -35.0
1.53, -35.0
1.53067, -35.0
1.53133, -36.0
1.532, -36.0
1.53267, -36.0
1.53333, -36.0
1.534, -36.0
1.53467, -36.0
1.53533, -36.0
1.536, -36.0
1.53667, -37.0
1.53733, -37.0
1.538, -37.0
1.53867, -37.0
1.53933, -37.0
1.54, -37.0
1.54067, -38.0
1.54133, -38.0
1.542, -38.0
1.54267, -38.0
1.54333, -38.0
1.544, -38.0
1.54467, -38.0
1.54533, -38.0
1.546, -38.0
1.54667, -38.0
1.54733, -38.0
1.548, -38.0
1.54867, -38.0
1.54933, -38.0
1.55, -38.0
1.55067, -38.0
1.55133, -38.0
1.552, -38.0
1.55267, -38.0
1.55333, -38.0
1.554, -38.0
1.55467, -38.0
1.55533, -38.0
1.556, -38.0
1.55667, -38.0
1.55733, -38.0
1.558, -38.0
1.55867, -38.0
1.55933, -38.0
1.56, -38.0
1.56067, -38.0
1.56133, -38.0
1.562, -38.0
1.56267, -38.0
1.56333, -39.0
1.564, -39.0
1.56467, -39.0
1.56533, -39.0
1.566, -39.0
1.56667, -39.0
1.56733, -39.0
1.568, -39.0
1.56867, -39.0
1.56933, -39.0
1.57, -39.0
1.57067, -39.0
1.57133, -39.0
1.572, -39.0
1.57267, -39.0
1.57333, -39.0
1.574, -39.0
1.57467, -39.0
1.57533, -39.0
1.576, -39.0
1.57667, -39.0
1.57733, -40.0
1.578, -40.0
1.57867, -40.0
1.57933, -40.0
1.58, -40.0
1.58067, -40.0
1.58133, -40.0
1.582, -40.0
1.58267, -40.0
1.58333, -40.0
1.584, -40.0
1.58467, -40.0
1.58533, -39.0
1.586, -39.0
1.58667, -39.0
1.58733, -39.0
1.588, -39.0
1.58867, -39.0
1.58933, -39.0
1.59, -38.0
1.59067, -38.0
1.59133, -38.0
1.592, -38.0
1.59267, -38.0
1.59333, -38.0
1.594, -38.0
1.59467, -38.0
1.59533, -38.0
1.596, -38.0
1.59667, -38.0
1.59733, -38.0
1.598, -38.0
1.59867, -38.0
1.59933, -38.0
1.6, -38.0
1.60067, -38.0
1.60133, -38.0
1.602, -38.0
1.60267, -38.0
1.60333, -38.0
1.604, -38.0
1.60467, -38.0
1.60533, -38.0
1.606, -38.0
1.60667, -38.0
1.60733, -38.0
1.608, -38.0
1.60867, -39.0
1.60933, -39.0
1.61, -39.0
1.61067, -39.0
1.61133, -39.0
1.612, -39.0
1.61267, -40.0
1.61333, -40.0
1.614, -40.0
1.61467, -40.0
1.61533, -41.0
1.616, -41.0
1.61667, -41.0
1.61733, -41.0
1.618, -41.0
1.61867, -42.0
1.61933, -42.0
1.62, -42.0
1.62067, -42.0
1.62133, -42.0
1.622, -42.0
1.62267, -42.0
1.62333, -42.0
1.624, -42.0
1.62467, -42.0
1.62533, -42.0
1.626, -43.0
1.62667, -43.0
1.62733, -43.0
1.628, -44.0
1.62867, -44.0
1.62933, -45.0
1.63, -45.0
1.63067, -45.0
1.63133, -45.0
1.632, -46.0
1.63267, -46.0
1.63333, -46.0
1.634, -46.0
1.63467, -46.0
1.63533, -46.0
1.636, -46.0
1.63667, -46.0
1.63733, -46.0
1.638, -46.0
1.63867, -46.0
1.63933, -46.0
1.64, -46.0
1.64067, -46.0
1.64133, -46.0
1.642, -46.0
1.64267, -47.0
1.64333, -47.0
1.644, -47.0
1.64467, -47.0
1.64533, -47.0
1.646, -47.0
1.64667, -48.0
1.64733, -48.0
1.648, -48.0
1.64867, -48.0
1.64933, -48.0
1.65, -48.0
1.65067, -48.0
1.65133, -48.0
1.652, -48.0
1.65267, -48.0
1.65333, -48.0
1.654, -48.0
1.65467, -48.0
1.65533, -48.0
1.656, -48.0
1.65667, -48.0
1.65733, -48.0
1.658, -48.0
1.65867, -48.0
1.65933, -48.0
1.66, -49.0
1.66067, -49.0
1.66133, -49.0
1.662, -49.0
1.66267, -49.0
1.66333, -49.0
1.664, -49.0
1.66467, -49.0
1.66533, -49.0
1.666, -49.0
1.66667, -49.0
1.66733, -49.0
1.668, -48.0
1.66867, -48.0
1.66933, -48.0
1.67, -48.0
1.67067, -47.0
1.67133, -47.0
1.672, -47.0
1.67267, -47.0
1.67333, -47.0
1.674, -47.0
1.67467, -47.0
1.67533, -47.0
1.676, -47.0
1.67667, -47.0
1.67733, -47.0
1.678, -47.0
1.67867, -47.0
1.67933, -47.0
1.68, -48.0
1.68067, -48.0
1.68133, -48.0
1.682, -48.0
1.68267, -49.0
1.68333, -49.0
1.684, -49.0
1.68467, -50.0
1.68533, -50.0
1.686, -50.0
1.68667, -50.0
1.68733, -51.0
1.688, -51.0
1.68867, -51.0
1.68933, -51.0
1.69, -51.0
1.69067, -51.0
1.69133, -52.0
1.692, -52.0
1.69267, -52.0
1.69333, -52.0
1.694, -53.0
1.69467, -53.0
1.69533, -53.0
1.696, -53.0
1.69667, -54.0
1.69733, -54.0
1.698, -54.0
1.69867, -54.0
1.69933, -55.0
1.7, -55.0
1.70067, -55.0
1.70133, -55.0
1.702, -56.0
1.70267, -56.0
1.70333, -56.0
1.704, -56.0
1.70467, -57.0
1.70533, -57.0
1.706, -57.0
1.70667, -57.0
1.70733, -57.0
1.708, -57.0
1.70867, -57.0
1.70933, -57.0
1.71, -57.0
1.71067, -57.0
1.71133, -57.0
1.712, -58.0
1.71267, -58.0
1.71333, -58.0
1.714, -58.0
1.71467, -58.0
1.71533, -58.0
1.716, -58.0
1.71667, -58.0
1.71733, -59.0
1.718, -59.0
1.71867, -58.0
1.71933, -58.0
1.72, -58.0
1.72067, -58.0
1.72133, -58.0
1.722, -58.0
1.72267, -58.0
1.72333, -58.0
1.724, -58.0
1.72467, -58.0
1.72533, -58.0
1.726, -58.0
1.72667, -58.0
1.72733, -58.0
1.728, -58.0
1.72867, -58.0
1.72933, -58.0
1.73, -59.0
1.73067, -59.0
1.73133, -59.0
1.732, -59.0
1.73267, -60.0
1.73333, -60.0
1.734, -60.0
1.73467, -61.0
1.73533, -61.0
1.736, -61.0
1.73667, -61.0
1.73733, -62.0
1.738, -62.0
1.73867, -62.0
1.73933, -62.0
1.74, -62.0
1.74067, -62.0
1.74133, -62.0
1.742, -62.0
1.74267, -62.0
1.74333, -62.0
1.744, -62.0
1.74467, -62.0
1.74533, -63.0
1.746, -63.0
1.74667, -63.0
1.74733, -63.0
1.748, -63.0
1.74867, -63.0
1.74933, -63.0
1.75, -63.0
1.75067, -63.0
1.75133, -63.0
1.752, -64.0
1.75267, -64.0
1.75333, -64.0
1.754, -64.0
1.75467, -64.0
1.75533, -64.0
1.756, -64.0
1.75667, -64.0
1.75733, -63.0
1.758, -63.0
1.75867, -63.0
1.75933, -63.0
1.76, -63.0
1.76067, -63.0
1.76133, -63.0
1.762, -63.0
1.76267, -62.0
1.76333, -62.0
1.764, -62.0
1.76467, -62.0
1.76533, -62.0
1.766, -62.0
1.76667, -62.0
1.76733, -62.0
1.768, -62.0
1.76867, -62.0
1.76933, -62.0
1.77, -62.0
1.77067, -62.0
1.77133, -62.0
1.772, -62.0
1.77267, -62.0
1.77333, -63.0
1.774, -63.0
1.77467, -63.0
1.77533, -63.0
1.776, -63.0
1.77667, -64.0
1.77733, -64.0
1.778, -64.0
1.77867, -65.0
1.77933, -65.0
1.78, -65.0
1.78067, -65.0
1.78133, -65.0
1.782, -65.0
1.78267, -65.0
1.78333, -65.0
1.784, -65.0
1.78467, -65.0
1.78533, -65.0
1.786, -65.0
1.78667, -65.0
1.78733, -65.0
1.788, -65.0
1.78867, -66.0
1.78933, -66.0
1.79, -66.0
1.79067, -67.0
1.79133, -67.0
1.792, -67.0
1.79267, -67.0
1.79333, -68.0
1.794, -68.0
1.79467, -68.0
1.79533, -68.0
1.796, -68.0
1.79667, -69.0
1.79733, -69.0
1.798, -69.0
1.79867, -69.0
1.79933, -69.0
1.8, -69.0
1.80067, -69.0
1.80133, -69.0
1.802, -70.0
1.80267, -70.0
1.80333, -70.0
1.804, -71.0
1.80467, -71.0
1.80533, -71.0
1.806, -72.0
1.80667, -72.0
1.80733, -72.0
1.808, -72.0
1.80867, -72.0
1.80933, -73.0
1.81, -73.0
1.81067, -73.0
1.81133, -73.0
1.812, -73.0
1.81267, -74.0
1.81333, -74.0
1.814, -74.0
1.81467, -74.0
1.81533, -74.0
1.816, -75.0
1.81667, -75.0
1.81733, -75.0
1.818, -75.0
1.81867, -75.0
1.81933, -75.0
1.82, -75.0
1.82067, -75.0
1.82133, -75.0
1.822, -75.0
1.82267, -74.0
1.82333, -74.0
1.824, -74.0
1.82467, -74.0
1.82533, -74.0
1.826, -74.0
1.82667, -75.0
1.82733, -75.0
1.828, -75.0
1.82867, -75.0
1.82933, -76.0
1.83, -76.0
1.83067, -76.0
1.83133, -77.0
1.832, -77.0
1.83267, -78.0
1.83333, -78.0
1.834, -79.0
1.83467, -79.0
1.83533, -79.0
1.836, -80.0
1.83667, -80.0
1.83733, -80.0
1.838, -81.0
1.83867, -81.0
1.83933, -81.0
1.84, -81.0
1.84067, -81.0
1.84133, -81.0
1.842, -81.0
1.84267, -81.0
1.84333, -81.0
1.844, -81.0
1.84467, -81.0
1.84533, -81.0
1.846, -81.0
1.84667, -81.0
1.84733, -82.0
1.848, -82.0
1.84867, -82.0
1.84933, -82.0
1.85, -82.0
1.85067, -82.0
1.85133, -83.0
1.852, -83.0
1.85267, -83.0
1.85333, -83.0
1.854, -84.0
1.85467, -84.0
1.85533, -84.0
1.856, -85.0
1.85667, -85.0
1.85733, -85.0
1.858, -86.0
1.85867, -86.0
1.85933, -86.0
1.86, -87.0
1.86067, -87.0
1.86133, -87.0
1.862, -88.0
1.86267, -88.0
1.86333, -88.0
1.864, -88.0
1.86467, -88.0
1.86533, -88.0
1.866, -88.0
1.86667, -88.0
1.86733, -88.0
1.868, -88.0
1.86867, -88.0
1.86933, -88.0
1.87, -88.0
1.87067, -88.0
1.87133, -88.0
1.872, -88.0
1.87267, -88.0
1.87333, -88.0
1.874, -88.0
1.87467, -88.0
1.87533, -88.0
1.876, -88.0
1.87667, -88.0
1.87733, -88.0
1.878, -88.0
1.87867, -88.0
1.87933, -88.0
1.88, -88.0
1.88067, -88.0
1.88133, -88.0
1.882, -88.0
1.88267, -88.0
1.88333, -89.0
1.884, -88.0
1.88467, -89.0
1.88533, -89.0
1.886, -89.0
1.88667, -89.0
1.88733, -89.0
1.888, -89.0
1.88867, -89.0
1.88933, -89.0
1.89, -90.0
1.89067, -90.0
1.89133, -90.0
1.892, -90.0
1.89267, -90.0
1.89333, -91.0
1.894, -91.0
1.89467, -92.0
1.89533, -92.0
1.896, -92.0
1.89667, -92.0
1.89733, -93.0
1.898, -93.0
1.89867, -93.0
1.89933, -94.0
1.9, -94.0
1.90067, -94.0
1.90133, -95.0
1.902, -95.0
1.90267, -95.0
1.90333, -95.0
1.904, -95.0
1.90467, -95.0
1.90533, -95.0
1.906, -94.0
1.90667, -94.0
1.90733, -94.0
1.908, -94.0
1.90867, -93.0
1.90933, -93.0
1.91, -93.0
1.91067, -93.0
1.91133, -93.0
1.912, -93.0
1.91267, -93.0
1.91333, -93.0
1.914, -93.0
1.91467, -93.0
1.91533, -93.0
1.916, -93.0
1.91667, -93.0
1.91733, -93.0
1.918, -92.0
1.91867, -92.0
1.91933, -92.0
1.92, -93.0
1.92067, -93.0
1.92133, -93.0
1.922, -94.0
1.92267, -94.0
1.92333, -95.0
1.924, -95.0
1.92467, -96.0
1.92533, -96.0
1.926, -97.0
1.92667, -98.0
1.92733, -98.0
1.928, -99.0
1.92867, -99.0
1.92933, -99.0
1.93, -99.0
1.93067, -100.0
1.93133, -100.0
1.932, -100.0
1.93267, -100.0
1.93333, -99.0
1.934, -99.0
1.93467, -99.0
1.93533, -99.0
1.936, -99.0
1.93667, -99.0
1.93733, -99.0
1.938, -99.0
1.93867, -99.0
1.93933, -99.0
1.94, -99.0
1.94067, -99.0
1.94133, -99.0
1.942, -100.0
1.94267, -100.0
1.94333, -101.0
1.944, -101.0
1.94467, -102.0
1.94533, -102.0
1.946, -103.0
1.94667, -103.0
1.94733, -103.0
1.948, -104.0
1.94867, -104.0
1.94933, -105.0
1.95, -105.0
1.95067, -105.0
1.95133, -106.0
1.952, -106.0
1.95267, -106.0
1.95333, -106.0
1.954, -107.0
1.95467, -107.0
1.95533, -107.0
1.956, -107.0
1.95667, -107.0
1.95733, -107.0
1.958, -107.0
1.95867, -108.0
1.95933, -108.0
1.96, -108.0
1.96067, -108.0
1.96133, -108.0
1.962, -108.0
1.96267, -108.0
1.96333, -108.0
1.964, -108.0
1.96467, -108.0
1.96533, -108.0
1.966, -107.0
1.96667, -107.0
1.96733, -107.0
1.968, -107.0
1.96867, -107.0
1.96933, -106.0
1.97, -106.0
1.97067, -106.0
1.97133, -106.0
1.972, -106.0
1.97267, -105.0
1.97333, -105.0
1.974, -105.0
1.97467, -105.0
1.97533, -104.0
1.976, -104.0
1.97667, -104.0
1.97733, -104.0
1.978, -104.0
1.97867, -104.0
1.97933, -104.0
1.98, -104.0
1.98067, -105.0
1.98133, -105.0
1.982, -105.0
1.98267, -106.0
1.98333, -106.0
1.984, -106.0
1.98467, -106.0
1.98533, -107.0
1.986, -107.0
1.98667, -108.0
1.98733, -108.0
1.988, -108.0
1.98867, -109.0
1.98933, -109.0
1.99, -109.0
1.99067, -109.0
1.99133, -109.0
1.992, -109.0
1.99267, -109.0
1.99333, -109.0
1.994, -109.0
1.99467, -110.0
1.99533, -110.0
1.996, -110.0
1.99667, -110.0
1.99733, -110.0
1.998, -110.0
1.99867, -110.0
1.99933, -110.0
2.0, -110.0
2.00067, -111.0
2.00133, -111.0
2.002, -111.0
2.00267, -111.0
2.00333, -111.0
2.004, -112.0
2.00467, -112.0
2.00533, -112.0
2.006, -113.0
2.00667, -113.0
2.00733, -113.0
2.008, -114.0
2.00867, -114.0
2.00933, -114.0
2.01, -115.0
2.01067, -115.0
2.01133, -116.0
2.012, -116.0
2.01267, -117.0
2.01333, -117.0
2.014, -118.0
2.01467, -118.0
2.01533, -118.0
2.016, -119.0
2.01667, -119.0
2.01733, -120.0
2.018, -120.0
2.01867, -121.0
2.01933, -121.0
2.02, -121.0
2.02067, -122.0
2.02133, -122.0
2.022, -122.0
2.02267, -122.0
2.02333, -122.0
2.024, -122.0
2.02467, -122.0
2.02533, -122.0
2.026, -122.0
2.02667, -122.0
2.02733, -122.0
2.028, -123.0
2.02867, -123.0
2.02933, -123.0
2.03, -123.0
2.03067, -123.0
2.03133, -123.0
2.032, -123.0
2.03267, -123.0
2.03333, -123.0
2.034, -123.0
2.03467, -123.0
2.03533, -123.0
2.036, -123.0
2.03667, -124.0
2.03733, -124.0
2.038, -124.0
2.03867, -124.0
2.03933, -125.0
2.04, -125.0
2.04067, -125.0
2.04133, -126.0
2.042, -126.0
2.04267, -126.0
2.04333, -126.0
2.044, -127.0
2.04467, -127.0
2.04533, -127.0
2.046, -127.0
2.04667, -128.0
2.04733, -128.0
2.048, -128.0
2.04867, -128.0
2.04933, -128.0
2.05, -128.0
2.05067, -129.0
2.05133, -129.0
2.052, -129.0
2.05267, -129.0
2.05333, -129.0
2.054, -129.0
2.05467, -129.0
2.05533, -129.0
2.056, -129.0
2.05667, -129.0
2.05733, -129.0
2.058, -129.0
2.05867, -129.0
2.05933, -129.0
2.06, -129.0
2.06067, -130.0
2.06133, -130.0
2.062, -130.0
2.06267, -130.0
2.06333, -130.0
2.064, -130.0
2.06467, -130.0
2.06533, -130.0
2.066, -130.0
2.06667, -131.0
2.06733, -131.0
2.068, -131.0
2.06867, -131.0
2.06933, -131.0
2.07, -131.0
2.07067, -131.0
2.07133, -132.0
2.072, -132.0
2.07267, -132.0
2.07333, -132.0
2.074, -132.0
2.07467, -132.0
2.07533, -133.0
2.076, -133.0
2.07667, -133.0
2.07733, -133.0
2.078, -134.0
2.07867, -134.0
2.07933, -134.0
2.08, -134.0
2.08067, -134.0
2.08133, -134.0
2.082, -134.0
2.08267, -134.0
2.08333, -135.0
2.084, -135.0
2.08467, -135.0
2.08533, -135.0
2.086, -135.0
2.08667, -135.0
2.08733, -135.0
2.088, -136.0
2.08867, -136.0
2.08933, -136.0
2.09, -136.0
2.09067, -137.0
2.09133, -137.0
2.092, -137.0
2.09267, -138.0
2.09333, -138.0
2.094, -138.0
2.09467, -138.0
2.09533, -138.0
2.096, -138.0
2.09667, -138.0
2.09733, -137.0
2.098, -137.0
2.09867, -137.0
2.09933, -137.0
2.1, -136.0
2.10067, -136.0
2.10133, -136.0
2.102, -136.0
2.10267, -136.0
2.10333, -136.0
2.104, -136.0
2.10467, -136.0
2.10533, -136.0
2.106, -136.0
2.10667, -137.0
2.10733, -137.0
2.108, -137.0
2.10867, -137.0
2.10933, -137.0
2.11, -137.0
2.11067, -137.0
2.11133, -138.0
2.112, -138.0
2.11267, -138.0
2.11333, -138.0
2.114, -138.0
2.11467, -139.0
2.11533, -139.0
2.116, -139.0
2.11667, -139.0
2.11733, -139.0
2.118, -139.0
2.11867, -140.0
2.11933, -140.0
2.12, -140.0
2.12067, -140.0
2.12133, -140.0
2.122, -140.0
2.12267, -140.0
2.12333, -140.0
2.124, -140.0
2.12467, -140.0
2.12533, -140.0
2.126, -140.0
2.12667, -140.0
2.12733, -140.0
2.128, -140.0
2.12867, -140.0
2.12933, -141.0
2.13, -141.0
2.13067, -141.0
2.13133, -141.0
2.132, -141.0
2.13267, -141.0
2.13333, -141.0
2.134, -141.0
2.13467, -142.0
2.13533, -142.0
2.136, -142.0
2.13667, -142.0
2.13733, -142.0
2.138, -142.0
2.13867, -142.0
2.13933, -142.0
2.14, -142.0
2.14067, -142.0
2.14133, -143.0
2.142, -143.0
2.14267, -143.0
2.14333, -143.0
2.144, -144.0
2.14467, -144.0
2.14533, -144.0
2.146, -144.0
2.14667, -144.0
2.14733, -144.0
2.148, -144.0
2.14867, -145.0
2.14933, -145.0
2.15, -145.0
2.15067, -145.0
2.15133, -146.0
2.152, -146.0
2.15267, -146.0
2.15333, -146.0
2.154, -146.0
2.15467, -147.0
2.15533, -147.0
2.156, -147.0
2.15667, -147.0
2.15733, -147.0
2.158, -147.0
2.15867, -147.0
2.15933, -147.0
2.16, -147.0
2.16067, -148.0
2.16133, -148.0
2.162, -148.0
2.16267, -148.0
2.16333, -148.0
2.164, -148.0
2.16467, -148.0
2.16533, -149.0
2.166, -149.0
2.16667, -149.0
2.16733, -149.0
2.168, -149.0
2.16867, -150.0
2.16933, -150.0
2.17, -150.0
2.17067, -150.0
2.17133, -149.0
2.172, -149.0
2.17267, -149.0
2.17333, -149.0
2.174, -149.0
2.17467, -149.0
2.17533, -149.0
2.176, -149.0
2.17667, -149.0
2.17733, -149.0
2.178, -150.0
2.17867, -150.0
2.17933, -150.0
2.18, -150.0
2.18067, -151.0
2.18133, -151.0
2.182, -151.0
2.18267, -152.0
2.18333, -152.0
2.184, -152.0
2.18467, -153.0
2.18533, -153.0
2.186, -154.0
2.18667, -154.0
2.18733, -154.0
2.188, -154.0
2.18867, -155.0
2.18933, -155.0
2.19, -155.0
2.19067, -155.0
2.19133, -155.0
2.192, -155.0
2.19267, -154.0
2.19333, -154.0
2.194, -154.0
2.19467, -154.0
2.19533, -154.0
2.196, -153.0
2.19667, -153.0
2.19733, -153.0
2.198, -153.0
2.19867, -153.0
2.19933, -153.0
2.2, -153.0
2.20067, -153.0
2.20133, -154.0
2.202, -154.0
2.20267, -154.0
2.20333, -154.0
2.204, -154.0
2.20467, -154.0
2.20533, -155.0
2.206, -155.0
2.20667, -155.0
2.20733, -155.0
2.208, -155.0
2.20867, -156.0
2.20933, -156.0
2.21, -156.0
2.21067, -156.0
2.21133, -156.0
2.212, -156.0
2.21267, -156.0
2.21333, -156.0
2.214, -156.0
2.21467, -156.0
2.21533, -156.0
2.216, -156.0
2.21667, -156.0
2.21733, -156.0
2.218, -156.0
2.21867, -156.0
2.21933, -156.0
2.22, -155.0
2.22067, -155.0
2.22133, -155.0
2.222, -155.0
2.22267, -155.0
2.22333, -155.0
2.224, -155.0
2.22467, -155.0
2.22533, -155.0
2.226, -155.0
2.22667, -155.0
2.22733, -155.0
2.228, -155.0
2.22867, -155.0
2.22933, -155.0
2.23, -155.0
2.23067, -155.0
2.23133, -155.0
2.232, -155.0
2.23267, -155.0
2.23333, -155.0
2.234, -155.0
2.23467, -155.0
2.23533, -156.0
2.236, -156.0
2.23667, -156.0
2.23733, -157.0
2.238, -157.0
2.23867, -157.0
2.23933, -158.0
2.24, -158.0
2.24067, -158.0
2.24133, -158.0
2.242, -159.0
2.24267, -159.0
2.24333, -159.0
2.244, -159.0
2.24467, -159.0
2.24533, -159.0
2.246, -159.0
2.24667, -159.0
2.24733, -159.0
2.248, -159.0
2.24867, -159.0
2.24933, -159.0
2.25, -159.0
2.25067, -159.0
2.25133, -159.0
2.252, -159.0
2.25267, -159.0
2.25333, -158.0
2.254, -159.0
2.25467, -159.0
2.25533, -159.0
2.256, -159.0
2.25667, -159.0
2.25733, -159.0
2.258, -159.0
2.25867, -159.0
2.25933, -159.0
2.26, -160.0
2.26067, -160.0
2.26133, -160.0
2.262, -160.0
2.26267, -160.0
2.26333, -160.0
2.264, -160.0
2.26467, -161.0
2.26533, -161.0
2.266, -161.0
2.26667, -161.0
2.26733, -162.0
2.268, -162.0
2.26867, -162.0
2.26933, -163.0
2.27, -163.0
2.27067, -164.0
2.27133, -164.0
2.272, -165.0
2.27267, -165.0
2.27333, -166.0
2.274, -166.0
2.27467, -166.0
2.27533, -167.0
2.276, -167.0
2.27667, -168.0
2.27733, -168.0
2.278, -168.0
2.27867, -169.0
2.27933, -169.0
2.28, -169.0
2.28067, -169.0
2.28133, -169.0
2.282, -169.0
2.28267, -170.0
2.28333, -170.0
2.284, -170.0
2.28467, -170.0
2.28533, -170.0
2.286, -170.0
2.28667, -170.0
2.28733, -170.0
2.288, -170.0
2.28867, -170.0
2.28933, -171.0
2.29, -171.0
2.29067, -171.0
2.29133, -171.0
2.292, -172.0
2.29267, -172.0
2.29333, -172.0
2.294, -173.0
2.29467, -173.0
2.29533, -173.0
2.296, -174.0
2.29667, -174.0
2.29733, -174.0
2.298, -174.0
2.29867, -174.0
2.29933, -174.0
2.3, -174.0
2.30067, -174.0
2.30133, -174.0
2.302, -174.0
2.30267, -174.0
2.30333, -174.0
2.304, -174.0
2.30467, -174.0
2.30533, -174.0
2.306, -174.0
2.30667, -174.0
2.30733, -174.0
2.308, -174.0
2.30867, -174.0
2.30933, -174.0
2.31, -174.0
2.31067, -174.0
2.31133, -174.0
2.312, -174.0
2.31267, -174.0
2.31333, -174.0
2.314, -173.0
2.31467, -173.0
2.31533, -173.0
2.316, -173.0
2.31667, -173.0
2.31733, -173.0
2.318, -173.0
2.31867, -173.0
2.31933, -173.0
2.32, -173.0
2.32067, -173.0
2.32133, -173.0
2.322, -173.0
2.32267, -173.0
2.32333, -173.0
2.324, -174.0
2.32467, -174.0
2.32533, -175.0
2.326, -175.0
2.32667, -175.0
2.32733, -176.0
2.328, -176.0
2.32867, -177.0
2.32933, -177.0
2.33, -177.0
2.33067, -178.0
2.33133, -178.0
2.332, -179.0
2.33267, -179.0
2.33333, -179.0
2.334, -179.0
2.33467, -180.0
2.33533, -180.0
2.336, -180.0
2.33667, -180.0
2.33733, -180.0
2.338, -180.0
2.33867, -181.0
2.33933, -180.0
2.34, -180.0
2.34067, -180.0
2.34133, -180.0
2.342, -180.0
2.34267, -179.0
2.34333, -179.0
2.344, -179.0
2.34467, -179.0
2.34533, -178.0
2.346, -178.0
2.34667, -178.0
2.34733, -178.0
2.348, -178.0
2.34867, -178.0
2.34933, -179.0
2.35, -179.0
2.35067, -180.0
2.35133, -180.0
2.352, -181.0
2.35267, -181.0
2.35333, -182.0
2.354, -182.0
2.35467, -183.0
2.35533, -183.0
2.356, -184.0
2.35667, -184.0
2.35733, -184.0
2.358, -184.0
2.35867, -185.0
2.35933, -185.0
2.36, -185.0
2.36067, -185.0
2.36133, -185.0
2.362, -185.0
2.36267, -185.0
2.36333, -185.0
2.364, -185.0
2.36467, -185.0
2.36533, -185.0
2.366, -185.0
2.36667, -185.0
2.36733, -185.0
2.368, -185.0
2.36867, -185.0
2.36933, -185.0
2.37, -185.0
2.37067, -185.0
2.37133, -185.0
2.372, -185.0
2.37267, -185.0
2.37333, -186.0
2.374, -186.0
2.37467, -186.0
2.37533, -186.0
2.376, -186.0
2.37667, -186.0
2.37733, -186.0
2.378, -186.0
2.37867, -186.0
2.37933, -187.0
2.38, -187.0
2.38067, -187.0
2.38133, -187.0
2.382, -187.0
2.38267, -187.0
2.38333, -187.0
2.384, -187.0
2.38467, -187.0
2.38533, -187.0
2.386, -186.0
2.38667, -186.0
2.38733, -186.0
2.388, -187.0
2.38867, -187.0
2.38933, -187.0
2.39, -187.0
2.39067, -187.0
2.39133, -187.0
2.392, -187.0
2.39267, -187.0
2.39333, -187.0
2.394, -187.0
2.39467, -187.0
2.39533, -187.0
2.396, -187.0
2.39667, -187.0
2.39733, -187.0
2.398, -187.0
2.39867, -187.0
2.39933, -188.0
2.4, -188.0
2.40067, -188.0
2.40133, -189.0
2.402, -189.0
2.40267, -189.0
2.40333, -190.0
2.404, -190.0
2.40467, -191.0
2.40533, -191.0
2.406, -192.0
2.40667, -193.0
2.40733, -194.0
2.408, -194.0
2.40867, -195.0
2.40933, -196.0
2.41, -197.0
2.41067, -198.0
2.41133, -199.0
2.412, -200.0
2.41267, -201.0
2.41333, -202.0
2.414, -204.0
2.41467, -205.0
2.41533, -206.0
2.416, -208.0
2.41667, -209.0
2.41733, -211.0
2.418, -212.0
2.41867, -214.0
2.41933, -215.0
2.42, -217.0
2.42067, -219.0
2.42133, -220.0
2.422, -222.0
2.42267, -224.0
2.42333, -226.0
2.424, -228.0
2.42467, -230.0
2.42533, -232.0
2.426, -234.0
2.42667, -236.0
2.42733, -238.0
2.428, -240.0
2.42867, -242.0
2.42933, -244.0
2.43, -246.0
2.43067, -248.0
2.43133, -250.0
2.432, -252.0
2.43267, -254.0
2.43333, -256.0
2.434, -257.0
2.43467, -259.0
2.43533, -260.0
2.436, -261.0
2.43667, -262.0
2.43733, -263.0
2.438, -265.0
2.43867, -266.0
2.43933, -266.0
2.44, -267.0
2.44067, -268.0
2.44133, -269.0
2.442, -269.0
2.44267, -270.0
2.44333, -271.0
2.444, -271.0
2.44467, -272.0
2.44533, -273.0
2.446, -273.0
2.44667, -274.0
2.44733, -275.0
2.448, -275.0
2.44867, -275.0
2.44933, -276.0
2.45, -276.0
2.45067, -276.0
2.45133, -277.0
2.452, -277.0
2.45267, -278.0
2.45333, -278.0
2.454, -278.0
2.45467, -279.0
2.45533, -279.0
2.456, -280.0
2.45667, -280.0
2.45733, -281.0
2.458, -281.0
2.45867, -281.0
2.45933, -282.0
2.46, -282.0
2.46067, -282.0
2.46133, -283.0
2.462, -283.0
2.46267, -283.0
2.46333, -283.0
2.464, -283.0
2.46467, -283.0
2.46533, -283.0
2.466, -283.0
2.46667, -283.0
2.46733, -283.0
2.468, -283.0
2.46867, -283.0
2.46933, -283.0
2.47, -283.0
2.47067, -283.0
2.47133, -283.0
2.472, -284.0
2.47267, -284.0
2.47333, -284.0
2.474, -284.0
2.47467, -284.0
2.47533, -284.0
2.476, -284.0
2.47667, -284.0
2.47733, -284.0
2.478, -284.0
2.47867, -285.0
2.47933, -285.0
2.48, -285.0
2.48067, -285.0
2.48133, -285.0
2.482, -285.0
2.48267, -285.0
2.48333, -286.0
2.484, -286.0
2.48467, -286.0
2.48533, -286.0
2.486, -286.0
2.48667, -286.0
2.48733, -286.0
2.488, -286.0
2.48867, -286.0
2.48933, -285.0
2.49, -285.0
2.49067, -285.0
2.49133, -285.0
2.492, -285.0
2.49267, -285.0
2.49333, -284.0
2.494, -284.0
2.49467, -284.0
2.49533, -284.0
2.496, -284.0
2.49667, -285.0
2.49733, -285.0
2.498, -285.0
2.49867, -285.0
2.49933, -285.0
2.5, -285.0
2.50067, -285.0
2.50133, -285.0
2.502, -285.0
2.50267, -285.0
2.50333, -285.0
2.504, -285.0
2.50467, -285.0
2.50533, -285.0
2.506, -285.0
2.50667, -285.0
2.50733, -285.0
2.508, -285.0
2.50867, -285.0
2.50933, -285.0
2.51, -285.0
2.51067, -285.0
2.51133, -285.0
2.512, -285.0
2.51267, -285.0
2.51333, -285.0
2.514, -285.0
2.51467, -285.0
2.51533, -285.0
2.516, -285.0
2.51667, -286.0
2.51733, -286.0
2.518, -286.0
2.51867, -286.0
2.51933, -286.0
2.52, -286.0
2.52067, -286.0
2.52133, -286.0
2.522, -287.0
2.52267, -287.0
2.52333, -287.0
2.524, -287.0
2.52467, -287.0
2.52533, -287.0
2.526, -288.0
2.52667, -288.0
2.52733, -288.0
2.528, -288.0
2.52867, -288.0
2.52933, -288.0
2.53, -288.0
2.53067, -288.0
2.53133, -288.0
2.532, -287.0
2.53267, -287.0
2.53333, -287.0
2.534, -287.0
2.53467, -287.0
2.53533, -287.0
2.536, -287.0
2.53667, -287.0
2.53733, -287.0
2.538, -287.0
2.53867, -287.0
2.53933, -287.0
2.54, -286.0
2.54067, -286.0
2.54133, -286.0
2.542, -286.0
2.54267, -286.0
2.54333, -286.0
2.544, -286.0
2.54467, -286.0
2.54533, -286.0
2.546, -286.0
2.54667, -286.0
2.54733, -286.0
2.548, -287.0
2.54867, -287.0
2.54933, -287.0
2.55, -287.0
2.55067, -287.0
2.55133, -287.0
2.552, -287.0
2.55267, -287.0
2.55333, -287.0
2.554, -287.0
2.55467, -287.0
2.55533, -287.0
2.556, -287.0
2.55667, -287.0
2.55733, -287.0
2.558, -287.0
2.55867, -287.0
2.55933, -286.0
2.56, -286.0
2.56067, -286.0
2.56133, -286.0
2.562, -286.0
2.56267, -286.0
2.56333, -285.0
2.564, -285.0
2.56467, -285.0
2.56533, -285.0
2.566, -285.0
2.56667, -285.0
2.56733, -285.0
2.568, -285.0
2.56867, -285.0
2.56933, -285.0
2.57, -285.0
2.57067, -285.0
2.57133, -285.0
2.572, -285.0
2.57267, -285.0
2.57333, -285.0
2.574, -285.0
2.57467, -285.0
2.57533, -285.0
2.576, -285.0
2.57667, -285.0
2.57733, -285.0
2.578, -285.0
2.57867, -285.0
2.57933, -285.0
2.58, -285.0
2.58067, -286.0
2.58133, -286.0
2.582, -286.0
2.58267, -286.0
2.58333, -286.0
2.584, -286.0
2.58467, -287.0
2.58533, -287.0
2.586, -287.0
2.58667, -287.0
2.58733, -287.0
2.588, -286.0
2.58867, -286.0
2.58933, -286.0
2.59, -286.0
2.59067, -286.0
2.59133, -286.0
2.592, -285.0
2.59267, -285.0
2.59333, -285.0
2.594, -285.0
2.59467, -285.0
2.59533, -286.0
2.596, -286.0
2.59667, -286.0
2.59733, -286.0
2.598, -286.0
2.59867, -286.0
2.59933, -287.0
2.6, -287.0
2.60067, -287.0
2.60133, -287.0
2.602, -287.0
2.60267, -287.0
2.60333, -287.0
2.604, -288.0
2.60467, -288.0
2.60533, -288.0
2.606, -288.0
2.60667, -288.0
2.60733, -288.0
2.608, -288.0
2.60867, -288.0
2.60933, -288.0
2.61, -288.0
2.61067, -289.0
2.61133, -289.0
2.612, -289.0
2.61267, -289.0
2.61333, -290.0
2.614, -290.0
2.61467, -290.0
2.61533, -290.0
2.616, -291.0
2.61667, -291.0
2.61733, -291.0
2.618, -291.0
2.61867, -291.0
2.61933, -291.0
2.62, -291.0
2.62067, -291.0
2.62133, -292.0
2.622, -292.0
2.62267, -292.0
2.62333, -292.0
2.624, -292.0
2.62467, -292.0
2.62533, -293.0
2.626, -293.0
2.62667, -293.0
2.62733, -293.0
2.628, -293.0
2.62867, -293.0
2.62933, -293.0
2.63, -293.0
2.63067, -293.0
2.63133, -293.0
2.632, -293.0
2.63267, -294.0
2.63333, -294.0
2.634, -294.0
2.63467, -294.0
2.63533, -294.0
2.636, -294.0
2.63667, -294.0
2.63733, -294.0
2.638, -294.0
2.63867, -294.0
2.63933, -294.0
2.64, -294.0
2.64067, -295.0
2.64133, -295.0
2.642, -295.0
2.64267, -295.0
2.64333, -295.0
2.644, -295.0
2.64467, -295.0
2.64533, -295.0
2.646, -295.0
2.64667, -295.0
2.64733, -295.0
2.648, -295.0
2.64867, -296.0
2.64933, -296.0
2.65, -296.0
2.65067, -296.0
2.65133, -296.0
2.652, -297.0
2.65267, -297.0
2.65333, -297.0
2.654, -297.0
2.65467, -297.0
2.65533, -297.0
2.656, -297.0
2.65667, -297.0
2.65733, -297.0
2.658, -297.0
2.65867, -297.0
2.65933, -297.0
2.66, -297.0
2.66067, -297.0
2.66133, -297.0
2.662, -297.0
2.66267, -297.0
2.66333, -297.0
2.664, -297.0
2.66467, -297.0
2.66533, -297.0
2.666, -296.0
2.66667, -296.0
2.66733, -296.0
2.668, -295.0
2.66867, -295.0
2.66933, -295.0
2.67, -295.0
2.67067, -295.0
2.67133, -295.0
2.672, -295.0
2.67267, -295.0
2.67333, -295.0
2.674, -296.0
2.67467, -296.0
2.67533, -296.0
2.676, -296.0
2.67667, -296.0
2.67733, -296.0
2.678, -296.0
2.67867, -296.0
2.67933, -296.0
2.68, -296.0
2.68067, -296.0
2.68133, -296.0
2.682, -296.0
2.68267, -296.0
2.68333, -296.0
2.684, -296.0
2.68467, -296.0
2.68533, -296.0
2.686, -296.0
2.68667, -296.0
2.68733, -296.0
2.688, -296.0
2.68867, -296.0
2.68933, -296.0
2.69, -296.0
2.69067, -297.0
2.69133, -297.0
2.692, -297.0
2.69267, -297.0
2.69333, -297.0
2.694, -297.0
2.69467, -297.0
2.69533, -297.0
2.696, -297.0
2.69667, -298.0
2.69733, -298.0
2.698, -298.0
2.69867, -299.0
2.69933, -299.0
2.7, -299.0
2.70067, -299.0
2.70133, -300.0
2.702, -300.0
2.70267, -300.0
2.70333, -300.0
2.704, -300.0
2.70467, -300.0
2.70533, -301.0
2.706, -301.0
2.70667, -301.0
2.70733, -301.0
2.708, -301.0
2.70867, -301.0
2.70933, -301.0
2.71, -301.0
2.71067, -301.0
2.71133, -301.0
2.712, -301.0
2.71267, -301.0
2.71333, -301.0
2.714, -301.0
2.71467, -301.0
2.71533, -301.0
2.716, -301.0
2.71667, -301.0
2.71733, -301.0
2.718, -301.0
2.71867, -301.0
2.71933, -301.0
2.72, -301.0
2.72067, -301.0
2.72133, -301.0
2.722, -301.0
2.72267, -301.0
2.72333, -301.0
2.724, -301.0
2.72467, -301.0
2.72533, -301.0
2.726, -301.0
2.72667, -301.0
2.72733, -301.0
2.728, -301.0
2.72867, -301.0
2.72933, -301.0
2.73, -301.0
2.73067, -301.0
2.73133, -301.0
2.732, -301.0
2.73267, -301.0
2.73333, -301.0
2.734, -301.0
2.73467, -302.0
2.73533, -302.0
2.736, -302.0
2.73667, -302.0
2.73733, -303.0
2.738, -303.0
2.73867, -303.0
2.73933, -303.0
2.74, -304.0
2.74067, -304.0
2.74133, -304.0
2.742, -304.0
2.74267, -304.0
2.74333, -304.0
2.744, -304.0
2.74467, -304.0
2.74533, -304.0
2.746, -304.0
2.74667, -304.0
2.74733, -304.0
2.748, -304.0
2.74867, -304.0
2.74933, -303.0
2.75, -303.0
2.75067, -303.0
2.75133, -303.0
2.752, -303.0
2.75267, -303.0
2.75333, -303.0
2.754, -303.0
2.75467, -303.0
2.75533, -303.0
2.756, -303.0
2.75667, -302.0
2.75733, -302.0
2.758, -302.0
2.75867, -302.0
2.75933, -302.0
2.76, -302.0
2.76067, -302.0
2.76133, -302.0
2.762, -302.0
2.76267, -302.0
2.76333, -302.0
2.764, -302.0
2.76467, -303.0
2.76533, -303.0
2.766, -303.0
2.76667, -304.0
2.76733, -304.0
2.768, -304.0
2.76867, -305.0
2.76933, -305.0
2.77, -305.0
2.77067, -305.0
2.77133, -305.0
2.772, -305.0
2.77267, -305.0
2.77333, -305.0
2.774, -305.0
2.77467, -305.0
2.77533, -305.0
2.776, -305.0
2.77667, -305.0
2.77733, -304.0
2.778, -304.0
2.77867, -304.0
2.77933, -304.0
2.78, -304.0
2.78067, -303.0
2.78133, -303.0
2.782, -303.0
2.78267, -303.0
2.78333, -303.0
2.784, -302.0
2.78467, -302.0
2.78533, -302.0
2.786, -302.0
2.78667, -302.0
2.78733, -302.0
2.788, -302.0
2.78867, -302.0
2.78933, -302.0
2.79, -302.0
2.79067, -302.0
2.79133, -302.0
2.792, -303.0
2.79267, -303.0
2.79333, -303.0
2.794, -304.0
2.79467, -304.0
2.79533, -304.0
2.796, -304.0
2.79667, -304.0
2.79733, -304.0
2.798, -305.0
2.79867, -305.0
2.79933, -305.0
2.8, -305.0
2.80067, -305.0
2.80133, -305.0
2.802, -305.0
2.80267, -305.0
2.80333, -305.0
2.804, -305.0
2.80467, -305.0
2.80533, -305.0
2.806, -305.0
2.80667, -305.0
2.80733, -305.0
2.808, -305.0
2.80867, -305.0
2.80933, -306.0
2.81, -306.0
2.81067, -306.0
2.81133, -306.0
2.812, -306.0
2.81267, -306.0
2.81333, -306.0
2.814, -306.0
2.81467, -307.0
2.81533, -307.0
2.816, -307.0
2.81667, -307.0
2.81733, -307.0
2.818, -307.0
2.81867, -307.0
2.81933, -307.0
2.82, -307.0
2.82067, -307.0
2.82133, -307.0
2.822, -307.0
2.82267, -307.0
2.82333, -307.0
2.824, -307.0
2.82467, -307.0
2.82533, -307.0
2.826, -307.0
2.82667, -307.0
2.82733, -307.0
2.828, -307.0
2.82867, -307.0
2.82933, -307.0
2.83, -307.0
2.83067, -307.0
2.83133, -307.0
2.832, -307.0
2.83267, -307.0
2.83333, -306.0
2.834, -306.0
2.83467, -306.0
2.83533, -306.0
2.836, -305.0
2.83667, -305.0
2.83733, -304.0
2.838, -303.0
2.83867, -301.0
2.83933, -300.0
2.84, -298.0
2.84067, -295.0
2.84133, -292.0
2.842, -287.0
2.84267, -282.0
2.84333, -275.0
2.844, -266.0
2.84467, -254.0
2.84533, -240.0
2.846, -222.0
2.84667, -199.0
2.84733, -170.0
2.848, -135.0
2.84867, -92.0
2.84933, -39.0
2.85, 25.0
2.85067, 103.0
2.85133, 198.0
2.852, 311.0
2.85267, 445.0
2.85333, 606.0
2.854, 795.0
2.85467, 1018.0
2.85533, 1278.0
2.856, 1581.0
2.85667, 1931.0
2.85733, 2334.0
2.858, 2796.0
2.85867, 3323.0
2.85933, 3920.0
2.86, 4593.0
2.86067, 5349.0
2.86133, 6192.0
2.862, 7128.0
2.86267, 8162.0
2.86333, 9299.0
2.864, 10543.0
2.86467, 11895.0
2.86533, 13360.0
2.866, 14937.0
2.86667, 16627.0
2.86733, 18428.0
2.868, 20339.0
2.86867, 22355.0
2.86933, 24471.0
2.87, 26680.0
2.87067, 28973.0
2.87133, 31341.0
2.872, 33771.0
2.87267, 36252.0
2.87333, 38770.0
2.874, 41310.0
2.87467, 43857.0
2.87533, 46392.0
2.876, 48901.0
2.87667, 51365.0
2.87733, 53766.0
2.878, 56089.0
2.87867, 58315.0
2.87933, 60430.0
2.88, 62418.0
2.88067, 64265.0
2.88133, 65958.0
2.882, 67486.0
2.88267, 68839.0
2.88333, 70008.0
2.884, 70988.0
2.88467, 71772.0
2.88533, 72359.0
2.886, 72748.0
2.88667, 72938.0
2.88733, 72931.0
2.888, 72733.0
2.88867, 72348.0
2.88933, 71782.0
2.89, 71045.0
2.89067, 70146.0
2.89133, 69093.0
2.892, 67899.0
2.89267, 66575.0
2.89333, 65132.0
2.894, 63583.0
2.89467, 61940.0
2.89533, 60216.0
2.896, 58423.0
2.89667, 56573.0
2.89733, 54678.0
2.898, 52748.0
2.89867, 50795.0
2.89933, 48830.0
2.9, 46860.0
2.90067, 44897.0
2.90133, 42947.0
2.902, 41019.0
2.90267, 39119.0
2.90333, 37254.0
2.904, 35428.0
2.90467, 33646.0
2.90533, 31914.0
2.906, 30233.0
2.90667, 28606.0
2.90733, 27037.0
2.908, 25526.0
2.90867, 24075.0
2.90933, 22685.0
2.91, 21355.0
2.91067, 20085.0
2.91133, 18876.0
2.912, 17726.0
2.91267, 16634.0
2.91333, 15600.0
2.914, 14621.0
2.91467, 13696.0
2.91533, 12824.0
2.916, 12002.0
2.91667, 11228.0
2.91733, 10502.0
2.918, 9820.0
2.91867, 9180.0
2.91933, 8582.0
2.92, 8022.0
2.92067, 7498.0
2.92133, 7009.0
2.922, 6553.0
2.92267, 6128.0
2.92333, 5732.0
2.924, 5363.0
2.92467, 5020.0
2.92533, 4701.0
2.926, 4405.0
2.92667, 4129.0
2.92733, 3873.0
2.928, 3636.0
2.92867, 3416.0
2.92933, 3212.0
2.93, 3023.0
2.93067, 2847.0
2.93133, 2685.0
2.932, 2534.0
2.93267, 2394.0
2.93333, 2264.0
2.934, 2144.0
2.93467, 2033.0
2.93533, 1930.0
2.936, 1834.0
2.93667, 1746.0
2.93733, 1663.0
2.938, 1587.0
2.93867, 1515.0
2.93933, 1449.0
2.94, 1388.0
2.94067, 1330.0
2.94133, 1277.0
2.942, 1227.0
2.94267, 1181.0
2.94333, 1137.0
2.944, 1097.0
2.94467, 1059.0
2.94533, 1023.0
2.946, 990.0
2.94667, 958.0
2.94733, 929.0
2.948, 901.0
2.94867, 874.0
2.94933, 849.0
2.95, 826.0
2.95067, 803.0
2.95133, 782.0
2.952, 762.0
2.95267, 743.0
2.95333, 724.0
2.954, 707.0
2.95467, 690.0
2.95533, 674.0
2.956, 659.0
2.95667, 645.0
2.95733, 631.0
2.958, 617.0
2.95867, 604.0
2.95933, 592.0
2.96, 580.0
2.96067, 569.0
2.96133, 558.0
2.962, 547.0
2.96267, 537.0
2.96333, 527.0
2.964, 518.0
2.96467, 508.0
2.96533, 499.0
2.966, 489.0
2.96667, 480.0
2.96733, 471.0
2.968, 463.0
2.96867, 454.0
2.96933, 446.0
2.97, 438.0
2.97067, 431.0
2.97133, 423.0
2.972, 416.0
2.97267, 409.0
2.97333, 402.0
2.974, 396.0
2.97467, 389.0
2.97533, 383.0
2.976, 376.0
2.97667, 370.0
2.97733, 365.0
2.978, 359.0
2.97867, 353.0
2.97933, 347.0
2.98, 341.0
2.98067, 336.0
2.98133, 330.0
2.982, 325.0
2.98267, 319.0
2.98333, 314.0
2.984, 309.0
2.98467, 304.0
2.98533, 299.0
2.986, 294.0
2.98667, 289.0
2.98733, 284.0
2.988, 279.0
2.98867, 274.0
2.98933, 270.0
2.99, 265.0
2.99067, 260.0
2.99133, 256.0
2.992, 251.0
2.99267, 247.0
2.99333, 243.0
2.994, 239.0
2.99467, 235.0
2.99533, 231.0
2.996, 227.0
2.99667, 223.0
2.99733, 219.0
2.998, 215.0
2.99867, 211.0
2.99933, 207.0
3.0, 203.0
3.00067, 200.0
3.00133, 196.0
3.002, 192.0
3.00267, 188.0
3.00333, 185.0
3.004, 181.0
3.00467, 177.0
3.00533, 174.0
3.006, 170.0
3.00667, 166.0
3.00733, 163.0
3.008, 159.0
3.00867, 156.0
3.00933, 153.0
3.01, 149.0
3.01067, 146.0
3.01133, 143.0
3.012, 140.0
3.01267, 137.0
3.01333, 133.0
3.014, 130.0
3.01467, 127.0
3.01533, 124.0
3.016, 121.0
3.01667, 119.0
3.01733, 116.0
3.018, 113.0
3.01867, 111.0
3.01933, 108.0
3.02, 106.0
3.02067, 104.0
3.02133, 101.0
3.022, 99.0
3.02267, 97.0
3.02333, 95.0
3.024, 92.0
3.02467, 90.0
3.02533, 88.0
3.026, 86.0
3.02667, 83.0
3.02733, 81.0
3.028, 79.0
3.02867, 77.0
3.02933, 74.0
3.03, 72.0
3.03067, 70.0
3.03133, 68.0
3.032, 66.0
3.03267, 64.0
3.03333, 61.0
3.034, 59.0
3.03467, 57.0
3.03533, 55.0
3.036, 53.0
3.03667, 51.0
3.03733, 49.0
3.038, 47.0
3.03867, 44.0
3.03933, 42.0
3.04, 40.0
3.04067, 38.0
3.04133, 36.0
3.042, 34.0
3.04267, 32.0
3.04333, 31.0
3.044, 29.0
3.04467, 27.0
3.04533, 25.0
3.046, 23.0
3.04667, 22.0
3.04733, 20.0
3.048, 19.0
3.04867, 17.0
3.04933, 15.0
3.05, 14.0
3.05067, 12.0
3.05133, 10.0
3.052, 9.0
3.05267, 7.0
3.05333, 6.0
3.054, 4.0
3.05467, 2.0
3.05533, 1.0
3.056, -1.0
3.05667, -2.0
3.05733, -4.0
3.058, -5.0
3.05867, -7.0
3.05933, -8.0
3.06, -9.0
3.06067, -11.0
3.06133, -12.0
3.062, -14.0
3.06267, -15.0
3.06333, -16.0
3.064, -17.0
3.06467, -18.0
3.06533, -19.0
3.066, -21.0
3.06667, -22.0
3.06733, -23.0
3.068, -24.0
3.06867, -25.0
3.06933, -26.0
3.07, -27.0
3.07067, -28.0
3.07133, -29.0
3.072, -30.0
3.07267, -30.0
3.07333, -31.0
3.074, -32.0
3.07467, -32.0
3.07533, -33.0
3.076, -34.0
3.07667, -34.0
3.07733, -35.0
3.078, -36.0
3.07867, -37.0
3.07933, -37.0
3.08, -38.0
3.08067, -39.0
3.08133, -40.0
3.082, -41.0
3.08267, -42.0
3.08333, -43.0
3.084, -44.0
3.08467, -45.0
3.08533, -46.0
3.086, -46.0
3.08667, -47.0
3.08733, -48.0
3.088, -49.0
3.08867, -49.0
3.08933, -50.0
3.09, -51.0
3.09067, -51.0
3.09133, -52.0
3.092, -52.0
3.09267, -53.0
3.09333, -54.0
3.094, -54.0
3.09467, -55.0
3.09533, -56.0
3.096, -57.0
3.09667, -57.0
3.09733, -58.0
3.098, -58.0
3.09867, -58.0
3.09933, -59.0
3.1, -59.0
3.10067, -60.0
3.10133, -60.0
3.102, -61.0
3.10267, -61.0
3.10333, -62.0
3.104, -62.0
3.10467, -62.0
3.10533, -62.0
3.106, -63.0
3.10667, -63.0
3.10733, -63.0
3.108, -64.0
3.10867, -64.0
3.10933, -65.0
3.11, -65.0
3.11067, -66.0
3.11133, -66.0
3.112, -67.0
3.11267, -67.0
3.11333, -68.0
3.114, -68.0
3.11467, -69.0
3.11533, -69.0
3.116, -70.0
3.11667, -70.0
3.11733, -71.0
3.118, -71.0
3.11867, -71.0
3.11933, -72.0
3.12, -72.0
3.12067, -72.0
3.12133, -72.0
3.122, -73.0
3.12267, -73.0
3.12333, -73.0
3.124, -73.0
3.12467, -74.0
3.12533, -74.0
3.126, -74.0
3.12667, -74.0
3.12733, -75.0
3.128, -75.0
3.12867, -75.0
3.12933, -75.0
3.13, -75.0
3.13067, -75.0
3.13133, -76.0
3.132, -76.0
3.13267, -76.0
3.13333, -76.0
3.134, -76.0
3.13467, -76.0
3.13533, -77.0
3.136, -77.0
3.13667, -77.0
3.13733, -77.0
3.138, -77.0
3.13867, -78.0
3.13933, -78.0
3.14, -79.0
3.14067, -79.0
3.14133, -79.0
3.142, -80.0
3.14267, -80.0
3.14333, -80.0
3.144, -81.0
3.14467, -81.0
3.14533, -81.0
3.146, -81.0
3.14667, -81.0
3.14733, -81.0
3.148, -81.0
3.14867, -81.0
3.14933, -81.0
3.15, -81.0
3.15067, -81.0
3.15133, -81.0
3.152, -81.0
3.15267, -81.0
3.15333, -81.0
3.154, -81.0
3.15467, -81.0
3.15533, -81.0
3.156, -82.0
3.15667, -82.0
3.15733, -82.0
3.158, -82.0
3.15867, -82.0
3.15933, -82.0
3.16, -83.0
3.16067, -83.0
3.16133, -83.0
3.162, -83.0
3.16267, -83.0
3.16333, -83.0
3.164, -83.0
3.16467, -82.0
3.16533, -82.0
3.166, -82.0
3.16667, -82.0
3.16733, -82.0
3.168, -82.0
3.16867, -82.0
3.16933, -82.0
3.17, -82.0
3.17067, -82.0
3.17133, -81.0
3.172, -81.0
3.17267, -81.0
3.17333, -81.0
3.174, -81.0
3.17467, -81.0
3.17533, -81.0
3.176, -81.0
3.17667, -81.0
3.17733, -81.0
3.178, -81.0
3.17867, -81.0
3.17933, -81.0
3.18, -81.0
3.18067, -82.0
3.18133, -82.0
3.182, -82.0
3.18267, -82.0
3.18333, -83.0
3.184, -83.0
3.18467, -83.0
3.18533, -84.0
3.186, -84.0
3.18667, -84.0
3.18733, -84.0
3.188, -84.0
3.18867, -85.0
3.18933, -85.0
3.19, -86.0
3.19067, -86.0
3.19133, -86.0
3.192, -86.0
3.19267, -86.0
3.19333, -87.0
3.194, -87.0
3.19467, -86.0
3.19533, -86.0
3.196, -86.0
3.19667, -86.0
3.19733, -86.0
3.198, -86.0
3.19867, -86.0
3.19933, -86.0
3.2, -86.0
3.20067, -85.0
3.20133, -85.0
3.202, -85.0
3.20267, -85.0
3.20333, -85.0
3.204, -85.0
3.20467, -85.0
3.20533, -85.0
3.206, -85.0
3.20667, -85.0
3.20733, -85.0
3.208, -85.0
3.20867, -85.0
3.20933, -85.0
3.21, -84.0
3.21067, -84.0
3.21133, -84.0
3.212, -84.0
3.21267, -84.0
3.21333, -84.0
3.214, -84.0
3.21467, -84.0
3.21533, -84.0
3.216, -84.0
3.21667, -84.0
3.21733, -84.0
3.218, -84.0
3.21867, -84.0
3.21933, -83.0
3.22, -83.0
3.22067, -83.0
3.22133, -82.0
3.222, -82.0
3.22267, -82.0
3.22333, -81.0
3.224, -81.0
3.22467, -80.0
3.22533, -80.0
3.226, -80.0
3.22667, -79.0
3.22733, -79.0
3.228, -79.0
3.22867, -79.0
3.22933, -79.0
3.23, -78.0
3.23067, -78.0
3.23133, -78.0
3.232, -78.0
3.23267, -77.0
3.23333, -77.0
3.234, -77.0
3.23467, -77.0
3.23533, -77.0
3.236, -77.0
3.23667, -77.0
3.23733, -77.0
3.238, -77.0
3.23867, -77.0
3.23933, -77.0
3.24, -77.0
3.24067, -77.0
3.24133, -76.0
3.242, -76.0
3.24267, -76.0
3.24333, -76.0
3.244, -76.0
3.24467, -75.0
3.24533, -75.0
3.246, -75.0
3.24667, -74.0
3.24733, -74.0
3.248, -74.0
3.24867, -73.0
3.24933, -73.0
3.25, -73.0
3.25067, -73.0
3.25133, -73.0
3.252, -73.0
3.25267, -73.0
3.25333, -73.0
3.254, -73.0
3.25467, -72.0
3.25533, -72.0
3.256, -72.0
3.25667, -72.0
3.25733, -72.0
3.258, -72.0
3.25867, -72.0
3.25933, -71.0
3.26, -71.0
3.26067, -71.0
3.26133, -71.0
3.262, -70.0
3.26267, -70.0
3.26333, -70.0
3.264, -70.0
3.26467, -69.0
3.26533, -69.0
3.266, -68.0
3.26667, -68.0
3.26733, -68.0
3.268, -67.0
3.26867, -67.0
3.26933, -66.0
3.27, -66.0
3.27067, -65.0
3.27133, -65.0
3.272, -64.0
3.27267, -64.0
3.27333, -63.0
3.274, -63.0
3.27467, -62.0
3.27533, -62.0
3.276, -62.0
3.27667, -61.0
3.27733, -61.0
3.278, -61.0
3.27867, -61.0
3.27933, -60.0
3.28, -60.0
3.28067, -60.0
3.28133, -60.0
3.282, -59.0
3.28267, -59.0
3.28333, -59.0
3.284, -58.0
3.28467, -58.0
3.28533, -58.0
3.286, -57.0
3.28667, -57.0
3.28733, -56.0
3.288, -56.0
3.28867, -55.0
3.28933, -55.0
3.29, -54.0
3.29067, -54.0
3.29133, -53.0
3.292, -53.0
3.29267, -52.0
3.29333, -51.0
3.294, -51.0
3.29467, -50.0
3.29533, -49.0
3.296, -48.0
3.29667, -48.0
3.29733, -47.0
3.298, -46.0
3.29867, -45.0
3.29933, -44.0
3.3, -44.0
3.30067, -43.0
3.30133, -42.0
3.302, -41.0
3.30267, -40.0
3.30333, -39.0
3.304, -39.0
3.30467, -38.0
3.30533, -37.0
3.306, -37.0
3.30667, -36.0
3.30733, -36.0
3.308, -35.0
3.30867, -35.0
3.30933, -34.0
3.31, -34.0
3.31067, -33.0
3.31133, -33.0
3.312, -32.0
3.31267, -32.0
3.31333, -32.0
3.314, -31.0
3.31467, -31.0
3.31533, -31.0
3.316, -30.0
3.31667, -30.0
3.31733, -29.0
3.318, -29.0
3.31867, -28.0
3.31933, -28.0
3.32, -27.0
3.32067, -26.0
3.32133, -25.0
3.322, -25.0
3.32267, -24.0
3.32333, -23.0
3.324, -22.0
3.32467, -21.0
3.32533, -20.0
3.326, -19.0
3.32667, -18.0
3.32733, -17.0
3.328, -16.0
3.32867, -15.0
3.32933, -15.0
3.33, -14.0
3.33067, -13.0
3.33133, -12.0
3.332, -11.0
3.33267, -10.0
3.33333, -9.0
3.334, -8.0
3.33467, -7.0
3.33533, -6.0
3.336, -6.0
3.33667, -5.0
3.33733, -4.0
3.338, -4.0
3.33867, -3.0
3.33933, -3.0
3.34, -3.0
3.34067, -2.0
3.34133, -2.0
3.342, -2.0
3.34267, -2.0
3.34333, -2.0
3.344, -1.0
3.34467, -1.0
3.34533, -1.0
3.346, -1.0
3.34667, -1.0
3.34733, -1.0
3.348, -1.0
3.34867, -1.0
3.34933, -1.0
3.35, -0.0
3.35067, -0.0
3.35133, 0.0
3.352, 1.0
3.35267, 1.0
3.35333, 2.0
3.354, 2.0
3.35467, 3.0
3.35533, 3.0
3.356, 4.0
3.35667, 4.0
3.35733, 5.0
3.358, 6.0
3.35867, 7.0
3.35933, 7.0
3.36, 8.0
3.36067, 9.0
3.36133, 10.0
3.362, 11.0
3.36267, 12.0
3.36333, 13.0
3.364, 14.0
3.36467, 15.0
3.36533, 16.0
3.366, 17.0
3.36667, 19.0
3.36733, 20.0
3.368, 21.0
3.36867, 22.0
3.36933, 23.0
3.37, 24.0
3.37067, 25.0
3.37133, 26.0
3.372, 27.0
3.37267, 27.0
3.37333, 28.0
3.374, 29.0
3.37467, 30.0
3.37533, 30.0
3.376, 31.0
3.37667, 32.0
3.37733, 32.0
3.378, 33.0
3.37867, 33.0
3.37933, 34.0
3.38, 35.0
3.38067, 35.0
3.38133, 36.0
3.382, 36.0
3.38267, 37.0
3.38333, 37.0
3.384, 38.0
3.38467, 39.0
3.38533, 40.0
3.386, 40.0
3.38667, 41.0
3.38733, 42.0
3.388, 43.0
3.38867, 44.0
3.38933, 44.0
3.39, 45.0
3.39067, 46.0
3.39133, 47.0
3.392, 47.0
3.39267, 48.0
3.39333, 49.0
3.394, 50.0
3.39467, 50.0
3.39533, 51.0
3.396, 52.0
3.39667, 53.0
3.39733, 53.0
3.398, 54.0
3.39867, 55.0
3.39933, 56.0
3.4, 56.0
3.40067, 57.0
3.40133, 58.0
3.402, 58.0
3.40267, 59.0
3.40333, 59.0
3.404, 59.0
3.40467, 60.0
3.40533, 60.0
3.406, 60.0
3.40667, 61.0
3.40733, 61.0
3.408, 61.0
3.40867, 62.0
3.40933, 62.0
3.41, 62.0
3.41067, 63.0
3.41133, 63.0
3.412, 63.0
3.41267, 63.0
3.41333, 63.0
3.414, 63.0
3.41467, 63.0
3.41533, 62.0
3.416, 62.0
3.41667, 62.0
3.41733, 62.0
3.418, 62.0
3.41867, 62.0
3.41933, 62.0
3.42, 63.0
3.42067, 64.0
3.42133, 65.0
3.422, 67.0
3.42267, 69.0
3.42333, 73.0
3.424, 77.0
3.42467, 83.0
3.42533, 91.0
3.426, 100.0
3.42667, 111.0
3.42733, 126.0
3.428, 143.0
3.42867, 164.0
3.42933, 189.0
3.43, 219.0
3.43067, 255.0
3.43133, 297.0
3.432, 346.0
3.43267, 403.0
3.43333, 468.0
3.434, 542.0
3.43467, 627.0
3.43533, 723.0
3.436, 831.0
3.43667, 951.0
3.43733, 1084.0
3.438, 1231.0
3.43867, 1392.0
3.43933, 1569.0
3.44, 1761.0
3.44067, 1969.0
3.44133, 2194.0
3.442, 2437.0
3.44267, 2697.0
3.44333, 2975.0
3.444, 3273.0
3.44467, 3590.0
3.44533, 3929.0
3.446, 4290.0
3.44667, 4674.0
3.44733, 5083.0
3.448, 5519.0
3.44867, 5984.0
3.44933, 6479.0
3.45, 7006.0
3.45067, 7569.0
3.45133, 8169.0
3.452, 8808.0
3.45267, 9489.0
3.45333, 10211.0
3.454, 10977.0
3.45467, 11787.0
3.45533, 12641.0
3.456, 13539.0
3.45667, 14478.0
3.45733, 15456.0
3.458, 16470.0
3.45867, 17516.0
3.45933, 18590.0
3.46, 19684.0
3.46067, 20792.0
3.46133, 21907.0
3.462, 23021.0
3.46267, 24124.0
3.46333, 25208.0
3.464, 26263.0
3.46467, 27279.0
3.46533, 28247.0
3.466, 29157.0
3.46667, 30002.0
3.46733, 30772.0
3.468, 31460.0
3.46867, 32060.0
3.46933, 32566.0
3.47, 32972.0
3.47067, 33277.0
3.47133, 33477.0
3.472, 33572.0
3.47267, 33562.0
3.47333, 33449.0
3.474, 33235.0
3.47467, 32923.0
3.47533, 32519.0
3.476, 32027.0
3.47667, 31453.0
3.47733, 30805.0
3.478, 30088.0
3.47867, 29310.0
3.47933, 28480.0
3.48, 27603.0
3.48067, 26688.0
3.48133, 25743.0
3.482, 24773.0
3.48267, 23787.0
3.48333, 22791.0
3.484, 21790.0
3.48467, 20791.0
3.48533, 19799.0
3.486, 18818.0
3.48667, 17853.0
3.48733, 16908.0
3.488, 15985.0
3.48867, 15089.0
3.48933, 14220.0
3.49, 13381.0
3.49067, 12574.0
3.49133, 11799.0
3.492, 11057.0
3.49267, 10349.0
3.49333, 9674.0
3.494, 9033.0
3.49467, 8426.0
3.49533, 7852.0
3.496, 7309.0
3.49667, 6798.0
3.49733, 6318.0
3.498, 5867.0
3.49867, 5444.0
3.49933, 5048.0
3.5, 4677.0
3.50067, 4332.0
3.50133, 4010.0
3.502, 3710.0
3.50267, 3431.0
3.50333, 3173.0
3.504, 2932.0
3.50467, 2710.0
3.50533, 2504.0
3.506, 2313.0
3.50667, 2137.0
3.50733, 1974.0
3.508, 1824.0
3.50867, 1685.0
3.50933, 1557.0
3.51, 1440.0
3.51067, 1332.0
3.51133, 1233.0
3.512, 1141.0
3.51267, 1057.0
3.51333, 981.0
3.514, 910.0
3.51467, 845.0
3.51533, 786.0
3.516, 732.0
3.51667, 682.0
3.51733, 636.0
3.518, 594.0
3.51867, 556.0
3.51933, 521.0
3.52, 489.0
3.52067, 459.0
3.52133, 432.0
3.522, 407.0
3.52267, 384.0
3.52333, 363.0
3.524, 344.0
3.52467, 327.0
3.52533, 311.0
3.526, 297.0
3.52667, 283.0
3.52733, 271.0
3.528, 261.0
3.52867, 251.0
3.52933, 242.0
3.53, 233.0
3.53067, 226.0
3.53133, 219.0
3.532, 213.0
3.53267, 207.0
3.53333, 202.0
3.534, 197.0
3.53467, 193.0
3.53533, 189.0
3.536, 185.0
3.53667, 182.0
3.53733, 179.0
3.538, 177.0
3.53867, 174.0
3.53933, 172.0
3.54, 170.0
3.54067, 168.0
3.54133, 166.0
3.542, 165.0
3.54267, 164.0
3.54333, 162.0
3.544, 161.0
3.54467, 160.0
3.54533, 159.0
3.546, 159.0
3.54667, 158.0
3.54733, 157.0
3.548, 156.0
3.54867, 156.0
3.54933, 155.0
3.55, 155.0
3.55067, 154.0
3.55133, 154.0
3.552, 153.0
3.55267, 153.0
3.55333, 153.0
3.554, 152.0
3.55467, 152.0
3.55533, 152.0
3.556, 152.0
3.55667, 152.0
3.55733, 152.0
3.558, 152.0
3.55867, 152.0
3.55933, 152.0
3.56, 152.0
3.56067, 152.0
3.56133, 153.0
3.562, 153.0
3.56267, 153.0
3.56333, 154.0
3.564, 154.0
3.56467, 154.0
3.56533, 155.0
3.566, 155.0
3.56667, 156.0
3.56733, 156.0
3.568, 157.0
3.56867, 157.0
3.56933, 157.0
3.57, 158.0
3.57067, 158.0
3.57133, 159.0
3.572, 159.0
3.57267, 160.0
3.57333, 161.0
3.574, 161.0
3.57467, 162.0
3.57533, 163.0
3.576, 163.0
3.57667, 164.0
3.57733, 165.0
3.578, 165.0
3.57867, 166.0
3.57933, 166.0
3.58, 167.0
3.58067, 168.0
3.58133, 168.0
3.582, 169.0
3.58267, 169.0
3.58333, 170.0
3.584, 170.0
3.58467, 171.0
3.58533, 171.0
3.586, 172.0
3.58667, 172.0
3.58733, 173.0
3.588, 173.0
3.58867, 174.0
3.58933, 175.0
3.59, 175.0
3.59067, 176.0
3.59133, 177.0
3.592, 178.0
3.59267, 179.0
3.59333, 179.0
3.594, 180.0
3.59467, 181.0
3.59533, 182.0
3.596, 182.0
3.59667, 183.0
3.59733, 184.0
3.598, 185.0
3.59867, 186.0
3.59933, 186.0
3.6, 187.0
3.60067, 188.0
3.60133, 189.0
3.602, 190.0
3.60267, 190.0
3.60333, 191.0
3.604, 192.0
3.60467, 193.0
3.60533, 193.0
3.606, 194.0
3.60667, 195.0
3.60733, 196.0
3.608, 196.0
3.60867, 197.0
3.60933, 198.0
3.61, 199.0
3.61067, 199.0
3.61133, 200.0
3.612, 201.0
3.61267, 201.0
3.61333, 202.0
3.614, 203.0
3.61467, 203.0
3.61533, 204.0
3.616, 205.0
3.61667, 206.0
3.61733, 207.0
3.618, 208.0
3.61867, 209.0
3.61933, 210.0
3.62, 211.0
3.62067, 212.0
3.62133, 213.0
3.622, 214.0
3.62267, 215.0
3.62333, 217.0
3.624, 218.0
3.62467, 219.0
3.62533, 220.0
3.626, 221.0
3.62667, 222.0
3.62733, 223.0
3.628, 224.0
3.62867, 224.0
3.62933, 225.0
3.63, 226.0
3.63067, 227.0
3.63133, 228.0
3.632, 229.0
3.63267, 230.0
3.63333, 231.0
3.634, 232.0
3.63467, 233.0
3.63533, 234.0
3.636, 236.0
3.63667, 237.0
3.63733, 238.0
3.638, 239.0
3.63867, 240.0
3.63933, 241.0
3.64, 243.0
3.64067, 244.0
3.64133, 245.0
3.642, 246.0
3.64267, 246.0
3.64333, 247.0
3.644, 248.0
3.64467, 249.0
3.64533, 250.0
3.646, 251.0
3.64667, 252.0
3.64733, 253.0
3.648, 254.0
3.64867, 255.0
3.64933, 256.0
3.65, 257.0
3.65067, 258.0
3.65133, 259.0
3.652, 260.0
3.65267, 262.0
3.65333, 263.0
3.654, 264.0
3.65467, 265.0
3.65533, 266.0
3.656, 267.0
3.65667, 268.0
3.65733, 269.0
3.658, 270.0
3.65867, 271.0
3.65933, 273.0
3.66, 274.0
3.66067, 275.0
3.66133, 276.0
3.662, 277.0
3.66267, 278.0
3.66333, 279.0
3.664, 280.0
3.66467, 280.0
3.66533, 281.0
3.666, 282.0
3.66667, 283.0
3.66733, 283.0
3.668, 284.0
3.66867, 285.0
3.66933, 286.0
3.67, 287.0
3.67067, 288.0
3.67133, 289.0
3.672, 290.0
3.67267, 291.0
3.67333, 291.0
3.674, 292.0
3.67467, 293.0
3.67533, 293.0
3.676, 294.0
3.67667, 295.0
3.67733, 295.0
3.678, 296.0
3.67867, 297.0
3.67933, 297.0
3.68, 298.0
3.68067, 299.0
3.68133, 300.0
3.682, 301.0
3.68267, 302.0
3.68333, 303.0
3.684, 304.0
3.68467, 305.0
3.68533, 306.0
3.686, 307.0
3.68667, 308.0
3.68733, 309.0
3.688, 310.0
3.68867, 311.0
3.68933, 312.0
3.69, 313.0
3.69067, 314.0
3.69133, 315.0
3.692, 316.0
3.69267, 317.0
3.69333, 318.0
3.694, 319.0
3.69467, 321.0
3.69533, 322.0
3.696, 323.0
3.69667, 324.0
3.69733, 325.0
3.698, 326.0
3.69867, 327.0
3.69933, 328.0
3.7, 329.0
3.70067, 330.0
3.70133, 332.0
3.702, 333.0
3.70267, 334.0
3.70333, 335.0
3.704, 336.0
3.70467, 337.0
3.70533, 339.0
3.706, 340.0
3.70667, 341.0
3.70733, 342.0
3.708, 343.0
3.70867, 344.0
3.70933, 345.0
3.71, 346.0
3.71067, 347.0
3.71133, 348.0
3.712, 349.0
3.71267, 350.0
3.71333, 351.0
3.714, 352.0
3.71467, 353.0
3.71533, 354.0
3.716, 354.0
3.71667, 355.0
3.71733, 356.0
3.718, 357.0
3.71867, 357.0
3.71933, 358.0
3.72, 359.0
3.72067, 360.0
3.72133, 361.0
3.722, 362.0
3.72267, 363.0
3.72333, 364.0
3.724, 365.0
3.72467, 366.0
3.72533, 367.0
3.726, 368.0
3.72667, 369.0
3.72733, 370.0
3.728, 371.0
3.72867, 372.0
3.72933, 373.0
3.73, 374.0
3.73067, 375.0
3.73133, 376.0
3.732, 377.0
3.73267, 378.0
3.73333, 379.0
3.734, 380.0
3.73467, 381.0
3.73533, 382.0
3.736, 383.0
3.73667, 384.0
3.73733, 385.0
3.738, 386.0
3.73867, 387.0
3.73933, 388.0
3.74, 388.0
3.74067, 389.0
3.74133, 390.0
3.742, 391.0
3.74267, 392.0
3.74333, 393.0
3.744, 394.0
3.74467, 395.0
3.74533, 396.0
3.746, 398.0
3.74667, 399.0
3.74733, 400.0
3.748, 401.0
3.74867, 402.0
3.74933, 404.0
3.75, 405.0
3.75067, 406.0
3.75133, 407.0
3.752, 409.0
3.75267, 410.0
3.75333, 411.0
3.754, 413.0
3.75467, 414.0
3.75533, 415.0
3.756, 416.0
3.75667, 418.0
3.75733, 419.0
3.758, 420.0
3.75867, 421.0
3.75933, 422.0
3.76, 424.0
3.76067, 425.0
3.76133, 426.0
3.762, 427.0
3.76267, 429.0
3.76333, 430.0
3.764, 431.0
3.76467, 432.0
3.76533, 433.0
3.766, 435.0
3.76667, 436.0
3.76733, 437.0
3.768, 438.0
3.76867, 439.0
3.76933, 440.0
3.77, 441.0
3.77067, 442.0
3.77133, 443.0
3.772, 444.0
3.77267, 444.0
3.77333, 445.0
3.774, 446.0
3.77467, 447.0
3.77533, 448.0
3.776, 449.0
3.77667, 450.0
3.77733, 451.0
3.778, 452.0
3.77867, 453.0
3.77933, 454.0
3.78, 455.0
3.78067, 457.0
3.78133, 458.0
3.782, 459.0
3.78267, 460.0
3.78333, 462.0
3.784, 463.0
3.78467, 464.0
3.78533, 465.0
3.786, 467.0
3.78667, 468.0
3.78733, 469.0
3.788, 470.0
3.78867, 472.0
3.78933, 473.0
3.79, 474.0
3.79067, 475.0
3.79133, 476.0
3.792, 478.0
3.79267, 479.0
3.79333, 480.0
3.794, 481.0
3.79467, 482.0
3.79533, 483.0
3.796, 484.0
3.79667, 485.0
3.79733, 486.0
3.798, 487.0
3.79867, 489.0
3.79933, 490.0
3.8, 491.0
3.80067, 492.0
3.80133, 493.0
3.802, 494.0
3.80267, 495.0
3.80333, 496.0
3.804, 497.0
3.80467, 498.0
3.80533, 499.0
3.806, 500.0
3.80667, 501.0
3.80733, 502.0
3.808, 503.0
3.80867, 505.0
3.80933, 506.0
3.81, 507.0
3.81067, 508.0
3.81133, 509.0
3.812, 510.0
3.81267, 511.0
3.81333, 512.0
3.814, 513.0
3.81467, 514.0
3.81533, 516.0
3.816, 517.0
3.81667, 518.0
3.81733, 519.0
3.818, 520.0
3.81867, 521.0
3.81933, 522.0
3.82, 523.0
3.82067, 525.0
3.82133, 526.0
3.822, 527.0
3.82267, 528.0
3.82333, 529.0
3.824, 531.0
3.82467, 532.0
3.82533, 533.0
3.826, 534.0
3.82667, 536.0
3.82733, 537.0
3.828, 538.0
3.82867, 539.0
3.82933, 540.0
3.83, 541.0
3.83067, 542.0
3.83133, 543.0
3.832, 544.0
3.83267, 545.0
3.83333, 546.0
3.834, 547.0
3.83467, 548.0
3.83533, 549.0
3.836, 550.0
3.83667, 551.0
3.83733, 552.0
3.838, 554.0
3.83867, 555.0
3.83933, 556.0
3.84, 557.0
3.84067, 558.0
3.84133, 560.0
3.842, 561.0
3.84267, 562.0
3.84333, 564.0
3.844, 565.0
3.84467, 566.0
3.84533, 567.0
3.846, 569.0
3.84667, 570.0
3.84733, 571.0
3.848, 573.0
3.84867, 574.0
3.84933, 575.0
3.85, 577.0
3.85067, 578.0
3.85133, 579.0
3.852, 580.0
3.85267, 581.0
3.85333, 582.0
3.854, 583.0
3.85467, 584.0
3.85533, 585.0
3.856, 586.0
3.85667, 587.0
3.85733, 588.0
3.858, 589.0
3.85867, 590.0
3.85933, 591.0
3.86, 592.0
3.86067, 593.0
3.86133, 594.0
3.862, 595.0
3.86267, 596.0
3.86333, 598.0
3.864, 599.0
3.86467, 600.0
3.86533, 602.0
3.866, 603.0
3.86667, 605.0
3.86733, 606.0
3.868, 607.0
3.86867, 609.0
3.86933, 610.0
3.87, 612.0
3.87067, 613.0
3.87133, 615.0
3.872, 616.0
3.87267, 617.0
3.87333, 619.0
3.874, 620.0
3.87467, 621.0
3.87533, 623.0
3.876, 624.0
3.87667, 625.0
3.87733, 626.0
3.878, 627.0
3.87867, 629.0
3.87933, 630.0
3.88, 631.0
3.88067, 632.0
3.88133, 633.0
3.882, 634.0
3.88267, 635.0
3.88333, 637.0
3.884, 638.0
3.88467, 639.0
3.88533, 640.0
3.886, 641.0
3.88667, 642.0
3.88733, 643.0
3.888, 644.0
3.88867, 645.0
3.88933, 646.0
3.89, 647.0
3.89067, 649.0
3.89133, 650.0
3.892, 651.0
3.89267, 652.0
3.89333, 653.0
3.894, 654.0
3.89467, 655.0
3.89533, 656.0
3.896, 657.0
3.89667, 659.0
3.89733, 660.0
3.898, 661.0
3.89867, 662.0
3.89933, 664.0
3.9, 665.0
3.90067, 667.0
3.90133, 668.0
3.902, 669.0
3.90267, 670.0
3.90333, 672.0
3.904, 673.0
3.90467, 674.0
3.90533, 676.0
3.906, 677.0
3.90667, 678.0
3.90733, 679.0
3.908, 681.0
3.90867, 682.0
3.90933, 683.0
3.91, 684.0
3.91067, 685.0
3.91133, 687.0
3.912, 688.0
3.91267, 689.0
3.91333, 691.0
3.914, 692.0
3.91467, 693.0
3.91533, 695.0
3.916, 696.0
3.91667, 697.0
3.91733, 698.0
3.918, 699.0
3.91867, 701.0
3.91933, 702.0
3.92, 703.0
3.92067, 705.0
3.92133, 706.0
3.922, 707.0
3.92267, 709.0
3.92333, 710.0
3.924, 711.0
3.92467, 713.0
3.92533, 714.0
3.926, 716.0
3.92667, 717.0
3.92733, 718.0
3.928, 719.0
3.92867, 721.0
3.92933, 722.0
3.93, 723.0
3.93067, 724.0
3.93133, 726.0
3.932, 727.0
3.93267, 728.0
3.93333, 729.0
3.934, 730.0
3.93467, 732.0
3.93533, 733.0
3.936, 734.0
3.93667, 735.0
3.93733, 736.0
3.938, 737.0
3.93867, 738.0
3.93933, 739.0
3.94, 741.0
3.94067, 742.0
3.94133, 744.0
3.942, 745.0
3.94267, 746.0
3.94333, 748.0
3.944, 749.0
3.94467, 751.0
3.94533, 752.0
3.946, 754.0
3.94667, 755.0
3.94733, 757.0
3.948, 758.0
3.94867, 760.0
3.94933, 762.0
3.95, 763.0
3.95067, 765.0
3.95133, 766.0
3.952, 768.0
3.95267, 769.0
3.95333, 771.0
3.954, 772.0
3.95467, 774.0
3.95533, 775.0
3.956, 776.0
3.95667, 778.0
3.95733, 779.0
3.958, 780.0
3.95867, 781.0
3.95933, 782.0
3.96, 784.0
3.96067, 785.0
3.96133, 786.0
3.962, 787.0
3.96267, 788.0
3.96333, 789.0
3.964, 790.0
3.96467, 791.0
3.96533, 793.0
3.966, 794.0
3.96667, 796.0
3.96733, 797.0
3.968, 799.0
3.96867, 800.0
3.96933, 802.0
3.97, 803.0
3.97067, 804.0
3.97133, 806.0
3.972, 807.0
3.97267, 809.0
3.97333, 810.0
3.974, 811.0
3.97467, 812.0
3.97533, 813.0
3.976, 815.0
3.97667, 816.0
3.97733, 817.0
3.978, 818.0
3.97867, 819.0
3.97933, 821.0
3.98, 822.0
3.98067, 824.0
3.98133, 825.0
3.982, 827.0
3.98267, 828.0
3.98333, 830.0
3.984, 831.0
3.98467, 833.0
3.98533, 834.0
3.986, 835.0
3.98667, 837.0
3.98733, 838.0
3.988, 840.0
3.98867, 841.0
3.98933, 843.0
3.99, 844.0
3.99067, 846.0
3.99133, 847.0
3.992, 849.0
3.99267, 850.0
3.99333, 851.0
3.994, 853.0
3.99467, 854.0
3.99533, 855.0
3.996, 857.0
3.99667, 858.0
3.99733, 859.0
3.998, 861.0
3.99867, 862.0
3.99933, 863.0
4.0, 864.0
4.00067, 866.0
4.00133, 867.0
4.002, 868.0
4.00267, 869.0
4.00333, 871.0
4.004, 872.0
4.00467, 873.0
4.00533, 874.0
4.006, 876.0
4.00667, 877.0
4.00733, 879.0
4.008, 880.0
4.00867, 882.0
4.00933, 883.0
4.01, 885.0
4.01067, 886.0
4.01133, 888.0
4.012, 889.0
4.01267, 891.0
4.01333, 892.0
4.014, 894.0
4.01467, 895.0
4.01533, 896.0
4.016, 898.0
4.01667, 899.0
4.01733, 901.0
4.018, 902.0
4.01867, 903.0
4.01933, 904.0
4.02, 906.0
4.02067, 907.0
4.02133, 909.0
4.022, 910.0
4.02267, 911.0
4.02333, 913.0
4.024, 914.0
4.02467, 916.0
4.02533, 917.0
4.026, 919.0
4.02667, 921.0
4.02733, 922.0
4.028, 924.0
4.02867, 925.0
4.02933, 927.0
4.03, 929.0
4.03067, 930.0
4.03133, 932.0
4.032, 933.0
4.03267, 935.0
4.03333, 936.0
4.034, 938.0
4.03467, 939.0
4.03533, 941.0
4.036, 942.0
4.03667, 944.0
4.03733, 945.0
4.038, 947.0
4.03867, 948.0
4.03933, 949.0
4.04, 951.0
4.04067, 952.0
4.04133, 953.0
4.042, 955.0
4.04267, 956.0
4.04333, 957.0
4.044, 959.0
4.04467, 960.0
4.04533, 961.0
4.046, 963.0
4.04667, 964.0
4.04733, 965.0
4.048, 967.0
4.04867, 968.0
4.04933, 970.0
4.05, 971.0
4.05067, 973.0
4.05133, 974.0
4.052, 976.0
4.05267, 978.0
4.05333, 979.0
4.054, 981.0
4.05467, 982.0
4.05533, 984.0
4.056, 985.0
4.05667, 987.0
4.05733, 989.0
4.058, 990.0
4.05867, 992.0
4.05933, 993.0
4.06, 995.0
4.06067, 996.0
4.06133, 998.0
4.062, 999.0
4.06267, 1000.0
4.06333, 1002.0
4.064, 1003.0
4.06467, 1004.0
4.06533, 1006.0
4.066, 1007.0
4.06667, 1009.0
4.06733, 1010.0
4.068, 1011.0
4.06867, 1013.0
4.06933, 1014.0
4.07, 1015.0
4.07067, 1017.0
4.07133, 1018.0
4.072, 1019.0
4.07267, 1021.0
4.07333, 1022.0
4.074, 1023.0
4.07467, 1025.0
4.07533, 1026.0
4.076, 1028.0
4.07667, 1029.0
4.07733, 1031.0
4.078, 1033.0
4.07867, 1034.0
4.07933, 1036.0
4.08, 1037.0
4.08067, 1038.0
4.08133, 1040.0
4.082, 1041.0
4.08267, 1043.0
4.08333, 1044.0
4.084, 1045.0
4.08467, 1046.0
4.08533, 1048.0
4.086, 1049.0
4.08667, 1050.0
4.08733, 1052.0
4.088, 1053.0
4.08867, 1054.0
4.08933, 1056.0
4.09, 1057.0
4.09067, 1059.0
4.09133, 1060.0
4.092, 1061.0
4.09267, 1063.0
4.09333, 1064.0
4.094, 1065.0
4.09467, 1067.0
4.09533, 1068.0
4.096, 1070.0
4.09667, 1071.0
4.09733, 1073.0
4.098, 1074.0
4.09867, 1076.0
4.09933, 1078.0
4.1, 1079.0
4.10067, 1081.0
4.10133, 1082.0
4.102, 1084.0
4.10267, 1086.0
4.10333, 1087.0
4.104, 1089.0
4.10467, 1091.0
4.10533, 1092.0
4.106, 1094.0
4.10667, 1096.0
4.10733, 1097.0
4.108, 1099.0
4.10867, 1100.0
4.10933, 1102.0
4.11, 1103.0
4.11067, 1105.0
4.11133, 1106.0
4.112, 1107.0
4.11267, 1109.0
4.11333, 1110.0
4.114, 1112.0
4.11467, 1113.0
4.11533, 1115.0
4.116, 1116.0
4.11667, 1117.0
4.11733, 1119.0
4.118, 1120.0
4.11867, 1121.0
4.11933, 1123.0
4.12, 1124.0
4.12067, 1125.0
4.12133, 1127.0
4.122, 1128.0
4.12267, 1129.0
4.12333, 1131.0
4.124, 1132.0
4.12467, 1134.0
4.12533, 1135.0
4.126, 1137.0
4.12667, 1138.0
4.12733, 1140.0
4.128, 1141.0
4.12867, 1142.0
4.12933, 1144.0
4.13, 1145.0
4.13067, 1146.0
4.13133, 1148.0
4.132, 1149.0
4.13267, 1151.0
4.13333, 1152.0
4.134, 1154.0
4.13467, 1156.0
4.13533, 1158.0
4.136, 1159.0
4.13667, 1161.0
4.13733, 1163.0
4.138, 1165.0
4.13867, 1167.0
4.13933, 1169.0
4.14, 1170.0
4.14067, 1172.0
4.14133, 1174.0
4.142, 1176.0
4.14267, 1177.0
4.14333, 1179.0
4.144, 1181.0
4.14467, 1182.0
4.14533, 1184.0
4.146, 1186.0
4.14667, 1187.0
4.14733, 1189.0
4.148, 1190.0
4.14867, 1192.0
4.14933, 1193.0
4.15, 1195.0
4.15067, 1196.0
4.15133, 1197.0
4.152, 1199.0
4.15267, 1200.0
4.15333, 1201.0
4.154, 1202.0
4.15467, 1203.0
4.15533, 1205.0
4.156, 1206.0
4.15667, 1207.0
4.15733, 1209.0
4.158, 1210.0
4.15867, 1211.0
4.15933, 1213.0
4.16, 1214.0
4.16067, 1215.0
4.16133, 1217.0
4.162, 1218.0
4.16267, 1219.0
4.16333, 1221.0
4.164, 1222.0
4.16467, 1223.0
4.16533, 1225.0
4.166, 1226.0
4.16667, 1228.0
4.16733, 1229.0
4.168, 1231.0
4.16867, 1232.0
4.16933, 1234.0
4.17, 1235.0
4.17067, 1237.0
4.17133, 1238.0
4.172, 1240.0
4.17267, 1241.0
4.17333, 1242.0
4.174, 1244.0
4.17467, 1245.0
4.17533, 1247.0
4.176, 1248.0
4.17667, 1250.0
4.17733, 1251.0
4.178, 1252.0
4.17867, 1254.0
4.17933, 1255.0
4.18, 1257.0
4.18067, 1258.0
4.18133, 1259.0
4.182, 1260.0
4.18267, 1262.0
4.18333, 1263.0
4.184, 1264.0
4.18467, 1265.0
4.18533, 1267.0
4.186, 1268.0
4.18667, 1269.0
4.18733, 1271.0
4.188, 1272.0
4.18867, 1274.0
4.18933, 1275.0
4.19, 1277.0
4.19067, 1279.0
4.19133, 1280.0
4.192, 1282.0
4.19267, 1284.0
4.19333, 1285.0
4.194, 1287.0
4.19467, 1289.0
4.19533, 1291.0
4.196, 1292.0
4.19667, 1294.0
4.19733, 1296.0
4.198, 1298.0
4.19867, 1299.0
4.19933, 1301.0
4.2, 1303.0
4.20067, 1305.0
4.20133, 1306.0
4.202, 1308.0
4.20267, 1310.0
4.20333, 1312.0
4.204, 1314.0
4.20467, 1316.0
4.20533, 1318.0
4.206, 1320.0
4.20667, 1322.0
4.20733, 1324.0
4.208, 1326.0
4.20867, 1328.0
4.20933, 1330.0
4.21, 1332.0
4.21067, 1334.0
4.21133, 1336.0
4.212, 1338.0
4.21267, 1339.0
4.21333, 1341.0
4.214, 1343.0
4.21467, 1344.0
4.21533, 1346.0
4.216, 1348.0
4.21667, 1349.0
4.21733, 1351.0
4.218, 1352.0
4.21867, 1354.0
4.21933, 1355.0
4.22, 1357.0
4.22067, 1358.0
4.22133, 1359.0
4.222, 1360.0
4.22267, 1362.0
4.22333, 1363.0
4.224, 1364.0
4.22467, 1365.0
4.22533, 1366.0
4.226, 1367.0
4.22667, 1369.0
4.22733, 1370.0
4.228, 1371.0
4.22867, 1373.0
4.22933, 1374.0
4.23, 1376.0
4.23067, 1378.0
4.23133, 1380.0
4.232, 1382.0
4.23267, 1384.0
4.23333, 1387.0
4.234, 1389.0
4.23467, 1392.0
4.23533, 1395.0
4.236, 1398.0
4.23667, 1401.0
4.23733, 1404.0
4.238, 1408.0
4.23867, 1411.0
4.23933, 1415.0
4.24, 1419.0
4.24067, 1423.0
4.24133, 1426.0
4.242, 1430.0
4.24267, 1434.0
4.24333, 1437.0
4.244, 1441.0
4.24467, 1444.0
4.24533, 1447.0
4.246, 1450.0
4.24667, 1453.0
4.24733, 1456.0
4.248, 1459.0
4.24867, 1462.0
4.24933, 1464.0
4.25, 1467.0
4.25067, 1469.0
4.25133, 1471.0
4.252, 1473.0
4.25267, 1475.0
4.25333, 1477.0
4.254, 1478.0
4.25467, 1480.0
4.25533, 1481.0
4.256, 1483.0
4.25667, 1484.0
4.25733, 1485.0
4.258, 1486.0
4.25867, 1487.0
4.25933, 1489.0
4.26, 1490.0
4.26067, 1491.0
4.26133, 1493.0
4.262, 1494.0
4.26267, 1496.0
4.26333, 1497.0
4.264, 1499.0
4.26467, 1501.0
4.26533, 1503.0
4.266, 1505.0
4.26667, 1507.0
4.26733, 1509.0
4.268, 1511.0
4.26867, 1514.0
4.26933, 1516.0
4.27, 1519.0
4.27067, 1521.0
4.27133, 1524.0
4.272, 1527.0
4.27267, 1529.0
4.27333, 1532.0
4.274, 1535.0
4.27467, 1537.0
4.27533, 1540.0
4.276, 1543.0
4.27667, 1546.0
4.27733, 1548.0
4.278, 1551.0
4.27867, 1554.0
4.27933, 1556.0
4.28, 1559.0
4.28067, 1562.0
4.28133, 1564.0
4.282, 1567.0
4.28267, 1569.0
4.28333, 1572.0
4.284, 1574.0
4.28467, 1576.0
4.28533, 1579.0
4.286, 1581.0
4.28667, 1583.0
4.28733, 1585.0
4.288, 1588.0
4.28867, 1590.0
4.28933, 1592.0
4.29, 1594.0
4.29067, 1596.0
4.29133, 1598.0
4.292, 1600.0
4.29267, 1602.0
4.29333, 1604.0
4.294, 1606.0
4.29467, 1608.0
4.29533, 1609.0
4.296, 1611.0
4.29667, 1613.0
4.29733, 1615.0
4.298, 1617.0
4.29867, 1619.0
4.29933, 1621.0
4.3, 1623.0
4.30067, 1626.0
4.30133, 1629.0
4.302, 1631.0
4.30267, 1634.0
4.30333, 1638.0
4.304, 1642.0
4.30467, 1646.0
4.30533, 1651.0
4.306, 1658.0
4.30667, 1665.0
4.30733, 1674.0
4.308, 1686.0
4.30867, 1699.0
4.30933, 1717.0
4.31, 1739.0
4.31067, 1766.0
4.31133, 1800.0
4.312, 1843.0
4.31267, 1896.0
4.31333, 1962.0
4.314, 2045.0
4.31467, 2147.0
4.31533, 2274.0
4.316, 2430.0
4.31667, 2621.0
4.31733, 2854.0
4.318, 3138.0
4.31867, 3481.0
4.31933, 3894.0
4.32, 4390.0
4.32067, 4982.0
4.32133, 5685.0
4.322, 6516.0
4.32267, 7494.0
4.32333, 8638.0
4.324, 9970.0
4.32467, 11513.0
4.32533, 13293.0
4.326, 15335.0
4.32667, 17666.0
4.32733, 20314.0
4.328, 23309.0
4.32867, 26679.0
4.32933, 30453.0
4.33, 34655.0
4.33067, 39310.0
4.33133, 44441.0
4.332, 50069.0
4.33267, 56209.0
4.33333, 62873.0
4.334, 70067.0
4.33467, 77791.0
4.33533, 86037.0
4.336, 94790.0
4.33667, 104029.0
4.33733, 113728.0
4.338, 123853.0
4.33867, 134357.0
4.33933, 145190.0
4.34, 156291.0
4.34067, 167596.0
4.34133, 179032.0
4.342, 190526.0
4.34267, 201999.0
4.34333, 213374.0
4.344, 224572.0
4.34467, 235514.0
4.34533, 246117.0
4.346, 256303.0
4.34667, 265995.0
4.34733, 275124.0
4.348, 283623.0
4.34867, 291434.0
4.34933, 298506.0
4.35, 304793.0
4.35067, 310259.0
4.35133, 314873.0
4.352, 318616.0
4.35267, 321473.0
4.35333, 323440.0
4.354, 324515.0
4.35467, 324708.0
4.35533, 324030.0
4.356, 322503.0
4.35667, 320152.0
4.35733, 317010.0
4.358, 313114.0
4.35867, 308508.0
4.35933, 303240.0
4.36, 297361.0
4.36067, 290922.0
4.36133, 283978.0
4.362, 276585.0
4.36267, 268800.0
4.36333, 260680.0
4.364, 252279.0
4.36467, 243653.0
4.36533, 234854.0
4.366, 225933.0
4.36667, 216938.0
4.36733, 207916.0
4.368, 198910.0
4.36867, 189959.0
4.36933, 181100.0
4.37, 172367.0
4.37067, 163790.0
4.37133, 155396.0
4.372, 147208.0
4.37267, 139247.0
4.37333, 131528.0
4.374, 124067.0
4.37467, 116874.0
4.37533, 109958.0
4.376, 103324.0
4.37667, 96976.0
4.37733, 90916.0
4.378, 85143.0
4.37867, 79655.0
4.37933, 74448.0
4.38, 69517.0
4.38067, 64857.0
4.38133, 60460.0
4.382, 56319.0
4.38267, 52425.0
4.38333, 48768.0
4.384, 45340.0
4.38467, 42131.0
4.38533, 39131.0
4.386, 36330.0
4.38667, 33718.0
4.38733, 31285.0
4.388, 29022.0
4.38867, 26919.0
4.38933, 24967.0
4.39, 23157.0
4.39067, 21480.0
4.39133, 19928.0
4.392, 18493.0
4.39267, 17167.0
4.39333, 15943.0
4.394, 14813.0
4.39467, 13772.0
4.39533, 12813.0
4.396, 11930.0
4.39667, 11118.0
4.39733, 10371.0
4.398, 9685.0
4.39867, 9055.0
4.39933, 8476.0
4.4, 7945.0
4.40067, 7458.0
4.40133, 7012.0
4.402, 6602.0
4.40267, 6227.0
4.40333, 5884.0
4.404, 5569.0
4.40467, 5281.0
4.40533, 5018.0
4.406, 4777.0
4.40667, 4556.0
4.40733, 4354.0
4.408, 4170.0
4.40867, 4001.0
4.40933, 3847.0
4.41, 3706.0
4.41067, 3576.0
4.41133, 3458.0
4.412, 3350.0
4.41267, 3251.0
4.41333, 3161.0
4.414, 3078.0
4.41467, 3002.0
4.41533, 2933.0
4.416, 2870.0
4.41667, 2812.0
4.41733, 2758.0
4.418, 2710.0
4.41867, 2665.0
4.41933, 2624.0
4.42, 2586.0
4.42067, 2552.0
4.42133, 2520.0
4.422, 2491.0
4.42267, 2464.0
4.42333, 2439.0
4.424, 2417.0
4.42467, 2396.0
4.42533, 2376.0
4.426, 2359.0
4.42667, 2342.0
4.42733, 2327.0
4.428, 2313.0
4.42867, 2300.0
4.42933, 2288.0
4.43, 2277.0
4.43067, 2267.0
4.43133, 2258.0
4.432, 2249.0
4.43267, 2241.0
4.43333, 2234.0
4.434, 2227.0
4.43467, 2221.0
4.43533, 2215.0
4.436, 2210.0
4.43667, 2205.0
4.43733, 2200.0
4.438, 2196.0
4.43867, 2193.0
4.43933, 2189.0
4.44, 2186.0
4.44067, 2184.0
4.44133, 2181.0
4.442, 2179.0
4.44267, 2177.0
4.44333, 2176.0
4.444, 2174.0
4.44467, 2173.0
4.44533, 2172.0
4.446, 2170.0
4.44667, 2169.0
4.44733, 2168.0
4.448, 2168.0
4.44867, 2167.0
4.44933, 2166.0
4.45, 2166.0
4.45067, 2165.0
4.45133, 2165.0
4.452, 2165.0
4.45267, 2164.0
4.45333, 2164.0
4.454, 2163.0
4.45467, 2163.0
4.45533, 2163.0
4.456, 2163.0
4.45667, 2163.0
4.45733, 2162.0
4.458, 2162.0
4.45867, 2162.0
4.45933, 2163.0
4.46, 2163.0
4.46067, 2163.0
4.46133, 2163.0
4.462, 2164.0
4.46267, 2164.0
4.46333, 2165.0
4.464, 2165.0
4.46467, 2166.0
4.46533, 2167.0
4.466, 2168.0
4.46667, 2169.0
4.46733, 2170.0
4.468, 2171.0
4.46867, 2172.0
4.46933, 2174.0
4.47, 2175.0
4.47067, 2176.0
4.47133, 2177.0
4.472, 2179.0
4.47267, 2180.0
4.47333, 2181.0
4.474, 2183.0
4.47467, 2184.0
4.47533, 2185.0
4.476, 2186.0
4.47667, 2188.0
4.47733, 2189.0
4.478, 2191.0
4.47867, 2192.0
4.47933, 2194.0
4.48, 2195.0
4.48067, 2197.0
4.48133, 2199.0
4.482, 2200.0
4.48267, 2202.0
4.48333, 2204.0
4.484, 2206.0
4.48467, 2208.0
4.48533, 2210.0
4.486, 2211.0
4.48667, 2213.0
4.48733, 2214.0
4.488, 2216.0
4.48867, 2218.0
4.48933, 2220.0
4.49, 2221.0
4.49067, 2223.0
4.49133, 2225.0
4.492, 2227.0
4.49267, 2229.0
4.49333, 2231.0
4.494, 2233.0
4.49467, 2235.0
4.49533, 2237.0
4.496, 2239.0
4.49667, 2241.0
4.49733, 2243.0
4.498, 2245.0
4.49867, 2247.0
4.49933, 2249.0
4.5, 2251.0
4.50067, 2253.0
4.50133, 2255.0
4.502, 2258.0
4.50267, 2260.0
4.50333, 2262.0
4.504, 2264.0
4.50467, 2266.0
4.50533, 2268.0
4.506, 2270.0
4.50667, 2272.0
4.50733, 2275.0
4.508, 2277.0
4.50867, 2279.0
4.50933, 2281.0
4.51, 2284.0
4.51067, 2286.0
4.51133, 2288.0
4.512, 2290.0
4.51267, 2293.0
4.51333, 2295.0
4.514, 2297.0
4.51467, 2299.0
4.51533, 2302.0
4.516, 2304.0
4.51667, 2306.0
4.51733, 2309.0
4.518, 2311.0
4.51867, 2313.0
4.51933, 2316.0
4.52, 2318.0
4.52067, 2321.0
4.52133, 2323.0
4.522, 2326.0
4.52267, 2329.0
4.52333, 2331.0
4.524, 2334.0
4.52467, 2336.0
4.52533, 2339.0
4.526, 2342.0
4.52667, 2344.0
4.52733, 2347.0
4.528, 2349.0
4.52867, 2352.0
4.52933, 2354.0
4.53, 2356.0
4.53067, 2359.0
4.53133, 2361.0
4.532, 2363.0
4.53267, 2366.0
4.53333, 2368.0
4.534, 2370.0
4.53467, 2372.0
4.53533, 2375.0
4.536, 2377.0
4.53667, 2379.0
4.53733, 2382.0
4.538, 2384.0
4.53867, 2387.0
4.53933, 2389.0
4.54, 2392.0
4.54067, 2394.0
4.54133, 2397.0
4.542, 2399.0
4.54267, 2402.0
4.54333, 2404.0
4.544, 2406.0
4.54467, 2409.0
4.54533, 2411.0
4.546, 2414.0
4.54667, 2416.0
4.54733, 2419.0
4.548, 2421.0
4.54867, 2423.0
4.54933, 2426.0
4.55, 2428.0
4.55067, 2431.0
4.55133, 2433.0
4.552, 2436.0
4.55267, 2438.0
4.55333, 2441.0
4.554, 2443.0
4.55467, 2445.0
4.55533, 2448.0
4.556, 2450.0
4.55667, 2452.0
4.55733, 2455.0
4.558, 2457.0
4.55867, 2459.0
4.55933, 2462.0
4.56, 2464.0
4.56067, 2467.0
4.56133, 2469.0
4.562, 2471.0
4.56267, 2474.0
4.56333, 2477.0
4.564, 2479.0
4.56467, 2482.0
4.56533, 2484.0
4.566, 2487.0
4.56667, 2489.0
4.56733, 2492.0
4.568, 2494.0
4.56867, 2497.0
4.56933, 2500.0
4.57, 2502.0
4.57067, 2505.0
4.57133, 2507.0
4.572, 2510.0
4.57267, 2513.0
4.57333, 2515.0
4.574, 2518.0
4.57467, 2520.0
4.57533, 2523.0
4.576, 2525.0
4.57667, 2527.0
4.57733, 2530.0
4.578, 2532.0
4.57867, 2535.0
4.57933, 2538.0
4.58, 2540.0
4.58067, 2543.0
4.58133, 2546.0
4.582, 2548.0
4.58267, 2551.0
4.58333, 2553.0
4.584, 2556.0
4.58467, 2558.0
4.58533, 2560.0
4.586, 2563.0
4.58667, 2566.0
4.58733, 2568.0
4.588, 2571.0
4.58867, 2573.0
4.58933, 2576.0
4.59, 2579.0
4.59067, 2582.0
4.59133, 2585.0
4.592, 2588.0
4.59267, 2591.0
4.59333, 2594.0
4.594, 2597.0
4.59467, 2600.0
4.59533, 2603.0
4.596, 2606.0
4.59667, 2609.0
4.59733, 2612.0
4.598, 2615.0
4.59867, 2618.0
4.59933, 2620.0
4.6, 2623.0
4.60067, 2626.0
4.60133, 2629.0
4.602, 2632.0
4.60267, 2635.0
4.60333, 2638.0
4.604, 2641.0
4.60467, 2644.0
4.60533, 2647.0
4.606, 2650.0
4.60667, 2653.0
4.60733, 2657.0
4.608, 2659.0
4.60867, 2663.0
4.60933, 2666.0
4.61, 2669.0
4.61067, 2672.0
4.61133, 2674.0
4.612, 2677.0
4.61267, 2680.0
4.61333, 2683.0
4.614, 2686.0
4.61467, 2688.0
4.61533, 2691.0
4.616, 2694.0
4.61667, 2696.0
4.61733, 2699.0
4.618, 2701.0
4.61867, 2704.0
4.61933, 2706.0
4.62, 2708.0
4.62067, 2711.0
4.62133, 2713.0
4.622, 2716.0
4.62267, 2718.0
4.62333, 2721.0
4.624, 2723.0
4.62467, 2726.0
4.62533, 2729.0
4.626, 2731.0
4.62667, 2734.0
4.62733, 2737.0
4.628, 2740.0
4.62867, 2743.0
4.62933, 2746.0
4.63, 2749.0
4.63067, 2752.0
4.63133, 2755.0
4.632, 2758.0
4.63267, 2761.0
4.63333, 2765.0
4.634, 2768.0
4.63467, 2771.0
4.63533, 2775.0
4.636, 2778.0
4.63667, 2781.0
4.63733, 2785.0
4.638, 2788.0
4.63867, 2792.0
4.63933, 2795.0
4.64, 2799.0
4.64067, 2802.0
4.64133, 2806.0
4.642, 2809.0
4.64267, 2812.0
4.64333, 2816.0
4.644, 2819.0
4.64467, 2822.0
4.64533, 2825.0
4.646, 2829.0
4.64667, 2832.0
4.64733, 2835.0
4.648, 2838.0
4.64867, 2841.0
4.64933, 2844.0
4.65, 2847.0
4.65067, 2850.0
4.65133, 2853.0
4.652, 2856.0
4.65267, 2859.0
4.65333, 2862.0
4.654, 2865.0
4.65467, 2868.0
4.65533, 2872.0
4.656, 2875.0
4.65667, 2878.0
4.65733, 2881.0
4.658, 2885.0
4.65867, 2888.0
4.65933, 2891.0
4.66, 2894.0
4.66067, 2897.0
4.66133, 2900.0
4.662, 2903.0
4.66267, 2906.0
4.66333, 2909.0
4.664, 2913.0
4.66467, 2916.0
4.66533, 2919.0
4.666, 2922.0
4.66667, 2926.0
4.66733, 2929.0
4.668, 2932.0
4.66867, 2936.0
4.66933, 2939.0
4.67, 2942.0
4.67067, 2946.0
4.67133, 2949.0
4.672, 2952.0
4.67267, 2956.0
4.67333, 2959.0
4.674, 2963.0
4.67467, 2966.0
4.67533, 2970.0
4.676, 2973.0
4.67667, 2976.0
4.67733, 2980.0
4.678, 2983.0
4.67867, 2986.0
4.67933, 2990.0
4.68, 2993.0
4.68067, 2997.0
4.68133, 3000.0
4.682, 3004.0
4.68267, 3007.0
4.68333, 3011.0
4.684, 3015.0
4.68467, 3018.0
4.68533, 3022.0
4.686, 3026.0
4.68667, 3030.0
4.68733, 3033.0
4.688, 3037.0
4.68867, 3041.0
4.68933, 3045.0
4.69, 3049.0
4.69067, 3053.0
4.69133, 3057.0
4.692, 3061.0
4.69267, 3065.0
4.69333, 3069.0
4.694, 3073.0
4.69467, 3077.0
4.69533, 3081.0
4.696, 3085.0
4.69667, 3089.0
4.69733, 3093.0
4.698, 3096.0
4.69867, 3100.0
4.69933, 3104.0
4.7, 3107.0
4.70067, 3111.0
4.70133, 3114.0
4.702, 3118.0
4.70267, 3121.0
4.70333, 3124.0
4.704, 3128.0
4.70467, 3131.0
4.70533, 3135.0
4.706, 3139.0
4.70667, 3142.0
4.70733, 3146.0
4.708, 3150.0
4.70867, 3154.0
4.70933, 3158.0
4.71, 3162.0
4.71067, 3166.0
4.71133, 3170.0
4.712, 3174.0
4.71267, 3178.0
4.71333, 3183.0
4.714, 3187.0
4.71467, 3191.0
4.71533, 3195.0
4.716, 3200.0
4.71667, 3204.0
4.71733, 3208.0
4.718, 3212.0
4.71867, 3217.0
4.71933, 3221.0
4.72, 3226.0
4.72067, 3230.0
4.72133, 3235.0
4.722, 3239.0
4.72267, 3244.0
4.72333, 3248.0
4.724, 3253.0
4.72467, 3257.0
4.72533, 3262.0
4.726, 3266.0
4.72667, 3270.0
4.72733, 3275.0
4.728, 3279.0
4.72867, 3284.0
4.72933, 3288.0
4.73, 3292.0
4.73067, 3297.0
4.73133, 3302.0
4.732, 3306.0
4.73267, 3311.0
4.73333, 3315.0
4.734, 3320.0
4.73467, 3324.0
4.73533, 3328.0
4.736, 3333.0
4.73667, 3337.0
4.73733, 3341.0
4.738, 3346.0
4.73867, 3350.0
4.73933, 3354.0
4.74, 3359.0
4.74067, 3363.0
4.74133, 3368.0
4.742, 3372.0
4.74267, 3377.0
4.74333, 3381.0
4.744, 3385.0
4.74467, 3389.0
4.74533, 3393.0
4.746, 3398.0
4.74667, 3401.0
4.74733, 3405.0
4.748, 3409.0
4.74867, 3413.0
4.74933, 3417.0
4.75, 3420.0
4.75067, 3424.0
4.75133, 3427.0
4.752, 3431.0
4.75267, 3434.0
4.75333, 3437.0
4.754, 3441.0
4.75467, 3444.0
4.75533, 3447.0
4.756, 3450.0
4.75667, 3454.0
4.75733, 3457.0
4.758, 3460.0
4.75867, 3463.0
4.75933, 3467.0
4.76, 3471.0
4.76067, 3474.0
4.76133, 3478.0
4.762, 3482.0
4.76267, 3486.0
4.76333, 3490.0
4.764, 3495.0
4.76467, 3499.0
4.76533, 3504.0
4.766, 3508.0
4.76667, 3513.0
4.76733, 3518.0
4.768, 3523.0
4.76867, 3528.0
4.76933, 3533.0
4.77, 3538.0
4.77067, 3544.0
4.77133, 3549.0
4.772, 3554.0
4.77267, 3560.0
4.77333, 3565.0
4.774, 3570.0
4.77467, 3575.0
4.77533, 3580.0
4.776, 3585.0
4.77667, 3589.0
4.77733, 3594.0
4.778, 3598.0
4.77867, 3603.0
4.77933, 3607.0
4.78, 3611.0
4.78067, 3616.0
4.78133, 3620.0
4.782, 3624.0
4.78267, 3628.0
4.78333, 3632.0
4.784, 3636.0
4.78467, 3640.0
4.78533, 3644.0
4.786, 3648.0
4.78667, 3652.0
4.78733, 3656.0
4.788, 3660.0
4.78867, 3664.0
4.78933, 3668.0
4.79, 3672.0
4.79067, 3676.0
4.79133, 3680.0
4.792, 3684.0
4.79267, 3689.0
4.79333, 3693.0
4.794, 3698.0
4.79467, 3702.0
4.79533, 3707.0
4.796, 3712.0
4.79667, 3716.0
4.79733, 3721.0
4.798, 3727.0
4.79867, 3732.0
4.79933, 3737.0
4.8, 3742.0
4.80067, 3748.0
4.80133, 3753.0
4.802, 3759.0
4.80267, 3765.0
4.80333, 3770.0
4.804, 3776.0
4.80467, 3781.0
4.80533, 3786.0
4.806, 3792.0
4.80667, 3797.0
4.80733, 3802.0
4.808, 3807.0
4.80867, 3812.0
4.80933, 3817.0
4.81, 3822.0
4.81067, 3827.0
4.81133, 3832.0
4.812, 3837.0
4.81267, 3841.0
4.81333, 3845.0
4.814, 3850.0
4.81467, 3854.0
4.81533, 3859.0
4.816, 3863.0
4.81667, 3867.0
4.81733, 3871.0
4.818, 3876.0
4.81867, 3880.0
4.81933, 3884.0
4.82, 3888.0
4.82067, 3892.0
4.82133, 3896.0
4.822, 3900.0
4.82267, 3904.0
4.82333, 3908.0
4.824, 3912.0
4.82467, 3916.0
4.82533, 3920.0
4.826, 3925.0
4.82667, 3929.0
4.82733, 3933.0
4.828, 3937.0
4.82867, 3942.0
4.82933, 3946.0
4.83, 3950.0
4.83067, 3955.0
4.83133, 3959.0
4.832, 3964.0
4.83267, 3968.0
4.83333, 3972.0
4.834, 3977.0
4.83467, 3982.0
4.83533, 3986.0
4.836, 3991.0
4.83667, 3995.0
4.83733, 4000.0
4.838, 4005.0
4.83867, 4010.0
4.83933, 4015.0
4.84, 4020.0
4.84067, 4024.0
4.84133, 4029.0
4.842, 4034.0
4.84267, 4038.0
4.84333, 4042.0
4.844, 4047.0
4.84467, 4051.0
4.84533, 4056.0
4.846, 4060.0
4.84667, 4065.0
4.84733, 4069.0
4.848, 4074.0
4.84867, 4078.0
4.84933, 4082.0
4.85, 4087.0
4.85067, 4091.0
4.85133, 4095.0
4.852, 4099.0
4.85267, 4103.0
4.85333, 4108.0
4.854, 4112.0
4.85467, 4116.0
4.85533, 4120.0
4.856, 4125.0
4.85667, 4129.0
4.85733, 4134.0
4.858, 4138.0
4.85867, 4143.0
4.85933, 4148.0
4.86, 4152.0
4.86067, 4157.0
4.86133, 4161.0
4.862, 4166.0
4.86267, 4171.0
4.86333, 4175.0
4.864, 4180.0
4.86467, 4185.0
4.86533, 4190.0
4.866, 4194.0
4.86667, 4199.0
4.86733, 4204.0
4.868, 4209.0
4.86867, 4213.0
4.86933, 4218.0
4.87, 4223.0
4.87067, 4228.0
4.87133, 4232.0
4.872, 4237.0
4.87267, 4242.0
4.87333, 4247.0
4.874, 4251.0
4.87467, 4256.0
4.87533, 4261.0
4.876, 4265.0
4.87667, 4270.0
4.87733, 4274.0
4.878, 4279.0
4.87867, 4284.0
4.87933, 4288.0
4.88, 4293.0
4.88067, 4298.0
4.88133, 4302.0
4.882, 4307.0
4.88267, 4312.0
4.88333, 4316.0
4.884, 4321.0
4.88467, 4326.0
4.88533, 4330.0
4.886, 4335.0
4.88667, 4340.0
4.88733, 4344.0
4.888, 4349.0
4.88867, 4354.0
4.88933, 4358.0
4.89, 4363.0
4.89067, 4367.0
4.89133, 4372.0
4.892, 4376.0
4.89267, 4381.0
4.89333, 4385.0
4.894, 4390.0
4.89467, 4395.0
4.89533, 4399.0
4.896, 4404.0
4.89667, 4409.0
4.89733, 4414.0
4.898, 4419.0
4.89867, 4423.0
4.89933, 4428.0
4.9, 4433.0
4.90067, 4438.0
4.90133, 4442.0
4.902, 4447.0
4.90267, 4452.0
4.90333, 4457.0
4.904, 4462.0
4.90467, 4467.0
4.90533, 4471.0
4.906, 4476.0
4.90667, 4481.0
4.90733, 4486.0
4.908, 4491.0
4.90867, 4495.0
4.90933, 4500.0
4.91, 4505.0
4.91067, 4509.0
4.91133, 4514.0
4.912, 4518.0
4.91267, 4523.0
4.91333, 4527.0
4.914, 4532.0
4.91467, 4536.0
4.91533, 4541.0
4.916, 4545.0
4.91667, 4550.0
4.91733, 4554.0
4.918, 4559.0
4.91867, 4563.0
4.91933, 4568.0
4.92, 4572.0
4.92067, 4577.0
4.92133, 4581.0
4.922, 4585.0
4.92267, 4590.0
4.92333, 4594.0
4.924, 4599.0
4.92467, 4603.0
4.92533, 4608.0
4.926, 4612.0
4.92667, 4617.0
4.92733, 4621.0
4.928, 4626.0
4.92867, 4631.0
4.92933, 4635.0
4.93, 4640.0
4.93067, 4645.0
4.93133, 4650.0
4.932, 4655.0
4.93267, 4660.0
4.93333, 4665.0
4.934, 4670.0
4.93467, 4675.0
4.93533, 4680.0
4.936, 4685.0
4.93667, 4690.0
4.93733, 4695.0
4.938, 4700.0
4.93867, 4705.0
4.93933, 4709.0
4.94, 4714.0
4.94067, 4719.0
4.94133, 4723.0
4.942, 4728.0
4.94267, 4732.0
4.94333, 4736.0
4.944, 4740.0
4.94467, 4745.0
4.94533, 4749.0
4.946, 4754.0
4.94667, 4758.0
4.94733, 4763.0
4.948, 4767.0
4.94867, 4772.0
4.94933, 4776.0
4.95, 4781.0
4.95067, 4785.0
4.95133, 4790.0
4.952, 4794.0
4.95267, 4799.0
4.95333, 4804.0
4.954, 4808.0
4.95467, 4813.0
4.95533, 4817.0
4.956, 4822.0
4.95667, 4826.0
4.95733, 4831.0
4.958, 4835.0
4.95867, 4840.0
4.95933, 4844.0
4.96, 4849.0
4.96067, 4853.0
4.96133, 4858.0
4.962, 4862.0
4.96267, 4867.0
4.96333, 4871.0
4.964, 4876.0
4.96467, 4880.0
4.96533, 4885.0
4.966, 4889.0
4.96667, 4893.0
4.96733, 4897.0
4.968, 4902.0
4.96867, 4906.0
4.96933, 4910.0
4.97, 4914.0
4.97067, 4918.0
4.97133, 4922.0
4.972, 4926.0
4.97267, 4930.0
4.97333, 4934.0
4.974, 4938.0
4.97467, 4942.0
4.97533, 4946.0
4.976, 4950.0
4.97667, 4954.0
4.97733, 4958.0
4.978, 4962.0
4.97867, 4966.0
4.97933, 4971.0
4.98, 4975.0
4.98067, 4979.0
4.98133, 4983.0
4.982, 4988.0
4.98267, 4992.0
4.98333, 4997.0
4.984, 5001.0
4.98467, 5006.0
4.98533, 5011.0
4.986, 5015.0
4.98667, 5020.0
4.98733, 5024.0
4.988, 5029.0
4.98867, 5034.0
4.98933, 5039.0
4.99, 5044.0
4.99067, 5049.0
4.99133, 5055.0
4.992, 5060.0
4.99267, 5065.0
4.99333, 5071.0
4.994, 5077.0
4.99467, 5083.0
4.99533, 5089.0
4.996, 5095.0
4.99667, 5101.0
4.99733, 5108.0
4.998, 5114.0
4.99867, 5121.0
4.99933, 5128.0
5.0, 5134.0
5.00067, 5141.0
5.00133, 5148.0
5.002, 5155.0
5.00267, 5162.0
5.00333, 5169.0
5.004, 5177.0
5.00467, 5184.0
5.00533, 5191.0
5.006, 5198.0
5.00667, 5205.0
5.00733, 5212.0
5.008, 5219.0
5.00867, 5226.0
5.00933, 5233.0
5.01, 5239.0
5.01067, 5245.0
5.01133, 5252.0
5.012, 5258.0
5.01267, 5264.0
5.01333, 5270.0
5.014, 5276.0
5.01467, 5282.0
5.01533, 5289.0
5.016, 5295.0
5.01667, 5301.0
5.01733, 5306.0
5.018, 5312.0
5.01867, 5318.0
5.01933, 5323.0
5.02, 5328.0
5.02067, 5334.0
5.02133, 5339.0
5.022, 5344.0
5.02267, 5348.0
5.02333, 5353.0
5.024, 5358.0
5.02467, 5362.0
5.02533, 5366.0
5.026, 5371.0
5.02667, 5375.0
5.02733, 5380.0
5.028, 5384.0
5.02867, 5388.0
5.02933, 5393.0
5.03, 5397.0
5.03067, 5402.0
5.03133, 5407.0
5.032, 5411.0
5.03267, 5416.0
5.03333, 5421.0
5.034, 5425.0
5.03467, 5430.0
5.03533, 5435.0
5.036, 5440.0
5.03667, 5445.0
5.03733, 5450.0
5.038, 5455.0
5.03867, 5460.0
5.03933, 5465.0
5.04, 5470.0
5.04067, 5475.0
5.04133, 5480.0
5.042, 5485.0
5.04267, 5491.0
5.04333, 5496.0
5.044, 5501.0
5.04467, 5506.0
5.04533, 5511.0
5.046, 5516.0
5.04667, 5521.0
5.04733, 5526.0
5.048, 5530.0
5.04867, 5535.0
5.04933, 5540.0
5.05, 5544.0
5.05067, 5549.0
5.05133, 5553.0
5.052, 5558.0
5.05267, 5562.0
5.05333, 5566.0
5.054, 5571.0
5.05467, 5575.0
5.05533, 5579.0
5.056, 5583.0
5.05667, 5587.0
5.05733, 5591.0
5.058, 5596.0
5.05867, 5600.0
5.05933, 5604.0
5.06, 5608.0
5.06067, 5613.0
5.06133, 5617.0
5.062, 5622.0
5.06267, 5626.0
5.06333, 5631.0
5.064, 5636.0
5.06467, 5640.0
5.06533, 5645.0
5.066, 5650.0
5.06667, 5655.0
5.06733, 5660.0
5.068, 5666.0
5.06867, 5671.0
5.06933, 5676.0
5.07, 5682.0
5.07067, 5687.0
5.07133, 5693.0
5.072, 5698.0
5.07267, 5703.0
5.07333, 5709.0
5.074, 5714.0
5.07467, 5720.0
5.07533, 5725.0
5.076, 5731.0
5.07667, 5737.0
5.07733, 5742.0
5.078, 5748.0
5.07867, 5754.0
5.07933, 5759.0
5.08, 5765.0
5.08067, 5771.0
5.08133, 5776.0
5.082, 5782.0
5.08267, 5787.0
5.08333, 5793.0
5.084, 5798.0
5.08467, 5804.0
5.08533, 5810.0
5.086, 5815.0
5.08667, 5821.0
5.08733, 5826.0
5.088, 5832.0
5.08867, 5837.0
5.08933, 5843.0
5.09, 5848.0
5.09067, 5854.0
5.09133, 5859.0
5.092, 5865.0
5.09267, 5870.0
5.09333, 5876.0
5.094, 5882.0
5.09467, 5887.0
5.09533, 5893.0
5.096, 5899.0
5.09667, 5905.0
5.09733, 5911.0
5.098, 5917.0
5.09867, 5923.0
5.09933, 5930.0
5.1, 5936.0
5.10067, 5942.0
5.10133, 5949.0
5.102, 5955.0
5.10267, 5962.0
5.10333, 5968.0
5.104, 5975.0
5.10467, 5982.0
5.10533, 5988.0
5.106, 5995.0
5.10667, 6001.0
5.10733, 6008.0
5.108, 6014.0
5.10867, 6020.0
5.10933, 6026.0
5.11, 6033.0
5.11067, 6039.0
5.11133, 6045.0
5.112, 6050.0
5.11267, 6056.0
5.11333, 6062.0
5.114, 6068.0
5.11467, 6073.0
5.11533, 6079.0
5.116, 6085.0
5.11667, 6091.0
5.11733, 6097.0
5.118, 6102.0
5.11867, 6108.0
5.11933, 6114.0
5.12, 6120.0
5.12067, 6126.0
5.12133, 6132.0
5.122, 6138.0
5.12267, 6144.0
5.12333, 6150.0
5.124, 6156.0
5.12467, 6162.0
5.12533, 6169.0
5.126, 6175.0
5.12667, 6182.0
5.12733, 6189.0
5.128, 6195.0
5.12867, 6202.0
5.12933, 6209.0
5.13, 6216.0
5.13067, 6222.0
5.13133, 6229.0
5.132, 6236.0
5.13267, 6243.0
5.13333, 6250.0
5.134, 6257.0
5.13467, 6264.0
5.13533, 6272.0
5.136, 6279.0
5.13667, 6286.0
5.13733, 6293.0
5.138, 6300.0
5.13867, 6307.0
5.13933, 6314.0
5.14, 6320.0
5.14067, 6327.0
5.14133, 6334.0
5.142, 6340.0
5.14267, 6347.0
5.14333, 6353.0
5.144, 6360.0
5.14467, 6366.0
5.14533, 6372.0
5.146, 6379.0
5.14667, 6385.0
5.14733, 6391.0
5.148, 6397.0
5.14867, 6403.0
5.14933, 6410.0
5.15, 6416.0
5.15067, 6422.0
5.15133, 6428.0
5.152, 6435.0
5.15267, 6441.0
5.15333, 6447.0
5.154, 6454.0
5.15467, 6460.0
5.15533, 6466.0
5.156, 6473.0
5.15667, 6479.0
5.15733, 6486.0
5.158, 6492.0
5.15867, 6499.0
5.15933, 6505.0
5.16, 6512.0
5.16067, 6518.0
5.16133, 6525.0
5.162, 6531.0
5.16267, 6538.0
5.16333, 6545.0
5.164, 6551.0
5.16467, 6558.0
5.16533, 6565.0
5.166, 6572.0
5.16667, 6578.0
5.16733, 6585.0
5.168, 6591.0
5.16867, 6598.0
5.16933, 6604.0
5.17, 6610.0
5.17067, 6617.0
5.17133, 6623.0
5.172, 6629.0
5.17267, 6635.0
5.17333, 6641.0
5.174, 6647.0
5.17467, 6653.0
5.17533, 6659.0
5.176, 6665.0
5.17667, 6671.0
5.17733, 6677.0
5.178, 6683.0
5.17867, 6689.0
5.17933, 6694.0
5.18, 6700.0
5.18067, 6706.0
5.18133, 6711.0
5.182, 6717.0
5.18267, 6723.0
5.18333, 6728.0
5.184, 6734.0
5.18467, 6740.0
5.18533, 6745.0
5.186, 6751.0
5.18667, 6757.0
5.18733, 6762.0
5.188, 6768.0
5.18867, 6774.0
5.18933, 6779.0
5.19, 6785.0
5.19067, 6791.0
5.19133, 6796.0
5.192, 6802.0
5.19267, 6808.0
5.19333, 6814.0
5.194, 6820.0
5.19467, 6826.0
5.19533, 6832.0
5.196, 6838.0
5.19667, 6845.0
5.19733, 6851.0
5.198, 6857.0
5.19867, 6864.0
5.19933, 6870.0
5.2, 6877.0
5.20067, 6883.0
5.20133, 6890.0
5.202, 6897.0
5.20267, 6904.0
5.20333, 6911.0
5.204, 6918.0
5.20467, 6924.0
5.20533, 6931.0
5.206, 6938.0
5.20667, 6944.0
5.20733, 6950.0
5.208, 6957.0
5.20867, 6963.0
5.20933, 6969.0
5.21, 6975.0
5.21067, 6981.0
5.21133, 6987.0
5.212, 6993.0
5.21267, 6999.0
5.21333, 7005.0
5.214, 7011.0
5.21467, 7017.0
5.21533, 7022.0
5.216, 7028.0
5.21667, 7034.0
5.21733, 7039.0
5.218, 7045.0
5.21867, 7051.0
5.21933, 7056.0
5.22, 7062.0
5.22067, 7068.0
5.22133, 7074.0
5.222, 7080.0
5.22267, 7085.0
5.22333, 7091.0
5.224, 7097.0
5.22467, 7103.0
5.22533, 7109.0
5.226, 7116.0
5.22667, 7122.0
5.22733, 7128.0
5.228, 7134.0
5.22867, 7141.0
5.22933, 7147.0
5.23, 7153.0
5.23067, 7159.0
5.23133, 7165.0
5.232, 7170.0
5.23267, 7176.0
5.23333, 7182.0
5.234, 7188.0
5.23467, 7194.0
5.23533, 7200.0
5.236, 7205.0
5.23667, 7211.0
5.23733, 7217.0
5.238, 7223.0
5.23867, 7230.0
5.23933, 7236.0
5.24, 7242.0
5.24067, 7248.0
5.24133, 7254.0
5.242, 7260.0
5.24267, 7267.0
5.24333, 7273.0
5.244, 7279.0
5.24467, 7285.0
5.24533, 7292.0
5.246, 7298.0
5.24667, 7304.0
5.24733, 7310.0
5.248, 7316.0
5.24867, 7322.0
5.24933, 7328.0
5.25, 7333.0
5.25067, 7339.0
5.25133, 7345.0
5.252, 7351.0
5.25267, 7357.0
5.25333, 7363.0
5.254, 7369.0
5.25467, 7375.0
5.25533, 7381.0
5.256, 7387.0
5.25667, 7393.0
5.25733, 7400.0
5.258, 7406.0
5.25867, 7412.0
5.25933, 7419.0
5.26, 7425.0
5.26067, 7432.0
5.26133, 7438.0
5.262, 7445.0
5.26267, 7451.0
5.26333, 7458.0
5.264, 7465.0
5.26467, 7472.0
5.26533, 7479.0
5.266, 7486.0
5.26667, 7493.0
5.26733, 7500.0
5.268, 7507.0
5.26867, 7514.0
5.26933, 7521.0
5.27, 7529.0
5.27067, 7536.0
5.27133, 7543.0
5.272, 7551.0
5.27267, 7559.0
5.27333, 7566.0
5.274, 7574.0
5.27467, 7581.0
5.27533, 7589.0
5.276, 7597.0
5.27667, 7605.0
5.27733, 7612.0
5.278, 7620.0
5.27867, 7628.0
5.27933, 7635.0
5.28, 7643.0
5.28067, 7650.0
5.28133, 7658.0
5.282, 7666.0
5.28267, 7673.0
5.28333, 7681.0
5.284, 7688.0
5.28467, 7696.0
5.28533, 7704.0
5.286, 7711.0
5.28667, 7719.0
5.28733, 7727.0
5.288, 7734.0
5.28867, 7742.0
5.28933, 7749.0
5.29, 7757.0
5.29067, 7764.0
5.29133, 7772.0
5.292, 7779.0
5.29267, 7787.0
5.29333, 7794.0
5.294, 7802.0
5.29467, 7809.0
5.29533, 7817.0
5.296, 7824.0
5.29667, 7832.0
5.29733, 7839.0
5.298, 7847.0
5.29867, 7855.0
5.29933, 7862.0
5.3, 7870.0
5.30067, 7877.0
5.30133, 7885.0
5.302, 7892.0
5.30267, 7900.0
5.30333, 7907.0
5.304, 7914.0
5.30467, 7922.0
5.30533, 7929.0
5.306, 7936.0
5.30667, 7943.0
5.30733, 7950.0
5.308, 7957.0
5.30867, 7964.0
5.30933, 7971.0
5.31, 7978.0
5.31067, 7985.0
5.31133, 7992.0
5.312, 7999.0
5.31267, 8006.0
5.31333, 8013.0
5.314, 8020.0
5.31467, 8027.0
5.31533, 8035.0
5.316, 8042.0
5.31667, 8049.0
5.31733, 8056.0
5.318, 8063.0
5.31867, 8070.0
5.31933, 8077.0
5.32, 8085.0
5.32067, 8092.0
5.32133, 8099.0
5.322, 8106.0
5.32267, 8113.0
5.32333, 8121.0
5.324, 8128.0
5.32467, 8135.0
5.32533, 8142.0
5.326, 8150.0
5.32667, 8157.0
5.32733, 8165.0
5.328, 8172.0
5.32867, 8180.0
5.32933, 8187.0
5.33, 8195.0
5.33067, 8202.0
5.33133, 8210.0
5.332, 8217.0
5.33267, 8225.0
5.33333, 8233.0
5.334, 8240.0
5.33467, 8248.0
5.33533, 8256.0
5.336, 8263.0
5.33667, 8271.0
5.33733, 8279.0
5.338, 8287.0
5.33867, 8295.0
5.33933, 8303.0
5.34, 8311.0
5.34067, 8319.0
5.34133, 8328.0
5.342, 8336.0
5.34267, 8344.0
5.34333, 8353.0
5.344, 8361.0
5.34467, 8369.0
5.34533, 8378.0
5.346, 8386.0
5.34667, 8394.0
5.34733, 8402.0
5.348, 8411.0
5.34867, 8419.0
5.34933, 8427.0
5.35, 8435.0
5.35067, 8444.0
5.35133, 8452.0
5.352, 8460.0
5.35267, 8468.0
5.35333, 8476.0
5.354, 8484.0
5.35467, 8492.0
5.35533, 8501.0
5.356, 8509.0
5.35667, 8517.0
5.35733, 8526.0
5.358, 8534.0
5.35867, 8542.0
5.35933, 8551.0
5.36, 8559.0
5.36067, 8568.0
5.36133, 8577.0
5.362, 8586.0
5.36267, 8594.0
5.36333, 8603.0
5.364, 8612.0
5.36467, 8621.0
5.36533, 8629.0
5.366, 8638.0
5.36667, 8647.0
5.36733, 8656.0
5.368, 8665.0
5.36867, 8674.0
5.36933, 8683.0
5.37, 8692.0
5.37067, 8701.0
5.37133, 8710.0
5.372, 8718.0
5.37267, 8727.0
5.37333, 8736.0
5.374, 8745.0
5.37467, 8754.0
5.37533, 8763.0
5.376, 8772.0
5.37667, 8781.0
5.37733, 8790.0
5.378, 8799.0
5.37867, 8808.0
5.37933, 8817.0
5.38, 8826.0
5.38067, 8835.0
5.38133, 8844.0
5.382, 8853.0
5.38267, 8862.0
5.38333, 8871.0
5.384, 8880.0
5.38467, 8890.0
5.38533, 8899.0
5.386, 8908.0
5.38667, 8917.0
5.38733, 8927.0
5.388, 8936.0
5.38867, 8945.0
5.38933, 8954.0
5.39, 8964.0
5.39067, 8973.0
5.39133, 8982.0
5.392, 8992.0
5.39267, 9001.0
5.39333, 9011.0
5.394, 9020.0
5.39467, 9030.0
5.39533, 9039.0
5.396, 9049.0
5.39667, 9059.0
5.39733, 9068.0
5.398, 9078.0
5.39867, 9088.0
5.39933, 9098.0
5.4, 9108.0
5.40067, 9118.0
5.40133, 9128.0
5.402, 9138.0
5.40267, 9147.0
5.40333, 9157.0
5.404, 9167.0
5.40467, 9177.0
5.40533, 9186.0
5.406, 9196.0
5.40667, 9206.0
5.40733, 9216.0
5.408, 9226.0
5.40867, 9236.0
5.40933, 9246.0
5.41, 9256.0
5.41067, 9266.0
5.41133, 9276.0
5.412, 9286.0
5.41267, 9296.0
5.41333, 9306.0
5.414, 9316.0
5.41467, 9326.0
5.41533, 9337.0
5.416, 9347.0
5.41667, 9357.0
5.41733, 9368.0
5.418, 9378.0
5.41867, 9388.0
5.41933, 9399.0
5.42, 9409.0
5.42067, 9419.0
5.42133, 9429.0
5.422, 9440.0
5.42267, 9450.0
5.42333, 9460.0
5.424, 9470.0
5.42467, 9480.0
5.42533, 9491.0
5.426, 9501.0
5.42667, 9511.0
5.42733, 9521.0
5.428, 9531.0
5.42867, 9541.0
5.42933, 9552.0
5.43, 9562.0
5.43067, 9572.0
5.43133, 9582.0
5.432, 9592.0
5.43267, 9601.0
5.43333, 9611.0
5.434, 9621.0
5.43467, 9631.0
5.43533, 9641.0
5.436, 9651.0
5.43667, 9661.0
5.43733, 9670.0
5.438, 9680.0
5.43867, 9690.0
5.43933, 9699.0
5.44, 9709.0
5.44067, 9718.0
5.44133, 9728.0
5.442, 9737.0
5.44267, 9746.0
5.44333, 9756.0
5.444, 9765.0
5.44467, 9775.0
5.44533, 9784.0
5.446, 9793.0
5.44667, 9802.0
5.44733, 9811.0
5.448, 9820.0
5.44867, 9829.0
5.44933, 9838.0
5.45, 9846.0
5.45067, 9855.0
5.45133, 9864.0
5.452, 9873.0
5.45267, 9882.0
5.45333, 9891.0
5.454, 9900.0
5.45467, 9909.0
5.45533, 9918.0
5.456, 9927.0
5.45667, 9937.0
5.45733, 9946.0
5.458, 9956.0
5.45867, 9965.0
5.45933, 9975.0
5.46, 9984.0
5.46067, 9994.0
5.46133, 10003.0
5.462, 10013.0
5.46267, 10022.0
5.46333, 10031.0
5.464, 10041.0
5.46467, 10050.0
5.46533, 10059.0
5.466, 10068.0
5.46667, 10076.0
5.46733, 10085.0
5.468, 10094.0
5.46867, 10103.0
5.46933, 10112.0
5.47, 10121.0
5.47067, 10130.0
5.47133, 10140.0
5.472, 10149.0
5.47267, 10159.0
5.47333, 10168.0
5.474, 10179.0
5.47467, 10189.0
5.47533, 10199.0
5.476, 10210.0
5.47667, 10222.0
5.47733, 10233.0
5.478, 10245.0
5.47867, 10257.0
5.47933, 10269.0
5.48, 10282.0
5.48067, 10294.0
5.48133, 10307.0
5.482, 10320.0
5.48267, 10333.0
5.48333, 10347.0
5.484, 10360.0
5.48467, 10374.0
5.48533, 10388.0
5.486, 10402.0
5.48667, 10416.0
5.48733, 10431.0
5.488, 10446.0
5.48867, 10461.0
5.48933, 10476.0
5.49, 10491.0
5.49067, 10506.0
5.49133, 10521.0
5.492, 10537.0
5.49267, 10552.0
5.49333, 10567.0
5.494, 10582.0
5.49467, 10596.0
5.49533, 10611.0
5.496, 10625.0
5.49667, 10640.0
5.49733, 10654.0
5.498, 10668.0
5.49867, 10681.0
5.49933, 10694.0
5.5, 10707.0
5.50067, 10719.0
5.50133, 10731.0
5.502, 10742.0
5.50267, 10753.0
5.50333, 10763.0
5.504, 10773.0
5.50467, 10782.0
5.50533, 10791.0
5.506, 10800.0
5.50667, 10807.0
5.50733, 10815.0
5.508, 10822.0
5.50867, 10829.0
5.50933, 10835.0
5.51, 10841.0
5.51067, 10846.0
5.51133, 10851.0
5.512, 10856.0
5.51267, 10861.0
5.51333, 10865.0
5.514, 10869.0
5.51467, 10873.0
5.51533, 10877.0
5.516, 10880.0
5.51667, 10884.0
5.51733, 10887.0
5.518, 10890.0
5.51867, 10893.0
5.51933, 10896.0
5.52, 10898.0
5.52067, 10901.0
5.52133, 10903.0
5.522, 10906.0
5.52267, 10908.0
5.52333, 10910.0
5.524, 10912.0
5.52467, 10914.0
5.52533, 10916.0
5.526, 10918.0
5.52667, 10921.0
5.52733, 10923.0
5.528, 10926.0
5.52867, 10929.0
5.52933, 10932.0
5.53, 10935.0
5.53067, 10938.0
5.53133, 10942.0
5.532, 10946.0
5.53267, 10950.0
5.53333, 10954.0
5.534, 10959.0
5.53467, 10963.0
5.53533, 10968.0
5.536, 10974.0
5.53667, 10979.0
5.53733, 10985.0
5.538, 10990.0
5.53867, 10996.0
5.53933, 11003.0
5.54, 11009.0
5.54067, 11015.0
5.54133, 11021.0
5.542, 11028.0
5.54267, 11035.0
5.54333, 11041.0
5.544, 11048.0
5.54467, 11055.0
5.54533, 11062.0
5.546, 11069.0
5.54667, 11075.0
5.54733, 11082.0
5.548, 11089.0
5.54867, 11096.0
5.54933, 11104.0
5.55, 11111.0
5.55067, 11118.0
5.55133, 11125.0
5.552, 11131.0
5.55267, 11138.0
5.55333, 11145.0
5.554, 11152.0
5.55467, 11159.0
5.55533, 11166.0
5.556, 11173.0
5.55667, 11180.0
5.55733, 11187.0
5.558, 11195.0
5.55867, 11202.0
5.55933, 11209.0
5.56, 11216.0
5.56067, 11224.0
5.56133, 11231.0
5.562, 11238.0
5.56267, 11246.0
5.56333, 11253.0
5.564, 11261.0
5.56467, 11269.0
5.56533, 11276.0
5.566, 11284.0
5.56667, 11291.0
5.56733, 11299.0
5.568, 11306.0
5.56867, 11314.0
5.56933, 11322.0
5.57, 11329.0
5.57067, 11337.0
5.57133, 11345.0
5.572, 11352.0
5.57267, 11360.0
5.57333, 11368.0
5.574, 11376.0
5.57467, 11385.0
5.57533, 11393.0
5.576, 11401.0
5.57667, 11409.0
5.57733, 11418.0
5.578, 11426.0
5.57867, 11435.0
5.57933, 11443.0
5.58, 11452.0
5.58067, 11460.0
5.58133, 11468.0
5.582, 11477.0
5.58267, 11485.0
5.58333, 11494.0
5.584, 11502.0
5.58467, 11510.0
5.58533, 11519.0
5.586, 11527.0
5.58667, 11535.0
5.58733, 11544.0
5.588, 11552.0
5.58867, 11560.0
5.58933, 11568.0
5.59, 11576.0
5.59067, 11584.0
5.59133, 11592.0
5.592, 11599.0
5.59267, 11607.0
5.59333, 11615.0
5.594, 11623.0
5.59467, 11630.0
5.59533, 11638.0
5.596, 11645.0
5.59667, 11653.0
5.59733, 11660.0
5.598, 11668.0
5.59867, 11675.0
5.59933, 11683.0
5.6, 11691.0
5.60067, 11698.0
5.60133, 11706.0
5.602, 11714.0
5.60267, 11722.0
5.60333, 11729.0
5.604, 11737.0
5.60467, 11745.0
5.60533, 11753.0
5.606, 11761.0
5.60667, 11769.0
5.60733, 11777.0
5.608, 11786.0
5.60867, 11794.0
5.60933, 11803.0
5.61, 11811.0
5.61067, 11820.0
5.61133, 11829.0
5.612, 11838.0
5.61267, 11846.0
5.61333, 11855.0
5.614, 11864.0
5.61467, 11873.0
5.61533, 11882.0
5.616, 11891.0
5.61667, 11900.0
5.61733, 11908.0
5.618, 11917.0
5.61867, 11925.0
5.61933, 11934.0
5.62, 11943.0
5.62067, 11951.0
5.62133, 11960.0
5.622, 11969.0
5.62267, 11977.0
5.62333, 11986.0
5.624, 11994.0
5.62467, 12003.0
5.62533, 12011.0
5.626, 12020.0
5.62667, 12028.0
5.62733, 12037.0
5.628, 12045.0
5.62867, 12053.0
5.62933, 12061.0
5.63, 12069.0
5.63067, 12077.0
5.63133, 12085.0
5.632, 12093.0
5.63267, 12101.0
5.63333, 12109.0
5.634, 12117.0
5.63467, 12125.0
5.63533, 12133.0
5.636, 12141.0
5.63667, 12149.0
5.63733, 12157.0
5.638, 12166.0
5.63867, 12174.0
5.63933, 12182.0
5.64, 12191.0
5.64067, 12199.0
5.64133, 12207.0
5.642, 12215.0
5.64267, 12223.0
5.64333, 12231.0
5.644, 12239.0
5.64467, 12247.0
5.64533, 12255.0
5.646, 12263.0
5.64667, 12271.0
5.64733, 12279.0
5.648, 12288.0
5.64867, 12296.0
5.64933, 12304.0
5.65, 12312.0
5.65067, 12320.0
5.65133, 12329.0
5.652, 12337.0
5.65267, 12345.0
5.65333, 12354.0
5.654, 12362.0
5.65467, 12371.0
5.65533, 12379.0
5.656, 12387.0
5.65667, 12396.0
5.65733, 12404.0
5.658, 12413.0
5.65867, 12421.0
5.65933, 12430.0
5.66, 12438.0
5.66067, 12446.0
5.66133, 12455.0
5.662, 12463.0
5.66267, 12472.0
5.66333, 12481.0
5.664, 12490.0
5.66467, 12499.0
5.66533, 12508.0
5.666, 12517.0
5.66667, 12526.0
5.66733, 12535.0
5.668, 12545.0
5.66867, 12554.0
5.66933, 12564.0
5.67, 12574.0
5.67067, 12584.0
5.67133, 12594.0
5.672, 12604.0
5.67267, 12614.0
5.67333, 12624.0
5.674, 12634.0
5.67467, 12645.0
5.67533, 12655.0
5.676, 12665.0
5.67667, 12675.0
5.67733, 12685.0
5.678, 12695.0
5.67867, 12705.0
5.67933, 12715.0
5.68, 12725.0
5.68067, 12734.0
5.68133, 12744.0
5.682, 12753.0
5.68267, 12763.0
5.68333, 12772.0
5.684, 12781.0
5.68467, 12791.0
5.68533, 12800.0
5.686, 12809.0
5.68667, 12818.0
5.68733, 12827.0
5.688, 12837.0
5.68867, 12846.0
5.68933, 12855.0
5.69, 12864.0
5.69067, 12874.0
5.69133, 12883.0
5.692, 12892.0
5.69267, 12902.0
5.69333, 12912.0
5.694, 12921.0
5.69467, 12931.0
5.69533, 12941.0
5.696, 12951.0
5.69667, 12961.0
5.69733, 12971.0
5.698, 12981.0
5.69867, 12990.0
5.69933, 13000.0
5.7, 13010.0
5.70067, 13020.0
5.70133, 13030.0
5.702, 13041.0
5.70267, 13051.0
5.70333, 13061.0
5.704, 13071.0
5.70467, 13081.0
5.70533, 13091.0
5.706, 13101.0
5.70667, 13111.0
5.70733, 13121.0
5.708, 13131.0
5.70867, 13141.0
5.70933, 13151.0
5.71, 13161.0
5.71067, 13171.0
5.71133, 13181.0
5.712, 13190.0
5.71267, 13200.0
5.71333, 13209.0
5.714, 13219.0
5.71467, 13228.0
5.71533, 13238.0
5.716, 13247.0
5.71667, 13257.0
5.71733, 13267.0
5.718, 13277.0
5.71867, 13287.0
5.71933, 13297.0
5.72, 13307.0
5.72067, 13317.0
5.72133, 13327.0
5.722, 13338.0
5.72267, 13348.0
5.72333, 13358.0
5.724, 13369.0
5.72467, 13379.0
5.72533, 13390.0
5.726, 13400.0
5.72667, 13411.0
5.72733, 13421.0
5.728, 13432.0
5.72867, 13442.0
5.72933, 13453.0
5.73, 13463.0
5.73067, 13474.0
5.73133, 13485.0
5.732, 13495.0
5.73267, 13506.0
5.73333, 13516.0
5.734, 13527.0
5.73467, 13538.0
5.73533, 13548.0
5.736, 13559.0
5.73667, 13569.0
5.73733, 13580.0
5.738, 13591.0
5.73867, 13601.0
5.73933, 13612.0
5.74, 13622.0
5.74067, 13632.0
5.74133, 13642.0
5.742, 13652.0
5.74267, 13662.0
5.74333, 13672.0
5.744, 13682.0
5.74467, 13692.0
5.74533, 13702.0
5.746, 13712.0
5.74667, 13722.0
5.74733, 13732.0
5.748, 13742.0
5.74867, 13752.0
5.74933, 13762.0
5.75, 13771.0
5.75067, 13781.0
5.75133, 13791.0
5.752, 13800.0
5.75267, 13810.0
5.75333, 13819.0
5.754, 13829.0
5.75467, 13839.0
5.75533, 13849.0
5.756, 13858.0
5.75667, 13868.0
5.75733, 13878.0
5.758, 13888.0
5.75867, 13898.0
5.75933, 13908.0
5.76, 13918.0
5.76067, 13928.0
5.76133, 13938.0
5.762, 13949.0
5.76267, 13959.0
5.76333, 13969.0
5.764, 13980.0
5.76467, 13990.0
5.76533, 14000.0
5.766, 14011.0
5.76667, 14021.0
5.76733, 14032.0
5.768, 14042.0
5.76867, 14052.0
5.76933, 14063.0
5.77, 14073.0
5.77067, 14084.0
5.77133, 14094.0
5.772, 14105.0
5.77267, 14116.0
5.77333, 14126.0
5.774, 14137.0
5.77467, 14147.0
5.77533, 14158.0
5.776, 14168.0
5.77667, 14179.0
5.77733, 14189.0
5.778, 14199.0
5.77867, 14210.0
5.77933, 14220.0
5.78, 14231.0
5.78067, 14241.0
5.78133, 14251.0
5.782, 14261.0
5.78267, 14271.0
5.78333, 14281.0
5.784, 14291.0
5.78467, 14301.0
5.78533, 14311.0
5.786, 14321.0
5.78667, 14330.0
5.78733, 14340.0
5.788, 14349.0
5.78867, 14358.0
5.78933, 14368.0
5.79, 14377.0
5.79067, 14386.0
5.79133, 14395.0
5.792, 14405.0
5.79267, 14414.0
5.79333, 14423.0
5.794, 14432.0
5.79467, 14441.0
5.79533, 14449.0
5.796, 14458.0
5.79667, 14467.0
5.79733, 14475.0
5.798, 14484.0
5.79867, 14493.0
5.79933, 14501.0
5.8, 14510.0
5.80067, 14519.0
5.80133, 14528.0
5.802, 14537.0
5.80267, 14546.0
5.80333, 14556.0
5.804, 14565.0
5.80467, 14574.0
5.80533, 14584.0
5.806, 14594.0
5.80667, 14604.0
5.80733, 14614.0
5.808, 14624.0
5.80867, 14634.0
5.80933, 14644.0
5.81, 14654.0
5.81067, 14665.0
5.81133, 14675.0
5.812, 14685.0
5.81267, 14696.0
5.81333, 14706.0
5.814, 14716.0
5.81467, 14726.0
5.81533, 14736.0
5.816, 14747.0
5.81667, 14757.0
5.81733, 14767.0
5.818, 14777.0
5.81867, 14787.0
5.81933, 14798.0
5.82, 14808.0
5.82067, 14818.0
5.82133, 14828.0
5.822, 14838.0
5.82267, 14849.0
5.82333, 14859.0
5.824, 14869.0
5.82467, 14879.0
5.82533, 14889.0
5.826, 14899.0
5.82667, 14909.0
5.82733, 14919.0
5.828, 14929.0
5.82867, 14939.0
5.82933, 14949.0
5.83, 14960.0
5.83067, 14970.0
5.83133, 14980.0
5.832, 14990.0
5.83267, 15000.0
5.83333, 15010.0
5.834, 15020.0
5.83467, 15030.0
5.83533, 15040.0
5.836, 15050.0
5.83667, 15060.0
5.83733, 15070.0
5.838, 15080.0
5.83867, 15090.0
5.83933, 15100.0
5.84, 15110.0
5.84067, 15120.0
5.84133, 15130.0
5.842, 15141.0
5.84267, 15151.0
5.84333, 15162.0
5.844, 15172.0
5.84467, 15183.0
5.84533, 15193.0
5.846, 15204.0
5.84667, 15214.0
5.84733, 15225.0
5.848, 15235.0
5.84867, 15245.0
5.84933, 15255.0
5.85, 15265.0
5.85067, 15275.0
5.85133, 15285.0
5.852, 15295.0
5.85267, 15304.0
5.85333, 15314.0
5.854, 15323.0
5.85467, 15332.0
5.85533, 15341.0
5.856, 15350.0
5.85667, 15359.0
5.85733, 15367.0
5.858, 15376.0
5.85867, 15385.0
5.85933, 15394.0
5.86, 15403.0
5.86067, 15411.0
5.86133, 15420.0
5.862, 15429.0
5.86267, 15438.0
5.86333, 15446.0
5.864, 15455.0
5.86467, 15464.0
5.86533, 15472.0
5.866, 15481.0
5.86667, 15490.0
5.86733, 15499.0
5.868, 15508.0
5.86867, 15516.0
5.86933, 15525.0
5.87, 15533.0
5.87067, 15542.0
5.87133, 15550.0
5.872, 15559.0
5.87267, 15568.0
5.87333, 15577.0
5.874, 15586.0
5.87467, 15595.0
5.87533, 15604.0
5.876, 15613.0
5.87667, 15622.0
5.87733, 15632.0
5.878, 15641.0
5.87867, 15651.0
5.87933, 15661.0
5.88, 15670.0
5.88067, 15680.0
5.88133, 15689.0
5.882, 15699.0
5.88267, 15708.0
5.88333, 15717.0
5.884, 15726.0
5.88467, 15735.0
5.88533, 15744.0
5.886, 15752.0
5.88667, 15761.0
5.88733, 15770.0
5.888, 15779.0
5.88867, 15788.0
5.88933, 15796.0
5.89, 15804.0
5.89067, 15813.0
5.89133, 15821.0
5.892, 15829.0
5.89267, 15837.0
5.89333, 15845.0
5.894, 15854.0
5.89467, 15862.0
5.89533, 15870.0
5.896, 15879.0
5.89667, 15887.0
5.89733, 15896.0
5.898, 15905.0
5.89867, 15913.0
5.89933, 15922.0
5.9, 15931.0
5.90067, 15940.0
5.90133, 15949.0
5.902, 15957.0
5.90267, 15966.0
5.90333, 15974.0
5.904, 15983.0
5.90467, 15991.0
5.90533, 16000.0
5.906, 16008.0
5.90667, 16016.0
5.90733, 16024.0
5.908, 16032.0
5.90867, 16040.0
5.90933, 16048.0
5.91, 16056.0
5.91067, 16064.0
5.91133, 16072.0
5.912, 16080.0
5.91267, 16088.0
5.91333, 16096.0
5.914, 16104.0
5.91467, 16112.0
5.91533, 16120.0
5.916, 16128.0
5.91667, 16136.0
5.91733, 16145.0
5.918, 16153.0
5.91867, 16161.0
5.91933, 16170.0
5.92, 16178.0
5.92067, 16186.0
5.92133, 16195.0
5.922, 16203.0
5.92267, 16211.0
5.92333, 16219.0
5.924, 16228.0
5.92467, 16236.0
5.92533, 16245.0
5.926, 16254.0
5.92667, 16262.0
5.92733, 16272.0
5.928, 16281.0
5.92867, 16290.0
5.92933, 16300.0
5.93, 16309.0
5.93067, 16318.0
5.93133, 16328.0
5.932, 16337.0
5.93267, 16347.0
5.93333, 16357.0
5.934, 16366.0
5.93467, 16376.0
5.93533, 16386.0
5.936, 16396.0
5.93667, 16406.0
5.93733, 16416.0
5.938, 16426.0
5.93867, 16436.0
5.93933, 16447.0
5.94, 16457.0
5.94067, 16467.0
5.94133, 16477.0
5.942, 16487.0
5.94267, 16497.0
5.94333, 16507.0
5.944, 16517.0
5.94467, 16527.0
5.94533, 16537.0
5.946, 16547.0
5.94667, 16557.0
5.94733, 16567.0
5.948, 16577.0
5.94867, 16587.0
5.94933, 16597.0
5.95, 16606.0
5.95067, 16616.0
5.95133, 16625.0
5.952, 16635.0
5.95267, 16644.0
5.95333, 16653.0
5.954, 16662.0
5.95467, 16671.0
5.95533, 16680.0
5.956, 16690.0
5.95667, 16699.0
5.95733, 16708.0
5.958, 16718.0
5.95867, 16727.0
5.95933, 16736.0
5.96, 16745.0
5.96067, 16754.0
5.96133, 16764.0
5.962, 16773.0
5.96267, 16782.0
5.96333, 16791.0
5.964, 16800.0
5.96467, 16809.0
5.96533, 16818.0
5.966, 16827.0
5.96667, 16836.0
5.96733, 16846.0
5.968, 16855.0
5.96867, 16864.0
5.96933, 16873.0
5.97, 16882.0
5.97067, 16891.0
5.97133, 16900.0
5.972, 16909.0
5.97267, 16918.0
5.97333, 16927.0
5.974, 16936.0
5.97467, 16944.0
5.97533, 16953.0
5.976, 16962.0
5.97667, 16971.0
5.97733, 16980.0
5.978, 16989.0
5.97867, 16998.0
5.97933, 17007.0
5.98, 17017.0
5.98067, 17026.0
5.98133, 17035.0
5.982, 17045.0
5.98267, 17055.0
5.98333, 17064.0
5.984, 17074.0
5.98467, 17084.0
5.98533, 17094.0
5.986, 17105.0
5.98667, 17115.0
5.98733, 17125.0
5.988, 17135.0
5.98867, 17146.0
5.98933, 17156.0
5.99, 17167.0
5.99067, 17177.0
5.99133, 17188.0
5.992, 17199.0
5.99267, 17209.0
5.99333, 17220.0
5.994, 17231.0
5.99467, 17241.0
5.99533, 17252.0
5.996, 17263.0
5.99667, 17274.0
5.99733, 17284.0
5.998, 17295.0
5.99867, 17306.0
5.99933, 17317.0
6.0, 17328.0
6.00067, 17338.0
6.00133, 17349.0
6.002, 17360.0
6.00267, 17371.0
6.00333, 17381.0
6.004, 17392.0
6.00467, 17402.0
6.00533, 17413.0
6.006, 17423.0
6.00667, 17434.0
6.00733, 17445.0
6.008, 17456.0
6.00867, 17467.0
6.00933, 17478.0
6.01, 17489.0
6.01067, 17500.0
6.01133, 17512.0
6.012, 17523.0
6.01267, 17534.0
6.01333, 17545.0
6.014, 17556.0
6.01467, 17567.0
6.01533, 17579.0
6.016, 17590.0
6.01667, 17601.0
6.01733, 17612.0
6.018, 17623.0
6.01867, 17635.0
6.01933, 17646.0
6.02, 17658.0
6.02067, 17669.0
6.02133, 17681.0
6.022, 17692.0
6.02267, 17704.0
6.02333, 17716.0
6.024, 17729.0
6.02467, 17741.0
6.02533, 17753.0
6.026, 17765.0
6.02667, 17777.0
6.02733, 17788.0
6.028, 17800.0
6.02867, 17811.0
6.02933, 17822.0
6.03, 17833.0
6.03067, 17843.0
6.03133, 17854.0
6.032, 17864.0
6.03267, 17874.0
6.03333, 17885.0
6.034, 17895.0
6.03467, 17905.0
6.03533, 17916.0
6.036, 17926.0
6.03667, 17937.0
6.03733, 17947.0
6.038, 17958.0
6.03867, 17968.0
6.03933, 17979.0
6.04, 17990.0
6.04067, 18001.0
6.04133, 18012.0
6.042, 18023.0
6.04267, 18034.0
6.04333, 18045.0
6.044, 18056.0
6.04467, 18068.0
6.04533, 18079.0
6.046, 18090.0
6.04667, 18102.0
6.04733, 18113.0
6.048, 18125.0
6.04867, 18136.0
6.04933, 18148.0
6.05, 18160.0
6.05067, 18172.0
6.05133, 18184.0
6.052, 18196.0
6.05267, 18208.0
6.05333, 18220.0
6.054, 18233.0
6.05467, 18245.0
6.05533, 18257.0
6.056, 18269.0
6.05667, 18282.0
6.05733, 18294.0
6.058, 18307.0
6.05867, 18320.0
6.05933, 18333.0
6.06, 18345.0
6.06067, 18358.0
6.06133, 18370.0
6.062, 18383.0
6.06267, 18395.0
6.06333, 18408.0
6.064, 18420.0
6.06467, 18433.0
6.06533, 18445.0
6.066, 18458.0
6.06667, 18471.0
6.06733, 18483.0
6.068, 18496.0
6.06867, 18508.0
6.06933, 18521.0
6.07, 18533.0
6.07067, 18545.0
6.07133, 18557.0
6.072, 18570.0
6.07267, 18582.0
6.07333, 18593.0
6.074, 18605.0
6.07467, 18617.0
6.07533, 18629.0
6.076, 18640.0
6.07667, 18651.0
6.07733, 18663.0
6.078, 18674.0
6.07867, 18685.0
6.07933, 18697.0
6.08, 18708.0
6.08067, 18720.0
6.08133, 18732.0
6.082, 18744.0
6.08267, 18756.0
6.08333, 18768.0
6.084, 18780.0
6.08467, 18793.0
6.08533, 18805.0
6.086, 18817.0
6.08667, 18830.0
6.08733, 18842.0
6.088, 18855.0
6.08867, 18868.0
6.08933, 18880.0
6.09, 18893.0
6.09067, 18906.0
6.09133, 18918.0
6.092, 18931.0
6.09267, 18944.0
6.09333, 18957.0
6.094, 18969.0
6.09467, 18982.0
6.09533, 18995.0
6.096, 19007.0
6.09667, 19020.0
6.09733, 19033.0
6.098, 19046.0
6.09867, 19058.0
6.09933, 19071.0
6.1, 19084.0
6.10067, 19097.0
6.10133, 19109.0
6.102, 19122.0
6.10267, 19135.0
6.10333, 19148.0
6.104, 19161.0
6.10467, 19174.0
6.10533, 19187.0
6.106, 19199.0
6.10667, 19211.0
6.10733, 19224.0
6.108, 19236.0
6.10867, 19248.0
6.10933, 19260.0
6.11, 19273.0
6.11067, 19285.0
6.11133, 19297.0
6.112, 19310.0
6.11267, 19322.0
6.11333, 19335.0
6.114, 19347.0
6.11467, 19360.0
6.11533, 19372.0
6.116, 19385.0
6.11667, 19398.0
6.11733, 19411.0
6.118, 19424.0
6.11867, 19437.0
6.11933, 19450.0
6.12, 19464.0
6.12067, 19477.0
6.12133, 19491.0
6.122, 19504.0
6.12267, 19518.0
6.12333, 19532.0
6.124, 19546.0
6.12467, 19560.0
6.12533, 19573.0
6.126, 19587.0
6.12667, 19601.0
6.12733, 19615.0
6.128, 19629.0
6.12867, 19643.0
6.12933, 19657.0
6.13, 19671.0
6.13067, 19685.0
6.13133, 19699.0
6.132, 19713.0
6.13267, 19726.0
6.13333, 19740.0
6.134, 19754.0
6.13467, 19767.0
6.13533, 19781.0
6.136, 19794.0
6.13667, 19808.0
6.13733, 19821.0
6.138, 19835.0
6.13867, 19848.0
6.13933, 19861.0
6.14, 19875.0
6.14067, 19888.0
6.14133, 19901.0
6.142, 19915.0
6.14267, 19928.0
6.14333, 19942.0
6.144, 19955.0
6.14467, 19969.0
6.14533, 19983.0
6.146, 19997.0
6.14667, 20011.0
6.14733, 20025.0
6.148, 20038.0
6.14867, 20052.0
6.14933, 20066.0
6.15, 20080.0
6.15067, 20094.0
6.15133, 20108.0
6.152, 20122.0
6.15267, 20137.0
6.15333, 20151.0
6.154, 20166.0
6.15467, 20181.0
6.15533, 20196.0
6.156, 20211.0
6.15667, 20226.0
6.15733, 20241.0
6.158, 20255.0
6.15867, 20270.0
6.15933, 20285.0
6.16, 20299.0
6.16067, 20314.0
6.16133, 20328.0
6.162, 20342.0
6.16267, 20357.0
6.16333, 20371.0
6.164, 20386.0
6.16467, 20400.0
6.16533, 20415.0
6.166, 20430.0
6.16667, 20444.0
6.16733, 20459.0
6.168, 20474.0
6.16867, 20489.0
6.16933, 20504.0
6.17, 20519.0
6.17067, 20534.0
6.17133, 20549.0
6.172, 20564.0
6.17267, 20579.0
6.17333, 20594.0
6.174, 20609.0
6.17467, 20624.0
6.17533, 20640.0
6.176, 20655.0
6.17667, 20670.0
6.17733, 20685.0
6.178, 20700.0
6.17867, 20715.0
6.17933, 20730.0
6.18, 20745.0
6.18067, 20760.0
6.18133, 20775.0
6.182, 20790.0
6.18267, 20805.0
6.18333, 20820.0
6.184, 20836.0
6.18467, 20851.0
6.18533, 20866.0
6.186, 20881.0
6.18667, 20896.0
6.18733, 20911.0
6.188, 20926.0
6.18867, 20941.0
6.18933, 20956.0
6.19, 20971.0
6.19067, 20987.0
6.19133, 21003.0
6.192, 21018.0
6.19267, 21034.0
6.19333, 21050.0
6.194, 21066.0
6.19467, 21082.0
6.19533, 21098.0
6.196, 21115.0
6.19667, 21131.0
6.19733, 21147.0
6.198, 21164.0
6.19867, 21180.0
6.19933, 21196.0
6.2, 21213.0
6.20067, 21229.0
6.20133, 21245.0
6.202, 21262.0
6.20267, 21278.0
6.20333, 21294.0
6.204, 21310.0
6.20467, 21326.0
6.20533, 21343.0
6.206, 21359.0
6.20667, 21375.0
6.20733, 21391.0
6.208, 21407.0
6.20867, 21423.0
6.20933, 21439.0
6.21, 21455.0
6.21067, 21470.0
6.21133, 21486.0
6.212, 21501.0
6.21267, 21517.0
6.21333, 21533.0
6.214, 21549.0
6.21467, 21565.0
6.21533, 21582.0
6.216, 21599.0
6.21667, 21615.0
6.21733, 21633.0
6.218, 21650.0
6.21867, 21668.0
6.21933, 21686.0
6.22, 21703.0
6.22067, 21721.0
6.22133, 21739.0
6.222, 21757.0
6.22267, 21775.0
6.22333, 21794.0
6.224, 21812.0
6.22467, 21830.0
6.22533, 21848.0
6.226, 21866.0
6.22667, 21884.0
6.22733, 21901.0
6.228, 21919.0
6.22867, 21937.0
6.22933, 21955.0
6.23, 21973.0
6.23067, 21990.0
6.23133, 22008.0
6.232, 22026.0
6.23267, 22044.0
6.23333, 22061.0
6.234, 22079.0
6.23467, 22096.0
6.23533, 22113.0
6.236, 22129.0
6.23667, 22146.0
6.23733, 22162.0
6.238, 22178.0
6.23867, 22195.0
6.23933, 22211.0
6.24, 22227.0
6.24067, 22242.0
6.24133, 22258.0
6.242, 22274.0
6.24267, 22290.0
6.24333, 22306.0
6.244, 22323.0
6.24467, 22339.0
6.24533, 22355.0
6.246, 22372.0
6.24667, 22388.0
6.24733, 22405.0
6.248, 22421.0
6.24867, 22438.0
6.24933, 22454.0
6.25, 22471.0
6.25067, 22487.0
6.25133, 22504.0
6.252, 22520.0
6.25267, 22537.0
6.25333, 22554.0
6.254, 22570.0
6.25467, 22587.0
6.25533, 22603.0
6.256, 22620.0
6.25667, 22637.0
6.25733, 22654.0
6.258, 22670.0
6.25867, 22687.0
6.25933, 22704.0
6.26, 22721.0
6.26067, 22738.0
6.26133, 22756.0
6.262, 22773.0
6.26267, 22790.0
6.26333, 22807.0
6.264, 22824.0
6.26467, 22841.0
6.26533, 22858.0
6.266, 22875.0
6.26667, 22892.0
6.26733, 22909.0
6.268, 22926.0
6.26867, 22943.0
6.26933, 22961.0
6.27, 22978.0
6.27067, 22996.0
6.27133, 23014.0
6.272, 23032.0
6.27267, 23050.0
6.27333, 23068.0
6.274, 23086.0
6.27467, 23104.0
6.27533, 23122.0
6.276, 23140.0
6.27667, 23158.0
6.27733, 23176.0
6.278, 23194.0
6.27867, 23212.0
6.27933, 23231.0
6.28, 23250.0
6.28067, 23269.0
6.28133, 23288.0
6.282, 23306.0
6.28267, 23325.0
6.28333, 23344.0
6.284, 23363.0
6.28467, 23382.0
6.28533, 23400.0
6.286, 23418.0
6.28667, 23437.0
6.28733, 23455.0
6.288, 23473.0
6.28867, 23492.0
6.28933, 23510.0
6.29, 23528.0
6.29067, 23546.0
6.29133, 23564.0
6.292, 23582.0
6.29267, 23600.0
6.29333, 23618.0
6.294, 23636.0
6.29467, 23654.0
6.29533, 23671.0
6.296, 23689.0
6.29667, 23707.0
6.29733, 23725.0
6.298, 23743.0
6.29867, 23762.0
6.29933, 23780.0
6.3, 23798.0
6.30067, 23816.0
6.30133, 23834.0
6.302, 23852.0
6.30267, 23870.0
6.30333, 23888.0
6.304, 23907.0
6.30467, 23926.0
6.30533, 23945.0
6.306, 23964.0
6.30667, 23983.0
6.30733, 24002.0
6.308, 24021.0
6.30867, 24040.0
6.30933, 24059.0
6.31, 24078.0
6.31067, 24097.0
6.31133, 24116.0
6.312, 24135.0
6.31267, 24154.0
6.31333, 24173.0
6.314, 24192.0
6.31467, 24211.0
6.31533, 24230.0
6.316, 24249.0
6.31667, 24267.0
6.31733, 24285.0
6.318, 24303.0
6.31867, 24321.0
6.31933, 24338.0
6.32, 24356.0
6.32067, 24374.0
6.32133, 24392.0
6.322, 24409.0
6.32267, 24427.0
6.32333, 24445.0
6.324, 24463.0
6.32467, 24481.0
6.32533, 24499.0
6.326, 24518.0
6.32667, 24536.0
6.32733, 24555.0
6.328, 24573.0
6.32867, 24592.0
6.32933, 24611.0
6.33, 24630.0
6.33067, 24649.0
6.33133, 24668.0
6.332, 24688.0
6.33267, 24707.0
6.33333, 24727.0
6.334, 24746.0
6.33467, 24766.0
6.33533, 24785.0
6.336, 24805.0
6.33667, 24825.0
6.33733, 24845.0
6.338, 24864.0
6.33867, 24884.0
6.33933, 24904.0
6.34, 24924.0
6.34067, 24944.0
6.34133, 24964.0
6.342, 24984.0
6.34267, 25003.0
6.34333, 25023.0
6.344, 25042.0
6.34467, 25061.0
6.34533, 25080.0
6.346, 25099.0
6.34667, 25118.0
6.34733, 25137.0
6.348, 25156.0
6.34867, 25175.0
6.34933, 25194.0
6.35, 25213.0
6.35067, 25233.0
6.35133, 25252.0
6.352, 25271.0
6.35267, 25290.0
6.35333, 25310.0
6.354, 25329.0
6.35467, 25348.0
6.35533, 25368.0
6.356, 25387.0
6.35667, 25407.0
6.35733, 25426.0
6.358, 25446.0
6.35867, 25465.0
6.35933, 25485.0
6.36, 25505.0
6.36067, 25525.0
6.36133, 25545.0
6.362, 25565.0
6.36267, 25585.0
6.36333, 25604.0
6.364, 25624.0
6.36467, 25643.0
6.36533, 25662.0
6.366, 25682.0
6.36667, 25701.0
6.36733, 25719.0
6.368, 25738.0
6.36867, 25757.0
6.36933, 25775.0
6.37, 25794.0
6.37067, 25812.0
6.37133, 25831.0
6.372, 25850.0
6.37267, 25869.0
6.37333, 25888.0
6.374, 25907.0
6.37467, 25927.0
6.37533, 25946.0
6.376, 25966.0
6.37667, 25986.0
6.37733, 26005.0
6.378, 26026.0
6.37867, 26046.0
6.37933, 26066.0
6.38, 26087.0
6.38067, 26108.0
6.38133, 26128.0
6.382, 26148.0
6.38267, 26168.0
6.38333, 26189.0
6.384, 26209.0
6.38467, 26229.0
6.38533, 26250.0
6.386, 26271.0
6.38667, 26292.0
6.38733, 26313.0
6.388, 26334.0
6.38867, 26355.0
6.38933, 26376.0
6.39, 26397.0
6.39067, 26419.0
6.39133, 26440.0
6.392, 26461.0
6.39267, 26482.0
6.39333, 26504.0
6.394, 26525.0
6.39467, 26547.0
6.39533, 26568.0
6.396, 26590.0
6.39667, 26611.0
6.39733, 26632.0
6.398, 26653.0
6.39867, 26674.0
6.39933, 26695.0
6.4, 26717.0
6.40067, 26738.0
6.40133, 26759.0
6.402, 26781.0
6.40267, 26802.0
6.40333, 26824.0
6.404, 26845.0
6.40467, 26867.0
6.40533, 26888.0
6.406, 26909.0
6.40667, 26931.0
6.40733, 26952.0
6.408, 26973.0
6.40867, 26995.0
6.40933, 27016.0
6.41, 27038.0
6.41067, 27059.0
6.41133, 27080.0
6.412, 27101.0
6.41267, 27121.0
6.41333, 27142.0
6.414, 27163.0
6.41467, 27183.0
6.41533, 27204.0
6.416, 27224.0
6.41667, 27244.0
6.41733, 27264.0
6.418, 27284.0
6.41867, 27305.0
6.41933, 27325.0
6.42, 27346.0
6.42067, 27366.0
6.42133, 27387.0
6.422, 27407.0
6.42267, 27428.0
6.42333, 27448.0
6.424, 27469.0
6.42467, 27490.0
6.42533, 27511.0
6.426, 27532.0
6.42667, 27553.0
6.42733, 27574.0
6.428, 27596.0
6.42867, 27617.0
6.42933, 27638.0
6.43, 27660.0
6.43067, 27681.0
6.43133, 27703.0
6.432, 27725.0
6.43267, 27747.0
6.43333, 27769.0
6.434, 27791.0
6.43467, 27814.0
6.43533, 27837.0
6.436, 27860.0
6.43667, 27883.0
6.43733, 27906.0
6.438, 27930.0
6.43867, 27953.0
6.43933, 27976.0
6.44, 27999.0
6.44067, 28022.0
6.44133, 28044.0
6.442, 28067.0
6.44267, 28090.0
6.44333, 28112.0
6.444, 28133.0
6.44467, 28154.0
6.44533, 28175.0
6.446, 28196.0
6.44667, 28216.0
6.44733, 28235.0
6.448, 28255.0
6.44867, 28274.0
6.44933, 28293.0
6.45, 28312.0
6.45067, 28331.0
6.45133, 28350.0
6.452, 28369.0
6.45267, 28387.0
6.45333, 28406.0
6.454, 28425.0
6.45467, 28443.0
6.45533, 28462.0
6.456, 28482.0
6.45667, 28501.0
6.45733, 28521.0
6.458, 28540.0
6.45867, 28560.0
6.45933, 28580.0
6.46, 28600.0
6.46067, 28620.0
6.46133, 28640.0
6.462, 28660.0
6.46267, 28681.0
6.46333, 28701.0
6.464, 28721.0
6.46467, 28741.0
6.46533, 28762.0
6.466, 28782.0
6.46667, 28803.0
6.46733, 28823.0
6.468, 28844.0
6.46867, 28864.0
6.46933, 28884.0
6.47, 28903.0
6.47067, 28923.0
6.47133, 28942.0
6.472, 28962.0
6.47267, 28981.0
6.47333, 29001.0
6.474, 29020.0
6.47467, 29039.0
6.47533, 29057.0
6.476, 29076.0
6.47667, 29094.0
6.47733, 29112.0
6.478, 29131.0
6.47867, 29148.0
6.47933, 29166.0
6.48, 29184.0
6.48067, 29202.0
6.48133, 29220.0
6.482, 29238.0
6.48267, 29256.0
6.48333, 29274.0
6.484, 29293.0
6.48467, 29311.0
6.48533, 29330.0
6.486, 29348.0
6.48667, 29366.0
6.48733, 29384.0
6.488, 29401.0
6.48867, 29419.0
6.48933, 29436.0
6.49, 29453.0
6.49067, 29470.0
6.49133, 29487.0
6.492, 29504.0
6.49267, 29521.0
6.49333, 29538.0
6.494, 29554.0
6.49467, 29570.0
6.49533, 29586.0
6.496, 29603.0
6.49667, 29619.0
6.49733, 29636.0
6.498, 29652.0
6.49867, 29669.0
6.49933, 29686.0
6.5, 29703.0
6.50067, 29721.0
6.50133, 29738.0
6.502, 29755.0
6.50267, 29772.0
6.50333, 29790.0
6.504, 29807.0
6.50467, 29825.0
6.50533, 29843.0
6.506, 29861.0
6.50667, 29879.0
6.50733, 29898.0
6.508, 29917.0
6.50867, 29936.0
6.50933, 29955.0
6.51, 29974.0
6.51067, 29993.0
6.51133, 30013.0
6.512, 30032.0
6.51267, 30052.0
6.51333, 30072.0
6.514, 30092.0
6.51467, 30113.0
6.51533, 30133.0
6.516, 30154.0
6.51667, 30174.0
6.51733, 30194.0
6.518, 30215.0
6.51867, 30235.0
6.51933, 30255.0
6.52, 30276.0
6.52067, 30296.0
6.52133, 30317.0
6.522, 30337.0
6.52267, 30358.0
6.52333, 30379.0
6.524, 30400.0
6.52467, 30422.0
6.52533, 30443.0
6.526, 30464.0
6.52667, 30484.0
6.52733, 30505.0
6.528, 30526.0
6.52867, 30547.0
6.52933, 30568.0
6.53, 30589.0
6.53067, 30610.0
6.53133, 30631.0
6.532, 30652.0
6.53267, 30672.0
6.53333, 30692.0
6.534, 30713.0
6.53467, 30733.0
6.53533, 30754.0
6.536, 30774.0
6.53667, 30795.0
6.53733, 30816.0
6.538, 30837.0
6.53867, 30859.0
6.53933, 30880.0
6.54, 30902.0
6.54067, 30924.0
6.54133, 30945.0
6.542, 30967.0
6.54267, 30989.0
6.54333, 31011.0
6.544, 31033.0
6.54467, 31055.0
6.54533, 31076.0
6.546, 31097.0
6.54667, 31119.0
6.54733, 31140.0
6.548, 31162.0
6.54867, 31183.0
6.54933, 31204.0
6.55, 31225.0
6.55067, 31247.0
6.55133, 31268.0
6.552, 31288.0
6.55267, 31309.0
6.55333, 31330.0
6.554, 31351.0
6.55467, 31371.0
6.55533, 31392.0
6.556, 31412.0
6.55667, 31433.0
6.55733, 31453.0
6.558, 31473.0
6.55867, 31492.0
6.55933, 31512.0
6.56, 31532.0
6.56067, 31551.0
6.56133, 31571.0
6.562, 31592.0
6.56267, 31612.0
6.56333, 31632.0
6.564, 31653.0
6.56467, 31673.0
6.56533, 31693.0
6.566, 31714.0
6.56667, 31734.0
6.56733, 31755.0
6.568, 31776.0
6.56867, 31797.0
6.56933, 31818.0
6.57, 31839.0
6.57067, 31861.0
6.57133, 31882.0
6.572, 31903.0
6.57267, 31925.0
6.57333, 31946.0
6.574, 31968.0
6.57467, 31989.0
6.57533, 32010.0
6.576, 32032.0
6.57667, 32053.0
6.57733, 32074.0
6.578, 32095.0
6.57867, 32115.0
6.57933, 32136.0
6.58, 32156.0
6.58067, 32176.0
6.58133, 32196.0
6.582, 32215.0
6.58267, 32235.0
6.58333, 32254.0
6.584, 32272.0
6.58467, 32291.0
6.58533, 32310.0
6.586, 32329.0
6.58667, 32347.0
6.58733, 32366.0
6.588, 32385.0
6.58867, 32404.0
6.58933, 32423.0
6.59, 32441.0
6.59067, 32460.0
6.59133, 32479.0
6.592, 32499.0
6.59267, 32518.0
6.59333, 32537.0
6.594, 32556.0
6.59467, 32576.0
6.59533, 32595.0
6.596, 32615.0
6.59667, 32634.0
6.59733, 32654.0
6.598, 32674.0
6.59867, 32694.0
6.59933, 32714.0
6.6, 32735.0
6.60067, 32755.0
6.60133, 32776.0
6.602, 32797.0
6.60267, 32818.0
6.60333, 32839.0
6.604, 32861.0
6.60467, 32882.0
6.60533, 32904.0
6.606, 32926.0
6.60667, 32948.0
6.60733, 32969.0
6.608, 32991.0
6.60867, 33013.0
6.60933, 33035.0
6.61, 33057.0
6.61067, 33079.0
6.61133, 33101.0
6.612, 33123.0
6.61267, 33145.0
6.61333, 33167.0
6.614, 33189.0
6.61467, 33211.0
6.61533, 33234.0
6.616, 33255.0
6.61667, 33277.0
6.61733, 33299.0
6.618, 33320.0
6.61867, 33341.0
6.61933, 33362.0
6.62, 33382.0
6.62067, 33402.0
6.62133, 33422.0
6.622, 33443.0
6.62267, 33463.0
6.62333, 33484.0
6.624, 33505.0
6.62467, 33526.0
6.62533, 33548.0
6.626, 33570.0
6.62667, 33594.0
6.62733, 33620.0
6.628, 33647.0
6.62867, 33677.0
6.62933, 33711.0
6.63, 33749.0
6.63067, 33793.0
6.63133, 33844.0
6.632, 33905.0
6.63267, 33976.0
6.63333, 34062.0
6.634, 34165.0
6.63467, 34289.0
6.63533, 34441.0
6.636, 34626.0
6.63667, 34851.0
6.63733, 35126.0
6.638, 35463.0
6.63867, 35873.0
6.63933, 36374.0
6.64, 36983.0
6.64067, 37723.0
6.64133, 38621.0
6.642, 39707.0
6.64267, 41019.0
6.64333, 42597.0
6.644, 44493.0
6.64467, 46761.0
6.64533, 49468.0
6.646, 52686.0
6.64667, 56499.0
6.64733, 60999.0
6.648, 66288.0
6.64867, 72483.0
6.64933, 79710.0
6.65, 88105.0
6.65067, 97818.0
6.65133, 109005.0
6.652, 121830.0
6.65267, 136455.0
6.65333, 153045.0
6.654, 171760.0
6.65467, 192754.0
6.65533, 216168.0
6.656, 242128.0
6.65667, 270739.0
6.65733, 302083.0
6.658, 336211.0
6.65867, 373146.0
6.65933, 412882.0
6.66, 455374.0
6.66067, 500537.0
6.66133, 548245.0
6.662, 598326.0
6.66267, 650568.0
6.66333, 704719.0
6.664, 760497.0
6.66467, 817597.0
6.66533, 875685.0
6.666, 934413.0
6.66667, 993425.0
6.66733, 1052368.0
6.668, 1110885.0
6.66867, 1168621.0
6.66933, 1225231.0
6.67, 1280386.0
6.67067, 1333773.0
6.67133, 1385109.0
6.672, 1434142.0
6.67267, 1480646.0
6.67333, 1524424.0
6.674, 1565304.0
6.67467, 1603131.0
6.67533, 1637779.0
6.676, 1669141.0
6.67667, 1697140.0
6.67733, 1721720.0
6.678, 1742839.0
6.67867, 1760473.0
6.67933, 1774617.0
6.68, 1785283.0
6.68067, 1792497.0
6.68133, 1796303.0
6.682, 1796764.0
6.68267, 1793962.0
6.68333, 1787996.0
6.684, 1778981.0
6.68467, 1767045.0
6.68533, 1752319.0
6.686, 1734939.0
6.68667, 1715054.0
6.68733, 1692809.0
6.688, 1668355.0
6.68867, 1641839.0
6.68933, 1613414.0
6.69, 1583233.0
6.69067, 1551454.0
6.69133, 1518230.0
6.692, 1483712.0
6.69267, 1448051.0
6.69333, 1411394.0
6.694, 1373887.0
6.69467, 1335669.0
6.69533, 1296879.0
6.696, 1257647.0
6.69667, 1218101.0
6.69733, 1178362.0
6.698, 1138548.0
6.69867, 1098771.0
6.69933, 1059141.0
6.7, 1019759.0
6.70067, 980723.0
6.70133, 942122.0
6.702, 904039.0
6.70267, 866549.0
6.70333, 829722.0
6.704, 793623.0
6.70467, 758308.0
6.70533, 723830.0
6.706, 690235.0
6.70667, 657563.0
6.70733, 625850.0
6.708, 595125.0
6.70867, 565411.0
6.70933, 536727.0
6.71, 509087.0
6.71067, 482498.0
6.71133, 456967.0
6.712, 432491.0
6.71267, 409066.0
6.71333, 386684.0
6.714, 365332.0
6.71467, 344994.0
6.71533, 325651.0
6.716, 307284.0
6.71667, 289867.0
6.71733, 273375.0
6.718, 257782.0
6.71867, 243058.0
6.71933, 229174.0
6.72, 216098.0
6.72067, 203799.0
6.72133, 192245.0
6.722, 181405.0
6.72267, 171245.0
6.72333, 161733.0
6.724, 152837.0
6.72467, 144526.0
6.72533, 136770.0
6.726, 129538.0
6.72667, 122802.0
6.72733, 116532.0
6.728, 110702.0
6.72867, 105285.0
6.72933, 100256.0
6.73, 95591.0
6.73067, 91266.0
6.73133, 87261.0
6.732, 83554.0
6.73267, 80124.0
6.73333, 76954.0
6.734, 74026.0
6.73467, 71322.0
6.73533, 68826.0
6.736, 66524.0
6.73667, 64402.0
6.73733, 62446.0
6.738, 60644.0
6.73867, 58985.0
6.73933, 57457.0
6.74, 56051.0
6.74067, 54757.0
6.74133, 53567.0
6.742, 52472.0
6.74267, 51465.0
6.74333, 50539.0
6.744, 49688.0
6.74467, 48906.0
6.74533, 48188.0
6.746, 47528.0
6.74667, 46922.0
6.74733, 46365.0
6.748, 45854.0
6.74867, 45384.0
6.74933, 44952.0
6.75, 44555.0
6.75067, 44191.0
6.75133, 43855.0
6.752, 43547.0
6.75267, 43262.0
6.75333, 43001.0
6.754, 42761.0
6.75467, 42540.0
6.75533, 42337.0
6.756, 42149.0
6.75667, 41976.0
6.75733, 41817.0
6.758, 41670.0
6.75867, 41534.0
6.75933, 41408.0
6.76, 41292.0
6.76067, 41185.0
6.76133, 41085.0
6.762, 40994.0
6.76267, 40908.0
6.76333, 40829.0
6.764, 40756.0
6.76467, 40687.0
6.76533, 40624.0
6.766, 40565.0
6.76667, 40510.0
6.76733, 40459.0
6.768, 40411.0
6.76867, 40367.0
6.76933, 40325.0
6.77, 40287.0
6.77067, 40250.0
6.77133, 40217.0
6.772, 40186.0
6.77267, 40157.0
6.77333, 40131.0
6.774, 40107.0
6.77467, 40084.0
6.77533, 40064.0
6.776, 40044.0
6.77667, 40027.0
6.77733, 40011.0
6.778, 39996.0
6.77867, 39983.0
6.77933, 39971.0
6.78, 39960.0
6.78067, 39950.0
6.78133, 39942.0
6.782, 39934.0
6.78267, 39927.0
6.78333, 39922.0
6.784, 39917.0
6.78467, 39913.0
6.78533, 39910.0
6.786, 39908.0
6.78667, 39907.0
6.78733, 39906.0
6.788, 39905.0
6.78867, 39906.0
6.78933, 39907.0
6.79, 39908.0
6.79067, 39910.0
6.79133, 39912.0
6.792, 39914.0
6.79267, 39917.0
6.79333, 39920.0
6.794, 39924.0
6.79467, 39928.0
6.79533, 39932.0
6.796, 39937.0
6.79667, 39943.0
6.79733, 39948.0
6.798, 39954.0
6.79867, 39961.0
6.79933, 39967.0
6.8, 39973.0
6.80067, 39980.0
6.80133, 39987.0
6.802, 39995.0
6.80267, 40003.0
6.80333, 40012.0
6.804, 40021.0
6.80467, 40030.0
6.80533, 40039.0
6.806, 40048.0
6.80667, 40058.0
6.80733, 40068.0
6.808, 40078.0
6.80867, 40089.0
6.80933, 40099.0
6.81, 40110.0
6.81067, 40122.0
6.81133, 40133.0
6.812, 40145.0
6.81267, 40157.0
6.81333, 40169.0
6.814, 40182.0
6.81467, 40194.0
6.81533, 40207.0
6.816, 40221.0
6.81667, 40234.0
6.81733, 40248.0
6.818, 40262.0
6.81867, 40276.0
6.81933, 40289.0
6.82, 40303.0
6.82067, 40317.0
6.82133, 40331.0
6.822, 40346.0
6.82267, 40360.0
6.82333, 40375.0
6.824, 40390.0
6.82467, 40406.0
6.82533, 40421.0
6.826, 40438.0
6.82667, 40454.0
6.82733, 40471.0
6.828, 40488.0
6.82867, 40505.0
6.82933, 40523.0
6.83, 40541.0
6.83067, 40559.0
6.83133, 40577.0
6.832, 40595.0
6.83267, 40613.0
6.83333, 40632.0
6.834, 40650.0
6.83467, 40669.0
6.83533, 40688.0
6.836, 40707.0
6.83667, 40726.0
6.83733, 40745.0
6.838, 40764.0
6.83867, 40784.0
6.83933, 40803.0
6.84, 40824.0
6.84067, 40844.0
6.84133, 40865.0
6.842, 40886.0
6.84267, 40908.0
6.84333, 40930.0
6.844, 40952.0
6.84467, 40974.0
6.84533, 40996.0
6.846, 41018.0
6.84667, 41040.0
6.84733, 41062.0
6.848, 41084.0
6.84867, 41106.0
6.84933, 41127.0
6.85, 41149.0
6.85067, 41170.0
6.85133, 41192.0
6.852, 41213.0
6.85267, 41234.0
6.85333, 41255.0
6.854, 41276.0
6.85467, 41298.0
6.85533, 41319.0
6.856, 41341.0
6.85667, 41362.0
6.85733, 41384.0
6.858, 41406.0
6.85867, 41428.0
6.85933, 41450.0
6.86, 41473.0
6.86067, 41496.0
6.86133, 41518.0
6.862, 41542.0
6.86267, 41565.0
6.86333, 41589.0
6.864, 41612.0
6.86467, 41636.0
6.86533, 41660.0
6.866, 41684.0
6.86667, 41708.0
6.86733, 41731.0
6.868, 41755.0
6.86867, 41778.0
6.86933, 41801.0
6.87, 41824.0
6.87067, 41847.0
6.87133, 41870.0
6.872, 41893.0
6.87267, 41916.0
6.87333, 41939.0
6.874, 41962.0
6.87467, 41985.0
6.87533, 42009.0
6.876, 42032.0
6.87667, 42056.0
6.87733, 42080.0
6.878, 42104.0
6.87867, 42128.0
6.87933, 42153.0
6.88, 42177.0
6.88067, 42202.0
6.88133, 42227.0
6.882, 42252.0
6.88267, 42277.0
6.88333, 42302.0
6.884, 42327.0
6.88467, 42353.0
6.88533, 42379.0
6.886, 42405.0
6.88667, 42431.0
6.88733, 42457.0
6.888, 42482.0
6.88867, 42508.0
6.88933, 42534.0
6.89, 42560.0
6.89067, 42586.0
6.89133, 42612.0
6.892, 42639.0
6.89267, 42665.0
6.89333, 42692.0
6.894, 42718.0
6.89467, 42744.0
6.89533, 42771.0
6.896, 42797.0
6.89667, 42823.0
6.89733, 42849.0
6.898, 42875.0
6.89867, 42901.0
6.89933, 42927.0
6.9, 42953.0
6.90067, 42978.0
6.90133, 43004.0
6.902, 43030.0
6.90267, 43055.0
6.90333, 43081.0
6.904, 43106.0
6.90467, 43132.0
6.90533, 43157.0
6.906, 43183.0
6.90667, 43209.0
6.90733, 43235.0
6.908, 43261.0
6.90867, 43286.0
6.90933, 43311.0
6.91, 43336.0
6.91067, 43361.0
6.91133, 43387.0
6.912, 43412.0
6.91267, 43438.0
6.91333, 43463.0
6.914, 43489.0
6.91467, 43515.0
6.91533, 43541.0
6.916, 43567.0
6.91667, 43593.0
6.91733, 43619.0
6.918, 43645.0
6.91867, 43672.0
6.91933, 43698.0
6.92, 43724.0
6.92067, 43751.0
6.92133, 43778.0
6.922, 43805.0
6.92267, 43833.0
6.92333, 43861.0
6.924, 43890.0
6.92467, 43919.0
6.92533, 43948.0
6.926, 43977.0
6.92667, 44007.0
6.92733, 44037.0
6.928, 44067.0
6.92867, 44097.0
6.92933, 44128.0
6.93, 44159.0
6.93067, 44190.0
6.93133, 44221.0
6.932, 44252.0
6.93267, 44283.0
6.93333, 44314.0
6.934, 44345.0
6.93467, 44377.0
6.93533, 44408.0
6.936, 44439.0
6.93667, 44470.0
6.93733, 44501.0
6.938, 44532.0
6.93867, 44562.0
6.93933, 44593.0
6.94, 44624.0
6.94067, 44656.0
6.94133, 44687.0
6.942, 44718.0
6.94267, 44749.0
6.94333, 44781.0
6.944, 44812.0
6.94467, 44843.0
6.94533, 44874.0
6.946, 44905.0
6.94667, 44936.0
6.94733, 44966.0
6.948, 44996.0
6.94867, 45026.0
6.94933, 45055.0
6.95, 45084.0
6.95067, 45113.0
6.95133, 45142.0
6.952, 45171.0
6.95267, 45200.0
6.95333, 45229.0
6.954, 45258.0
6.95467, 45287.0
6.95533, 45316.0
6.956, 45346.0
6.95667, 45375.0
6.95733, 45405.0
6.958, 45435.0
6.95867, 45466.0
6.95933, 45496.0
6.96, 45528.0
6.96067, 45560.0
6.96133, 45592.0
6.962, 45626.0
6.96267, 45659.0
6.96333, 45693.0
6.964, 45727.0
6.96467, 45761.0
6.96533, 45795.0
6.966, 45829.0
6.96667, 45863.0
6.96733, 45896.0
6.968, 45930.0
6.96867, 45962.0
6.96933, 45995.0
6.97, 46027.0
6.97067, 46059.0
6.97133, 46091.0
6.972, 46123.0
6.97267, 46154.0
6.97333, 46186.0
6.974, 46218.0
6.97467, 46250.0
6.97533, 46281.0
6.976, 46312.0
6.97667, 46343.0
6.97733, 46373.0
6.978, 46403.0
6.97867, 46433.0
6.97933, 46463.0
6.98, 46493.0
6.98067, 46524.0
6.98133, 46554.0
6.982, 46584.0
6.98267, 46614.0
6.98333, 46644.0
6.984, 46673.0
6.98467, 46703.0
6.98533, 46733.0
6.986, 46763.0
6.98667, 46793.0
6.98733, 46823.0
6.988, 46853.0
6.98867, 46883.0
6.98933, 46914.0
6.99, 46944.0
6.99067, 46975.0
6.99133, 47005.0
6.992, 47036.0
6.99267, 47066.0
6.99333, 47097.0
6.994, 47128.0
6.99467, 47159.0
6.99533, 47190.0
6.996, 47221.0
6.99667, 47253.0
6.99733, 47285.0
6.998, 47316.0
6.99867, 47348.0
6.99933, 47379.0
7.0, 47411.0
7.00067, 47443.0
7.00133, 47475.0
7.002, 47507.0
7.00267, 47540.0
7.00333, 47572.0
7.004, 47605.0
7.00467, 47638.0
7.00533, 47671.0
7.006, 47705.0
7.00667, 47738.0
7.00733, 47771.0
7.008, 47805.0
7.00867, 47837.0
7.00933, 47870.0
7.01, 47902.0
7.01067, 47934.0
7.01133, 47965.0
7.012, 47996.0
7.01267, 48028.0
7.01333, 48059.0
7.014, 48090.0
7.01467, 48121.0
7.01533, 48152.0
7.016, 48184.0
7.01667, 48215.0
7.01733, 48246.0
7.018, 48277.0
7.01867, 48309.0
7.01933, 48340.0
7.02, 48371.0
7.02067, 48402.0
7.02133, 48433.0
7.022, 48464.0
7.02267, 48496.0
7.02333, 48527.0
7.024, 48559.0
7.02467, 48591.0
7.02533, 48623.0
7.026, 48656.0
7.02667, 48688.0
7.02733, 48721.0
7.028, 48755.0
7.02867, 48788.0
7.02933, 48823.0
7.03, 48857.0
7.03067, 48893.0
7.03133, 48929.0
7.032, 48965.0
7.03267, 49002.0
7.03333, 49039.0
7.034, 49076.0
7.03467, 49113.0
7.03533, 49150.0
7.036, 49186.0
7.03667, 49221.0
7.03733, 49256.0
7.038, 49291.0
7.03867, 49325.0
7.03933, 49359.0
7.04, 49392.0
7.04067, 49425.0
7.04133, 49458.0
7.042, 49491.0
7.04267, 49523.0
7.04333, 49555.0
7.044, 49586.0
7.04467, 49617.0
7.04533, 49648.0
7.046, 49678.0
7.04667, 49709.0
7.04733, 49740.0
7.048, 49771.0
7.04867, 49803.0
7.04933, 49835.0
7.05, 49867.0
7.05067, 49900.0
7.05133, 49934.0
7.052, 49967.0
7.05267, 50001.0
7.05333, 50035.0
7.054, 50069.0
7.05467, 50103.0
7.05533, 50138.0
7.056, 50172.0
7.05667, 50207.0
7.05733, 50241.0
7.058, 50275.0
7.05867, 50310.0
7.05933, 50344.0
7.06, 50378.0
7.06067, 50413.0
7.06133, 50447.0
7.062, 50482.0
7.06267, 50517.0
7.06333, 50552.0
7.064, 50587.0
7.06467, 50622.0
7.06533, 50658.0
7.066, 50693.0
7.06667, 50728.0
7.06733, 50763.0
7.068, 50797.0
7.06867, 50832.0
7.06933, 50867.0
7.07, 50902.0
7.07067, 50936.0
7.07133, 50971.0
7.072, 51006.0
7.07267, 51041.0
7.07333, 51075.0
7.074, 51110.0
7.07467, 51145.0
7.07533, 51179.0
7.076, 51214.0
7.07667, 51248.0
7.07733, 51283.0
7.078, 51318.0
7.07867, 51352.0
7.07933, 51387.0
7.08, 51422.0
7.08067, 51458.0
7.08133, 51493.0
7.082, 51529.0
7.08267, 51565.0
7.08333, 51602.0
7.084, 51639.0
7.08467, 51676.0
7.08533, 51714.0
7.086, 51751.0
7.08667, 51789.0
7.08733, 51828.0
7.088, 51866.0
7.08867, 51904.0
7.08933, 51941.0
7.09, 51978.0
7.09067, 52015.0
7.09133, 52051.0
7.092, 52087.0
7.09267, 52123.0
7.09333, 52159.0
7.094, 52195.0
7.09467, 52231.0
7.09533, 52267.0
7.096, 52303.0
7.09667, 52338.0
7.09733, 52373.0
7.098, 52408.0
7.09867, 52443.0
7.09933, 52478.0
7.1, 52512.0
7.10067, 52547.0
7.10133, 52583.0
7.102, 52618.0
7.10267, 52653.0
7.10333, 52688.0
7.104, 52723.0
7.10467, 52758.0
7.10533, 52792.0
7.106, 52826.0
7.10667, 52861.0
7.10733, 52894.0
7.108, 52928.0
7.10867, 52962.0
7.10933, 52996.0
7.11, 53030.0
7.11067, 53064.0
7.11133, 53098.0
7.112, 53133.0
7.11267, 53169.0
7.11333, 53204.0
7.114, 53239.0
7.11467, 53274.0
7.11533, 53309.0
7.116, 53344.0
7.11667, 53379.0
7.11733, 53414.0
7.118, 53449.0
7.11867, 53485.0
7.11933, 53521.0
7.12, 53557.0
7.12067, 53593.0
7.12133, 53628.0
7.122, 53663.0
7.12267, 53697.0
7.12333, 53731.0
7.124, 53765.0
7.12467, 53797.0
7.12533, 53830.0
7.126, 53862.0
7.12667, 53894.0
7.12733, 53926.0
7.128, 53958.0
7.12867, 53991.0
7.12933, 54023.0
7.13, 54056.0
7.13067, 54089.0
7.13133, 54121.0
7.132, 54155.0
7.13267, 54188.0
7.13333, 54221.0
7.134, 54254.0
7.13467, 54288.0
7.13533, 54321.0
7.136, 54354.0
7.13667, 54387.0
7.13733, 54419.0
7.138, 54452.0
7.13867, 54484.0
7.13933, 54517.0
7.14, 54550.0
7.14067, 54583.0
7.14133, 54617.0
7.142, 54651.0
7.14267, 54685.0
7.14333, 54719.0
7.144, 54755.0
7.14467, 54791.0
7.14533, 54827.0
7.146, 54863.0
7.14667, 54900.0
7.14733, 54936.0
7.148, 54972.0
7.14867, 55008.0
7.14933, 55043.0
7.15, 55079.0
7.15067, 55115.0
7.15133, 55150.0
7.152, 55186.0
7.15267, 55222.0
7.15333, 55258.0
7.154, 55294.0
7.15467, 55330.0
7.15533, 55367.0
7.156, 55403.0
7.15667, 55440.0
7.15733, 55476.0
7.158, 55512.0
7.15867, 55549.0
7.15933, 55585.0
7.16, 55621.0
7.16067, 55657.0
7.16133, 55694.0
7.162, 55730.0
7.16267, 55767.0
7.16333, 55805.0
7.164, 55842.0
7.16467, 55880.0
7.16533, 55918.0
7.166, 55956.0
7.16667, 55994.0
7.16733, 56032.0
7.168, 56071.0
7.16867, 56110.0
7.16933, 56150.0
7.17, 56190.0
7.17067, 56229.0
7.17133, 56268.0
7.172, 56306.0
7.17267, 56344.0
7.17333, 56382.0
7.174, 56420.0
7.17467, 56457.0
7.17533, 56494.0
7.176, 56531.0
7.17667, 56566.0
7.17733, 56602.0
7.178, 56637.0
7.17867, 56671.0
7.17933, 56706.0
7.18, 56741.0
7.18067, 56775.0
7.18133, 56810.0
7.182, 56844.0
7.18267, 56878.0
7.18333, 56912.0
7.184, 56946.0
7.18467, 56979.0
7.18533, 57012.0
7.186, 57044.0
7.18667, 57077.0
7.18733, 57110.0
7.188, 57143.0
7.18867, 57177.0
7.18933, 57210.0
7.19, 57243.0
7.19067, 57276.0
7.19133, 57309.0
7.192, 57342.0
7.19267, 57375.0
7.19333, 57409.0
7.194, 57443.0
7.19467, 57477.0
7.19533, 57510.0
7.196, 57544.0
7.19667, 57577.0
7.19733, 57611.0
7.198, 57645.0
7.19867, 57679.0
7.19933, 57713.0
7.2, 57748.0
7.20067, 57784.0
7.20133, 57820.0
7.202, 57855.0
7.20267, 57891.0
7.20333, 57926.0
7.204, 57961.0
7.20467, 57997.0
7.20533, 58032.0
7.206, 58067.0
7.20667, 58103.0
7.20733, 58140.0
7.208, 58176.0
7.20867, 58213.0
7.20933, 58249.0
7.21, 58286.0
7.21067, 58323.0
7.21133, 58359.0
7.212, 58396.0
7.21267, 58432.0
7.21333, 58469.0
7.214, 58505.0
7.21467, 58541.0
7.21533, 58577.0
7.216, 58613.0
7.21667, 58649.0
7.21733, 58684.0
7.218, 58720.0
7.21867, 58756.0
7.21933, 58791.0
7.22, 58826.0
7.22067, 58862.0
7.22133, 58897.0
7.222, 58931.0
7.22267, 58966.0
7.22333, 59000.0
7.224, 59034.0
7.22467, 59068.0
7.22533, 59102.0
7.226, 59135.0
7.22667, 59168.0
7.22733, 59200.0
7.228, 59233.0
7.22867, 59267.0
7.22933, 59301.0
7.23, 59336.0
7.23067, 59370.0
7.23133, 59405.0
7.232, 59440.0
7.23267, 59475.0
7.23333, 59510.0
7.234, 59545.0
7.23467, 59581.0
7.23533, 59616.0
7.236, 59652.0
7.23667, 59688.0
7.23733, 59723.0
7.238, 59758.0
7.23867, 59792.0
7.23933, 59826.0
7.24, 59859.0
7.24067, 59892.0
7.24133, 59926.0
7.242, 59958.0
7.24267, 59991.0
7.24333, 60023.0
7.244, 60054.0
7.24467, 60085.0
7.24533, 60116.0
7.246, 60146.0
7.24667, 60176.0
7.24733, 60205.0
7.248, 60234.0
7.24867, 60263.0
7.24933, 60293.0
7.25, 60324.0
7.25067, 60355.0
7.25133, 60386.0
7.252, 60418.0
7.25267, 60449.0
7.25333, 60481.0
7.254, 60513.0
7.25467, 60546.0
7.25533, 60579.0
7.256, 60613.0
7.25667, 60647.0
7.25733, 60681.0
7.258, 60715.0
7.25867, 60750.0
7.25933, 60783.0
7.26, 60817.0
7.26067, 60851.0
7.26133, 60884.0
7.262, 60917.0
7.26267, 60949.0
7.26333, 60982.0
7.264, 61015.0
7.26467, 61047.0
7.26533, 61078.0
7.266, 61110.0
7.26667, 61141.0
7.26733, 61171.0
7.268, 61202.0
7.26867, 61232.0
7.26933, 61263.0
7.27, 61293.0
7.27067, 61324.0
7.27133, 61354.0
7.272, 61385.0
7.27267, 61416.0
7.27333, 61447.0
7.274, 61479.0
7.27467, 61510.0
7.27533, 61542.0
7.276, 61574.0
7.27667, 61607.0
7.27733, 61639.0
7.278, 61672.0
7.27867, 61704.0
7.27933, 61737.0
7.28, 61771.0
7.28067, 61805.0
7.28133, 61839.0
7.282, 61873.0
7.28267, 61908.0
7.28333, 61943.0
7.284, 61979.0
7.28467, 62016.0
7.28533, 62053.0
7.286, 62090.0
7.28667, 62128.0
7.28733, 62166.0
7.288, 62204.0
7.28867, 62242.0
7.28933, 62279.0
7.29, 62316.0
7.29067, 62353.0
7.29133, 62389.0
7.292, 62425.0
7.29267, 62460.0
7.29333, 62496.0
7.294, 62531.0
7.29467, 62567.0
7.29533, 62604.0
7.296, 62640.0
7.29667, 62676.0
7.29733, 62712.0
7.298, 62747.0
7.29867, 62783.0
7.29933, 62819.0
7.3, 62854.0
7.30067, 62891.0
7.30133, 62927.0
7.302, 62964.0
7.30267, 63000.0
7.30333, 63037.0
7.304, 63075.0
7.30467, 63113.0
7.30533, 63153.0
7.306, 63192.0
7.30667, 63232.0
7.30733, 63273.0
7.308, 63314.0
7.30867, 63354.0
7.30933, 63395.0
7.31, 63435.0
7.31067, 63476.0
7.31133, 63516.0
7.312, 63556.0
7.31267, 63595.0
7.31333, 63634.0
7.314, 63673.0
7.31467, 63712.0
7.31533, 63751.0
7.316, 63789.0
7.31667, 63827.0
7.31733, 63865.0
7.318, 63903.0
7.31867, 63941.0
7.31933, 63979.0
7.32, 64017.0
7.32067, 64054.0
7.32133, 64092.0
7.322, 64129.0
7.32267, 64164.0
7.32333, 64200.0
7.324, 64235.0
7.32467, 64270.0
7.32533, 64304.0
7.326, 64338.0
7.32667, 64372.0
7.32733, 64405.0
7.328, 64438.0
7.32867, 64471.0
7.32933, 64504.0
7.33, 64538.0
7.33067, 64572.0
7.33133, 64607.0
7.332, 64642.0
7.33267, 64678.0
7.33333, 64714.0
7.334, 64750.0
7.33467, 64787.0
7.33533, 64824.0
7.336, 64861.0
7.33667, 64899.0
7.33733, 64937.0
7.338, 64975.0
7.33867, 65014.0
7.33933, 65054.0
7.34, 65093.0
7.34067, 65133.0
7.34133, 65173.0
7.342, 65213.0
7.34267, 65253.0
7.34333, 65293.0
7.344, 65333.0
7.34467, 65373.0
7.34533, 65412.0
7.346, 65452.0
7.34667, 65491.0
7.34733, 65531.0
7.348, 65570.0
7.34867, 65609.0
7.34933, 65648.0
7.35, 65686.0
7.35067, 65725.0
7.35133, 65763.0
7.352, 65801.0
7.35267, 65839.0
7.35333, 65877.0
7.354, 65916.0
7.35467, 65954.0
7.35533, 65992.0
7.356, 66030.0
7.35667, 66068.0
7.35733, 66107.0
7.358, 66145.0
7.35867, 66183.0
7.35933, 66221.0
7.36, 66259.0
7.36067, 66297.0
7.36133, 66335.0
7.362, 66373.0
7.36267, 66412.0
7.36333, 66452.0
7.364, 66492.0
7.36467, 66533.0
7.36533, 66574.0
7.366, 66615.0
7.36667, 66657.0
7.36733, 66698.0
7.368, 66740.0
7.36867, 66781.0
7.36933, 66822.0
7.37, 66864.0
7.37067, 66906.0
7.37133, 66947.0
7.372, 66988.0
7.37267, 67030.0
7.37333, 67071.0
7.374, 67113.0
7.37467, 67155.0
7.37533, 67196.0
7.376, 67238.0
7.37667, 67279.0
7.37733, 67320.0
7.378, 67361.0
7.37867, 67401.0
7.37933, 67442.0
7.38, 67482.0
7.38067, 67522.0
7.38133, 67562.0
7.382, 67602.0
7.38267, 67641.0
7.38333, 67680.0
7.384, 67719.0
7.38467, 67758.0
7.38533, 67796.0
7.386, 67834.0
7.38667, 67872.0
7.38733, 67910.0
7.388, 67948.0
7.38867, 67986.0
7.38933, 68024.0
7.39, 68061.0
7.39067, 68099.0
7.39133, 68137.0
7.392, 68174.0
7.39267, 68212.0
7.39333, 68250.0
7.394, 68288.0
7.39467, 68327.0
7.39533, 68366.0
7.396, 68405.0
7.39667, 68445.0
7.39733, 68485.0
7.398, 68526.0
7.39867, 68567.0
7.39933, 68608.0
7.4, 68649.0
7.40067, 68690.0
7.40133, 68732.0
7.402, 68774.0
7.40267, 68816.0
7.40333, 68858.0
7.404, 68901.0
7.40467, 68945.0
7.40533, 68987.0
7.406, 69030.0
7.40667, 69073.0
7.40733, 69116.0
7.408, 69159.0
7.40867, 69203.0
7.40933, 69246.0
7.41, 69290.0
7.41067, 69334.0
7.41133, 69377.0
7.412, 69421.0
7.41267, 69464.0
7.41333, 69506.0
7.414, 69549.0
7.41467, 69591.0
7.41533, 69633.0
7.416, 69675.0
7.41667, 69718.0
7.41733, 69760.0
7.418, 69802.0
7.41867, 69844.0
7.41933, 69887.0
7.42, 69930.0
7.42067, 69974.0
7.42133, 70017.0
7.422, 70060.0
7.42267, 70103.0
7.42333, 70147.0
7.424, 70191.0
7.42467, 70236.0
7.42533, 70281.0
7.426, 70326.0
7.42667, 70371.0
7.42733, 70416.0
7.428, 70460.0
7.42867, 70505.0
7.42933, 70549.0
7.43, 70593.0
7.43067, 70638.0
7.43133, 70682.0
7.432, 70726.0
7.43267, 70771.0
7.43333, 70816.0
7.434, 70860.0
7.43467, 70905.0
7.43533, 70950.0
7.436, 70995.0
7.43667, 71041.0
7.43733, 71086.0
7.438, 71132.0
7.43867, 71177.0
7.43933, 71223.0
7.44, 71269.0
7.44067, 71314.0
7.44133, 71359.0
7.442, 71403.0
7.44267, 71447.0
7.44333, 71491.0
7.444, 71534.0
7.44467, 71578.0
7.44533, 71620.0
7.446, 71663.0
7.44667, 71705.0
7.44733, 71747.0
7.448, 71789.0
7.44867, 71831.0
7.44933, 71873.0
7.45, 71915.0
7.45067, 71957.0
7.45133, 71999.0
7.452, 72041.0
7.45267, 72083.0
7.45333, 72126.0
7.454, 72169.0
7.45467, 72213.0
7.45533, 72257.0
7.456, 72301.0
7.45667, 72346.0
7.45733, 72392.0
7.458, 72437.0
7.45867, 72483.0
7.45933, 72529.0
7.46, 72575.0
7.46067, 72621.0
7.46133, 72667.0
7.462, 72712.0
7.46267, 72757.0
7.46333, 72801.0
7.464, 72845.0
7.46467, 72889.0
7.46533, 72933.0
7.466, 72978.0
7.46667, 73022.0
7.46733, 73067.0
7.468, 73113.0
7.46867, 73158.0
7.46933, 73204.0
7.47, 73250.0
7.47067, 73297.0
7.47133, 73344.0
7.472, 73392.0
7.47267, 73440.0
7.47333, 73489.0
7.474, 73539.0
7.47467, 73589.0
7.47533, 73640.0
7.476, 73692.0
7.47667, 73744.0
7.47733, 73796.0
7.478, 73848.0
7.47867, 73900.0
7.47933, 73952.0
7.48, 74004.0
7.48067, 74056.0
7.48133, 74108.0
7.482, 74160.0
7.48267, 74213.0
7.48333, 74264.0
7.484, 74315.0
7.48467, 74365.0
7.48533, 74415.0
7.486, 74463.0
7.48667, 74511.0
7.48733, 74558.0
7.488, 74605.0
7.48867, 74650.0
7.48933, 74696.0
7.49, 74740.0
7.49067, 74784.0
7.49133, 74828.0
7.492, 74872.0
7.49267, 74914.0
7.49333, 74957.0
7.494, 74999.0
7.49467, 75042.0
7.49533, 75084.0
7.496, 75126.0
7.49667, 75169.0
7.49733, 75211.0
7.498, 75253.0
7.49867, 75295.0
7.49933, 75336.0
7.5, 75378.0
7.50067, 75420.0
7.50133, 75462.0
7.502, 75505.0
7.50267, 75547.0
7.50333, 75589.0
7.504, 75631.0
7.50467, 75673.0
7.50533, 75715.0
7.506, 75758.0
7.50667, 75801.0
7.50733, 75845.0
7.508, 75888.0
7.50867, 75931.0
7.50933, 75975.0
7.51, 76020.0
7.51067, 76065.0
7.51133, 76110.0
7.512, 76156.0
7.51267, 76202.0
7.51333, 76248.0
7.514, 76295.0
7.51467, 76342.0
7.51533, 76389.0
7.516, 76437.0
7.51667, 76485.0
7.51733, 76534.0
7.518, 76584.0
7.51867, 76633.0
7.51933, 76684.0
7.52, 76734.0
7.52067, 76785.0
7.52133, 76836.0
7.522, 76887.0
7.52267, 76938.0
7.52333, 76990.0
7.524, 77042.0
7.52467, 77094.0
7.52533, 77146.0
7.526, 77197.0
7.52667, 77248.0
7.52733, 77299.0
7.528, 77349.0
7.52867, 77398.0
7.52933, 77447.0
7.53, 77495.0
7.53067, 77542.0
7.53133, 77589.0
7.532, 77635.0
7.53267, 77681.0
7.53333, 77727.0
7.534, 77773.0
7.53467, 77819.0
7.53533, 77866.0
7.536, 77913.0
7.53667, 77962.0
7.53733, 78011.0
7.538, 78060.0
7.53867, 78110.0
7.53933, 78160.0
7.54, 78210.0
7.54067, 78260.0
7.54133, 78309.0
7.542, 78359.0
7.54267, 78409.0
7.54333, 78460.0
7.544, 78510.0
7.54467, 78560.0
7.54533, 78609.0
7.546, 78658.0
7.54667, 78706.0
7.54733, 78754.0
7.548, 78800.0
7.54867, 78847.0
7.54933, 78894.0
7.55, 78941.0
7.55067, 78987.0
7.55133, 79035.0
7.552, 79082.0
7.55267, 79130.0
7.55333, 79177.0
7.554, 79225.0
7.55467, 79274.0
7.55533, 79323.0
7.556, 79373.0
7.55667, 79424.0
7.55733, 79475.0
7.558, 79526.0
7.55867, 79578.0
7.55933, 79630.0
7.56, 79683.0
7.56067, 79737.0
7.56133, 79790.0
7.562, 79844.0
7.56267, 79899.0
7.56333, 79953.0
7.564, 80007.0
7.56467, 80060.0
7.56533, 80114.0
7.566, 80166.0
7.56667, 80218.0
7.56733, 80269.0
7.568, 80318.0
7.56867, 80366.0
7.56933, 80413.0
7.57, 80460.0
7.57067, 80505.0
7.57133, 80550.0
7.572, 80593.0
7.57267, 80635.0
7.57333, 80676.0
7.574, 80717.0
7.57467, 80756.0
7.57533, 80796.0
7.576, 80836.0
7.57667, 80877.0
7.57733, 80918.0
7.578, 80961.0
7.57867, 81004.0
7.57933, 81048.0
7.58, 81092.0
7.58067, 81138.0
7.58133, 81184.0
7.582, 81232.0
7.58267, 81281.0
7.58333, 81332.0
7.584, 81384.0
7.58467, 81438.0
7.58533, 81493.0
7.586, 81549.0
7.58667, 81606.0
7.58733, 81665.0
7.588, 81726.0
7.58867, 81787.0
7.58933, 81848.0
7.59, 81911.0
7.59067, 81974.0
7.59133, 82038.0
7.592, 82103.0
7.59267, 82168.0
7.59333, 82232.0
7.594, 82296.0
7.59467, 82359.0
7.59533, 82421.0
7.596, 82481.0
7.59667, 82541.0
7.59733, 82599.0
7.598, 82656.0
7.59867, 82712.0
7.59933, 82766.0
7.6, 82820.0
7.60067, 82873.0
7.60133, 82925.0
7.602, 82976.0
7.60267, 83026.0
7.60333, 83074.0
7.604, 83122.0
7.60467, 83170.0
7.60533, 83216.0
7.606, 83263.0
7.60667, 83309.0
7.60733, 83355.0
7.608, 83400.0
7.60867, 83445.0
7.60933, 83489.0
7.61, 83532.0
7.61067, 83575.0
7.61133, 83618.0
7.612, 83660.0
7.61267, 83703.0
7.61333, 83746.0
7.614, 83789.0
7.61467, 83833.0
7.61533, 83877.0
7.616, 83922.0
7.61667, 83967.0
7.61733, 84013.0
7.618, 84060.0
7.61867, 84107.0
7.61933, 84155.0
7.62, 84204.0
7.62067, 84253.0
7.62133, 84303.0
7.622, 84353.0
7.62267, 84404.0
7.62333, 84456.0
7.624, 84509.0
7.62467, 84562.0
7.62533, 84615.0
7.626, 84669.0
7.62667, 84724.0
7.62733, 84780.0
7.628, 84835.0
7.62867, 84891.0
7.62933, 84947.0
7.63, 85004.0
7.63067, 85061.0
7.63133, 85118.0
7.632, 85175.0
7.63267, 85231.0
7.63333, 85286.0
7.634, 85341.0
7.63467, 85396.0
7.63533, 85450.0
7.636, 85503.0
7.63667, 85555.0
7.63733, 85607.0
7.638, 85659.0
7.63867, 85711.0
7.63933, 85762.0
7.64, 85814.0
7.64067, 85865.0
7.64133, 85915.0
7.642, 85965.0
7.64267, 86015.0
7.64333, 86065.0
7.644, 86115.0
7.64467, 86165.0
7.64533, 86215.0
7.646, 86266.0
7.64667, 86317.0
7.64733, 86369.0
7.648, 86422.0
7.64867, 86475.0
7.64933, 86529.0
7.65, 86583.0
7.65067, 86637.0
7.65133, 86690.0
7.652, 86744.0
7.65267, 86798.0
7.65333, 86852.0
7.654, 86906.0
7.65467, 86959.0
7.65533, 87013.0
7.656, 87067.0
7.65667, 87121.0
7.65733, 87174.0
7.658, 87227.0
7.65867, 87280.0
7.65933, 87334.0
7.66, 87387.0
7.66067, 87441.0
7.66133, 87496.0
7.662, 87551.0
7.66267, 87606.0
7.66333, 87661.0
7.664, 87716.0
7.66467, 87771.0
7.66533, 87826.0
7.666, 87881.0
7.66667, 87936.0
7.66733, 87990.0
7.668, 88045.0
7.66867, 88100.0
7.66933, 88155.0
7.67, 88210.0
7.67067, 88266.0
7.67133, 88322.0
7.672, 88378.0
7.67267, 88434.0
7.67333, 88491.0
7.674, 88547.0
7.67467, 88604.0
7.67533, 88662.0
7.676, 88719.0
7.67667, 88776.0
7.67733, 88833.0
7.678, 88890.0
7.67867, 88948.0
7.67933, 89005.0
7.68, 89063.0
7.68067, 89121.0
7.68133, 89179.0
7.682, 89237.0
7.68267, 89295.0
7.68333, 89354.0
7.684, 89411.0
7.68467, 89469.0
7.68533, 89525.0
7.686, 89581.0
7.68667, 89637.0
7.68733, 89693.0
7.688, 89748.0
7.68867, 89804.0
7.68933, 89859.0
7.69, 89914.0
7.69067, 89969.0
7.69133, 90024.0
7.692, 90080.0
7.69267, 90135.0
7.69333, 90190.0
7.694, 90246.0
7.69467, 90302.0
7.69533, 90358.0
7.696, 90416.0
7.69667, 90474.0
7.69733, 90532.0
7.698, 90589.0
7.69867, 90647.0
7.69933, 90704.0
7.7, 90760.0
7.70067, 90817.0
7.70133, 90873.0
7.702, 90929.0
7.70267, 90985.0
7.70333, 91041.0
7.704, 91097.0
7.70467, 91152.0
7.70533, 91208.0
7.706, 91263.0
7.70667, 91319.0
7.70733, 91374.0
7.708, 91428.0
7.70867, 91482.0
7.70933, 91536.0
7.71, 91590.0
7.71067, 91644.0
7.71133, 91698.0
7.712, 91751.0
7.71267, 91805.0
7.71333, 91859.0
7.714, 91913.0
7.71467, 91966.0
7.71533, 92019.0
7.716, 92071.0
7.71667, 92123.0
7.71733, 92174.0
7.718, 92226.0
7.71867, 92277.0
7.71933, 92328.0
7.72, 92379.0
7.72067, 92429.0
7.72133, 92478.0
7.722, 92528.0
7.72267, 92577.0
7.72333, 92625.0
7.724, 92674.0
7.72467, 92722.0
7.72533, 92770.0
7.726, 92818.0
7.72667, 92866.0
7.72733, 92914.0
7.728, 92961.0
7.72867, 93008.0
7.72933, 93056.0
7.73, 93103.0
7.73067, 93149.0
7.73133, 93196.0
7.732, 93244.0
7.73267, 93291.0
7.73333, 93339.0
7.734, 93387.0
7.73467, 93435.0
7.73533, 93484.0
7.736, 93533.0
7.73667, 93583.0
7.73733, 93633.0
7.738, 93683.0
7.73867, 93733.0
7.73933, 93783.0
7.74, 93834.0
7.74067, 93885.0
7.74133, 93936.0
7.742, 93988.0
7.74267, 94039.0
7.74333, 94091.0
7.744, 94143.0
7.74467, 94195.0
7.74533, 94248.0
7.746, 94300.0
7.74667, 94352.0
7.74733, 94404.0
7.748, 94457.0
7.74867, 94509.0
7.74933, 94563.0
7.75, 94616.0
7.75067, 94671.0
7.75133, 94725.0
7.752, 94780.0
7.75267, 94834.0
7.75333, 94889.0
7.754, 94944.0
7.75467, 94999.0
7.75533, 95054.0
7.756, 95108.0
7.75667, 95161.0
7.75733, 95214.0
7.758, 95265.0
7.75867, 95316.0
7.75933, 95366.0
7.76, 95415.0
7.76067, 95464.0
7.76133, 95512.0
7.762, 95560.0
7.76267, 95607.0
7.76333, 95654.0
7.764, 95701.0
7.76467, 95747.0
7.76533, 95793.0
7.766, 95838.0
7.76667, 95883.0
7.76733, 95929.0
7.768, 95974.0
7.76867, 96021.0
7.76933, 96068.0
7.77, 96116.0
7.77067, 96164.0
7.77133, 96213.0
7.772, 96263.0
7.77267, 96313.0
7.77333, 96364.0
7.774, 96417.0
7.77467, 96470.0
7.77533, 96523.0
7.776, 96577.0
7.77667, 96632.0
7.77733, 96687.0
7.778, 96742.0
7.77867, 96798.0
7.77933, 96854.0
7.78, 96911.0
7.78067, 96966.0
7.78133, 97022.0
7.782, 97077.0
7.78267, 97132.0
7.78333, 97186.0
7.784, 97241.0
7.78467, 97295.0
7.78533, 97349.0
7.786, 97404.0
7.78667, 97459.0
7.78733, 97514.0
7.788, 97571.0
7.78867, 97628.0
7.78933, 97685.0
7.79, 97742.0
7.79067, 97798.0
7.79133, 97855.0
7.792, 97911.0
7.79267, 97968.0
7.79333, 98025.0
7.794, 98082.0
7.79467, 98138.0
7.79533, 98194.0
7.796, 98250.0
7.79667, 98306.0
7.79733, 98361.0
7.798, 98417.0
7.79867, 98472.0
7.79933, 98527.0
7.8, 98582.0
7.80067, 98635.0
7.80133, 98689.0
7.802, 98742.0
7.80267, 98795.0
7.80333, 98847.0
7.804, 98899.0
7.80467, 98950.0
7.80533, 99001.0
7.806, 99051.0
7.80667, 99102.0
7.80733, 99152.0
7.808, 99202.0
7.80867, 99253.0
7.80933, 99304.0
7.81, 99356.0
7.81067, 99407.0
7.81133, 99459.0
7.812, 99512.0
7.81267, 99565.0
7.81333, 99618.0
7.814, 99671.0
7.81467, 99724.0
7.81533, 99777.0
7.816, 99831.0
7.81667, 99884.0
7.81733, 99938.0
7.818, 99992.0
7.81867, 100047.0
7.81933, 100101.0
7.82, 100156.0
7.82067, 100211.0
7.82133, 100266.0
7.822, 100320.0
7.82267, 100374.0
7.82333, 100427.0
7.824, 100480.0
7.82467, 100533.0
7.82533, 100586.0
7.826, 100638.0
7.82667, 100691.0
7.82733, 100743.0
7.828, 100796.0
7.82867, 100849.0
7.82933, 100903.0
7.83, 100957.0
7.83067, 101011.0
7.83133, 101066.0
7.832, 101121.0
7.83267, 101177.0
7.83333, 101233.0
7.834, 101290.0
7.83467, 101348.0
7.83533, 101407.0
7.836, 101465.0
7.83667, 101524.0
7.83733, 101583.0
7.838, 101642.0
7.83867, 101701.0
7.83933, 101759.0
7.84, 101817.0
7.84067, 101875.0
7.84133, 101932.0
7.842, 101988.0
7.84267, 102043.0
7.84333, 102097.0
7.844, 102150.0
7.84467, 102201.0
7.84533, 102251.0
7.846, 102299.0
7.84667, 102346.0
7.84733, 102391.0
7.848, 102435.0
7.84867, 102477.0
7.84933, 102519.0
7.85, 102560.0
7.85067, 102601.0
7.85133, 102641.0
7.852, 102682.0
7.85267, 102723.0
7.85333, 102764.0
7.854, 102806.0
7.85467, 102850.0
7.85533, 102895.0
7.856, 102941.0
7.85667, 102989.0
7.85733, 103039.0
7.858, 103091.0
7.85867, 103145.0
7.85933, 103201.0
7.86, 103258.0
7.86067, 103318.0
7.86133, 103380.0
7.862, 103444.0
7.86267, 103509.0
7.86333, 103577.0
7.864, 103646.0
7.86467, 103717.0
7.86533, 103790.0
7.866, 103864.0
7.86667, 103939.0
7.86733, 104016.0
7.868, 104093.0
7.86867, 104171.0
7.86933, 104250.0
7.87, 104329.0
7.87067, 104407.0
7.87133, 104485.0
7.872, 104561.0
7.87267, 104637.0
7.87333, 104711.0
7.874, 104783.0
7.87467, 104855.0
7.87533, 104925.0
7.876, 104994.0
7.87667, 105061.0
7.87733, 105127.0
7.878, 105192.0
7.87867, 105257.0
7.87933, 105321.0
7.88, 105385.0
7.88067, 105447.0
7.88133, 105509.0
7.882, 105569.0
7.88267, 105629.0
7.88333, 105688.0
7.884, 105746.0
7.88467, 105804.0
7.88533, 105862.0
7.886, 105919.0
7.88667, 105975.0
7.88733, 106031.0
7.888, 106087.0
7.88867, 106144.0
7.88933, 106200.0
7.89, 106257.0
7.89067, 106316.0
7.89133, 106375.0
7.892, 106435.0
7.89267, 106494.0
7.89333, 106554.0
7.894, 106614.0
7.89467, 106675.0
7.89533, 106737.0
7.896, 106798.0
7.89667, 106859.0
7.89733, 106920.0
7.898, 106980.0
7.89867, 107040.0
7.89933, 107099.0
7.9, 107158.0
7.90067, 107217.0
7.90133, 107275.0
7.902, 107333.0
7.90267, 107392.0
7.90333, 107450.0
7.904, 107509.0
7.90467, 107569.0
7.90533, 107627.0
7.906, 107686.0
7.90667, 107744.0
7.90733, 107802.0
7.908, 107860.0
7.90867, 107918.0
7.90933, 107976.0
7.91, 108034.0
7.91067, 108091.0
7.91133, 108149.0
7.912, 108207.0
7.91267, 108265.0
7.91333, 108323.0
7.914, 108383.0
7.91467, 108443.0
7.91533, 108504.0
7.916, 108565.0
7.91667, 108626.0
7.91733, 108686.0
7.918, 108747.0
7.91867, 108808.0
7.91933, 108871.0
7.92, 108936.0
7.92067, 109001.0
7.92133, 109067.0
7.922, 109133.0
7.92267, 109200.0
7.92333, 109267.0
7.924, 109333.0
7.92467, 109400.0
7.92533, 109466.0
7.926, 109531.0
7.92667, 109597.0
7.92733, 109662.0
7.928, 109727.0
7.92867, 109792.0
7.92933, 109856.0
7.93, 109921.0
7.93067, 109986.0
7.93133, 110050.0
7.932, 110115.0
7.93267, 110181.0
7.93333, 110246.0
7.934, 110312.0
7.93467, 110377.0
7.93533, 110441.0
7.936, 110504.0
7.93667, 110566.0
7.93733, 110628.0
7.938, 110689.0
7.93867, 110749.0
7.93933, 110810.0
7.94, 110870.0
7.94067, 110930.0
7.94133, 110990.0
7.942, 111050.0
7.94267, 111110.0
7.94333, 111172.0
7.944, 111233.0
7.94467, 111295.0
7.94533, 111358.0
7.946, 111420.0
7.94667, 111483.0
7.94733, 111547.0
7.948, 111611.0
7.94867, 111676.0
7.94933, 111740.0
7.95, 111804.0
7.95067, 111869.0
7.95133, 111935.0
7.952, 112000.0
7.95267, 112065.0
7.95333, 112130.0
7.954, 112195.0
7.95467, 112260.0
7.95533, 112325.0
7.956, 112390.0
7.95667, 112455.0
7.95733, 112521.0
7.958, 112588.0
7.95867, 112654.0
7.95933, 112721.0
7.96, 112788.0
7.96067, 112855.0
7.96133, 112924.0
7.962, 112994.0
7.96267, 113066.0
7.96333, 113138.0
7.964, 113211.0
7.96467, 113284.0
7.96533, 113357.0
7.966, 113430.0
7.96667, 113503.0
7.96733, 113577.0
7.968, 113651.0
7.96867, 113725.0
7.96933, 113800.0
7.97, 113874.0
7.97067, 113949.0
7.97133, 114024.0
7.972, 114099.0
7.97267, 114174.0
7.97333, 114248.0
7.974, 114322.0
7.97467, 114394.0
7.97533, 114466.0
7.976, 114539.0
7.97667, 114612.0
7.97733, 114684.0
7.978, 114755.0
7.97867, 114826.0
7.97933, 114897.0
7.98, 114966.0
7.98067, 115035.0
7.98133, 115104.0
7.982, 115172.0
7.98267, 115240.0
7.98333, 115307.0
7.984, 115375.0
7.98467, 115443.0
7.98533, 115511.0
7.986, 115579.0
7.98667, 115648.0
7.98733, 115717.0
7.988, 115786.0
7.98867, 115856.0
7.98933, 115925.0
7.99, 115995.0
7.99067, 116065.0
7.99133, 116136.0
7.992, 116208.0
7.99267, 116281.0
7.99333, 116355.0
7.994, 116431.0
7.99467, 116509.0
7.99533, 116588.0
7.996, 116668.0
7.99667, 116749.0
7.99733, 116832.0
7.998, 116915.0
7.99867, 116998.0
7.99933, 117081.0
8.0, 117164.0
8.00067, 117247.0
8.00133, 117331.0
8.002, 117414.0
8.00267, 117497.0
8.00333, 117579.0
8.004, 117661.0
8.00467, 117743.0
8.00533, 117824.0
8.006, 117905.0
8.00667, 117984.0
8.00733, 118062.0
8.008, 118138.0
8.00867, 118214.0
8.00933, 118287.0
8.01, 118360.0
8.01067, 118431.0
8.01133, 118501.0
8.012, 118569.0
8.01267, 118636.0
8.01333, 118703.0
8.014, 118768.0
8.01467, 118834.0
8.01533, 118899.0
8.016, 118963.0
8.01667, 119027.0
8.01733, 119091.0
8.018, 119155.0
8.01867, 119220.0
8.01933, 119286.0
8.02, 119353.0
8.02067, 119421.0
8.02133, 119489.0
8.022, 119558.0
8.02267, 119629.0
8.02333, 119699.0
8.024, 119771.0
8.02467, 119844.0
8.02533, 119917.0
8.026, 119990.0
8.02667, 120063.0
8.02733, 120135.0
8.028, 120207.0
8.02867, 120277.0
8.02933, 120347.0
8.03, 120415.0
8.03067, 120484.0
8.03133, 120552.0
8.032, 120621.0
8.03267, 120690.0
8.03333, 120760.0
8.034, 120830.0
8.03467, 120899.0
8.03533, 120968.0
8.036, 121038.0
8.03667, 121109.0
8.03733, 121180.0
8.038, 121251.0
8.03867, 121322.0
8.03933, 121392.0
8.04, 121463.0
8.04067, 121533.0
8.04133, 121602.0
8.042, 121671.0
8.04267, 121740.0
8.04333, 121808.0
8.044, 121876.0
8.04467, 121943.0
8.04533, 122009.0
8.046, 122075.0
8.04667, 122140.0
8.04733, 122206.0
8.048, 122271.0
8.04867, 122335.0
8.04933, 122398.0
8.05, 122461.0
8.05067, 122524.0
8.05133, 122587.0
8.052, 122650.0
8.05267, 122713.0
8.05333, 122777.0
8.054, 122841.0
8.05467, 122905.0
8.05533, 122970.0
8.056, 123035.0
8.05667, 123100.0
8.05733, 123166.0
8.058, 123231.0
8.05867, 123297.0
8.05933, 123363.0
8.06, 123430.0
8.06067, 123499.0
8.06133, 123568.0
8.062, 123639.0
8.06267, 123710.0
8.06333, 123781.0
8.064, 123852.0
8.06467, 123922.0
8.06533, 123991.0
8.066, 124060.0
8.06667, 124129.0
8.06733, 124198.0
8.068, 124266.0
8.06867, 124334.0
8.06933, 124403.0
8.07, 124471.0
8.07067, 124539.0
8.07133, 124606.0
8.072, 124672.0
8.07267, 124738.0
8.07333, 124804.0
8.074, 124870.0
8.07467, 124937.0
8.07533, 125004.0
8.076, 125072.0
8.07667, 125141.0
8.07733, 125211.0
8.078, 125281.0
8.07867, 125352.0
8.07933, 125423.0
8.08, 125494.0
8.08067, 125566.0
8.08133, 125639.0
8.082, 125714.0
8.08267, 125788.0
8.08333, 125863.0
8.084, 125938.0
8.08467, 126012.0
8.08533, 126085.0
8.086, 126159.0
8.08667, 126232.0
8.08733, 126304.0
8.088, 126376.0
8.08867, 126448.0
8.08933, 126520.0
8.09, 126592.0
8.09067, 126662.0
8.09133, 126731.0
8.092, 126799.0
8.09267, 126867.0
8.09333, 126933.0
8.094, 126999.0
8.09467, 127064.0
8.09533, 127129.0
8.096, 127194.0
8.09667, 127258.0
8.09733, 127322.0
8.098, 127386.0
8.09867, 127450.0
8.09933, 127512.0
8.1, 127574.0
8.10067, 127635.0
8.10133, 127696.0
8.102, 127757.0
8.10267, 127817.0
8.10333, 127878.0
8.104, 127940.0
8.10467, 128002.0
8.10533, 128064.0
8.106, 128126.0
8.10667, 128189.0
8.10733, 128253.0
8.108, 128318.0
8.10867, 128382.0
8.10933, 128446.0
8.11, 128510.0
8.11067, 128573.0
8.11133, 128636.0
8.112, 128699.0
8.11267, 128760.0
8.11333, 128822.0
8.114, 128884.0
8.11467, 128945.0
8.11533, 129007.0
8.116, 129068.0
8.11667, 129130.0
8.11733, 129193.0
8.118, 129257.0
8.11867, 129322.0
8.11933, 129387.0
8.12, 129454.0
8.12067, 129520.0
8.12133, 129587.0
8.122, 129653.0
8.12267, 129720.0
8.12333, 129788.0
8.124, 129855.0
8.12467, 129923.0
8.12533, 129991.0
8.126, 130060.0
8.12667, 130129.0
8.12733, 130197.0
8.128, 130265.0
8.12867, 130333.0
8.12933, 130400.0
8.13, 130467.0
8.13067, 130534.0
8.13133, 130600.0
8.132, 130666.0
8.13267, 130732.0
8.13333, 130797.0
8.134, 130862.0
8.13467, 130927.0
8.13533, 130992.0
8.136, 131057.0
8.13667, 131121.0
8.13733, 131186.0
8.138, 131252.0
8.13867, 131318.0
8.13933, 131385.0
8.14, 131451.0
8.14067, 131517.0
8.14133, 131583.0
8.142, 131649.0
8.14267, 131714.0
8.14333, 131779.0
8.144, 131843.0
8.14467, 131907.0
8.14533, 131970.0
8.146, 132033.0
8.14667, 132096.0
8.14733, 132159.0
8.148, 132223.0
8.14867, 132287.0
8.14933, 132353.0
8.15, 132420.0
8.15067, 132489.0
8.15133, 132559.0
8.152, 132629.0
8.15267, 132700.0
8.15333, 132772.0
8.154, 132845.0
8.15467, 132918.0
8.15533, 132992.0
8.156, 133065.0
8.15667, 133139.0
8.15733, 133212.0
8.158, 133285.0
8.15867, 133358.0
8.15933, 133432.0
8.16, 133505.0
8.16067, 133578.0
8.16133, 133650.0
8.162, 133722.0
8.16267, 133794.0
8.16333, 133865.0
8.164, 133937.0
8.16467, 134009.0
8.16533, 134081.0
8.166, 134153.0
8.16667, 134226.0
8.16733, 134299.0
8.168, 134373.0
8.16867, 134448.0
8.16933, 134523.0
8.17, 134598.0
8.17067, 134673.0
8.17133, 134747.0
8.172, 134820.0
8.17267, 134892.0
8.17333, 134964.0
8.174, 135034.0
8.17467, 135105.0
8.17533, 135176.0
8.176, 135247.0
8.17667, 135320.0
8.17733, 135393.0
8.178, 135468.0
8.17867, 135543.0
8.17933, 135618.0
8.18, 135693.0
8.18067, 135769.0
8.18133, 135843.0
8.182, 135917.0
8.18267, 135990.0
8.18333, 136063.0
8.184, 136136.0
8.18467, 136210.0
8.18533, 136284.0
8.186, 136359.0
8.18667, 136436.0
8.18733, 136513.0
8.188, 136591.0
8.18867, 136670.0
8.18933, 136749.0
8.19, 136828.0
8.19067, 136907.0
8.19133, 136987.0
8.192, 137066.0
8.19267, 137146.0
8.19333, 137226.0
8.194, 137305.0
8.19467, 137385.0
8.19533, 137464.0
8.196, 137543.0
8.19667, 137622.0
8.19733, 137699.0
8.198, 137776.0
8.19867, 137853.0
8.19933, 137929.0
8.2, 138006.0
8.20067, 138081.0
8.20133, 138157.0
8.202, 138232.0
8.20267, 138308.0
8.20333, 138383.0
8.204, 138458.0
8.20467, 138531.0
8.20533, 138604.0
8.206, 138676.0
8.20667, 138747.0
8.20733, 138818.0
8.208, 138888.0
8.20867, 138958.0
8.20933, 139029.0
8.21, 139099.0
8.21067, 139170.0
8.21133, 139240.0
8.212, 139311.0
8.21267, 139382.0
8.21333, 139453.0
8.214, 139524.0
8.21467, 139595.0
8.21533, 139667.0
8.216, 139738.0
8.21667, 139808.0
8.21733, 139879.0
8.218, 139949.0
8.21867, 140019.0
8.21933, 140089.0
8.22, 140159.0
8.22067, 140229.0
8.22133, 140299.0
8.222, 140370.0
8.22267, 140441.0
8.22333, 140512.0
8.224, 140584.0
8.22467, 140658.0
8.22533, 140732.0
8.226, 140808.0
8.22667, 140885.0
8.22733, 140961.0
8.228, 141039.0
8.22867, 141118.0
8.22933, 141198.0
8.23, 141278.0
8.23067, 141359.0
8.23133, 141441.0
8.232, 141524.0
8.23267, 141607.0
8.23333, 141691.0
8.234, 141776.0
8.23467, 141860.0
8.23533, 141943.0
8.236, 142026.0
8.23667, 142108.0
8.23733, 142190.0
8.238, 142272.0
8.23867, 142354.0
8.23933, 142435.0
8.24, 142516.0
8.24067, 142595.0
8.24133, 142673.0
8.242, 142750.0
8.24267, 142827.0
8.24333, 142904.0
8.244, 142981.0
8.24467, 143058.0
8.24533, 143135.0
8.246, 143213.0
8.24667, 143291.0
8.24733, 143370.0
8.248, 143448.0
8.24867, 143526.0
8.24933, 143604.0
8.25, 143681.0
8.25067, 143758.0
8.25133, 143836.0
8.252, 143914.0
8.25267, 143992.0
8.25333, 144071.0
8.254, 144149.0
8.25467, 144228.0
8.25533, 144308.0
8.256, 144388.0
8.25667, 144467.0
8.25733, 144546.0
8.258, 144626.0
8.25867, 144706.0
8.25933, 144787.0
8.26, 144868.0
8.26067, 144950.0
8.26133, 145034.0
8.262, 145119.0
8.26267, 145205.0
8.26333, 145292.0
8.264, 145379.0
8.26467, 145466.0
8.26533, 145552.0
8.266, 145639.0
8.26667, 145725.0
8.26733, 145811.0
8.268, 145897.0
8.26867, 145983.0
8.26933, 146068.0
8.27, 146154.0
8.27067, 146239.0
8.27133, 146325.0
8.272, 146411.0
8.27267, 146496.0
8.27333, 146581.0
8.274, 146665.0
8.27467, 146748.0
8.27533, 146831.0
8.276, 146914.0
8.27667, 146995.0
8.27733, 147076.0
8.278, 147158.0
8.27867, 147239.0
8.27933, 147319.0
8.28, 147399.0
8.28067, 147479.0
8.28133, 147558.0
8.282, 147636.0
8.28267, 147714.0
8.28333, 147791.0
8.284, 147868.0
8.28467, 147944.0
8.28533, 148019.0
8.286, 148093.0
8.28667, 148167.0
8.28733, 148240.0
8.288, 148315.0
8.28867, 148389.0
8.28933, 148465.0
8.29, 148542.0
8.29067, 148621.0
8.29133, 148700.0
8.292, 148781.0
8.29267, 148863.0
8.29333, 148946.0
8.294, 149030.0
8.29467, 149115.0
8.29533, 149201.0
8.296, 149288.0
8.29667, 149376.0
8.29733, 149464.0
8.298, 149552.0
8.29867, 149640.0
8.29933, 149728.0
8.3, 149816.0
8.30067, 149904.0
8.30133, 149994.0
8.302, 150083.0
8.30267, 150173.0
8.30333, 150261.0
8.304, 150349.0
8.30467, 150436.0
8.30533, 150522.0
8.306, 150608.0
8.30667, 150694.0
8.30733, 150781.0
8.308, 150868.0
8.30867, 150957.0
8.30933, 151045.0
8.31, 151133.0
8.31067, 151222.0
8.31133, 151312.0
8.312, 151402.0
8.31267, 151492.0
8.31333, 151583.0
8.314, 151675.0
8.31467, 151767.0
8.31533, 151858.0
8.316, 151949.0
8.31667, 152039.0
8.31733, 152130.0
8.318, 152220.0
8.31867, 152310.0
8.31933, 152399.0
8.32, 152489.0
8.32067, 152580.0
8.32133, 152670.0
8.322, 152760.0
8.32267, 152850.0
8.32333, 152938.0
8.324, 153026.0
8.32467, 153114.0
8.32533, 153202.0
8.326, 153291.0
8.32667, 153380.0
8.32733, 153470.0
8.328, 153558.0
8.32867, 153647.0
8.32933, 153736.0
8.33, 153824.0
8.33067, 153914.0
8.33133, 154003.0
8.332, 154094.0
8.33267, 154184.0
8.33333, 154274.0
8.334, 154365.0
8.33467, 154455.0
8.33533, 154546.0
8.336, 154636.0
8.33667, 154727.0
8.33733, 154819.0
8.338, 154912.0
8.33867, 155004.0
8.33933, 155096.0
8.34, 155188.0
8.34067, 155278.0
8.34133, 155368.0
8.342, 155457.0
8.34267, 155546.0
8.34333, 155636.0
8.344, 155725.0
8.34467, 155813.0
8.34533, 155902.0
8.346, 155991.0
8.34667, 156079.0
8.34733, 156166.0
8.348, 156252.0
8.34867, 156337.0
8.34933, 156423.0
8.35, 156509.0
8.35067, 156595.0
8.35133, 156682.0
8.352, 156769.0
8.35267, 156856.0
8.35333, 156944.0
8.354, 157031.0
8.35467, 157117.0
8.35533, 157203.0
8.356, 157288.0
8.35667, 157372.0
8.35733, 157457.0
8.358, 157541.0
8.35867, 157625.0
8.35933, 157708.0
8.36, 157790.0
8.36067, 157872.0
8.36133, 157953.0
8.362, 158033.0
8.36267, 158113.0
8.36333, 158192.0
8.364, 158271.0
8.36467, 158350.0
8.36533, 158429.0
8.366, 158509.0
8.36667, 158590.0
8.36733, 158671.0
8.368, 158753.0
8.36867, 158835.0
8.36933, 158917.0
8.37, 158998.0
8.37067, 159081.0
8.37133, 159165.0
8.372, 159250.0
8.37267, 159336.0
8.37333, 159425.0
8.374, 159515.0
8.37467, 159606.0
8.37533, 159698.0
8.376, 159789.0
8.37667, 159881.0
8.37733, 159973.0
8.378, 160066.0
8.37867, 160158.0
8.37933, 160252.0
8.38, 160346.0
8.38067, 160439.0
8.38133, 160531.0
8.382, 160621.0
8.38267, 160710.0
8.38333, 160797.0
8.384, 160885.0
8.38467, 160972.0
8.38533, 161058.0
8.386, 161144.0
8.38667, 161230.0
8.38733, 161315.0
8.388, 161401.0
8.38867, 161487.0
8.38933, 161573.0
8.39, 161660.0
8.39067, 161747.0
8.39133, 161835.0
8.392, 161923.0
8.39267, 162012.0
8.39333, 162102.0
8.394, 162191.0
8.39467, 162281.0
8.39533, 162371.0
8.396, 162460.0
8.39667, 162547.0
8.39733, 162633.0
8.398, 162719.0
8.39867, 162805.0
8.39933, 162891.0
8.4, 162976.0
8.40067, 163061.0
8.40133, 163145.0
8.402, 163229.0
8.40267, 163313.0
8.40333, 163397.0
8.404, 163481.0
8.40467, 163565.0
8.40533, 163649.0
8.406, 163734.0
8.40667, 163818.0
8.40733, 163902.0
8.408, 163985.0
8.40867, 164069.0
8.40933, 164154.0
8.41, 164239.0
8.41067, 164326.0
8.41133, 164414.0
8.412, 164502.0
8.41267, 164593.0
8.41333, 164684.0
8.414, 164776.0
8.41467, 164867.0
8.41533, 164959.0
8.416, 165051.0
8.41667, 165143.0
8.41733, 165236.0
8.418, 165329.0
8.41867, 165424.0
8.41933, 165519.0
8.42, 165614.0
8.42067, 165710.0
8.42133, 165807.0
8.422, 165904.0
8.42267, 166002.0
8.42333, 166099.0
8.424, 166195.0
8.42467, 166291.0
8.42533, 166387.0
8.426, 166483.0
8.42667, 166581.0
8.42733, 166679.0
8.428, 166778.0
8.42867, 166878.0
8.42933, 166977.0
8.43, 167078.0
8.43067, 167179.0
8.43133, 167281.0
8.432, 167382.0
8.43267, 167482.0
8.43333, 167581.0
8.434, 167679.0
8.43467, 167776.0
8.43533, 167872.0
8.436, 167967.0
8.43667, 168060.0
8.43733, 168153.0
8.438, 168244.0
8.43867, 168334.0
8.43933, 168423.0
8.44, 168511.0
8.44067, 168598.0
8.44133, 168685.0
8.442, 168772.0
8.44267, 168858.0
8.44333, 168945.0
8.444, 169032.0
8.44467, 169119.0
8.44533, 169207.0
8.446, 169294.0
8.44667, 169380.0
8.44733, 169465.0
8.448, 169552.0
8.44867, 169638.0
8.44933, 169726.0
8.45, 169815.0
8.45067, 169905.0
8.45133, 169997.0
8.452, 170090.0
8.45267, 170184.0
8.45333, 170278.0
8.454, 170373.0
8.45467, 170467.0
8.45533, 170563.0
8.456, 170660.0
8.45667, 170757.0
8.45733, 170856.0
8.458, 170955.0
8.45867, 171055.0
8.45933, 171155.0
8.46, 171253.0
8.46067, 171351.0
8.46133, 171447.0
8.462, 171542.0
8.46267, 171637.0
8.46333, 171732.0
8.464, 171827.0
8.46467, 171922.0
8.46533, 172016.0
8.466, 172108.0
8.46667, 172197.0
8.46733, 172285.0
8.468, 172372.0
8.46867, 172457.0
8.46933, 172542.0
8.47, 172628.0
8.47067, 172713.0
8.47133, 172799.0
8.472, 172884.0
8.47267, 172969.0
8.47333, 173054.0
8.474, 173138.0
8.47467, 173221.0
8.47533, 173304.0
8.476, 173387.0
8.47667, 173471.0
8.47733, 173555.0
8.478, 173641.0
8.47867, 173726.0
8.47933, 173812.0
8.48, 173898.0
8.48067, 173983.0
8.48133, 174067.0
8.482, 174151.0
8.48267, 174234.0
8.48333, 174316.0
8.484, 174398.0
8.48467, 174481.0
8.48533, 174564.0
8.486, 174647.0
8.48667, 174729.0
8.48733, 174811.0
8.488, 174895.0
8.48867, 174979.0
8.48933, 175065.0
8.49, 175152.0
8.49067, 175239.0
8.49133, 175325.0
8.492, 175412.0
8.49267, 175499.0
8.49333, 175586.0
8.494, 175674.0
8.49467, 175764.0
8.49533, 175855.0
8.496, 175947.0
8.49667, 176041.0
8.49733, 176135.0
8.498, 176230.0
8.49867, 176326.0
8.49933, 176421.0
8.5, 176516.0
8.50067, 176610.0
8.50133, 176705.0
8.502, 176801.0
8.50267, 176897.0
8.50333, 176993.0
8.504, 177089.0
8.50467, 177183.0
8.50533, 177277.0
8.506, 177371.0
8.50667, 177464.0
8.50733, 177557.0
8.508, 177650.0
8.50867, 177743.0
8.50933, 177837.0
8.51, 177931.0
8.51067, 178027.0
8.51133, 178124.0
8.512, 178221.0
8.51267, 178317.0
8.51333, 178413.0
8.514, 178508.0
8.51467, 178605.0
8.51533, 178702.0
8.516, 178800.0
8.51667, 178899.0
8.51733, 178998.0
8.518, 179097.0
8.51867, 179194.0
8.51933, 179292.0
8.52, 179389.0
8.52067, 179486.0
8.52133, 179582.0
8.522, 179678.0
8.52267, 179773.0
8.52333, 179868.0
8.524, 179962.0
8.52467, 180055.0
8.52533, 180147.0
8.526, 180239.0
8.52667, 180331.0
8.52733, 180424.0
8.528, 180517.0
8.52867, 180610.0
8.52933, 180702.0
8.53, 180794.0
8.53067, 180886.0
8.53133, 180979.0
8.532, 181071.0
8.53267, 181165.0
8.53333, 181259.0
8.534, 181352.0
8.53467, 181446.0
8.53533, 181540.0
8.536, 181633.0
8.53667, 181727.0
8.53733, 181821.0
8.538, 181915.0
8.53867, 182009.0
8.53933, 182102.0
8.54, 182195.0
8.54067, 182286.0
8.54133, 182376.0
8.542, 182465.0
8.54267, 182554.0
8.54333, 182641.0
8.544, 182728.0
8.54467, 182815.0
8.54533, 182902.0
8.546, 182990.0
8.54667, 183078.0
8.54733, 183166.0
8.548, 183253.0
8.54867, 183340.0
8.54933, 183426.0
8.55, 183512.0
8.55067, 183597.0
8.55133, 183682.0
8.552, 183767.0
8.55267, 183852.0
8.55333, 183938.0
8.554, 184025.0
8.55467, 184111.0
8.55533, 184197.0
8.556, 184284.0
8.55667, 184371.0
8.55733, 184458.0
8.558, 184546.0
8.55867, 184634.0
8.55933, 184722.0
8.56, 184811.0
8.56067, 184901.0
8.56133, 184991.0
8.562, 185081.0
8.56267, 185172.0
8.56333, 185262.0
8.564, 185354.0
8.56467, 185446.0
8.56533, 185539.0
8.566, 185632.0
8.56667, 185728.0
8.56733, 185824.0
8.568, 185922.0
8.56867, 186022.0
8.56933, 186122.0
8.57, 186225.0
8.57067, 186330.0
8.57133, 186435.0
8.572, 186542.0
8.57267, 186650.0
8.57333, 186757.0
8.574, 186865.0
8.57467, 186972.0
8.57533, 187078.0
8.576, 187184.0
8.57667, 187288.0
8.57733, 187393.0
8.578, 187497.0
8.57867, 187600.0
8.57933, 187701.0
8.58, 187800.0
8.58067, 187900.0
8.58133, 187999.0
8.582, 188097.0
8.58267, 188195.0
8.58333, 188292.0
8.584, 188387.0
8.58467, 188482.0
8.58533, 188577.0
8.586, 188671.0
8.58667, 188765.0
8.58733, 188859.0
8.588, 188954.0
8.58867, 189050.0
8.58933, 189146.0
8.59, 189241.0
8.59067, 189335.0
8.59133, 189427.0
8.592, 189518.0
8.59267, 189608.0
8.59333, 189698.0
8.594, 189789.0
8.59467, 189880.0
8.59533, 189971.0
8.596, 190064.0
8.59667, 190155.0
8.59733, 190247.0
8.598, 190338.0
8.59867, 190428.0
8.59933, 190516.0
8.6, 190602.0
8.60067, 190687.0
8.60133, 190771.0
8.602, 190855.0
8.60267, 190938.0
8.60333, 191022.0
8.604, 191105.0
8.60467, 191188.0
8.60533, 191273.0
8.606, 191359.0
8.60667, 191446.0
8.60733, 191535.0
8.608, 191626.0
8.60867, 191718.0
8.60933, 191811.0
8.61, 191905.0
8.61067, 192000.0
8.61133, 192096.0
8.612, 192191.0
8.61267, 192288.0
8.61333, 192386.0
8.614, 192487.0
8.61467, 192589.0
8.61533, 192693.0
8.616, 192799.0
8.61667, 192906.0
8.61733, 193013.0
8.618, 193120.0
8.61867, 193227.0
8.61933, 193334.0
8.62, 193442.0
8.62067, 193549.0
8.62133, 193654.0
8.622, 193757.0
8.62267, 193857.0
8.62333, 193954.0
8.624, 194047.0
8.62467, 194136.0
8.62533, 194221.0
8.626, 194302.0
8.62667, 194379.0
8.62733, 194454.0
8.628, 194526.0
8.62867, 194597.0
8.62933, 194666.0
8.63, 194734.0
8.63067, 194799.0
8.63133, 194863.0
8.632, 194926.0
8.63267, 194988.0
8.63333, 195049.0
8.634, 195110.0
8.63467, 195173.0
8.63533, 195238.0
8.636, 195304.0
8.63667, 195373.0
8.63733, 195445.0
8.638, 195521.0
8.63867, 195600.0
8.63933, 195683.0
8.64, 195769.0
8.64067, 195857.0
8.64133, 195949.0
8.642, 196043.0
8.64267, 196140.0
8.64333, 196241.0
8.644, 196347.0
8.64467, 196458.0
8.64533, 196573.0
8.646, 196694.0
8.64667, 196818.0
8.64733, 196945.0
8.648, 197075.0
8.64867, 197208.0
8.64933, 197341.0
8.65, 197476.0
8.65067, 197611.0
8.65133, 197746.0
8.652, 197880.0
8.65267, 198012.0
8.65333, 198142.0
8.654, 198271.0
8.65467, 198397.0
8.65533, 198521.0
8.656, 198642.0
8.65667, 198760.0
8.65733, 198875.0
8.658, 198988.0
8.65867, 199097.0
8.65933, 199203.0
8.66, 199306.0
8.66067, 199407.0
8.66133, 199506.0
8.662, 199602.0
8.66267, 199697.0
8.66333, 199789.0
8.664, 199882.0
8.66467, 199975.0
8.66533, 200068.0
8.666, 200161.0
8.66667, 200254.0
8.66733, 200349.0
8.668, 200444.0
8.66867, 200540.0
8.66933, 200638.0
8.67, 200736.0
8.67067, 200836.0
8.67133, 200938.0
8.672, 201043.0
8.67267, 201149.0
8.67333, 201257.0
8.674, 201367.0
8.67467, 201478.0
8.67533, 201590.0
8.676, 201705.0
8.67667, 201821.0
8.67733, 201938.0
8.678, 202057.0
8.67867, 202175.0
8.67933, 202294.0
8.68, 202412.0
8.68067, 202530.0
8.68133, 202647.0
8.682, 202764.0
8.68267, 202881.0
8.68333, 202999.0
8.684, 203117.0
8.68467, 203235.0
8.68533, 203352.0
8.686, 203468.0
8.68667, 203584.0
8.68733, 203699.0
8.688, 203813.0
8.68867, 203925.0
8.68933, 204035.0
8.69, 204144.0
8.69067, 204252.0
8.69133, 204359.0
8.692, 204466.0
8.69267, 204572.0
8.69333, 204675.0
8.694, 204778.0
8.69467, 204878.0
8.69533, 204975.0
8.696, 205070.0
8.69667, 205162.0
8.69733, 205253.0
8.698, 205342.0
8.69867, 205431.0
8.69933, 205518.0
8.7, 205605.0
8.70067, 205690.0
8.70133, 205775.0
8.702, 205860.0
8.70267, 205945.0
8.70333, 206030.0
8.704, 206115.0
8.70467, 206201.0
8.70533, 206288.0
8.706, 206376.0
8.70667, 206466.0
8.70733, 206559.0
8.708, 206654.0
8.70867, 206750.0
8.70933, 206847.0
8.71, 206944.0
8.71067, 207044.0
8.71133, 207144.0
8.712, 207245.0
8.71267, 207347.0
8.71333, 207450.0
8.714, 207554.0
8.71467, 207659.0
8.71533, 207765.0
8.716, 207871.0
8.71667, 207977.0
8.71733, 208084.0
8.718, 208192.0
8.71867, 208301.0
8.71933, 208411.0
8.72, 208521.0
8.72067, 208632.0
8.72133, 208745.0
8.722, 208859.0
8.72267, 208973.0
8.72333, 209088.0
8.724, 209202.0
8.72467, 209316.0
8.72533, 209431.0
8.726, 209547.0
8.72667, 209664.0
8.72733, 209782.0
8.728, 209899.0
8.72867, 210016.0
8.72933, 210133.0
8.73, 210250.0
8.73067, 210368.0
8.73133, 210487.0
8.732, 210606.0
8.73267, 210726.0
8.73333, 210846.0
8.734, 210966.0
8.73467, 211087.0
8.73533, 211208.0
8.736, 211328.0
8.73667, 211447.0
8.73733, 211565.0
8.738, 211681.0
8.73867, 211793.0
8.73933, 211904.0
8.74, 212013.0
8.74067, 212121.0
8.74133, 212228.0
8.742, 212335.0
8.74267, 212441.0
8.74333, 212547.0
8.744, 212651.0
8.74467, 212754.0
8.74533, 212856.0
8.746, 212957.0
8.74667, 213059.0
8.74733, 213161.0
8.748, 213262.0
8.74867, 213364.0
8.74933, 213465.0
8.75, 213566.0
8.75067, 213668.0
8.75133, 213769.0
8.752, 213871.0
8.75267, 213973.0
8.75333, 214076.0
8.754, 214178.0
8.75467, 214280.0
8.75533, 214382.0
8.756, 214484.0
8.75667, 214586.0
8.75733, 214688.0
8.758, 214790.0
8.75867, 214891.0
8.75933, 214992.0
8.76, 215093.0
8.76067, 215194.0
8.76133, 215295.0
8.762, 215397.0
8.76267, 215500.0
8.76333, 215604.0
8.764, 215707.0
8.76467, 215811.0
8.76533, 215914.0
8.766, 216018.0
8.76667, 216123.0
8.76733, 216229.0
8.768, 216335.0
8.76867, 216442.0
8.76933, 216548.0
8.77, 216653.0
8.77067, 216757.0
8.77133, 216862.0
8.772, 216967.0
8.77267, 217073.0
8.77333, 217179.0
8.774, 217284.0
8.77467, 217387.0
8.77533, 217489.0
8.776, 217589.0
8.77667, 217690.0
8.77733, 217791.0
8.778, 217895.0
8.77867, 218000.0
8.77933, 218109.0
8.78, 218219.0
8.78067, 218331.0
8.78133, 218442.0
8.782, 218555.0
8.78267, 218667.0
8.78333, 218779.0
8.784, 218890.0
8.78467, 219000.0
8.78533, 219109.0
8.786, 219216.0
8.78667, 219321.0
8.78733, 219426.0
8.788, 219531.0
8.78867, 219636.0
8.78933, 219740.0
8.79, 219844.0
8.79067, 219948.0
8.79133, 220051.0
8.792, 220155.0
8.79267, 220257.0
8.79333, 220358.0
8.794, 220460.0
8.79467, 220562.0
8.79533, 220663.0
8.796, 220764.0
8.79667, 220865.0
8.79733, 220965.0
8.798, 221064.0
8.79867, 221163.0
8.79933, 221260.0
8.8, 221357.0
8.80067, 221452.0
8.80133, 221548.0
8.802, 221642.0
8.80267, 221737.0
8.80333, 221832.0
8.804, 221929.0
8.80467, 222028.0
8.80533, 222128.0
8.806, 222231.0
8.80667, 222336.0
8.80733, 222442.0
8.808, 222550.0
8.80867, 222659.0
8.80933, 222771.0
8.81, 222883.0
8.81067, 222995.0
8.81133, 223107.0
8.812, 223220.0
8.81267, 223332.0
8.81333, 223445.0
8.814, 223557.0
8.81467, 223671.0
8.81533, 223784.0
8.816, 223898.0
8.81667, 224011.0
8.81733, 224122.0
8.818, 224232.0
8.81867, 224341.0
8.81933, 224448.0
8.82, 224553.0
8.82067, 224657.0
8.82133, 224760.0
8.822, 224860.0
8.82267, 224960.0
8.82333, 225058.0
8.824, 225156.0
8.82467, 225254.0
8.82533, 225353.0
8.826, 225452.0
8.82667, 225552.0
8.82733, 225652.0
8.828, 225754.0
8.82867, 225858.0
8.82933, 225964.0
8.83, 226070.0
8.83067, 226177.0
8.83133, 226284.0
8.832, 226390.0
8.83267, 226497.0
8.83333, 226605.0
8.834, 226712.0
8.83467, 226819.0
8.83533, 226926.0
8.836, 227034.0
8.83667, 227141.0
8.83733, 227248.0
8.838, 227355.0
8.83867, 227463.0
8.83933, 227572.0
8.84, 227682.0
8.84067, 227793.0
8.84133, 227903.0
8.842, 228013.0
8.84267, 228122.0
8.84333, 228229.0
8.844, 228336.0
8.84467, 228442.0
8.84533, 228547.0
8.846, 228652.0
8.84667, 228756.0
8.84733, 228861.0
8.848, 228965.0
8.84867, 229069.0
8.84933, 229175.0
8.85, 229280.0
8.85067, 229387.0
8.85133, 229494.0
8.852, 229603.0
8.85267, 229714.0
8.85333, 229825.0
8.854, 229937.0
8.85467, 230047.0
8.85533, 230156.0
8.856, 230265.0
8.85667, 230374.0
8.85733, 230482.0
8.858, 230590.0
8.85867, 230698.0
8.85933, 230804.0
8.86, 230909.0
8.86067, 231014.0
8.86133, 231117.0
8.862, 231218.0
8.86267, 231318.0
8.86333, 231416.0
8.864, 231513.0
8.86467, 231610.0
8.86533, 231706.0
8.866, 231800.0
8.86667, 231894.0
8.86733, 231986.0
8.868, 232078.0
8.86867, 232171.0
8.86933, 232265.0
8.87, 232361.0
8.87067, 232459.0
8.87133, 232558.0
8.872, 232658.0
8.87267, 232759.0
8.87333, 232860.0
8.874, 232964.0
8.87467, 233070.0
8.87533, 233180.0
8.876, 233292.0
8.87667, 233407.0
8.87733, 233524.0
8.878, 233641.0
8.87867, 233760.0
8.87933, 233880.0
8.88, 234000.0
8.88067, 234122.0
8.88133, 234245.0
8.882, 234366.0
8.88267, 234486.0
8.88333, 234604.0
8.884, 234720.0
8.88467, 234836.0
8.88533, 234952.0
8.886, 235068.0
8.88667, 235184.0
8.88733, 235302.0
8.888, 235421.0
8.88867, 235541.0
8.88933, 235661.0
8.89, 235781.0
8.89067, 235900.0
8.89133, 236018.0
8.892, 236137.0
8.89267, 236256.0
8.89333, 236377.0
8.894, 236498.0
8.89467, 236619.0
8.89533, 236739.0
8.896, 236860.0
8.89667, 236980.0
8.89733, 237099.0
8.898, 237216.0
8.89867, 237331.0
8.89933, 237444.0
8.9, 237556.0
8.90067, 237667.0
8.90133, 237777.0
8.902, 237886.0
8.90267, 237994.0
8.90333, 238103.0
8.904, 238212.0
8.90467, 238321.0
8.90533, 238431.0
8.906, 238541.0
8.90667, 238650.0
8.90733, 238760.0
8.908, 238869.0
8.90867, 238979.0
8.90933, 239088.0
8.91, 239197.0
8.91067, 239305.0
8.91133, 239411.0
8.912, 239515.0
8.91267, 239618.0
8.91333, 239722.0
8.914, 239828.0
8.91467, 239935.0
8.91533, 240045.0
8.916, 240156.0
8.91667, 240270.0
8.91733, 240386.0
8.918, 240504.0
8.91867, 240625.0
8.91933, 240746.0
8.92, 240868.0
8.92067, 240991.0
8.92133, 241113.0
8.922, 241235.0
8.92267, 241357.0
8.92333, 241480.0
8.924, 241604.0
8.92467, 241727.0
8.92533, 241852.0
8.926, 241977.0
8.92667, 242102.0
8.92733, 242227.0
8.928, 242351.0
8.92867, 242476.0
8.92933, 242600.0
8.93, 242726.0
8.93067, 242853.0
8.93133, 242979.0
8.932, 243105.0
8.93267, 243231.0
8.93333, 243357.0
8.934, 243485.0
8.93467, 243614.0
8.93533, 243745.0
8.936, 243878.0
8.93667, 244011.0
8.93733, 244146.0
8.938, 244281.0
8.93867, 244417.0
8.93933, 244554.0
8.94, 244691.0
8.94067, 244831.0
8.94133, 244973.0
8.942, 245117.0
8.94267, 245263.0
8.94333, 245409.0
8.944, 245556.0
8.94467, 245704.0
8.94533, 245852.0
8.946, 246001.0
8.94667, 246149.0
8.94733, 246299.0
8.948, 246449.0
8.94867, 246599.0
8.94933, 246748.0
8.95, 246896.0
8.95067, 247042.0
8.95133, 247185.0
8.952, 247327.0
8.95267, 247466.0
8.95333, 247603.0
8.954, 247740.0
8.95467, 247875.0
8.95533, 248007.0
8.956, 248137.0
8.95667, 248265.0
8.95733, 248392.0
8.958, 248519.0
8.95867, 248644.0
8.95933, 248767.0
8.96, 248889.0
8.96067, 249010.0
8.96133, 249129.0
8.962, 249248.0
8.96267, 249365.0
8.96333, 249479.0
8.964, 249591.0
8.96467, 249701.0
8.96533, 249810.0
8.966, 249918.0
8.96667, 250027.0
8.96733, 250136.0
8.968, 250245.0
8.96867, 250354.0
8.96933, 250464.0
8.97, 250576.0
8.97067, 250688.0
8.97133, 250801.0
8.972, 250916.0
8.97267, 251033.0
8.97333, 251152.0
8.974, 251274.0
8.97467, 251397.0
8.97533, 251521.0
8.976, 251645.0
8.97667, 251769.0
8.97733, 251894.0
8.978, 252019.0
8.97867, 252144.0
8.97933, 252270.0
8.98, 252396.0
8.98067, 252522.0
8.98133, 252648.0
8.982, 252775.0
8.98267, 252902.0
8.98333, 253030.0
8.984, 253157.0
8.98467, 253283.0
8.98533, 253408.0
8.986, 253530.0
8.98667, 253651.0
8.98733, 253768.0
8.988, 253884.0
8.98867, 253999.0
8.98933, 254113.0
8.99, 254228.0
8.99067, 254343.0
8.99133, 254460.0
8.992, 254577.0
8.99267, 254695.0
8.99333, 254814.0
8.994, 254935.0
8.99467, 255057.0
8.99533, 255180.0
8.996, 255303.0
8.99667, 255428.0
8.99733, 255554.0
8.998, 255683.0
8.99867, 255814.0
8.99933, 255945.0
9.0, 256076.0
9.00067, 256208.0
9.00133, 256340.0
9.002, 256470.0
9.00267, 256600.0
9.00333, 256731.0
9.004, 256862.0
9.00467, 256994.0
9.00533, 257127.0
9.006, 257260.0
9.00667, 257394.0
9.00733, 257529.0
9.008, 257663.0
9.00867, 257797.0
9.00933, 257930.0
9.01, 258063.0
9.01067, 258195.0
9.01133, 258326.0
9.012, 258458.0
9.01267, 258588.0
9.01333, 258718.0
9.014, 258848.0
9.01467, 258977.0
9.01533, 259105.0
9.016, 259233.0
9.01667, 259361.0
9.01733, 259489.0
9.018, 259616.0
9.01867, 259742.0
9.01933, 259866.0
9.02, 259988.0
9.02067, 260109.0
9.02133, 260229.0
9.022, 260349.0
9.02267, 260469.0
9.02333, 260586.0
9.024, 260702.0
9.02467, 260817.0
9.02533, 260934.0
9.026, 261051.0
9.02667, 261168.0
9.02733, 261285.0
9.028, 261402.0
9.02867, 261518.0
9.02933, 261634.0
9.03, 261749.0
9.03067, 261864.0
9.03133, 261978.0
9.032, 262092.0
9.03267, 262206.0
9.03333, 262320.0
9.034, 262436.0
9.03467, 262554.0
9.03533, 262672.0
9.036, 262790.0
9.03667, 262908.0
9.03733, 263026.0
9.038, 263145.0
9.03867, 263264.0
9.03933, 263384.0
9.04, 263502.0
9.04067, 263619.0
9.04133, 263735.0
9.042, 263850.0
9.04267, 263966.0
9.04333, 264082.0
9.044, 264197.0
9.04467, 264312.0
9.04533, 264427.0
9.046, 264542.0
9.04667, 264659.0
9.04733, 264776.0
9.048, 264896.0
9.04867, 265017.0
9.04933, 265140.0
9.05, 265265.0
9.05067, 265391.0
9.05133, 265519.0
9.052, 265648.0
9.05267, 265776.0
9.05333, 265902.0
9.054, 266029.0
9.05467, 266154.0
9.05533, 266278.0
9.056, 266401.0
9.05667, 266523.0
9.05733, 266646.0
9.058, 266767.0
9.05867, 266888.0
9.05933, 267009.0
9.06, 267129.0
9.06067, 267250.0
9.06133, 267370.0
9.062, 267490.0
9.06267, 267609.0
9.06333, 267726.0
9.064, 267841.0
9.06467, 267955.0
9.06533, 268068.0
9.066, 268179.0
9.06667, 268288.0
9.06733, 268396.0
9.068, 268505.0
9.06867, 268614.0
9.06933, 268723.0
9.07, 268834.0
9.07067, 268945.0
9.07133, 269057.0
9.072, 269170.0
9.07267, 269284.0
9.07333, 269398.0
9.074, 269514.0
9.07467, 269632.0
9.07533, 269753.0
9.076, 269875.0
9.07667, 269998.0
9.07733, 270124.0
9.078, 270252.0
9.07867, 270384.0
9.07933, 270518.0
9.08, 270654.0
9.08067, 270790.0
9.08133, 270926.0
9.082, 271061.0
9.08267, 271197.0
9.08333, 271332.0
9.084, 271468.0
9.08467, 271604.0
9.08533, 271738.0
9.086, 271873.0
9.08667, 272007.0
9.08733, 272142.0
9.088, 272275.0
9.08867, 272406.0
9.08933, 272535.0
9.09, 272664.0
9.09067, 272792.0
9.09133, 272919.0
9.092, 273045.0
9.09267, 273173.0
9.09333, 273302.0
9.094, 273430.0
9.09467, 273558.0
9.09533, 273686.0
9.096, 273814.0
9.09667, 273940.0
9.09733, 274065.0
9.098, 274189.0
9.09867, 274312.0
9.09933, 274434.0
9.1, 274556.0
9.10067, 274679.0
9.10133, 274801.0
9.102, 274920.0
9.10267, 275037.0
9.10333, 275152.0
9.104, 275265.0
9.10467, 275378.0
9.10533, 275492.0
9.106, 275606.0
9.10667, 275720.0
9.10733, 275835.0
9.108, 275951.0
9.10867, 276068.0
9.10933, 276185.0
9.11, 276302.0
9.11067, 276418.0
9.11133, 276534.0
9.112, 276648.0
9.11267, 276762.0
9.11333, 276874.0
9.114, 276984.0
9.11467, 277093.0
9.11533, 277200.0
9.116, 277306.0
9.11667, 277413.0
9.11733, 277519.0
9.118, 277627.0
9.11867, 277736.0
9.11933, 277848.0
9.12, 277961.0
9.12067, 278076.0
9.12133, 278192.0
9.122, 278309.0
9.12267, 278426.0
9.12333, 278542.0
9.124, 278659.0
9.12467, 278776.0
9.12533, 278892.0
9.126, 279007.0
9.12667, 279123.0
9.12733, 279239.0
9.128, 279357.0
9.12867, 279476.0
9.12933, 279598.0
9.13, 279721.0
9.13067, 279846.0
9.13133, 279971.0
9.132, 280099.0
9.13267, 280228.0
9.13333, 280359.0
9.134, 280491.0
9.13467, 280623.0
9.13533, 280756.0
9.136, 280890.0
9.13667, 281026.0
9.13733, 281164.0
9.138, 281302.0
9.13867, 281441.0
9.13933, 281578.0
9.14, 281715.0
9.14067, 281853.0
9.14133, 281990.0
9.142, 282125.0
9.14267, 282259.0
9.14333, 282390.0
9.144, 282520.0
9.14467, 282648.0
9.14533, 282776.0
9.146, 282902.0
9.14667, 283028.0
9.14733, 283155.0
9.148, 283282.0
9.14867, 283406.0
9.14933, 283527.0
9.15, 283647.0
9.15067, 283769.0
9.15133, 283893.0
9.152, 284018.0
9.15267, 284143.0
9.15333, 284266.0
9.154, 284388.0
9.15467, 284509.0
9.15533, 284630.0
9.156, 284750.0
9.15667, 284870.0
9.15733, 284989.0
9.158, 285109.0
9.15867, 285226.0
9.15933, 285343.0
9.16, 285458.0
9.16067, 285575.0
9.16133, 285692.0
9.162, 285810.0
9.16267, 285929.0
9.16333, 286048.0
9.164, 286165.0
9.16467, 286283.0
9.16533, 286400.0
9.166, 286518.0
9.16667, 286637.0
9.16733, 286756.0
9.168, 286876.0
9.16867, 286998.0
9.16933, 287123.0
9.17, 287249.0
9.17067, 287378.0
9.17133, 287510.0
9.172, 287644.0
9.17267, 287779.0
9.17333, 287916.0
9.174, 288054.0
9.17467, 288190.0
9.17533, 288327.0
9.176, 288465.0
9.17667, 288604.0
9.17733, 288743.0
9.178, 288882.0
9.17867, 289021.0
9.17933, 289161.0
9.18, 289300.0
9.18067, 289440.0
9.18133, 289581.0
9.182, 289724.0
9.18267, 289868.0
9.18333, 290013.0
9.184, 290158.0
9.18467, 290305.0
9.18533, 290452.0
9.186, 290599.0
9.18667, 290747.0
9.18733, 290895.0
9.188, 291045.0
9.18867, 291195.0
9.18933, 291346.0
9.19, 291494.0
9.19067, 291639.0
9.19133, 291780.0
9.192, 291919.0
9.19267, 292055.0
9.19333, 292193.0
9.194, 292332.0
9.19467, 292473.0
9.19533, 292616.0
9.196, 292760.0
9.19667, 292905.0
9.19733, 293049.0
9.198, 293193.0
9.19867, 293335.0
9.19933, 293477.0
9.2, 293617.0
9.20067, 293757.0
9.20133, 293895.0
9.202, 294031.0
9.20267, 294165.0
9.20333, 294301.0
9.204, 294438.0
9.20467, 294577.0
9.20533, 294717.0
9.206, 294857.0
9.20667, 294996.0
9.20733, 295133.0
9.208, 295268.0
9.20867, 295402.0
9.20933, 295535.0
9.21, 295669.0
9.21067, 295803.0
9.21133, 295934.0
9.212, 296065.0
9.21267, 296194.0
9.21333, 296322.0
9.214, 296450.0
9.21467, 296575.0
9.21533, 296699.0
9.216, 296820.0
9.21667, 296939.0
9.21733, 297056.0
9.218, 297171.0
9.21867, 297284.0
9.21933, 297396.0
9.22, 297508.0
9.22067, 297621.0
9.22133, 297735.0
9.222, 297848.0
9.22267, 297961.0
9.22333, 298074.0
9.224, 298186.0
9.22467, 298299.0
9.22533, 298412.0
9.226, 298526.0
9.22667, 298640.0
9.22733, 298754.0
9.228, 298869.0
9.22867, 298982.0
9.22933, 299095.0
9.23, 299209.0
9.23067, 299323.0
9.23133, 299438.0
9.232, 299553.0
9.23267, 299671.0
9.23333, 299790.0
9.234, 299912.0
9.23467, 300035.0
9.23533, 300162.0
9.236, 300292.0
9.23667, 300424.0
9.23733, 300556.0
9.238, 300688.0
9.23867, 300818.0
9.23933, 300947.0
9.24, 301074.0
9.24067, 301199.0
9.24133, 301323.0
9.242, 301445.0
9.24267, 301565.0
9.24333, 301685.0
9.244, 301805.0
9.24467, 301921.0
9.24533, 302034.0
9.246, 302143.0
9.24667, 302248.0
9.24733, 302351.0
9.248, 302452.0
9.24867, 302552.0
9.24933, 302652.0
9.25, 302750.0
9.25067, 302847.0
9.25133, 302945.0
9.252, 303044.0
9.25267, 303143.0
9.25333, 303244.0
9.254, 303346.0
9.25467, 303450.0
9.25533, 303556.0
9.256, 303663.0
9.25667, 303773.0
9.25733, 303886.0
9.258, 304003.0
9.25867, 304125.0
9.25933, 304249.0
9.26, 304377.0
9.26067, 304504.0
9.26133, 304631.0
9.262, 304754.0
9.26267, 304876.0
9.26333, 304996.0
9.264, 305114.0
9.26467, 305230.0
9.26533, 305346.0
9.266, 305462.0
9.26667, 305576.0
9.26733, 305690.0
9.268, 305803.0
9.26867, 305917.0
9.26933, 306031.0
9.27, 306145.0
9.27067, 306259.0
9.27133, 306373.0
9.272, 306484.0
9.27267, 306594.0
9.27333, 306702.0
9.274, 306810.0
9.27467, 306918.0
9.27533, 307028.0
9.276, 307140.0
9.27667, 307255.0
9.27733, 307369.0
9.278, 307480.0
9.27867, 307588.0
9.27933, 307693.0
9.28, 307796.0
9.28067, 307896.0
9.28133, 307992.0
9.282, 308085.0
9.28267, 308178.0
9.28333, 308273.0
9.284, 308370.0
9.28467, 308470.0
9.28533, 308573.0
9.286, 308680.0
9.28667, 308792.0
9.28733, 308908.0
9.288, 309031.0
9.28867, 309159.0
9.28933, 309292.0
9.29, 309431.0
9.29067, 309572.0
9.29133, 309714.0
9.292, 309859.0
9.29267, 310005.0
9.29333, 310150.0
9.294, 310294.0
9.29467, 310435.0
9.29533, 310575.0
9.296, 310714.0
9.29667, 310854.0
9.29733, 310994.0
9.298, 311133.0
9.29867, 311273.0
9.29933, 311413.0
9.3, 311554.0
9.30067, 311693.0
9.30133, 311831.0
9.302, 311966.0
9.30267, 312100.0
9.30333, 312233.0
9.304, 312364.0
9.30467, 312492.0
9.30533, 312618.0
9.306, 312744.0
9.30667, 312869.0
9.30733, 312995.0
9.308, 313120.0
9.30867, 313244.0
9.30933, 313367.0
9.31, 313488.0
9.31067, 313608.0
9.31133, 313728.0
9.312, 313846.0
9.31267, 313964.0
9.31333, 314080.0
9.314, 314194.0
9.31467, 314306.0
9.31533, 314417.0
9.316, 314526.0
9.31667, 314635.0
9.31733, 314745.0
9.318, 314857.0
9.31867, 314971.0
9.31933, 315087.0
9.32, 315205.0
9.32067, 315327.0
9.32133, 315452.0
9.322, 315581.0
9.32267, 315712.0
9.32333, 315846.0
9.324, 315983.0
9.32467, 316120.0
9.32533, 316258.0
9.326, 316396.0
9.32667, 316532.0
9.32733, 316667.0
9.328, 316800.0
9.32867, 316931.0
9.32933, 317060.0
9.33, 317189.0
9.33067, 317315.0
9.33133, 317442.0
9.332, 317569.0
9.33267, 317696.0
9.33333, 317822.0
9.334, 317946.0
9.33467, 318068.0
9.33533, 318189.0
9.336, 318307.0
9.33667, 318425.0
9.33733, 318540.0
9.338, 318654.0
9.33867, 318767.0
9.33933, 318880.0
9.34, 318994.0
9.34067, 319109.0
9.34133, 319226.0
9.342, 319344.0
9.34267, 319462.0
9.34333, 319581.0
9.344, 319701.0
9.34467, 319824.0
9.34533, 319948.0
9.346, 320075.0
9.34667, 320204.0
9.34733, 320336.0
9.348, 320471.0
9.34867, 320609.0
9.34933, 320748.0
9.35, 320886.0
9.35067, 321025.0
9.35133, 321163.0
9.352, 321300.0
9.35267, 321435.0
9.35333, 321571.0
9.354, 321708.0
9.35467, 321844.0
9.35533, 321979.0
9.356, 322113.0
9.35667, 322247.0
9.35733, 322382.0
9.358, 322516.0
9.35867, 322649.0
9.35933, 322781.0
9.36, 322912.0
9.36067, 323041.0
9.36133, 323168.0
9.362, 323292.0
9.36267, 323415.0
9.36333, 323538.0
9.364, 323661.0
9.36467, 323783.0
9.36533, 323905.0
9.366, 324025.0
9.36667, 324144.0
9.36733, 324263.0
9.368, 324382.0
9.36867, 324502.0
9.36933, 324622.0
9.37, 324742.0
9.37067, 324860.0
9.37133, 324978.0
9.372, 325094.0
9.37267, 325212.0
9.37333, 325330.0
9.374, 325449.0
9.37467, 325570.0
9.37533, 325691.0
9.376, 325812.0
9.37667, 325934.0
9.37733, 326057.0
9.378, 326184.0
9.37867, 326312.0
9.37933, 326441.0
9.38, 326569.0
9.38067, 326697.0
9.38133, 326827.0
9.382, 326959.0
9.38267, 327094.0
9.38333, 327230.0
9.384, 327368.0
9.38467, 327506.0
9.38533, 327644.0
9.386, 327782.0
9.38667, 327922.0
9.38733, 328065.0
9.388, 328208.0
9.38867, 328351.0
9.38933, 328494.0
9.39, 328636.0
9.39067, 328777.0
9.39133, 328917.0
9.392, 329055.0
9.39267, 329193.0
9.39333, 329329.0
9.394, 329465.0
9.39467, 329599.0
9.39533, 329733.0
9.396, 329866.0
9.39667, 330001.0
9.39733, 330138.0
9.398, 330276.0
9.39867, 330416.0
9.39933, 330556.0
9.4, 330695.0
9.40067, 330832.0
9.40133, 330967.0
9.402, 331098.0
9.40267, 331227.0
9.40333, 331352.0
9.404, 331477.0
9.40467, 331601.0
9.40533, 331725.0
9.406, 331849.0
9.40667, 331972.0
9.40733, 332096.0
9.408, 332219.0
9.40867, 332342.0
9.40933, 332465.0
9.41, 332587.0
9.41067, 332709.0
9.41133, 332830.0
9.412, 332953.0
9.41267, 333076.0
9.41333, 333199.0
9.414, 333323.0
9.41467, 333449.0
9.41533, 333575.0
9.416, 333704.0
9.41667, 333835.0
9.41733, 333967.0
9.418, 334100.0
9.41867, 334234.0
9.41933, 334369.0
9.42, 334503.0
9.42067, 334636.0
9.42133, 334769.0
9.422, 334903.0
9.42267, 335041.0
9.42333, 335181.0
9.424, 335324.0
9.42467, 335469.0
9.42533, 335615.0
9.426, 335763.0
9.42667, 335909.0
9.42733, 336055.0
9.428, 336199.0
9.42867, 336342.0
9.42933, 336485.0
9.43, 336627.0
9.43067, 336770.0
9.43133, 336913.0
9.432, 337057.0
9.43267, 337200.0
9.43333, 337343.0
9.434, 337483.0
9.43467, 337623.0
9.43533, 337763.0
9.436, 337903.0
9.43667, 338043.0
9.43733, 338181.0
9.438, 338319.0
9.43867, 338458.0
9.43933, 338597.0
9.44, 338737.0
9.44067, 338876.0
9.44133, 339017.0
9.442, 339159.0
9.44267, 339302.0
9.44333, 339444.0
9.444, 339587.0
9.44467, 339731.0
9.44533, 339877.0
9.446, 340027.0
9.44667, 340179.0
9.44733, 340331.0
9.448, 340483.0
9.44867, 340636.0
9.44933, 340791.0
9.45, 340945.0
9.45067, 341098.0
9.45133, 341250.0
9.452, 341399.0
9.45267, 341547.0
9.45333, 341697.0
9.454, 341849.0
9.45467, 342003.0
9.45533, 342159.0
9.456, 342316.0
9.45667, 342473.0
9.45733, 342630.0
9.458, 342785.0
9.45867, 342938.0
9.45933, 343089.0
9.46, 343237.0
9.46067, 343382.0
9.46133, 343527.0
9.462, 343670.0
9.46267, 343811.0
9.46333, 343949.0
9.464, 344085.0
9.46467, 344218.0
9.46533, 344350.0
9.466, 344479.0
9.46667, 344605.0
9.46733, 344728.0
9.468, 344849.0
9.46867, 344969.0
9.46933, 345089.0
9.47, 345209.0
9.47067, 345330.0
9.47133, 345453.0
9.472, 345579.0
9.47267, 345707.0
9.47333, 345836.0
9.474, 345966.0
9.47467, 346097.0
9.47533, 346228.0
9.476, 346361.0
9.47667, 346493.0
9.47733, 346623.0
9.478, 346752.0
9.47867, 346881.0
9.47933, 347010.0
9.48, 347141.0
9.48067, 347273.0
9.48133, 347406.0
9.482, 347541.0
9.48267, 347678.0
9.48333, 347816.0
9.484, 347957.0
9.48467, 348099.0
9.48533, 348243.0
9.486, 348388.0
9.48667, 348534.0
9.48733, 348679.0
9.488, 348823.0
9.48867, 348966.0
9.48933, 349110.0
9.49, 349255.0
9.49067, 349403.0
9.49133, 349554.0
9.492, 349707.0
9.49267, 349860.0
9.49333, 350013.0
9.494, 350165.0
9.49467, 350317.0
9.49533, 350468.0
9.496, 350618.0
9.49667, 350764.0
9.49733, 350909.0
9.498, 351052.0
9.49867, 351195.0
9.49933, 351338.0
9.5, 351481.0
9.50067, 351624.0
9.50133, 351766.0
9.502, 351908.0
9.50267, 352047.0
9.50333, 352183.0
9.504, 352316.0
9.50467, 352447.0
9.50533, 352578.0
9.506, 352709.0
9.50667, 352838.0
9.50733, 352965.0
9.508, 353091.0
9.50867, 353218.0
9.50933, 353344.0
9.51, 353468.0
9.51067, 353592.0
9.51133, 353714.0
9.512, 353837.0
9.51267, 353962.0
9.51333, 354087.0
9.514, 354213.0
9.51467, 354341.0
9.51533, 354468.0
9.516, 354596.0
9.51667, 354724.0
9.51733, 354853.0
9.518, 354983.0
9.51867, 355118.0
9.51933, 355256.0
9.52, 355396.0
9.52067, 355536.0
9.52133, 355675.0
9.522, 355814.0
9.52267, 355951.0
9.52333, 356087.0
9.524, 356222.0
9.52467, 356356.0
9.52533, 356489.0
9.526, 356620.0
9.52667, 356752.0
9.52733, 356882.0
9.528, 357011.0
9.52867, 357139.0
9.52933, 357266.0
9.53, 357390.0
9.53067, 357514.0
9.53133, 357637.0
9.532, 357761.0
9.53267, 357884.0
9.53333, 358009.0
9.534, 358134.0
9.53467, 358261.0
9.53533, 358391.0
9.536, 358525.0
9.53667, 358662.0
9.53733, 358804.0
9.538, 358950.0
9.53867, 359098.0
9.53933, 359247.0
9.54, 359396.0
9.54067, 359549.0
9.54133, 359707.0
9.542, 359872.0
9.54267, 360041.0
9.54333, 360213.0
9.544, 360386.0
9.54467, 360558.0
9.54533, 360729.0
9.546, 360896.0
9.54667, 361062.0
9.54733, 361224.0
9.548, 361382.0
9.54867, 361536.0
9.54933, 361685.0
9.55, 361830.0
9.55067, 361972.0
9.55133, 362110.0
9.552, 362244.0
9.55267, 362377.0
9.55333, 362509.0
9.554, 362640.0
9.55467, 362772.0
9.55533, 362905.0
9.556, 363039.0
9.55667, 363173.0
9.55733, 363308.0
9.558, 363444.0
9.55867, 363582.0
9.55933, 363722.0
9.56, 363862.0
9.56067, 364003.0
9.56133, 364145.0
9.562, 364286.0
9.56267, 364427.0
9.56333, 364569.0
9.564, 364710.0
9.56467, 364853.0
9.56533, 364996.0
9.566, 365143.0
9.56667, 365292.0
9.56733, 365445.0
9.568, 365599.0
9.56867, 365752.0
9.56933, 365904.0
9.57, 366055.0
9.57067, 366206.0
9.57133, 366356.0
9.572, 366505.0
9.57267, 366653.0
9.57333, 366801.0
9.574, 366949.0
9.57467, 367097.0
9.57533, 367246.0
9.576, 367392.0
9.57667, 367538.0
9.57733, 367682.0
9.578, 367827.0
9.57867, 367972.0
9.57933, 368117.0
9.58, 368262.0
9.58067, 368408.0
9.58133, 368556.0
9.582, 368705.0
9.58267, 368856.0
9.58333, 369010.0
9.584, 369167.0
9.58467, 369328.0
9.58533, 369492.0
9.586, 369658.0
9.58667, 369824.0
9.58733, 369989.0
9.588, 370152.0
9.58867, 370310.0
9.58933, 370464.0
9.59, 370614.0
9.59067, 370764.0
9.59133, 370912.0
9.592, 371060.0
9.59267, 371206.0
9.59333, 371351.0
9.594, 371495.0
9.59467, 371638.0
9.59533, 371782.0
9.596, 371925.0
9.59667, 372070.0
9.59733, 372215.0
9.598, 372362.0
9.59867, 372512.0
9.59933, 372663.0
9.6, 372816.0
9.60067, 372972.0
9.60133, 373129.0
9.602, 373286.0
9.60267, 373442.0
9.60333, 373598.0
9.604, 373754.0
9.60467, 373909.0
9.60533, 374066.0
9.606, 374224.0
9.60667, 374384.0
9.60733, 374545.0
9.608, 374709.0
9.60867, 374874.0
9.60933, 375041.0
9.61, 375207.0
9.61067, 375372.0
9.61133, 375536.0
9.612, 375698.0
9.61267, 375858.0
9.61333, 376016.0
9.614, 376171.0
9.61467, 376324.0
9.61533, 376474.0
9.616, 376622.0
9.61667, 376771.0
9.61733, 376921.0
9.618, 377071.0
9.61867, 377221.0
9.61933, 377370.0
9.62, 377518.0
9.62067, 377667.0
9.62133, 377817.0
9.622, 377967.0
9.62267, 378118.0
9.62333, 378268.0
9.624, 378419.0
9.62467, 378570.0
9.62533, 378723.0
9.626, 378878.0
9.62667, 379033.0
9.62733, 379189.0
9.628, 379344.0
9.62867, 379499.0
9.62933, 379656.0
9.63, 379814.0
9.63067, 379974.0
9.63133, 380135.0
9.632, 380295.0
9.63267, 380457.0
9.63333, 380621.0
9.634, 380786.0
9.63467, 380954.0
9.63533, 381125.0
9.636, 381297.0
9.63667, 381470.0
9.63733, 381643.0
9.638, 381815.0
9.63867, 381987.0
9.63933, 382159.0
9.64, 382329.0
9.64067, 382499.0
9.64133, 382668.0
9.642, 382838.0
9.64267, 383010.0
9.64333, 383182.0
9.644, 383354.0
9.64467, 383526.0
9.64533, 383697.0
9.646, 383866.0
9.64667, 384033.0
9.64733, 384198.0
9.648, 384363.0
9.64867, 384527.0
9.64933, 384694.0
9.65, 384861.0
9.65067, 385027.0
9.65133, 385190.0
9.652, 385353.0
9.65267, 385514.0
9.65333, 385674.0
9.654, 385833.0
9.65467, 385990.0
9.65533, 386146.0
9.656, 386301.0
9.65667, 386453.0
9.65733, 386604.0
9.658, 386750.0
9.65867, 386894.0
9.65933, 387036.0
9.66, 387179.0
9.66067, 387320.0
9.66133, 387462.0
9.662, 387605.0
9.66267, 387750.0
9.66333, 387899.0
9.664, 388052.0
9.66467, 388209.0
9.66533, 388368.0
9.666, 388530.0
9.66667, 388695.0
9.66733, 388863.0
9.668, 389033.0
9.66867, 389205.0
9.66933, 389380.0
9.67, 389557.0
9.67067, 389735.0
9.67133, 389913.0
9.672, 390094.0
9.67267, 390278.0
9.67333, 390468.0
9.674, 390661.0
9.67467, 390859.0
9.67533, 391060.0
9.676, 391264.0
9.67667, 391472.0
9.67733, 391681.0
9.678, 391889.0
9.67867, 392096.0
9.67933, 392305.0
9.68, 392515.0
9.68067, 392728.0
9.68133, 392942.0
9.682, 393158.0
9.68267, 393374.0
9.68333, 393587.0
9.684, 393799.0
9.68467, 394010.0
9.68533, 394221.0
9.686, 394435.0
9.68667, 394651.0
9.68733, 394868.0
9.688, 395088.0
9.68867, 395308.0
9.68933, 395528.0
9.69, 395748.0
9.69067, 395966.0
9.69133, 396181.0
9.692, 396392.0
9.69267, 396599.0
9.69333, 396802.0
9.694, 397003.0
9.69467, 397202.0
9.69533, 397401.0
9.696, 397600.0
9.69667, 397797.0
9.69733, 397995.0
9.698, 398194.0
9.69867, 398393.0
9.69933, 398594.0
9.7, 398796.0
9.70067, 398998.0
9.70133, 399201.0
9.702, 399403.0
9.70267, 399604.0
9.70333, 399804.0
9.704, 400000.0
9.70467, 400195.0
9.70533, 400392.0
9.706, 400592.0
9.70667, 400796.0
9.70733, 401003.0
9.708, 401212.0
9.70867, 401425.0
9.70933, 401641.0
9.71, 401861.0
9.71067, 402085.0
9.71133, 402314.0
9.712, 402545.0
9.71267, 402777.0
9.71333, 403009.0
9.714, 403240.0
9.71467, 403473.0
9.71533, 403705.0
9.716, 403937.0
9.71667, 404167.0
9.71733, 404394.0
9.718, 404620.0
9.71867, 404844.0
9.71933, 405066.0
9.72, 405286.0
9.72067, 405501.0
9.72133, 405713.0
9.722, 405921.0
9.72267, 406125.0
9.72333, 406327.0
9.724, 406526.0
9.72467, 406724.0
9.72533, 406923.0
9.726, 407121.0
9.72667, 407320.0
9.72733, 407520.0
9.728, 407721.0
9.72867, 407923.0
9.72933, 408125.0
9.73, 408327.0
9.73067, 408527.0
9.73133, 408723.0
9.732, 408916.0
9.73267, 409106.0
9.73333, 409295.0
9.734, 409482.0
9.73467, 409667.0
9.73533, 409852.0
9.736, 410036.0
9.73667, 410222.0
9.73733, 410410.0
9.738, 410602.0
9.73867, 410796.0
9.73933, 410991.0
9.74, 411186.0
9.74067, 411382.0
9.74133, 411580.0
9.742, 411780.0
9.74267, 411984.0
9.74333, 412190.0
9.744, 412399.0
9.74467, 412611.0
9.74533, 412827.0
9.746, 413045.0
9.74667, 413265.0
9.74733, 413485.0
9.748, 413704.0
9.74867, 413921.0
9.74933, 414137.0
9.75, 414351.0
9.75067, 414564.0
9.75133, 414775.0
9.752, 414984.0
9.75267, 415192.0
9.75333, 415401.0
9.754, 415609.0
9.75467, 415813.0
9.75533, 416015.0
9.756, 416215.0
9.75667, 416413.0
9.75733, 416610.0
9.758, 416805.0
9.75867, 416998.0
9.75933, 417189.0
9.76, 417377.0
9.76067, 417562.0
9.76133, 417745.0
9.762, 417927.0
9.76267, 418108.0
9.76333, 418288.0
9.764, 418467.0
9.76467, 418644.0
9.76533, 418818.0
9.766, 418990.0
9.76667, 419161.0
9.76733, 419332.0
9.768, 419503.0
9.76867, 419674.0
9.76933, 419847.0
9.77, 420024.0
9.77067, 420205.0
9.77133, 420389.0
9.772, 420577.0
9.77267, 420767.0
9.77333, 420960.0
9.774, 421155.0
9.77467, 421352.0
9.77533, 421552.0
9.776, 421755.0
9.77667, 421963.0
9.77733, 422174.0
9.778, 422387.0
9.77867, 422602.0
9.77933, 422821.0
9.78, 423044.0
9.78067, 423268.0
9.78133, 423496.0
9.782, 423725.0
9.78267, 423953.0
9.78333, 424181.0
9.784, 424407.0
9.78467, 424634.0
9.78533, 424862.0
9.786, 425090.0
9.78667, 425317.0
9.78733, 425544.0
9.788, 425773.0
9.78867, 426002.0
9.78933, 426233.0
9.79, 426464.0
9.79067, 426696.0
9.79133, 426927.0
9.792, 427159.0
9.79267, 427394.0
9.79333, 427630.0
9.794, 427867.0
9.79467, 428104.0
9.79533, 428342.0
9.796, 428580.0
9.79667, 428822.0
9.79733, 429069.0
9.798, 429319.0
9.79867, 429572.0
9.79933, 429826.0
9.8, 430084.0
9.80067, 430345.0
9.80133, 430610.0
9.802, 430876.0
9.80267, 431143.0
9.80333, 431412.0
9.804, 431682.0
9.80467, 431953.0
9.80533, 432222.0
9.806, 432492.0
9.80667, 432762.0
9.80733, 433032.0
9.808, 433304.0
9.80867, 433577.0
9.80933, 433850.0
9.81, 434123.0
9.81067, 434397.0
9.81133, 434673.0
9.812, 434956.0
9.81267, 435245.0
9.81333, 435538.0
9.814, 435833.0
9.81467, 436127.0
9.81533, 436420.0
9.816, 436712.0
9.81667, 437002.0
9.81733, 437289.0
9.818, 437571.0
9.81867, 437850.0
9.81933, 438127.0
9.82, 438400.0
9.82067, 438671.0
9.82133, 438941.0
9.822, 439210.0
9.82267, 439480.0
9.82333, 439751.0
9.824, 440022.0
9.82467, 440291.0
9.82533, 440558.0
9.826, 440826.0
9.82667, 441094.0
9.82733, 441363.0
9.828, 441631.0
9.82867, 441900.0
9.82933, 442170.0
9.83, 442441.0
9.83067, 442713.0
9.83133, 442983.0
9.832, 443251.0
9.83267, 443516.0
9.83333, 443776.0
9.834, 444030.0
9.83467, 444279.0
9.83533, 444523.0
9.836, 444763.0
9.83667, 444999.0
9.83733, 445234.0
9.838, 445472.0
9.83867, 445712.0
9.83933, 445952.0
9.84, 446195.0
9.84067, 446443.0
9.84133, 446698.0
9.842, 446958.0
9.84267, 447224.0
9.84333, 447493.0
9.844, 447763.0
9.84467, 448033.0
9.84533, 448305.0
9.846, 448578.0
9.84667, 448856.0
9.84733, 449138.0
9.848, 449423.0
9.84867, 449709.0
9.84933, 449994.0
9.85, 450279.0
9.85067, 450566.0
9.85133, 450855.0
9.852, 451146.0
9.85267, 451438.0
9.85333, 451731.0
9.854, 452028.0
9.85467, 452328.0
9.85533, 452634.0
9.856, 452941.0
9.85667, 453249.0
9.85733, 453555.0
9.858, 453861.0
9.85867, 454166.0
9.85933, 454470.0
9.86, 454773.0
9.86067, 455075.0
9.86133, 455375.0
9.862, 455677.0
9.86267, 455979.0
9.86333, 456284.0
9.864, 456592.0
9.86467, 456903.0
9.86533, 457215.0
9.866, 457529.0
9.86667, 457842.0
9.86733, 458153.0
9.868, 458462.0
9.86867, 458769.0
9.86933, 459076.0
9.87, 459383.0
9.87067, 459689.0
9.87133, 459995.0
9.872, 460299.0
9.87267, 460604.0
9.87333, 460911.0
9.874, 461219.0
9.87467, 461530.0
9.87533, 461843.0
9.876, 462157.0
9.87667, 462471.0
9.87733, 462786.0
9.878, 463099.0
9.87867, 463411.0
9.87933, 463720.0
9.88, 464028.0
9.88067, 464335.0
9.88133, 464641.0
9.882, 464946.0
9.88267, 465250.0
9.88333, 465553.0
9.884, 465858.0
9.88467, 466165.0
9.88533, 466475.0
9.886, 466790.0
9.88667, 467110.0
9.88733, 467434.0
9.888, 467760.0
9.88867, 468088.0
9.88933, 468418.0
9.89, 468750.0
9.89067, 469084.0
9.89133, 469417.0
9.892, 469751.0
9.89267, 470087.0
9.89333, 470423.0
9.894, 470759.0
9.89467, 471097.0
9.89533, 471437.0
9.896, 471780.0
9.89667, 472122.0
9.89733, 472465.0
9.898, 472806.0
9.89867, 473144.0
9.89933, 473479.0
9.9, 473815.0
9.90067, 474151.0
9.90133, 474488.0
9.902, 474824.0
9.90267, 475158.0
9.90333, 475488.0
9.904, 475815.0
9.90467, 476141.0
9.90533, 476468.0
9.906, 476800.0
9.90667, 477137.0
9.90733, 477474.0
9.908, 477809.0
9.90867, 478142.0
9.90933, 478476.0
9.91, 478812.0
9.91067, 479149.0
9.91133, 479488.0
9.912, 479825.0
9.91267, 480159.0
9.91333, 480492.0
9.914, 480826.0
9.91467, 481162.0
9.91533, 481498.0
9.916, 481834.0
9.91667, 482172.0
9.91733, 482511.0
9.918, 482852.0
9.91867, 483194.0
9.91933, 483537.0
9.92, 483881.0
9.92067, 484224.0
9.92133, 484567.0
9.922, 484910.0
9.92267, 485256.0
9.92333, 485608.0
9.924, 485964.0
9.92467, 486322.0
9.92533, 486681.0
9.926, 487039.0
9.92667, 487398.0
9.92733, 487759.0
9.928, 488121.0
9.92867, 488486.0
9.92933, 488855.0
9.93, 489225.0
9.93067, 489595.0
9.93133, 489962.0
9.932, 490327.0
9.93267, 490690.0
9.93333, 491053.0
9.934, 491417.0
9.93467, 491780.0
9.93533, 492144.0
9.936, 492507.0
9.93667, 492870.0
9.93733, 493233.0
9.938, 493596.0
9.93867, 493960.0
9.93933, 494325.0
9.94, 494690.0
9.94067, 495057.0
9.94133, 495424.0
9.942, 495794.0
9.94267, 496165.0
9.94333, 496539.0
9.944, 496914.0
9.94467, 497292.0
9.94533, 497672.0
9.946, 498057.0
9.94667, 498443.0
9.94733, 498830.0
9.948, 499220.0
9.94867, 499611.0
9.94933, 500004.0
9.95, 500401.0
9.95067, 500802.0
9.95133, 501208.0
9.952, 501614.0
9.95267, 502016.0
9.95333, 502413.0
9.954, 502810.0
9.95467, 503207.0
9.95533, 503606.0
9.956, 504008.0
9.95667, 504419.0
9.95733, 504834.0
9.958, 505251.0
9.95867, 505669.0
9.95933, 506089.0
9.96, 506508.0
9.96067, 506926.0
9.96133, 507341.0
9.962, 507756.0
9.96267, 508169.0
9.96333, 508580.0
9.964, 508988.0
9.96467, 509393.0
9.96533, 509794.0
9.966, 510192.0
9.96667, 510586.0
9.96733, 510977.0
9.968, 511367.0
9.96867, 511755.0
9.96933, 512147.0
9.97, 512543.0
9.97067, 512943.0
9.97133, 513345.0
9.972, 513745.0
9.97267, 514143.0
9.97333, 514538.0
9.974, 514929.0
9.97467, 515317.0
9.97533, 515706.0
9.976, 516100.0
9.97667, 516500.0
9.97733, 516906.0
9.978, 517315.0
9.97867, 517728.0
9.97933, 518146.0
9.98, 518570.0
9.98067, 518999.0
9.98133, 519434.0
9.982, 519872.0
9.98267, 520310.0
9.98333, 520748.0
9.984, 521183.0
9.98467, 521617.0
9.98533, 522050.0
9.986, 522482.0
9.98667, 522915.0
9.98733, 523345.0
9.988, 523770.0
9.98867, 524191.0
9.98933, 524608.0
9.99, 525022.0
9.99067, 525438.0
9.99133, 525856.0
9.992, 526279.0
9.99267, 526704.0
9.99333, 527131.0
9.994, 527560.0
9.99467, 527987.0
9.99533, 528414.0
9.996, 528840.0
9.99667, 529264.0
9.99733, 529691.0
9.998, 530121.0
9.99867, 530556.0
9.99933, 530996.0
10.0, 531438.0
10.00067, 531882.0
10.00133, 532327.0
10.002, 532771.0
10.00267, 533215.0
10.00333, 533659.0
10.004, 534102.0
10.00467, 534545.0
10.00533, 534987.0
10.006, 535424.0
10.00667, 535855.0
10.00733, 536278.0
10.008, 536693.0
10.00867, 537102.0
10.00933, 537504.0
10.01, 537899.0
10.01067, 538287.0
10.01133, 538669.0
10.012, 539044.0
10.01267, 539414.0
10.01333, 539779.0
10.014, 540140.0
10.01467, 540495.0
10.01533, 540846.0
10.016, 541194.0
10.01667, 541540.0
10.01733, 541885.0
10.018, 542231.0
10.01867, 542580.0
10.01933, 542932.0
10.02, 543286.0
10.02067, 543643.0
10.02133, 544003.0
10.022, 544365.0
10.02267, 544728.0
10.02333, 545089.0
10.024, 545451.0
10.02467, 545811.0
10.02533, 546173.0
10.026, 546538.0
10.02667, 546902.0
10.02733, 547266.0
10.028, 547631.0
10.02867, 547994.0
10.02933, 548353.0
10.03, 548708.0
10.03067, 549059.0
10.03133, 549405.0
10.032, 549744.0
10.03267, 550077.0
10.03333, 550404.0
10.034, 550726.0
10.03467, 551041.0
10.03533, 551353.0
10.036, 551664.0
10.03667, 551975.0
10.03733, 552288.0
10.038, 552602.0
10.03867, 552920.0
10.03933, 553244.0
10.04, 553572.0
10.04067, 553901.0
10.04133, 554228.0
10.042, 554555.0
10.04267, 554878.0
10.04333, 555199.0
10.044, 555515.0
10.04467, 555829.0
10.04533, 556142.0
10.046, 556455.0
10.04667, 556768.0
10.04733, 557078.0
10.048, 557390.0
10.04867, 557705.0
10.04933, 558025.0
10.05, 558349.0
10.05067, 558675.0
10.05133, 559000.0
10.052, 559322.0
10.05267, 559641.0
10.05333, 559953.0
10.054, 560258.0
10.05467, 560555.0
10.05533, 560845.0
10.056, 561127.0
10.05667, 561402.0
10.05733, 561672.0
10.058, 561933.0
10.05867, 562190.0
10.05933, 562443.0
10.06, 562692.0
10.06067, 562938.0
10.06133, 563182.0
10.062, 563425.0
10.06267, 563668.0
10.06333, 563912.0
10.064, 564158.0
10.06467, 564406.0
10.06533, 564657.0
10.066, 564909.0
10.06667, 565164.0
10.06733, 565423.0
10.068, 565685.0
10.06867, 565950.0
10.06933, 566218.0
10.07, 566488.0
10.07067, 566758.0
10.07133, 567027.0
10.072, 567294.0
10.07267, 567559.0
10.07333, 567822.0
10.074, 568079.0
10.07467, 568329.0
10.07533, 568568.0
10.076, 568796.0
10.07667, 569013.0
10.07733, 569219.0
10.078, 569416.0
10.07867, 569601.0
10.07933, 569774.0
10.08, 569934.0
10.08067, 570081.0
10.08133, 570217.0
10.082, 570341.0
10.08267, 570454.0
10.08333, 570556.0
10.084, 570647.0
10.08467, 570733.0
10.08533, 570814.0
10.086, 570894.0
10.08667, 570976.0
10.08733, 571062.0
10.088, 571154.0
10.08867, 571256.0
10.08933, 571369.0
10.09, 571496.0
10.09067, 571635.0
10.09133, 571784.0
10.092, 571946.0
10.09267, 572121.0
10.09333, 572311.0
10.094, 572515.0
10.09467, 572736.0
10.09533, 572971.0
10.096, 573223.0
10.09667, 573491.0
10.09733, 573777.0
10.098, 574079.0
10.09867, 574393.0
10.09933, 574719.0
10.1, 575055.0
10.10067, 575400.0
10.10133, 575750.0
10.102, 576102.0
10.10267, 576455.0
10.10333, 576805.0
10.104, 577151.0
10.10467, 577496.0
10.10533, 577838.0
10.106, 578177.0
10.10667, 578509.0
10.10733, 578832.0
10.108, 579146.0
10.10867, 579453.0
10.10933, 579753.0
10.11, 580046.0
10.11067, 580335.0
10.11133, 580616.0
10.112, 580890.0
10.11267, 581155.0
10.11333, 581413.0
10.114, 581665.0
10.11467, 581914.0
10.11533, 582159.0
10.116, 582397.0
10.11667, 582629.0
10.11733, 582856.0
10.118, 583082.0
10.11867, 583305.0
10.11933, 583525.0
10.12, 583742.0
10.12067, 583955.0
10.12133, 584165.0
10.122, 584372.0
10.12267, 584577.0
10.12333, 584784.0
10.124, 584992.0
10.12467, 585201.0
10.12533, 585411.0
10.126, 585624.0
10.12667, 585839.0
10.12733, 586057.0
10.128, 586277.0
10.12867, 586501.0
10.12933, 586727.0
10.13, 586957.0
10.13067, 587192.0
10.13133, 587432.0
10.132, 587675.0
10.13267, 587920.0
10.13333, 588166.0
10.134, 588414.0
10.13467, 588660.0
10.13533, 588901.0
10.136, 589139.0
10.13667, 589372.0
10.13733, 589600.0
10.138, 589821.0
10.13867, 590039.0
10.13933, 590253.0
10.14, 590464.0
10.14067, 590672.0
10.14133, 590879.0
10.142, 591084.0
10.14267, 591290.0
10.14333, 591495.0
10.144, 591699.0
10.14467, 591900.0
10.14533, 592100.0
10.146, 592299.0
10.14667, 592498.0
10.14733, 592701.0
10.148, 592908.0
10.14867, 593122.0
10.14933, 593337.0
10.15, 593552.0
10.15067, 593765.0
10.15133, 593975.0
10.152, 594183.0
10.15267, 594389.0
10.15333, 594592.0
10.154, 594793.0
10.15467, 594989.0
10.15533, 595181.0
10.156, 595370.0
10.15667, 595558.0
10.15733, 595749.0
10.158, 595940.0
10.15867, 596129.0
10.15933, 596317.0
10.16, 596501.0
10.16067, 596683.0
10.16133, 596864.0
10.162, 597045.0
10.16267, 597226.0
10.16333, 597406.0
10.164, 597583.0
10.16467, 597759.0
10.16533, 597934.0
10.166, 598105.0
10.16667, 598275.0
10.16733, 598442.0
10.168, 598609.0
10.16867, 598780.0
10.16933, 598956.0
10.17, 599140.0
10.17067, 599327.0
10.17133, 599515.0
10.172, 599702.0
10.17267, 599888.0
10.17333, 600074.0
10.174, 600258.0
10.17467, 600441.0
10.17533, 600626.0
10.176, 600814.0
10.17667, 601005.0
10.17733, 601196.0
10.178, 601385.0
10.17867, 601571.0
10.17933, 601757.0
10.18, 601942.0
10.18067, 602127.0
10.18133, 602312.0
10.182, 602494.0
10.18267, 602673.0
10.18333, 602851.0
10.184, 603029.0
10.18467, 603208.0
10.18533, 603386.0
10.186, 603562.0
10.18667, 603736.0
10.18733, 603912.0
10.188, 604092.0
10.18867, 604277.0
10.18933, 604464.0
10.19, 604652.0
10.19067, 604839.0
10.19133, 605025.0
10.192, 605212.0
10.19267, 605399.0
10.19333, 605586.0
10.194, 605773.0
10.19467, 605960.0
10.19533, 606150.0
10.196, 606342.0
10.19667, 606535.0
10.19733, 606727.0
10.198, 606918.0
10.19867, 607110.0
10.19933, 607304.0
10.2, 607504.0
10.20067, 607708.0
10.20133, 607918.0
10.202, 608129.0
10.20267, 608341.0
10.20333, 608554.0
10.204, 608770.0
10.20467, 608990.0
10.20533, 609214.0
10.206, 609441.0
10.20667, 609673.0
10.20733, 609909.0
10.208, 610150.0
10.20867, 610394.0
10.20933, 610639.0
10.21, 610885.0
10.21067, 611131.0
10.21133, 611374.0
10.212, 611615.0
10.21267, 611852.0
10.21333, 612085.0
10.214, 612314.0
10.21467, 612539.0
10.21533, 612755.0
10.216, 612962.0
10.21667, 613160.0
10.21733, 613350.0
10.218, 613533.0
10.21867, 613709.0
10.21933, 613876.0
10.22, 614036.0
10.22067, 614186.0
10.22133, 614328.0
10.222, 614461.0
10.22267, 614589.0
10.22333, 614711.0
10.224, 614827.0
10.22467, 614941.0
10.22533, 615055.0
10.226, 615167.0
10.22667, 615275.0
10.22733, 615380.0
10.228, 615480.0
10.22867, 615578.0
10.22933, 615674.0
10.23, 615773.0
10.23067, 615878.0
10.23133, 615986.0
10.232, 616100.0
10.23267, 616217.0
10.23333, 616340.0
10.234, 616469.0
10.23467, 616606.0
10.23533, 616751.0
10.236, 616902.0
10.23667, 617057.0
10.23733, 617214.0
10.238, 617374.0
10.23867, 617538.0
10.23933, 617704.0
10.24, 617874.0
10.24067, 618045.0
10.24133, 618218.0
10.242, 618393.0
10.24267, 618568.0
10.24333, 618743.0
10.244, 618919.0
10.24467, 619097.0
10.24533, 619276.0
10.246, 619456.0
10.24667, 619636.0
10.24733, 619816.0
10.248, 619995.0
10.24867, 620174.0
10.24933, 620352.0
10.25, 620530.0
10.25067, 620708.0
10.25133, 620888.0
10.252, 621071.0
10.25267, 621258.0
10.25333, 621447.0
10.254, 621636.0
10.25467, 621824.0
10.25533, 622012.0
10.256, 622198.0
10.25667, 622383.0
10.25733, 622566.0
10.258, 622747.0
10.25867, 622928.0
10.25933, 623108.0
10.26, 623289.0
10.26067, 623468.0
10.26133, 623646.0
10.262, 623824.0
10.26267, 624001.0
10.26333, 624178.0
10.264, 624358.0
10.26467, 624540.0
10.26533, 624721.0
10.266, 624902.0
10.26667, 625081.0
10.26733, 625260.0
10.268, 625439.0
10.26867, 625621.0
10.26933, 625805.0
10.27, 625989.0
10.27067, 626173.0
10.27133, 626358.0
10.272, 626544.0
10.27267, 626732.0
10.27333, 626920.0
10.274, 627109.0
10.27467, 627297.0
10.27533, 627484.0
10.276, 627669.0
10.27667, 627851.0
10.27733, 628028.0
10.278, 628203.0
10.27867, 628376.0
10.27933, 628546.0
10.28, 628714.0
10.28067, 628879.0
10.28133, 629041.0
10.282, 629200.0
10.28267, 629356.0
10.28333, 629511.0
10.284, 629666.0
10.28467, 629822.0
10.28533, 629980.0
10.286, 630140.0
10.28667, 630300.0
10.28733, 630461.0
10.288, 630621.0
10.28867, 630778.0
10.28933, 630930.0
10.29, 631081.0
10.29067, 631230.0
10.29133, 631378.0
10.292, 631521.0
10.29267, 631662.0
10.29333, 631801.0
10.294, 631942.0
10.29467, 632084.0
10.29533, 632227.0
10.296, 632368.0
10.29667, 632509.0
10.29733, 632649.0
10.298, 632790.0
10.29867, 632934.0
10.29933, 633083.0
10.3, 633236.0
10.30067, 633392.0
10.30133, 633552.0
10.302, 633714.0
10.30267, 633879.0
10.30333, 634046.0
10.304, 634215.0
10.30467, 634386.0
10.30533, 634557.0
10.306, 634729.0
10.30667, 634903.0
10.30733, 635080.0
10.308, 635258.0
10.30867, 635439.0
10.30933, 635620.0
10.31, 635799.0
10.31067, 635978.0
10.31133, 636158.0
10.312, 636336.0
10.31267, 636512.0
10.31333, 636686.0
10.314, 636856.0
10.31467, 637023.0
10.31533, 637187.0
10.316, 637349.0
10.31667, 637506.0
10.31733, 637658.0
10.318, 637807.0
10.31867, 637952.0
10.31933, 638096.0
10.32, 638240.0
10.32067, 638387.0
10.32133, 638535.0
10.322, 638684.0
10.32267, 638831.0
10.32333, 638975.0
10.324, 639117.0
10.32467, 639257.0
10.32533, 639395.0
10.326, 639533.0
10.32667, 639672.0
10.32733, 639811.0
10.328, 639952.0
10.32867, 640095.0
10.32933, 640241.0
10.33, 640390.0
10.33067, 640540.0
10.33133, 640688.0
10.332, 640834.0
10.33267, 640976.0
10.33333, 641116.0
10.334, 641253.0
10.33467, 641391.0
10.33533, 641531.0
10.336, 641674.0
10.33667, 641817.0
10.33733, 641957.0
10.338, 642096.0
10.33867, 642233.0
10.33933, 642368.0
10.34, 642503.0
10.34067, 642635.0
10.34133, 642764.0
10.342, 642891.0
10.34267, 643016.0
10.34333, 643139.0
10.344, 643262.0
10.34467, 643387.0
10.34533, 643516.0
10.346, 643649.0
10.34667, 643786.0
10.34733, 643928.0
10.348, 644071.0
10.34867, 644218.0
10.34933, 644367.0
10.35, 644521.0
10.35067, 644678.0
10.35133, 644834.0
10.352, 644987.0
10.35267, 645137.0
10.35333, 645282.0
10.354, 645425.0
10.35467, 645563.0
10.35533, 645696.0
10.356, 645821.0
10.35667, 645942.0
10.35733, 646057.0
10.358, 646170.0
10.35867, 646281.0
10.35933, 646388.0
10.36, 646493.0
10.36067, 646594.0
10.36133, 646692.0
10.362, 646787.0
10.36267, 646878.0
10.36333, 646966.0
10.364, 647052.0
10.36467, 647136.0
10.36533, 647219.0
10.366, 647297.0
10.36667, 647371.0
10.36733, 647443.0
10.368, 647514.0
10.36867, 647587.0
10.36933, 647662.0
10.37, 647741.0
10.37067, 647828.0
10.37133, 647922.0
10.372, 648020.0
10.37267, 648119.0
10.37333, 648219.0
10.374, 648320.0
10.37467, 648422.0
10.37533, 648525.0
10.376, 648631.0
10.37667, 648739.0
10.37733, 648849.0
10.378, 648961.0
10.37867, 649073.0
10.37933, 649183.0
10.38, 649293.0
10.38067, 649405.0
10.38133, 649517.0
10.382, 649628.0
10.38267, 649737.0
10.38333, 649845.0
10.384, 649952.0
10.38467, 650060.0
10.38533, 650167.0
10.386, 650271.0
10.38667, 650371.0
10.38733, 650467.0
10.388, 650561.0
10.38867, 650653.0
10.38933, 650744.0
10.39, 650835.0
10.39067, 650923.0
10.39133, 651011.0
10.392, 651099.0
10.39267, 651188.0
10.39333, 651277.0
10.394, 651366.0
10.39467, 651455.0
10.39533, 651544.0
10.396, 651633.0
10.39667, 651722.0
10.39733, 651810.0
10.398, 651899.0
10.39867, 651987.0
10.39933, 652075.0
10.4, 652163.0
10.40067, 652251.0
10.40133, 652338.0
10.402, 652421.0
10.40267, 652502.0
10.40333, 652583.0
10.404, 652660.0
10.40467, 652735.0
10.40533, 652808.0
10.406, 652878.0
10.40667, 652946.0
10.40733, 653009.0
10.408, 653069.0
10.40867, 653127.0
10.40933, 653181.0
10.41, 653235.0
10.41067, 653287.0
10.41133, 653340.0
10.412, 653393.0
10.41267, 653446.0
10.41333, 653499.0
10.414, 653554.0
10.41467, 653612.0
10.41533, 653675.0
10.416, 653742.0
10.41667, 653812.0
10.41733, 653884.0
10.418, 653956.0
10.41867, 654029.0
10.41933, 654104.0
10.42, 654180.0
10.42067, 654259.0
10.42133, 654338.0
10.422, 654420.0
10.42267, 654506.0
10.42333, 654596.0
10.424, 654691.0
10.42467, 654791.0
10.42533, 654895.0
10.426, 655000.0
10.42667, 655108.0
10.42733, 655218.0
10.428, 655330.0
10.42867, 655441.0
10.42933, 655552.0
10.43, 655660.0
10.43067, 655770.0
10.43133, 655880.0
10.432, 655989.0
10.43267, 656095.0
10.43333, 656199.0
10.434, 656299.0
10.43467, 656396.0
10.43533, 656490.0
10.436, 656583.0
10.43667, 656673.0
10.43733, 656761.0
10.438, 656848.0
10.43867, 656930.0
10.43933, 657009.0
10.44, 657088.0
10.44067, 657165.0
10.44133, 657241.0
10.442, 657313.0
10.44267, 657377.0
10.44333, 657434.0
10.444, 657485.0
10.44467, 657528.0
10.44533, 657566.0
10.446, 657601.0
10.44667, 657634.0
10.44733, 657667.0
10.448, 657698.0
10.44867, 657728.0
10.44933, 657755.0
10.45, 657779.0
10.45067, 657799.0
10.45133, 657821.0
10.452, 657843.0
10.45267, 657868.0
10.45333, 657895.0
10.454, 657924.0
10.45467, 657954.0
10.45533, 657986.0
10.456, 658022.0
10.45667, 658061.0
10.45733, 658101.0
10.458, 658144.0
10.45867, 658190.0
10.45933, 658238.0
10.46, 658287.0
10.46067, 658338.0
10.46133, 658389.0
10.462, 658442.0
10.46267, 658497.0
10.46333, 658555.0
10.464, 658618.0
10.46467, 658683.0
10.46533, 658750.0
10.466, 658815.0
10.46667, 658880.0
10.46733, 658946.0
10.468, 659011.0
10.46867, 659077.0
10.46933, 659145.0
10.47, 659212.0
10.47067, 659277.0
10.47133, 659344.0
10.472, 659415.0
10.47267, 659490.0
10.47333, 659567.0
10.474, 659645.0
10.47467, 659723.0
10.47533, 659801.0
10.476, 659877.0
10.47667, 659951.0
10.47733, 660022.0
10.478, 660089.0
10.47867, 660155.0
10.47933, 660219.0
10.48, 660282.0
10.48067, 660345.0
10.48133, 660406.0
10.482, 660467.0
10.48267, 660525.0
10.48333, 660581.0
10.484, 660635.0
10.48467, 660689.0
10.48533, 660744.0
10.486, 660800.0
10.48667, 660856.0
10.48733, 660911.0
10.488, 660964.0
10.48867, 661017.0
10.48933, 661071.0
10.49, 661128.0
10.49067, 661186.0
10.49133, 661243.0
10.492, 661300.0
10.49267, 661355.0
10.49333, 661408.0
10.494, 661460.0
10.49467, 661510.0
10.49533, 661557.0
10.496, 661599.0
10.49667, 661636.0
10.49733, 661667.0
10.498, 661697.0
10.49867, 661726.0
10.49933, 661754.0
10.5, 661780.0
10.50067, 661804.0
10.50133, 661826.0
10.502, 661849.0
10.50267, 661875.0
10.50333, 661902.0
10.504, 661931.0
10.50467, 661958.0
10.50533, 661986.0
10.506, 662013.0
10.50667, 662040.0
10.50733, 662068.0
10.508, 662098.0
10.50867, 662128.0
10.50933, 662161.0
10.51, 662195.0
10.51067, 662228.0
10.51133, 662262.0
10.512, 662296.0
10.51267, 662331.0
10.51333, 662369.0
10.514, 662408.0
10.51467, 662446.0
10.51533, 662483.0
10.516, 662520.0
10.51667, 662561.0
10.51733, 662603.0
10.518, 662646.0
10.51867, 662693.0
10.51933, 662743.0
10.52, 662796.0
10.52067, 662851.0
10.52133, 662906.0
10.522, 662964.0
10.52267, 663022.0
10.52333, 663082.0
10.524, 663147.0
10.52467, 663215.0
10.52533, 663286.0
10.526, 663357.0
10.52667, 663426.0
10.52733, 663497.0
10.528, 663567.0
10.52867, 663638.0
10.52933, 663708.0
10.53, 663777.0
10.53067, 663845.0
10.53133, 663909.0
10.532, 663972.0
10.53267, 664035.0
10.53333, 664096.0
10.534, 664157.0
10.53467, 664216.0
10.53533, 664274.0
10.536, 664330.0
10.53667, 664385.0
10.53733, 664440.0
10.538, 664496.0
10.53867, 664550.0
10.53933, 664604.0
10.54, 664658.0
10.54067, 664711.0
10.54133, 664764.0
10.542, 664817.0
10.54267, 664870.0
10.54333, 664923.0
10.544, 664974.0
10.54467, 665022.0
10.54533, 665069.0
10.546, 665115.0
10.54667, 665160.0
10.54733, 665204.0
10.548, 665248.0
10.54867, 665293.0
10.54933, 665337.0
10.55, 665380.0
10.55067, 665420.0
10.55133, 665459.0
10.552, 665499.0
10.55267, 665542.0
10.55333, 665589.0
10.554, 665636.0
10.55467, 665685.0
10.55533, 665734.0
10.556, 665783.0
10.55667, 665832.0
10.55733, 665879.0
10.558, 665923.0
10.55867, 665965.0
10.55933, 666004.0
10.56, 666043.0
10.56067, 666081.0
10.56133, 666119.0
10.562, 666158.0
10.56267, 666195.0
10.56333, 666231.0
10.564, 666265.0
10.56467, 666295.0
10.56533, 666323.0
10.566, 666348.0
10.56667, 666371.0
10.56733, 666391.0
10.568, 666407.0
10.56867, 666418.0
10.56933, 666426.0
10.57, 666428.0
10.57067, 666427.0
10.57133, 666424.0
10.572, 666421.0
10.57267, 666420.0
10.57333, 666419.0
10.574, 666422.0
10.57467, 666427.0
10.57533, 666435.0
10.576, 666447.0
10.57667, 666462.0
10.57733, 666482.0
10.578, 666507.0
10.57867, 666535.0
10.57933, 666565.0
10.58, 666596.0
10.58067, 666630.0
10.58133, 666666.0
10.582, 666707.0
10.58267, 666753.0
10.58333, 666805.0
10.584, 666861.0
10.58467, 666921.0
10.58533, 666983.0
10.586, 667047.0
10.58667, 667111.0
10.58733, 667173.0
10.588, 667233.0
10.58867, 667291.0
10.58933, 667347.0
10.59, 667401.0
10.59067, 667451.0
10.59133, 667499.0
10.592, 667545.0
10.59267, 667589.0
10.59333, 667629.0
10.594, 667662.0
10.59467, 667688.0
10.59533, 667710.0
10.596, 667728.0
10.59667, 667741.0
10.59733, 667750.0
10.598, 667757.0
10.59867, 667765.0
10.59933, 667777.0
10.6, 667790.0
10.60067, 667800.0
10.60133, 667810.0
10.602, 667818.0
10.60267, 667826.0
10.60333, 667833.0
10.604, 667837.0
10.60467, 667838.0
10.60533, 667833.0
10.606, 667824.0
10.60667, 667810.0
10.60733, 667792.0
10.608, 667773.0
10.60867, 667755.0
10.60933, 667737.0
10.61, 667719.0
10.61067, 667700.0
10.61133, 667682.0
10.612, 667664.0
10.61267, 667648.0
10.61333, 667634.0
10.614, 667620.0
10.61467, 667606.0
10.61533, 667592.0
10.616, 667579.0
10.61667, 667568.0
10.61733, 667560.0
10.618, 667557.0
10.61867, 667559.0
10.61933, 667566.0
10.62, 667579.0
10.62067, 667596.0
10.62133, 667615.0
10.622, 667637.0
10.62267, 667662.0
10.62333, 667690.0
10.624, 667723.0
10.62467, 667758.0
10.62533, 667794.0
10.626, 667830.0
10.62667, 667865.0
10.62733, 667898.0
10.628, 667929.0
10.62867, 667957.0
10.62933, 667983.0
10.63, 668008.0
10.63067, 668033.0
10.63133, 668061.0
10.632, 668094.0
10.63267, 668130.0
10.63333, 668173.0
10.634, 668224.0
10.63467, 668282.0
10.63533, 668345.0
10.636, 668410.0
10.63667, 668478.0
10.63733, 668547.0
10.638, 668618.0
10.63867, 668688.0
10.63933, 668756.0
10.64, 668823.0
10.64067, 668889.0
10.64133, 668958.0
10.642, 669027.0
10.64267, 669096.0
10.64333, 669161.0
10.644, 669220.0
10.64467, 669272.0
10.64533, 669315.0
10.646, 669353.0
10.64667, 669387.0
10.64733, 669418.0
10.648, 669446.0
10.64867, 669474.0
10.64933, 669504.0
10.65, 669537.0
10.65067, 669573.0
10.65133, 669610.0
10.652, 669648.0
10.65267, 669686.0
10.65333, 669726.0
10.654, 669766.0
10.65467, 669807.0
10.65533, 669848.0
10.656, 669891.0
10.65667, 669936.0
10.65733, 669980.0
10.658, 670023.0
10.65867, 670065.0
10.65933, 670105.0
10.66, 670143.0
10.66067, 670177.0
10.66133, 670208.0
10.662, 670234.0
10.66267, 670257.0
10.66333, 670277.0
10.664, 670294.0
10.66467, 670308.0
10.66533, 670318.0
10.666, 670324.0
10.66667, 670326.0
10.66733, 670326.0
10.668, 670327.0
10.66867, 670326.0
10.66933, 670326.0
10.67, 670327.0
10.67067, 670328.0
10.67133, 670329.0
10.672, 670330.0
10.67267, 670328.0
10.67333, 670324.0
10.674, 670315.0
10.67467, 670301.0
10.67533, 670281.0
10.676, 670256.0
10.67667, 670227.0
10.67733, 670191.0
10.678, 670150.0
10.67867, 670104.0
10.67933, 670053.0
10.68, 669994.0
10.68067, 669929.0
10.68133, 669859.0
10.682, 669787.0
10.68267, 669713.0
10.68333, 669638.0
10.684, 669565.0
10.68467, 669492.0
10.68533, 669424.0
10.686, 669361.0
10.68667, 669305.0
10.68733, 669257.0
10.688, 669219.0
10.68867, 669191.0
10.68933, 669175.0
10.69, 669167.0
10.69067, 669169.0
10.69133, 669177.0
10.692, 669193.0
10.69267, 669216.0
10.69333, 669244.0
10.694, 669275.0
10.69467, 669306.0
10.69533, 669338.0
10.696, 669371.0
10.69667, 669405.0
10.69733, 669441.0
10.698, 669477.0
10.69867, 669512.0
10.69933, 669547.0
10.7, 669579.0
10.70067, 669609.0
10.70133, 669637.0
10.702, 669662.0
10.70267, 669684.0
10.70333, 669703.0
10.704, 669718.0
10.70467, 669733.0
10.70533, 669748.0
10.706, 669765.0
10.70667, 669782.0
10.70733, 669798.0
10.708, 669810.0
10.70867, 669815.0
10.70933, 669816.0
10.71, 669812.0
10.71067, 669803.0
10.71133, 669792.0
10.712, 669777.0
10.71267, 669759.0
10.71333, 669738.0
10.714, 669715.0
10.71467, 669689.0
10.71533, 669662.0
10.716, 669633.0
10.71667, 669603.0
10.71733, 669571.0
10.718, 669539.0
10.71867, 669511.0
10.71933, 669485.0
10.72, 669461.0
10.72067, 669439.0
10.72133, 669419.0
10.722, 669402.0
10.72267, 669389.0
10.72333, 669381.0
10.724, 669378.0
10.72467, 669377.0
10.72533, 669380.0
10.726, 669387.0
10.72667, 669396.0
10.72733, 669407.0
10.728, 669421.0
10.72867, 669436.0
10.72933, 669452.0
10.73, 669470.0
10.73067, 669491.0
10.73133, 669515.0
10.732, 669539.0
10.73267, 669565.0
10.73333, 669590.0
10.734, 669616.0
10.73467, 669641.0
10.73533, 669667.0
10.736, 669693.0
10.73667, 669719.0
10.73733, 669745.0
10.738, 669770.0
10.73867, 669796.0
10.73933, 669820.0
10.74, 669841.0
10.74067, 669858.0
10.74133, 669867.0
10.742, 669871.0
10.74267, 669871.0
10.74333, 669868.0
10.744, 669865.0
10.74467, 669861.0
10.74533, 669857.0
10.746, 669855.0
10.74667, 669853.0
10.74733, 669849.0
10.748, 669840.0
10.74867, 669827.0
10.74933, 669812.0
10.75, 669795.0
10.75067, 669775.0
10.75133, 669758.0
10.752, 669746.0
10.75267, 669738.0
10.75333, 669735.0
10.754, 669734.0
10.75467, 669733.0
10.75533, 669733.0
10.756, 669731.0
10.75667, 669728.0
10.75733, 669725.0
10.758, 669720.0
10.75867, 669716.0
10.75933, 669710.0
10.76, 669703.0
10.76067, 669697.0
10.76133, 669691.0
10.762, 669687.0
10.76267, 669685.0
10.76333, 669686.0
10.764, 669690.0
10.76467, 669695.0
10.76533, 669702.0
10.766, 669711.0
10.76667, 669719.0
10.76733, 669726.0
10.768, 669731.0
10.76867, 669737.0
10.76933, 669743.0
10.77, 669752.0
10.77067, 669763.0
10.77133, 669775.0
10.772, 669789.0
10.77267, 669805.0
10.77333, 669822.0
10.774, 669843.0
10.77467, 669864.0
10.77533, 669887.0
10.776, 669910.0
10.77667, 669934.0
10.77733, 669956.0
10.778, 669977.0
10.77867, 669997.0
10.77933, 670017.0
10.78, 670038.0
10.78067, 670060.0
10.78133, 670082.0
10.782, 670104.0
10.78267, 670127.0
10.78333, 670148.0
10.784, 670170.0
10.78467, 670194.0
10.78533, 670219.0
10.786, 670242.0
10.78667, 670262.0
10.78733, 670281.0
10.788, 670300.0
10.78867, 670320.0
10.78933, 670343.0
10.79, 670366.0
10.79067, 670390.0
10.79133, 670413.0
10.792, 670438.0
10.79267, 670461.0
10.79333, 670483.0
10.794, 670503.0
10.79467, 670520.0
10.79533, 670536.0
10.796, 670551.0
10.79667, 670565.0
10.79733, 670579.0
10.798, 670595.0
10.79867, 670612.0
10.79933, 670629.0
10.8, 670645.0
10.80067, 670663.0
10.80133, 670682.0
10.802, 670703.0
10.80267, 670728.0
10.80333, 670755.0
10.804, 670784.0
10.80467, 670816.0
10.80533, 670851.0
10.806, 670888.0
10.80667, 670928.0
10.80733, 670969.0
10.808, 671011.0
10.80867, 671054.0
10.80933, 671097.0
10.81, 671138.0
10.81067, 671180.0
10.81133, 671223.0
10.812, 671267.0
10.81267, 671311.0
10.81333, 671354.0
10.814, 671395.0
10.81467, 671434.0
10.81533, 671472.0
10.816, 671506.0
10.81667, 671536.0
10.81733, 671562.0
10.818, 671583.0
10.81867, 671601.0
10.81933, 671614.0
10.82, 671621.0
10.82067, 671620.0
10.82133, 671612.0
10.822, 671594.0
10.82267, 671567.0
10.82333, 671532.0
10.824, 671491.0
10.82467, 671445.0
10.82533, 671396.0
10.826, 671344.0
10.82667, 671290.0
10.82733, 671236.0
10.828, 671182.0
10.82867, 671129.0
10.82933, 671075.0
10.83, 671024.0
10.83067, 670978.0
10.83133, 670935.0
10.832, 670897.0
10.83267, 670861.0
10.83333, 670829.0
10.834, 670797.0
10.83467, 670763.0
10.83533, 670726.0
10.836, 670687.0
10.83667, 670648.0
10.83733, 670610.0
10.838, 670574.0
10.83867, 670540.0
10.83933, 670508.0
10.84, 670480.0
10.84067, 670455.0
10.84133, 670432.0
10.842, 670409.0
10.84267, 670385.0
10.84333, 670358.0
10.844, 670327.0
10.84467, 670294.0
10.84533, 670258.0
10.846, 670218.0
10.84667, 670176.0
10.84733, 670132.0
10.848, 670090.0
10.84867, 670050.0
10.84933, 670012.0
10.85, 669974.0
10.85067, 669938.0
10.85133, 669901.0
10.852, 669864.0
10.85267, 669826.0
10.85333, 669788.0
10.854, 669749.0
10.85467, 669707.0
10.85533, 669662.0
10.856, 669613.0
10.85667, 669560.0
10.85733, 669503.0
10.858, 669442.0
10.85867, 669381.0
10.85933, 669317.0
10.86, 669252.0
10.86067, 669188.0
10.86133, 669124.0
10.862, 669060.0
10.86267, 668997.0
10.86333, 668934.0
10.864, 668871.0
10.86467, 668810.0
10.86533, 668752.0
10.866, 668698.0
10.86667, 668648.0
10.86733, 668603.0
10.868, 668563.0
10.86867, 668525.0
10.86933, 668491.0
10.87, 668460.0
10.87067, 668434.0
10.87133, 668411.0
10.872, 668392.0
10.87267, 668377.0
10.87333, 668365.0
10.874, 668354.0
10.87467, 668344.0
10.87533, 668334.0
10.876, 668325.0
10.87667, 668316.0
10.87733, 668309.0
10.878, 668300.0
10.87867, 668287.0
10.87933, 668271.0
10.88, 668251.0
10.88067, 668227.0
10.88133, 668200.0
10.882, 668172.0
10.88267, 668140.0
10.88333, 668103.0
10.884, 668060.0
10.88467, 668010.0
10.88533, 667955.0
10.886, 667896.0
10.88667, 667834.0
10.88733, 667769.0
10.888, 667700.0
10.88867, 667631.0
10.88933, 667562.0
10.89, 667494.0
10.89067, 667427.0
10.89133, 667363.0
10.892, 667305.0
10.89267, 667252.0
10.89333, 667201.0
10.894, 667152.0
10.89467, 667105.0
10.89533, 667061.0
10.896, 667021.0
10.89667, 666985.0
10.89733, 666955.0
10.898, 666931.0
10.89867, 666911.0
10.89933, 666894.0
10.9, 666878.0
10.90067, 666865.0
10.90133, 666853.0
10.902, 666842.0
10.90267, 666830.0
10.90333, 666820.0
10.904, 666811.0
10.90467, 666804.0
10.90533, 666799.0
10.906, 666796.0
10.90667, 666794.0
10.90733, 666793.0
10.908, 666789.0
10.90867, 666784.0
10.90933, 666776.0
10.91, 666765.0
10.91067, 666753.0
10.91133, 666736.0
10.912, 666714.0
10.91267, 666685.0
10.91333, 666648.0
10.914, 666605.0
10.91467, 666557.0
10.91533, 666506.0
10.916, 666452.0
10.91667, 666395.0
10.91733, 666335.0
10.918, 666275.0
10.91867, 666213.0
10.91933, 666148.0
10.92, 666081.0
10.92067, 666012.0
10.92133, 665940.0
10.922, 665867.0
10.92267, 665794.0
10.92333, 665721.0
10.924, 665648.0
10.92467, 665574.0
10.92533, 665500.0
10.926, 665425.0
10.92667, 665351.0
10.92733, 665280.0
10.928, 665213.0
10.92867, 665148.0
10.92933, 665087.0
10.93, 665030.0
10.93067, 664977.0
10.93133, 664928.0
10.932, 664883.0
10.93267, 664840.0
10.93333, 664801.0
10.934, 664765.0
10.93467, 664732.0
10.93533, 664701.0
10.936, 664671.0
10.93667, 664642.0
10.93733, 664614.0
10.938, 664586.0
10.93867, 664560.0
10.93933, 664535.0
10.94, 664512.0
10.94067, 664491.0
10.94133, 664474.0
10.942, 664459.0
10.94267, 664448.0
10.94333, 664436.0
10.944, 664424.0
10.94467, 664414.0
10.94533, 664403.0
10.946, 664391.0
10.94667, 664380.0
10.94733, 664370.0
10.948, 664359.0
10.94867, 664348.0
10.94933, 664335.0
10.95, 664320.0
10.95067, 664302.0
10.95133, 664279.0
10.952, 664251.0
10.95267, 664223.0
10.95333, 664193.0
10.954, 664162.0
10.95467, 664127.0
10.95533, 664088.0
10.956, 664045.0
10.95667, 663997.0
10.95733, 663945.0
10.958, 663890.0
10.95867, 663831.0
10.95933, 663767.0
10.96, 663699.0
10.96067, 663627.0
10.96133, 663554.0
10.962, 663477.0
10.96267, 663397.0
10.96333, 663317.0
10.964, 663236.0
10.96467, 663154.0
10.96533, 663072.0
10.966, 662991.0
10.96667, 662912.0
10.96733, 662835.0
10.968, 662762.0
10.96867, 662690.0
10.96933, 662618.0
10.97, 662546.0
10.97067, 662475.0
10.97133, 662408.0
10.972, 662345.0
10.97267, 662291.0
10.97333, 662243.0
10.974, 662201.0
10.97467, 662163.0
10.97533, 662128.0
10.976, 662094.0
10.97667, 662063.0
10.97733, 662034.0
10.978, 662008.0
10.97867, 661985.0
10.97933, 661965.0
10.98, 661949.0
10.98067, 661935.0
10.98133, 661925.0
10.982, 661916.0
10.98267, 661909.0
10.98333, 661900.0
10.984, 661888.0
10.98467, 661871.0
10.98533, 661849.0
10.986, 661823.0
10.98667, 661791.0
10.98733, 661755.0
10.988, 661715.0
10.98867, 661671.0
10.98933, 661624.0
10.99, 661572.0
10.99067, 661513.0
10.99133, 661448.0
10.992, 661376.0
10.99267, 661299.0
10.99333, 661219.0
10.994, 661136.0
10.99467, 661051.0
10.99533, 660964.0
10.996, 660877.0
10.99667, 660789.0
10.99733, 660700.0
10.998, 660610.0
10.99867, 660521.0
10.99933, 660433.0
11.0, 660345.0
11.00067, 660258.0
11.00133, 660171.0
11.002, 660086.0
11.00267, 660003.0
11.00333, 659921.0
11.004, 659840.0
11.00467, 659758.0
11.00533, 659674.0
11.006, 659590.0
11.00667, 659508.0
11.00733, 659428.0
11.008, 659350.0
11.00867, 659275.0
11.00933, 659199.0
11.01, 659122.0
11.01067, 659046.0
11.01133, 658972.0
11.012, 658900.0
11.01267, 658831.0
11.01333, 658765.0
11.014, 658700.0
11.01467, 658635.0
11.01533, 658567.0
11.016, 658499.0
11.01667, 658431.0
11.01733, 658360.0
11.018, 658283.0
11.01867, 658200.0
11.01933, 658110.0
11.02, 658012.0
11.02067, 657906.0
11.02133, 657793.0
11.022, 657674.0
11.02267, 657548.0
11.02333, 657417.0
11.024, 657284.0
11.02467, 657149.0
11.02533, 657010.0
11.026, 656870.0
11.02667, 656728.0
11.02733, 656586.0
11.028, 656447.0
11.02867, 656312.0
11.02933, 656180.0
11.03, 656052.0
11.03067, 655927.0
11.03133, 655804.0
11.032, 655685.0
11.03267, 655570.0
11.03333, 655461.0
11.034, 655357.0
11.03467, 655261.0
11.03533, 655175.0
11.036, 655100.0
11.03667, 655035.0
11.03733, 654983.0
11.038, 654943.0
11.03867, 654913.0
11.03933, 654894.0
11.04, 654886.0
11.04067, 654889.0
11.04133, 654900.0
11.042, 654916.0
11.04267, 654935.0
11.04333, 654955.0
11.044, 654977.0
11.04467, 655000.0
11.04533, 655024.0
11.046, 655049.0
11.04667, 655073.0
11.04733, 655094.0
11.048, 655109.0
11.04867, 655122.0
11.04933, 655133.0
11.05, 655141.0
11.05067, 655146.0
11.05133, 655145.0
11.052, 655138.0
11.05267, 655127.0
11.05333, 655111.0
11.054, 655089.0
11.05467, 655062.0
11.05533, 655030.0
11.056, 654993.0
11.05667, 654952.0
11.05733, 654906.0
11.058, 654855.0
11.05867, 654801.0
11.05933, 654745.0
11.06, 654686.0
11.06067, 654624.0
11.06133, 654558.0
11.062, 654490.0
11.06267, 654419.0
11.06333, 654346.0
11.064, 654273.0
11.06467, 654201.0
11.06533, 654130.0
11.066, 654061.0
11.06667, 653993.0
11.06733, 653928.0
11.068, 653863.0
11.06867, 653800.0
11.06933, 653741.0
11.07, 653686.0
11.07067, 653636.0
11.07133, 653593.0
11.072, 653557.0
11.07267, 653527.0
11.07333, 653502.0
11.074, 653479.0
11.07467, 653457.0
11.07533, 653434.0
11.076, 653411.0
11.07667, 653387.0
11.07733, 653362.0
11.078, 653338.0
11.07867, 653312.0
11.07933, 653285.0
11.08, 653256.0
11.08067, 653225.0
11.08133, 653191.0
11.082, 653155.0
11.08267, 653117.0
11.08333, 653079.0
11.084, 653039.0
11.08467, 652997.0
11.08533, 652955.0
11.086, 652911.0
11.08667, 652868.0
11.08733, 652825.0
11.088, 652781.0
11.08867, 652738.0
11.08933, 652696.0
11.09, 652654.0
11.09067, 652611.0
11.09133, 652569.0
11.092, 652528.0
11.09267, 652488.0
11.09333, 652448.0
11.094, 652408.0
11.09467, 652367.0
11.09533, 652326.0
11.096, 652284.0
11.09667, 652242.0
11.09733, 652199.0
11.098, 652156.0
11.09867, 652114.0
11.09933, 652073.0
11.1, 652033.0
11.10067, 651995.0
11.10133, 651956.0
11.102, 651916.0
11.10267, 651875.0
11.10333, 651832.0
11.104, 651787.0
11.10467, 651739.0
11.10533, 651691.0
11.106, 651642.0
11.10667, 651592.0
11.10733, 651542.0
11.108, 651490.0
11.10867, 651435.0
11.10933, 651375.0
11.11, 651308.0
11.11067, 651237.0
11.11133, 651162.0
11.112, 651085.0
11.11267, 651006.0
11.11333, 650928.0
11.114, 650851.0
11.11467, 650777.0
11.11533, 650707.0
11.116, 650640.0
11.11667, 650578.0
11.11733, 650517.0
11.118, 650457.0
11.11867, 650398.0
11.11933, 650339.0
11.12, 650280.0
11.12067, 650219.0
11.12133, 650160.0
11.122, 650104.0
11.12267, 650049.0
11.12333, 649995.0
11.124, 649941.0
11.12467, 649887.0
11.12533, 649834.0
11.126, 649781.0
11.12667, 649730.0
11.12733, 649680.0
11.128, 649630.0
11.12867, 649578.0
11.12933, 649524.0
11.13, 649467.0
11.13067, 649408.0
11.13133, 649348.0
11.132, 649287.0
11.13267, 649225.0
11.13333, 649160.0
11.134, 649092.0
11.13467, 649023.0
11.13533, 648953.0
11.136, 648884.0
11.13667, 648814.0
11.13733, 648744.0
11.138, 648673.0
11.13867, 648602.0
11.13933, 648530.0
11.14, 648459.0
11.14067, 648389.0
11.14133, 648320.0
11.142, 648252.0
11.14267, 648188.0
11.14333, 648126.0
11.144, 648068.0
11.14467, 648012.0
11.14533, 647960.0
11.146, 647910.0
11.14667, 647862.0
11.14733, 647815.0
11.148, 647769.0
11.14867, 647724.0
11.14933, 647680.0
11.15, 647638.0
11.15067, 647596.0
11.15133, 647555.0
11.152, 647515.0
11.15267, 647477.0
11.15333, 647440.0
11.154, 647406.0
11.15467, 647374.0
11.15533, 647345.0
11.156, 647316.0
11.15667, 647284.0
11.15733, 647251.0
11.158, 647214.0
11.15867, 647174.0
11.15933, 647130.0
11.16, 647083.0
11.16067, 647033.0
11.16133, 646983.0
11.162, 646933.0
11.16267, 646882.0
11.16333, 646829.0
11.164, 646774.0
11.16467, 646719.0
11.16533, 646663.0
11.166, 646607.0
11.16667, 646550.0
11.16733, 646496.0
11.168, 646447.0
11.16867, 646405.0
11.16933, 646368.0
11.17, 646335.0
11.17067, 646303.0
11.17133, 646271.0
11.172, 646239.0
11.17267, 646205.0
11.17333, 646170.0
11.174, 646135.0
11.17467, 646098.0
11.17533, 646059.0
11.176, 646018.0
11.17667, 645974.0
11.17733, 645927.0
11.178, 645877.0
11.17867, 645823.0
11.17933, 645764.0
11.18, 645700.0
11.18067, 645633.0
11.18133, 645561.0
11.182, 645483.0
11.18267, 645401.0
11.18333, 645314.0
11.184, 645222.0
11.18467, 645127.0
11.18533, 645031.0
11.186, 644933.0
11.18667, 644831.0
11.18733, 644726.0
11.188, 644617.0
11.18867, 644505.0
11.18933, 644391.0
11.19, 644274.0
11.19067, 644154.0
11.19133, 644032.0
11.192, 643910.0
11.19267, 643790.0
11.19333, 643673.0
11.194, 643558.0
11.19467, 643447.0
11.19533, 643342.0
11.196, 643244.0
11.19667, 643151.0
11.19733, 643063.0
11.198, 642977.0
11.19867, 642892.0
11.19933, 642809.0
11.2, 642726.0
11.20067, 642645.0
11.20133, 642567.0
11.202, 642491.0
11.20267, 642418.0
11.20333, 642349.0
11.204, 642285.0
11.20467, 642224.0
11.20533, 642166.0
11.206, 642113.0
11.20667, 642062.0
11.20733, 642013.0
11.208, 641967.0
11.20867, 641924.0
11.20933, 641883.0
11.21, 641842.0
11.21067, 641803.0
11.21133, 641761.0
11.212, 641718.0
11.21267, 641672.0
11.21333, 641624.0
11.214, 641576.0
11.21467, 641528.0
11.21533, 641480.0
11.216, 641433.0
11.21667, 641386.0
11.21733, 641343.0
11.218, 641301.0
11.21867, 641261.0
11.21933, 641219.0
11.22, 641174.0
11.22067, 641127.0
11.22133, 641077.0
11.222, 641025.0
11.22267, 640969.0
11.22333, 640909.0
11.224, 640846.0
11.22467, 640780.0
11.22533, 640712.0
11.226, 640641.0
11.22667, 640569.0
11.22733, 640498.0
11.228, 640429.0
11.22867, 640359.0
11.22933, 640290.0
11.23, 640219.0
11.23067, 640147.0
11.23133, 640075.0
11.232, 640003.0
11.23267, 639931.0
11.23333, 639863.0
11.234, 639798.0
11.23467, 639736.0
11.23533, 639675.0
11.236, 639613.0
11.23667, 639552.0
11.23733, 639490.0
11.238, 639427.0
11.23867, 639366.0
11.23933, 639305.0
11.24, 639246.0
11.24067, 639187.0
11.24133, 639129.0
11.242, 639069.0
11.24267, 639008.0
11.24333, 638947.0
11.244, 638886.0
11.24467, 638825.0
11.24533, 638765.0
11.246, 638705.0
11.24667, 638644.0
11.24733, 638584.0
11.248, 638525.0
11.24867, 638465.0
11.24933, 638404.0
11.25, 638340.0
11.25067, 638273.0
11.25133, 638203.0
11.252, 638132.0
11.25267, 638061.0
11.25333, 637990.0
11.254, 637920.0
11.25467, 637850.0
11.25533, 637780.0
11.256, 637710.0
11.25667, 637640.0
11.25733, 637570.0
11.258, 637501.0
11.25867, 637433.0
11.25933, 637364.0
11.26, 637296.0
11.26067, 637230.0
11.26133, 637164.0
11.262, 637097.0
11.26267, 637030.0
11.26333, 636962.0
11.264, 636893.0
11.26467, 636824.0
11.26533, 636756.0
11.266, 636690.0
11.26667, 636628.0
11.26733, 636569.0
11.268, 636514.0
11.26867, 636461.0
11.26933, 636410.0
11.27, 636361.0
11.27067, 636313.0
11.27133, 636262.0
11.272, 636211.0
11.27267, 636160.0
11.27333, 636110.0
11.274, 636065.0
11.27467, 636024.0
11.27533, 635988.0
11.276, 635956.0
11.27667, 635923.0
11.27733, 635888.0
11.278, 635855.0
11.27867, 635821.0
11.27933, 635786.0
11.28, 635749.0
11.28067, 635711.0
11.28133, 635671.0
11.282, 635629.0
11.28267, 635586.0
11.28333, 635543.0
11.284, 635498.0
11.28467, 635450.0
11.28533, 635398.0
11.286, 635343.0
11.28667, 635287.0
11.28733, 635230.0
11.288, 635172.0
11.28867, 635112.0
11.28933, 635049.0
11.29, 634981.0
11.29067, 634910.0
11.29133, 634835.0
11.292, 634760.0
11.29267, 634684.0
11.29333, 634608.0
11.294, 634535.0
11.29467, 634464.0
11.29533, 634397.0
11.296, 634332.0
11.29667, 634270.0
11.29733, 634211.0
11.298, 634153.0
11.29867, 634096.0
11.29933, 634039.0
11.3, 633984.0
11.30067, 633931.0
11.30133, 633881.0
11.302, 633836.0
11.30267, 633796.0
11.30333, 633762.0
11.304, 633732.0
11.30467, 633708.0
11.30533, 633689.0
11.306, 633673.0
11.30667, 633658.0
11.30733, 633647.0
11.308, 633638.0
11.30867, 633629.0
11.30933, 633620.0
11.31, 633610.0
11.31067, 633599.0
11.31133, 633586.0
11.312, 633571.0
11.31267, 633553.0
11.31333, 633531.0
11.314, 633505.0
11.31467, 633475.0
11.31533, 633443.0
11.316, 633410.0
11.31667, 633377.0
11.31733, 633344.0
11.318, 633310.0
11.31867, 633275.0
11.31933, 633239.0
11.32, 633203.0
11.32067, 633166.0
11.32133, 633128.0
11.322, 633087.0
11.32267, 633046.0
11.32333, 633003.0
11.324, 632960.0
11.32467, 632917.0
11.32533, 632875.0
11.326, 632832.0
11.32667, 632788.0
11.32733, 632743.0
11.328, 632697.0
11.32867, 632650.0
11.32933, 632601.0
11.33, 632549.0
11.33067, 632496.0
11.33133, 632445.0
11.332, 632396.0
11.33267, 632350.0
11.33333, 632307.0
11.334, 632266.0
11.33467, 632228.0
11.33533, 632193.0
11.336, 632161.0
11.33667, 632132.0
11.33733, 632104.0
11.338, 632079.0
11.33867, 632055.0
11.33933, 632033.0
11.34, 632011.0
11.34067, 631990.0
11.34133, 631969.0
11.342, 631950.0
11.34267, 631931.0
11.34333, 631910.0
11.344, 631888.0
11.34467, 631861.0
11.34533, 631829.0
11.346, 631789.0
11.34667, 631744.0
11.34733, 631695.0
11.348, 631641.0
11.34867, 631583.0
11.34933, 631519.0
11.35, 631452.0
11.35067, 631381.0
11.35133, 631307.0
11.352, 631228.0
11.35267, 631147.0
11.35333, 631068.0
11.354, 630992.0
11.35467, 630919.0
11.35533, 630849.0
11.356, 630782.0
11.35667, 630716.0
11.35733, 630650.0
11.358, 630584.0
11.35867, 630517.0
11.35933, 630451.0
11.36, 630384.0
11.36067, 630316.0
11.36133, 630249.0
11.362, 630181.0
11.36267, 630109.0
11.36333, 630036.0
11.364, 629962.0
11.36467, 629889.0
11.36533, 629818.0
11.366, 629749.0
11.36667, 629680.0
11.36733, 629612.0
11.368, 629545.0
11.36867, 629478.0
11.36933, 629410.0
11.37, 629339.0
11.37067, 629268.0
11.37133, 629199.0
11.372, 629131.0
11.37267, 629064.0
11.37333, 628998.0
11.374, 628935.0
11.37467, 628872.0
11.37533, 628809.0
11.376, 628746.0
11.37667, 628685.0
11.37733, 628626.0
11.378, 628572.0
11.37867, 628522.0
11.37933, 628477.0
11.38, 628435.0
11.38067, 628394.0
11.38133, 628358.0
11.382, 628325.0
11.38267, 628296.0
11.38333, 628269.0
11.384, 628244.0
11.38467, 628220.0
11.38533, 628195.0
11.386, 628170.0
11.38667, 628145.0
11.38733, 628118.0
11.388, 628088.0
11.38867, 628054.0
11.38933, 628016.0
11.39, 627976.0
11.39067, 627932.0
11.39133, 627886.0
11.392, 627837.0
11.39267, 627785.0
11.39333, 627728.0
11.394, 627665.0
11.39467, 627595.0
11.39533, 627519.0
11.396, 627438.0
11.39667, 627356.0
11.39733, 627273.0
11.398, 627190.0
11.39867, 627107.0
11.39933, 627025.0
11.4, 626943.0
11.40067, 626861.0
11.40133, 626780.0
11.402, 626702.0
11.40267, 626627.0
11.40333, 626555.0
11.404, 626486.0
11.40467, 626420.0
11.40533, 626354.0
11.406, 626287.0
11.40667, 626219.0
11.40733, 626151.0
11.408, 626086.0
11.40867, 626024.0
11.40933, 625963.0
11.41, 625903.0
11.41067, 625845.0
11.41133, 625787.0
11.412, 625730.0
11.41267, 625672.0
11.41333, 625611.0
11.414, 625547.0
11.41467, 625481.0
11.41533, 625411.0
11.416, 625339.0
11.41667, 625266.0
11.41733, 625193.0
11.418, 625118.0
11.41867, 625043.0
11.41933, 624968.0
11.42, 624893.0
11.42067, 624820.0
11.42133, 624750.0
11.422, 624683.0
11.42267, 624618.0
11.42333, 624555.0
11.424, 624490.0
11.42467, 624423.0
11.42533, 624354.0
11.426, 624284.0
11.42667, 624215.0
11.42733, 624145.0
11.428, 624074.0
11.42867, 624006.0
11.42933, 623941.0
11.43, 623879.0
11.43067, 623818.0
11.43133, 623758.0
11.432, 623699.0
11.43267, 623640.0
11.43333, 623582.0
11.434, 623528.0
11.43467, 623480.0
11.43533, 623435.0
11.436, 623394.0
11.43667, 623356.0
11.43733, 623322.0
11.438, 623290.0
11.43867, 623259.0
11.43933, 623226.0
11.44, 623193.0
11.44067, 623158.0
11.44133, 623123.0
11.442, 623090.0
11.44267, 623058.0
11.44333, 623028.0
11.444, 623000.0
11.44467, 622972.0
11.44533, 622943.0
11.446, 622911.0
11.44667, 622877.0
11.44733, 622843.0
11.448, 622808.0
11.44867, 622772.0
11.44933, 622734.0
11.45, 622696.0
11.45067, 622657.0
11.45133, 622616.0
11.452, 622573.0
11.45267, 622529.0
11.45333, 622483.0
11.454, 622436.0
11.45467, 622388.0
11.45533, 622340.0
11.456, 622293.0
11.45667, 622246.0
11.45733, 622200.0
11.458, 622155.0
11.45867, 622111.0
11.45933, 622066.0
11.46, 622022.0
11.46067, 621979.0
11.46133, 621936.0
11.462, 621891.0
11.46267, 621847.0
11.46333, 621801.0
11.464, 621755.0
11.46467, 621709.0
11.46533, 621662.0
11.466, 621616.0
11.46667, 621570.0
11.46733, 621523.0
11.468, 621476.0
11.46867, 621429.0
11.46933, 621385.0
11.47, 621344.0
11.47067, 621307.0
11.47133, 621272.0
11.472, 621239.0
11.47267, 621207.0
11.47333, 621174.0
11.474, 621140.0
11.47467, 621105.0
11.47533, 621066.0
11.476, 621025.0
11.47667, 620982.0
11.47733, 620938.0
11.478, 620893.0
11.47867, 620845.0
11.47933, 620793.0
11.48, 620740.0
11.48067, 620685.0
11.48133, 620629.0
11.482, 620571.0
11.48267, 620513.0
11.48333, 620455.0
11.484, 620396.0
11.48467, 620336.0
11.48533, 620275.0
11.486, 620212.0
11.48667, 620148.0
11.48733, 620084.0
11.488, 620020.0
11.48867, 619956.0
11.48933, 619892.0
11.49, 619827.0
11.49067, 619761.0
11.49133, 619695.0
11.492, 619629.0
11.49267, 619563.0
11.49333, 619497.0
11.494, 619429.0
11.49467, 619358.0
11.49533, 619287.0
11.496, 619217.0
11.49667, 619150.0
11.49733, 619085.0
11.498, 619022.0
11.49867, 618960.0
11.49933, 618896.0
11.5, 618832.0
11.50067, 618767.0
11.50133, 618700.0
11.502, 618632.0
11.50267, 618564.0
11.50333, 618495.0
11.504, 618427.0
11.50467, 618359.0
11.50533, 618292.0
11.506, 618226.0
11.50667, 618159.0
11.50733, 618090.0
11.508, 618023.0
11.50867, 617956.0
11.50933, 617889.0
11.51, 617824.0
11.51067, 617760.0
11.51133, 617696.0
11.512, 617632.0
11.51267, 617569.0
11.51333, 617505.0
11.514, 617439.0
11.51467, 617373.0
11.51533, 617307.0
11.516, 617243.0
11.51667, 617179.0
11.51733, 617117.0
11.518, 617055.0
11.51867, 616995.0
11.51933, 616937.0
11.52, 616883.0
11.52067, 616833.0
11.52133, 616785.0
11.522, 616737.0
11.52267, 616688.0
11.52333, 616640.0
11.524, 616591.0
11.52467, 616540.0
11.52533, 616489.0
11.526, 616440.0
11.52667, 616393.0
11.52733, 616346.0
11.528, 616298.0
11.52867, 616248.0
11.52933, 616197.0
11.53, 616145.0
11.53067, 616095.0
11.53133, 616045.0
11.532, 615995.0
11.53267, 615943.0
11.53333, 615891.0
11.534, 615838.0
11.53467, 615784.0
11.53533, 615730.0
11.536, 615677.0
11.53667, 615626.0
11.53733, 615574.0
11.538, 615522.0
11.53867, 615471.0
11.53933, 615421.0
11.54, 615373.0
11.54067, 615327.0
11.54133, 615283.0
11.542, 615241.0
11.54267, 615199.0
11.54333, 615158.0
11.544, 615119.0
11.54467, 615082.0
11.54533, 615048.0
11.546, 615015.0
11.54667, 614983.0
11.54733, 614951.0
11.548, 614919.0
11.54867, 614884.0
11.54933, 614846.0
11.55, 614805.0
11.55067, 614763.0
11.55133, 614721.0
11.552, 614678.0
11.55267, 614634.0
11.55333, 614589.0
11.554, 614542.0
11.55467, 614493.0
11.55533, 614445.0
11.556, 614398.0
11.55667, 614353.0
11.55733, 614308.0
11.558, 614263.0
11.55867, 614219.0
11.55933, 614177.0
11.56, 614137.0
11.56067, 614101.0
11.56133, 614070.0
11.562, 614043.0
11.56267, 614020.0
11.56333, 614000.0
11.564, 613980.0
11.56467, 613960.0
11.56533, 613942.0
11.566, 613926.0
11.56667, 613909.0
11.56733, 613893.0
11.568, 613878.0
11.56867, 613861.0
11.56933, 613844.0
11.57, 613825.0
11.57067, 613807.0
11.57133, 613788.0
11.572, 613769.0
11.57267, 613748.0
11.57333, 613724.0
11.574, 613698.0
11.57467, 613671.0
11.57533, 613641.0
11.576, 613609.0
11.57667, 613575.0
11.57733, 613538.0
11.578, 613500.0
11.57867, 613460.0
11.57933, 613417.0
11.58, 613373.0
11.58067, 613327.0
11.58133, 613279.0
11.582, 613231.0
11.58267, 613181.0
11.58333, 613128.0
11.584, 613074.0
11.58467, 613020.0
11.58533, 612964.0
11.586, 612908.0
11.58667, 612851.0
11.58733, 612794.0
11.588, 612738.0
11.58867, 612684.0
11.58933, 612632.0
11.59, 612583.0
11.59067, 612534.0
11.59133, 612486.0
11.592, 612438.0
11.59267, 612390.0
11.59333, 612341.0
11.594, 612289.0
11.59467, 612237.0
11.59533, 612184.0
11.596, 612131.0
11.59667, 612079.0
11.59733, 612027.0
11.598, 611976.0
11.59867, 611927.0
11.59933, 611880.0
11.6, 611834.0
11.60067, 611791.0
11.60133, 611749.0
11.602, 611710.0
11.60267, 611676.0
11.60333, 611646.0
11.604, 611621.0
11.60467, 611598.0
11.60533, 611577.0
11.606, 611559.0
11.60667, 611544.0
11.60733, 611529.0
11.608, 611517.0
11.60867, 611506.0
11.60933, 611494.0
11.61, 611484.0
11.61067, 611475.0
11.61133, 611468.0
11.612, 611462.0
11.61267, 611455.0
11.61333, 611448.0
11.614, 611439.0
11.61467, 611427.0
11.61533, 611412.0
11.616, 611393.0
11.61667, 611372.0
11.61733, 611349.0
11.618, 611324.0
11.61867, 611299.0
11.61933, 611272.0
11.62, 611245.0
11.62067, 611218.0
11.62133, 611194.0
11.622, 611173.0
11.62267, 611157.0
11.62333, 611142.0
11.624, 611128.0
11.62467, 611114.0
11.62533, 611100.0
11.626, 611087.0
11.62667, 611075.0
11.62733, 611063.0
11.628, 611052.0
11.62867, 611038.0
11.62933, 611021.0
11.63, 611002.0
11.63067, 610977.0
11.63133, 610947.0
11.632, 610913.0
11.63267, 610878.0
11.63333, 610843.0
11.634, 610809.0
11.63467, 610774.0
11.63533, 610738.0
11.636, 610697.0
11.63667, 610653.0
11.63733, 610604.0
11.638, 610553.0
11.63867, 610501.0
11.63933, 610451.0
11.64, 610400.0
11.64067, 610349.0
11.64133, 610298.0
11.642, 610246.0
11.64267, 610195.0
11.64333, 610145.0
11.644, 610096.0
11.64467, 610050.0
11.64533, 610007.0
11.646, 609970.0
11.64667, 609940.0
11.64733, 609916.0
11.648, 609897.0
11.64867, 609883.0
11.64933, 609875.0
11.65, 609873.0
11.65067, 609873.0
11.65133, 609877.0
11.652, 609882.0
11.65267, 609889.0
11.65333, 609897.0
11.654, 609908.0
11.65467, 609918.0
11.65533, 609928.0
11.656, 609936.0
11.65667, 609940.0
11.65733, 609940.0
11.658, 609934.0
11.65867, 609924.0
11.65933, 609908.0
11.66, 609888.0
11.66067, 609867.0
11.66133, 609843.0
11.662, 609819.0
11.66267, 609794.0
11.66333, 609767.0
11.664, 609738.0
11.66467, 609708.0
11.66533, 609676.0
11.666, 609641.0
11.66667, 609605.0
11.66733, 609568.0
11.668, 609533.0
11.66867, 609499.0
11.66933, 609470.0
11.67, 609445.0
11.67067, 609421.0
11.67133, 609399.0
11.672, 609377.0
11.67267, 609353.0
11.67333, 609330.0
11.674, 609305.0
11.67467, 609280.0
11.67533, 609253.0
11.676, 609224.0
11.67667, 609195.0
11.67733, 609165.0
11.678, 609136.0
11.67867, 609108.0
11.67933, 609081.0
11.68, 609054.0
11.68067, 609027.0
11.68133, 609000.0
11.682, 608971.0
11.68267, 608943.0
11.68333, 608915.0
11.684, 608887.0
11.68467, 608860.0
11.68533, 608833.0
11.686, 608805.0
11.68667, 608776.0
11.68733, 608744.0
11.688, 608710.0
11.68867, 608675.0
11.68933, 608639.0
11.69, 608602.0
11.69067, 608563.0
11.69133, 608525.0
11.692, 608486.0
11.69267, 608446.0
11.69333, 608402.0
11.694, 608354.0
11.69467, 608303.0
11.69533, 608250.0
11.696, 608199.0
11.69667, 608149.0
11.69733, 608100.0
11.698, 608053.0
11.69867, 608007.0
11.69933, 607961.0
11.7, 607917.0
11.70067, 607875.0
11.70133, 607832.0
11.702, 607793.0
11.70267, 607757.0
11.70333, 607725.0
11.704, 607696.0
11.70467, 607668.0
11.70533, 607643.0
11.706, 607621.0
11.70667, 607601.0
11.70733, 607581.0
11.708, 607563.0
11.70867, 607546.0
11.70933, 607531.0
11.71, 607516.0
11.71067, 607501.0
11.71133, 607486.0
11.712, 607472.0
11.71267, 607457.0
11.71333, 607441.0
11.714, 607424.0
11.71467, 607407.0
11.71533, 607388.0
11.716, 607369.0
11.71667, 607349.0
11.71733, 607326.0
11.718, 607301.0
11.71867, 607279.0
11.71933, 607258.0
11.72, 607238.0
11.72067, 607219.0
11.72133, 607200.0
11.722, 607180.0
11.72267, 607161.0
11.72333, 607142.0
11.724, 607123.0
11.72467, 607103.0
11.72533, 607082.0
11.726, 607062.0
11.72667, 607041.0
11.72733, 607018.0
11.728, 606994.0
11.72867, 606971.0
11.72933, 606950.0
11.73, 606934.0
11.73067, 606920.0
11.73133, 606905.0
11.732, 606891.0
11.73267, 606879.0
11.73333, 606871.0
11.734, 606866.0
11.73467, 606867.0
11.73533, 606872.0
11.736, 606879.0
11.73667, 606888.0
11.73733, 606898.0
11.738, 606908.0
11.73867, 606916.0
11.73933, 606922.0
11.74, 606925.0
11.74067, 606925.0
11.74133, 606923.0
11.742, 606918.0
11.74267, 606909.0
11.74333, 606896.0
11.744, 606879.0
11.74467, 606858.0
11.74533, 606834.0
11.746, 606808.0
11.74667, 606782.0
11.74733, 606753.0
11.748, 606722.0
11.74867, 606685.0
11.74933, 606644.0
11.75, 606600.0
11.75067, 606550.0
11.75133, 606498.0
11.752, 606443.0
11.75267, 606389.0
11.75333, 606336.0
11.754, 606285.0
11.75467, 606235.0
11.75533, 606185.0
11.756, 606136.0
11.75667, 606087.0
11.75733, 606037.0
11.758, 605986.0
11.75867, 605934.0
11.75933, 605884.0
11.76, 605837.0
11.76067, 605793.0
11.76133, 605751.0
11.762, 605712.0
11.76267, 605677.0
11.76333, 605644.0
11.764, 605616.0
11.76467, 605592.0
11.76533, 605572.0
11.766, 605557.0
11.76667, 605546.0
11.76733, 605539.0
11.768, 605534.0
11.76867, 605533.0
11.76933, 605534.0
11.77, 605536.0
11.77067, 605538.0
11.77133, 605541.0
11.772, 605544.0
11.77267, 605550.0
11.77333, 605559.0
11.774, 605569.0
11.77467, 605580.0
11.77533, 605591.0
11.776, 605601.0
11.77667, 605608.0
11.77733, 605614.0
11.778, 605617.0
11.77867, 605619.0
11.77933, 605620.0
11.78, 605621.0
11.78067, 605619.0
11.78133, 605615.0
11.782, 605608.0
11.78267, 605597.0
11.78333, 605583.0
11.784, 605567.0
11.78467, 605547.0
11.78533, 605523.0
11.786, 605495.0
11.78667, 605464.0
11.78733, 605431.0
11.788, 605395.0
11.78867, 605358.0
11.78933, 605320.0
11.79, 605281.0
11.79067, 605241.0
11.79133, 605199.0
11.792, 605156.0
11.79267, 605111.0
11.79333, 605065.0
11.794, 605018.0
11.79467, 604969.0
11.79533, 604920.0
11.796, 604870.0
11.79667, 604820.0
11.79733, 604769.0
11.798, 604718.0
11.79867, 604669.0
11.79933, 604621.0
11.8, 604573.0
11.80067, 604526.0
11.80133, 604478.0
11.802, 604429.0
11.80267, 604380.0
11.80333, 604335.0
11.804, 604293.0
11.80467, 604252.0
11.80533, 604214.0
11.806, 604178.0
11.80667, 604145.0
11.80733, 604117.0
11.808, 604090.0
11.80867, 604064.0
11.80933, 604038.0
11.81, 604014.0
11.81067, 603990.0
11.81133, 603966.0
11.812, 603940.0
11.81267, 603916.0
11.81333, 603893.0
11.814, 603873.0
11.81467, 603857.0
11.81533, 603844.0
11.816, 603835.0
11.81667, 603829.0
11.81733, 603825.0
11.818, 603821.0
11.81867, 603818.0
11.81933, 603814.0
11.82, 603807.0
11.82067, 603796.0
11.82133, 603778.0
11.822, 603754.0
11.82267, 603724.0
11.82333, 603687.0
11.824, 603643.0
11.82467, 603596.0
11.82533, 603545.0
11.826, 603492.0
11.82667, 603437.0
11.82733, 603384.0
11.828, 603331.0
11.82867, 603280.0
11.82933, 603229.0
11.83, 603180.0
11.83067, 603133.0
11.83133, 603089.0
11.832, 603046.0
11.83267, 603008.0
11.83333, 602971.0
11.834, 602937.0
11.83467, 602908.0
11.83533, 602885.0
11.836, 602868.0
11.83667, 602856.0
11.83733, 602849.0
11.838, 602843.0
11.83867, 602838.0
11.83933, 602834.0
11.84, 602831.0
11.84067, 602830.0
11.84133, 602830.0
11.842, 602830.0
11.84267, 602828.0
11.84333, 602823.0
11.844, 602817.0
11.84467, 602808.0
11.84533, 602796.0
11.846, 602781.0
11.84667, 602764.0
11.84733, 602746.0
11.848, 602727.0
11.84867, 602707.0
11.84933, 602685.0
11.85, 602661.0
11.85067, 602637.0
11.85133, 602613.0
11.852, 602587.0
11.85267, 602560.0
11.85333, 602532.0
11.854, 602504.0
11.85467, 602473.0
11.85533, 602440.0
11.856, 602403.0
11.85667, 602365.0
11.85733, 602326.0
11.858, 602287.0
11.85867, 602247.0
11.85933, 602206.0
11.86, 602165.0
11.86067, 602125.0
11.86133, 602086.0
11.862, 602047.0
11.86267, 602009.0
11.86333, 601972.0
11.864, 601939.0
11.86467, 601908.0
11.86533, 601880.0
11.866, 601853.0
11.86667, 601829.0
11.86733, 601808.0
11.868, 601791.0
11.86867, 601777.0
11.86933, 601766.0
11.87, 601757.0
11.87067, 601751.0
11.87133, 601746.0
11.872, 601743.0
11.87267, 601740.0
11.87333, 601740.0
11.874, 601743.0
11.87467, 601747.0
11.87533, 601752.0
11.876, 601754.0
11.87667, 601753.0
11.87733, 601750.0
11.878, 601745.0
11.87867, 601738.0
11.87933, 601728.0
11.88, 601716.0
11.88067, 601700.0
11.88133, 601682.0
11.882, 601662.0
11.88267, 601640.0
11.88333, 601615.0
11.884, 601586.0
11.88467, 601554.0
11.88533, 601519.0
11.886, 601482.0
11.88667, 601441.0
11.88733, 601397.0
11.888, 601352.0
11.88867, 601306.0
11.88933, 601256.0
11.89, 601205.0
11.89067, 601151.0
11.89133, 601095.0
11.892, 601038.0
11.89267, 600981.0
11.89333, 600922.0
11.894, 600864.0
11.89467, 600807.0
11.89533, 600751.0
11.896, 600697.0
11.89667, 600643.0
11.89733, 600589.0
11.898, 600534.0
11.89867, 600478.0
11.89933, 600424.0
11.9, 600371.0
11.90067, 600319.0
11.90133, 600270.0
11.902, 600227.0
11.90267, 600188.0
11.90333, 600156.0
11.904, 600129.0
11.90467, 600105.0
11.90533, 600082.0
11.906, 600061.0
11.90667, 600042.0
11.90733, 600023.0
11.908, 600005.0
11.90867, 599987.0
11.90933, 599968.0
11.91, 599946.0
11.91067, 599923.0
11.91133, 599900.0
11.912, 599878.0
11.91267, 599858.0
11.91333, 599840.0
11.914, 599822.0
11.91467, 599802.0
11.91533, 599781.0
11.916, 599757.0
11.91667, 599731.0
11.91733, 599703.0
11.918, 599673.0
11.91867, 599641.0
11.91933, 599608.0
11.92, 599575.0
11.92067, 599541.0
11.92133, 599507.0
11.922, 599473.0
11.92267, 599439.0
11.92333, 599404.0
11.924, 599369.0
11.92467, 599335.0
11.92533, 599301.0
11.926, 599268.0
11.92667, 599236.0
11.92733, 599204.0
11.928, 599174.0
11.92867, 599143.0
11.92933, 599113.0
11.93, 599081.0
11.93067, 599046.0
11.93133, 599011.0
11.932, 598975.0
11.93267, 598939.0
11.93333, 598901.0
11.934, 598863.0
11.93467, 598827.0
11.93533, 598790.0
11.936, 598754.0
11.93667, 598718.0
11.93733, 598684.0
11.938, 598651.0
11.93867, 598621.0
11.93933, 598596.0
11.94, 598573.0
11.94067, 598555.0
11.94133, 598541.0
11.942, 598530.0
11.94267, 598521.0
11.94333, 598512.0
11.944, 598504.0
11.94467, 598496.0
11.94533, 598488.0
11.946, 598481.0
11.94667, 598475.0
11.94733, 598469.0
11.948, 598463.0
11.94867, 598459.0
11.94933, 598457.0
11.95, 598457.0
11.95067, 598458.0
11.95133, 598461.0
11.952, 598466.0
11.95267, 598472.0
11.95333, 598477.0
11.954, 598483.0
11.95467, 598489.0
11.95533, 598496.0
11.956, 598503.0
11.95667, 598508.0
11.95733, 598511.0
11.958, 598513.0
11.95867, 598513.0
11.95933, 598511.0
11.96, 598507.0
11.96067, 598502.0
11.96133, 598497.0
11.962, 598491.0
11.96267, 598484.0
11.96333, 598476.0
11.964, 598466.0
11.96467, 598452.0
11.96533, 598433.0
11.966, 598411.0
11.96667, 598386.0
11.96733, 598358.0
11.968, 598328.0
11.96867, 598297.0
11.96933, 598265.0
11.97, 598233.0
11.97067, 598202.0
11.97133, 598170.0
11.972, 598138.0
11.97267, 598108.0
11.97333, 598079.0
11.974, 598053.0
11.97467, 598029.0
11.97533, 598006.0
11.976, 597983.0
11.97667, 597961.0
11.97733, 597939.0
11.978, 597919.0
11.97867, 597901.0
11.97933, 597885.0
11.98, 597869.0
11.98067, 597852.0
11.98133, 597833.0
11.982, 597811.0
11.98267, 597787.0
11.98333, 597761.0
11.984, 597733.0
11.98467, 597702.0
11.98533, 597668.0
11.986, 597633.0
11.98667, 597594.0
11.98733, 597553.0
11.988, 597509.0
11.98867, 597463.0
11.98933, 597415.0
11.99, 597362.0
11.99067, 597304.0
11.99133, 597241.0
11.992, 597172.0
11.99267, 597098.0
11.99333, 597019.0
11.994, 596935.0
11.99467, 596846.0
11.99533, 596754.0
11.996, 596658.0
11.99667, 596560.0
11.99733, 596460.0
11.998, 596357.0
11.99867, 596253.0
11.99933, 596149.0
12.0, 596046.0
##END=$$ End of the data block


`;

export default gcJcamp1;
